import '../index.css';var Bs = Object.defineProperty;
var Ls = (e, a, t) => a in e ? Bs(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t;
var te = (e, a, t) => Ls(e, typeof a != "symbol" ? a + "" : a, t);
import { defineComponent as Te, openBlock as v, createElementBlock as y, createElementVNode as k, renderSlot as ie, ref as B, normalizeClass as pe, withDirectives as ht, vModelCheckbox as so, toDisplayString as _e, useSlots as ea, useAttrs as io, computed as H, Fragment as me, mergeProps as dt, unref as m, renderList as Me, createBlock as Pe, resolveDynamicComponent as Va, createTextVNode as Je, normalizeStyle as Be, createCommentVNode as Y, resolveComponent as Vr, withModifiers as yt, createVNode as qe, watch as et, onBeforeUpdate as uo, vModelText as Ln, onMounted as Xe, onBeforeUnmount as Fs, vModelSelect as On, useCssVars as nr, isRef as ma, watchEffect as Vs, toRef as tn, nextTick as mt, pushScopeId as Tt, popScopeId as It, withCtx as Ae, reactive as _a, createStaticVNode as Hs, vShow as Aa, vModelRadio as Ys, getCurrentInstance as Ws, onUnmounted as vn, createSlots as bt, normalizeProps as gt, guardReactiveProps as $t, Teleport as Us, Transition as Ha, h as zs, render as wl, toValue as qs, getCurrentScope as js, onScopeDispose as Gs, withKeys as Cn, onUpdated as Qs } from "vue";
import { _ as Ye, u as co, a as Ks, b as Xs } from "../MessageBoxEx-CteyjAsC.js";
import { C as Wb, M as Ub } from "../MessageBoxEx-CteyjAsC.js";
import { U as Ya, g as Zs, c as Hr, r as Js, a as ei, b as fo, d as ti, e as ai, f as ni, h as ri, M as li, i as da, N as _l } from "../NaturalCompare-BhqAyIXe.js";
import { j as qb, k as jb, l as Gb } from "../NaturalCompare-BhqAyIXe.js";
import "utif2";
import oi from "moment";
import Sr from "iconv-lite";
import { t as Tn, I as kl, C as si } from "../Ipv4Address-CbH6PWSk.js";
import Oa from "jquery";
import { cloneDeep as Sa, isEqual as ii, sortBy as xl, debounce as ui } from "lodash";
const ci = {
  class: "btn-scv-bgcolor",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  style: { padding: "0px 0px" }
}, di = { class: "d-flex align-items-center" }, fi = /* @__PURE__ */ k("div", {
  class: "icon-font-deepblue ms-auto",
  style: { "margin-right": "2px", "letter-spacing": "normal" }
}, null, -1), pi = /* @__PURE__ */ k("div", {
  class: "icon-font-deepblue ms-auto",
  style: { "margin-right": "2px", "letter-spacing": "normal" }
}, [
  /* @__PURE__ */ k("i", { class: "icon-arrow2down" })
], -1), Cl = /* @__PURE__ */ Te({
  __name: "BGColorMenuButton",
  setup(e) {
    return (a, t) => (v(), y("button", ci, [
      k("div", di, [
        fi,
        ie(a.$slots, "text"),
        pi
      ])
    ]));
  }
}), mi = { class: "switchButtonArea" }, vi = { class: "switchArea" }, hi = { style: { "margin-left": "4px" } }, yi = /* @__PURE__ */ Te({
  __name: "SwitchButton",
  props: {
    text: { type: String, default: "" }
    // ボタンのテキスト
  },
  emits: ["onClickSwitch"],
  setup(e, { emit: a }) {
    const t = a, n = B(!1), r = () => {
      t("onClickSwitch", n.value);
    };
    return (l, o) => (v(), y("div", mi, [
      k("div", vi, [
        k("label", {
          class: pe(["switchLabel", [n.value ? "chk_on_switchLabel" : ""]]),
          style: { display: "block", float: "left" }
        }, [
          k("label", {
            class: pe(["swImg switchLabel", [n.value ? "chk_on_swImg" : ""]])
          }, [
            ht(k("input", {
              type: "checkbox",
              onChange: r,
              "onUpdate:modelValue": o[0] || (o[0] = (i) => n.value = i),
              autocomplete: "off"
            }, null, 544), [
              [so, n.value]
            ])
          ], 2)
        ], 2),
        k("div", {
          class: pe(["text", [n.value ? "chk_on_text" : ""]])
        }, [
          k("span", hi, _e(e.text), 1)
        ], 2)
      ])
    ]));
  }
}), db = /* @__PURE__ */ Ye(yi, [["__scopeId", "data-v-b63ff4f7"]]), gi = ["disabled"], bi = /* @__PURE__ */ k("div", {
  class: "icon-font-size ms-auto",
  style: { "margin-right": "2px", "letter-spacing": "normal" }
}, [
  /* @__PURE__ */ k("i", { class: "icon-arrow2down" })
], -1), wi = { class: "dropdown-menu scv-dropdown-menu scv-dropdown-sub-menu" }, _i = ["onClick"], ki = /* @__PURE__ */ Te({
  __name: "DropdownButton",
  props: {
    caption: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = ea(), l = io(), o = H(() => r.default ? r.default() : {}), i = H(() => l.class || "btn-scv-bgcolor");
    function s(c, u) {
      n("select", c, u.props);
    }
    return (c, u) => (v(), y(me, null, [
      k("button", dt({
        class: [c.$style.button, m(i)],
        type: "button",
        "data-bs-toggle": "dropdown",
        disabled: t.disabled
      }, c.$attrs), [
        k("span", null, _e(t.caption), 1),
        bi
      ], 16, gi),
      k("ul", wi, [
        (v(!0), y(me, null, Me(m(o), (d, f) => (v(), y("li", {
          key: f,
          class: pe(c.$style.dropdownItem),
          onClick: (h) => s(f, d)
        }, [
          (v(), Pe(Va(d)))
        ], 10, _i))), 128))
      ])
    ], 64));
  }
}), xi = "_button_zakwu_1", Ci = "_dropdownItem_zakwu_8", Di = {
  button: xi,
  dropdownItem: Ci
}, Ti = {
  $style: Di
}, fb = /* @__PURE__ */ Ye(ki, [["__cssModules", Ti]]), Ii = ["onClick"], Mi = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}, Si = {
  key: 1,
  class: "dropright scv-dropdown-sub"
}, $i = ["onClick"], Pi = {
  class: "dropdown-item",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown"
}, Ai = /* @__PURE__ */ k("div", { class: "icon-font-silver-gray scv-dropdown-icon-right ms-auto" }, [
  /* @__PURE__ */ k("i", { class: "icon-arrow1right" })
], -1), Oi = { class: "dropdown-menu scv-dropdown-menu scv-dropdown-sub-menu" }, Ri = ["onClick"], Ei = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}, Ni = {
  key: 1,
  class: "scv-dropdown-menu-button"
}, Bi = {
  key: 0,
  class: "dropdown-item scv-dropdown-item-disabled",
  disabled: ""
}, Li = {
  key: 1,
  class: "dropdown-item scv-dropdown-item-disabled",
  disabled: ""
}, Fi = /* @__PURE__ */ k("div", { class: "icon-font-silver-gray scv-dropdown-icon-right ms-auto" }, [
  /* @__PURE__ */ k("i", { class: "icon-arrow1right" })
], -1), Dl = /* @__PURE__ */ Te({
  __name: "DropdownMenu",
  props: {
    models: { type: Object, required: !0 }
    // 検索のID
  },
  emits: ["onClickMenuItem"],
  setup(e, { emit: a }) {
    const t = a, n = (r) => {
      t("onClickMenuItem", r);
    };
    return (r, l) => (v(!0), y(me, null, Me(e.models, (o) => (v(), y(me, { key: o }, [
      o.disabled ? (v(), y("div", Ni, [
        o.childMenuItem.length === 0 ? (v(), y("a", Bi, _e(o.description), 1)) : (v(), y("a", Li, [
          Je(_e(o.description) + " ", 1),
          Fi
        ]))
      ])) : (v(), y(me, { key: 0 }, [
        o.childMenuItem.length === 0 ? (v(), y("div", {
          key: 0,
          class: "scv-dropdown-menu-button",
          onClick: (i) => n(o.menuItemID)
        }, [
          k("a", Mi, _e(o.description), 1)
        ], 8, Ii)) : (v(), y("div", Si, [
          k("div", {
            class: "scv-dropdown-menu-button",
            onClick: (i) => n(o.menuItemID)
          }, [
            k("a", Pi, [
              Je(_e(o.description) + " ", 1),
              Ai
            ]),
            k("ul", Oi, [
              (v(!0), y(me, null, Me(o.childMenuItem, (i) => (v(), y("li", {
                key: i,
                class: "scv-dropdown-menu-button",
                onClick: (s) => n(i.menuItemID)
              }, [
                k("a", Ei, _e(i.description), 1)
              ], 8, Ri))), 128))
            ])
          ], 8, $i)
        ]))
      ], 64))
    ], 64))), 128));
  }
});
var In = /* @__PURE__ */ ((e) => (e[e.Normal = 0] = "Normal", e[e.Check = 1] = "Check", e))(In || {}), Kn = /* @__PURE__ */ ((e) => (e[e.Vertical = 0] = "Vertical", e[e.Horizontal = 1] = "Horizontal", e))(Kn || {}), ut = /* @__PURE__ */ ((e) => (e[e.Unchecked = 0] = "Unchecked", e[e.Checked = 1] = "Checked", e[e.Indeterminate = 2] = "Indeterminate", e))(ut || {});
const Vi = ["id", "checked", "indeterminate", "disabled"], Hi = ["for"], Yi = /* @__PURE__ */ Te({
  __name: "TriStateCheckbox",
  props: {
    modelValue: {},
    allowTriState: { type: Boolean, default: !1 },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    stopPropagation: { type: Boolean, default: !0 },
    labelClass: { default: () => ["default-text-font"] },
    labelStyle: { default: void 0 },
    beforeChange: { type: Function, default: () => !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = H(() => ut.Unchecked !== t.modelValue), l = H(() => ut.Indeterminate === t.modelValue), o = B(`triStateCheckbox${Ya.NewID()}`), i = H(() => {
      switch (t.modelValue) {
        case ut.Unchecked:
          return ut.Checked;
        case ut.Indeterminate:
          return ut.Unchecked;
        case ut.Checked:
          return t.allowTriState ? ut.Indeterminate : ut.Unchecked;
        default:
          return ut.Unchecked;
      }
    });
    function s(d) {
      t.beforeChange(t.modelValue, i.value) || d.preventDefault();
    }
    function c() {
      n("update:modelValue", i.value);
    }
    function u(d) {
      t.stopPropagation && d.stopPropagation();
    }
    return (d, f) => (v(), y("div", {
      class: pe(["triStateCheckbox", d.$style.container]),
      onClick: u
    }, [
      k("input", {
        type: "checkbox",
        id: m(o),
        checked: m(r),
        indeterminate: m(l),
        disabled: t.disabled,
        onChange: c,
        onClick: s
      }, null, 40, Vi),
      0 < t.label.length ? (v(), y("label", {
        key: 0,
        for: m(o),
        class: pe(t.labelClass),
        style: Be(t.labelStyle)
      }, _e(t.label), 15, Hi)) : Y("", !0)
    ], 2));
  }
}), Wi = "_container_17jg4_3", Ui = {
  container: Wi
}, zi = {
  $style: Ui
}, po = /* @__PURE__ */ Ye(Yi, [["__cssModules", zi]]), qi = /* @__PURE__ */ Te({
  __name: "DropdownMenuItem",
  props: {
    item: {},
    menuStyle: { default: In.Normal }
  },
  emits: ["change"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = H({
      get: () => t.item.checked ? ut.Checked : ut.Unchecked,
      set: () => o()
    }), l = H(() => t.item.disabled), o = () => {
      t.item.disabled || t.menuStyle !== In.Check || n("change", t.item.menuItemID, !t.item.checked);
    };
    return (i, s) => {
      const c = Vr("DropdownMenuItem", !0);
      return v(), y(me, null, [
        k("div", {
          class: "dropdownMenuItem dropdown-item",
          onClick: yt(o, ["stop"])
        }, [
          m(In).Check === t.menuStyle ? (v(), Pe(po, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": s[0] || (s[0] = (u) => r.value = u),
            label: i.item.description,
            disabled: l.value
          }, null, 8, ["modelValue", "label", "disabled"])) : (v(), y("span", {
            key: 1,
            class: pe({ disabled: l.value })
          }, _e(i.item.description), 3))
        ]),
        (v(!0), y(me, null, Me(i.item.childMenuItem, (u, d) => (v(), y("div", {
          key: d,
          class: "subMenu"
        }, [
          qe(c, {
            item: u,
            menuStyle: t.menuStyle,
            onChange: s[1] || (s[1] = (f, h) => n("change", f, h))
          }, null, 8, ["item", "menuStyle"])
        ]))), 128))
      ], 64);
    };
  }
}), ji = /* @__PURE__ */ Ye(qi, [["__scopeId", "data-v-27e6086b"]]), Gi = /* @__PURE__ */ Te({
  __name: "DropdownSelectMenu",
  props: {
    models: { type: Object, required: !0 }
    // 検索のID
  },
  emits: ["onChangeMenuItem"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = B(new Array());
    et(
      () => t.models,
      () => {
        r.value.splice(0, r.value.length), t.models.forEach((o) => r.value.push(JSON.parse(JSON.stringify(o))));
      },
      { deep: !0, immediate: !0 }
    );
    const l = (o, i) => {
      const s = (f) => {
        o === f.menuItemID ? f.checked = i : f.childMenuItem.forEach((h) => s(h));
      };
      r.value.forEach((f) => s(f));
      const c = (f, h) => {
        f.disabled = h ?? !1, f.childMenuItem.forEach((b) => c(b, h || f.checked));
      };
      r.value.forEach((f) => c(f));
      const u = (f, h) => {
        f.checked && h.push(f.menuItemID), f.childMenuItem.forEach((b) => u(b, h));
      };
      let d = [];
      r.value.forEach((f) => u(f, d)), d.sort((f, h) => f - h), n("onChangeMenuItem", d);
    };
    return (o, i) => (v(!0), y(me, null, Me(r.value, (s, c) => (v(), Pe(ji, {
      key: c,
      item: s,
      menuStyle: m(In).Check,
      onChange: l
    }, null, 8, ["item", "menuStyle"]))), 128));
  }
});
class pb {
  /// <summary>
  /// コンストラクタ
  /// </summary>
  constructor(a, t, n, r, l) {
    /// <summary>
    /// メニューアイテムのID クリック時にこのIDを元に判定を行うため、リスト内で一意になるように作成すること
    /// </summary>
    te(this, "menuItemID", 0);
    /// <summary>
    /// サブメニュー ★DropdownMenu: 現時点ではサブメニューは1階層までしか対応しておりません★
    ///              ★2階層目以降は、".\DropdownMenu.vue"への実装が必要です。
    ///              ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★
    ///              ★DropdownSelectMenu : 現時点ではサブメニュは対応しておりません。★
    ///              ★サブメニューを使用するには、".\DropdownSelectMenu.vue"への実装が必要です。
    /// </summary>
    te(this, "childMenuItem", new Array());
    /// <summary>
    /// メニュー名称
    /// </summary>
    te(this, "description", "");
    /// <summary>
    /// メニューの押下(有効・無効)
    /// </summary>
    te(this, "disabled", !1);
    /// <summary>
    /// メニューの選択(選択・非選択)
    /// </summary>
    te(this, "checked", !1);
    a != null && (this.menuItemID = a), t != null && (this.description = t), n != null && (this.disabled = n), r != null && (this.checked = r), l != null && (this.childMenuItem = l);
  }
}
String.prototype.getMultiBytesSize = function() {
  let e = 0;
  for (let a = 0; a < this.length; a++) {
    const t = this.charCodeAt(a);
    t >= 0 && t < 129 || t === 63728 || t >= 65377 && t < 65440 || t >= 63729 && t < 63732 ? e += 1 : e += 2;
  }
  return e;
};
String.prototype.trimMaxLengthByMulti = function(e) {
  if (e < 0) return this.toString();
  if (e >= this.getUtf8BytesSize()) return this.toString();
  const a = (n) => {
    if (n.length < 2)
      return !1;
    const r = n.charCodeAt(n.length - 2);
    return r >= 55296 && r <= 56319;
  };
  let t = this.toString();
  for (; t.getMultiBytesSize() > e; )
    t = t.slice(0, a(t) ? -2 : -1);
  return t;
};
String.prototype.getUtf8BytesSize = function() {
  return new TextEncoder().encode(this.toString()).length;
};
String.prototype.trimMaxLengthByUtf8 = function(e) {
  let a = "";
  if (e >= this.getUtf8BytesSize())
    a = this.toString();
  else {
    let t = this.toString();
    for (; t.getUtf8BytesSize() > e; )
      t = t.slice(0, -1);
    a = t;
  }
  return a;
};
String.prototype.removeNotHalfNumber = function() {
  return this.replace(/[^0-9]/g, "");
};
String.prototype.removeNotHalfNumberDecimal = function() {
  return this.replace(/[^0-9\u002e]/g, "");
};
String.prototype.removeNotHalfChar = function() {
  return this.replace(/[^\x01-\x7E]/g, "");
};
String.prototype.removeUnUsemailAddressChar = function() {
  return this.replace(/[^a-zA-Z0-9@.+\-_]/g, "");
};
String.prototype.removeNotHalfCharAllowNewLine = function() {
  return this.replace(/[^\x01-\x7E\u000A\u000D]/g, "");
};
String.prototype.includeChar = function(e) {
  for (let a = 0; a < e.length; a++)
    if (this.includes(e.charAt(a)))
      return !0;
  return !1;
};
String.prototype.removeControlCode = function() {
  const e = /[\u0000-\u001F\u007F–\u00A0\u00AD]/g;
  return this.replace(e, "");
};
String.prototype.removeControlCodeAllowNewLine = function() {
  const e = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F–\u00A0\u00AD]/g;
  return this.replace(e, "");
};
String.prototype.includeControlCode = function() {
  const e = /[\u0000-\u001F\u007F–\u00A0\u00AD]/g;
  return this.match(e) !== null;
};
String.prototype.includeControlCodeAllowNewLine = function() {
  const e = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F–\u00A0\u00AD]/g;
  return this.match(e) !== null;
};
String.prototype.includeFullChar = function() {
  const e = /[^\x01-\x7E\uFF61-\uFF9F]/g;
  return this.match(e) !== null;
};
String.prototype.includeHalfCharKANA = function() {
  const e = /[\uFF61-\uFF9F]/g;
  return this.match(e) !== null;
};
String.prototype.compareSort = function(e) {
  return this < e ? -1 : this > e ? 1 : 0;
};
String.prototype.makeCsvItemEx = function() {
  let e = !1;
  for (let a = 0; a < this.length; a++) {
    const t = this.charCodeAt(a);
    if (t == 10 || t == 13 || t == 44 || t == 34) {
      e = !0;
      break;
    }
  }
  return e == !1 ? this.toString() : '"' + this.replaceAll('"', '""') + '"';
};
String.prototype.removeNotSJIS = function() {
  const e = Sr.encode(this.normalize().toString(), "sjis");
  return Sr.decode(e, "sjis");
};
String.prototype.includeNotSJIS = function() {
  return this.removeNotSJIS() != Sr.encode(this.normalize().toString(), "utf-8").toString();
};
String.prototype.isValidMailAddress = function() {
  if (this.match("@") === null || this.length >= 256)
    return !1;
  let e = 0;
  for (e; e <= this.length && this.charCodeAt(e) != 64; )
    ++e;
  return !(e == 0 || (++e, this.length - e == 0) || new RegExp(/@.*\[[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+\]/).test(this.toString()));
};
String.prototype.isValidMailAddress2 = function() {
  const e = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  return new RegExp(e).test(this.toString());
};
String.prototype.compareScvVersion = function(e) {
  const a = new RegExp(/^[0-9]+\.[0-9][0-9][0-9]\.[0-9]+.*/);
  if (!a.test(this.toString()) || !a.test(e))
    return !1;
  const t = this.split("."), n = e.split(".");
  let r = parseInt(t[0]), l = parseInt(n[0]);
  return r < l ? -1 : r > l ? 1 : (r = parseInt(t[1]), l = parseInt(n[1]), r < l ? -1 : r > l ? 1 : (r = parseInt(t[2]), l = parseInt(n[2]), r < l ? -1 : r > l ? 1 : 0));
};
String.prototype.createErrorsMessage = function(e) {
  const a = e.length;
  if (a == 0)
    return "";
  if (a == 1)
    return e[0];
  {
    let t = "・" + e[0];
    for (let n = 1; n < a; n++)
      t += "<br />・" + e[n];
    return t;
  }
};
String.prototype.escapeHtml = function() {
  const e = {
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
  };
  return this.replace(/[<>&"'`]/g, function(a) {
    return e[a];
  });
};
String.prototype.designString = function(e) {
  const a = new RegExp("[^" + e + "]", "g");
  return this.replace(a, "");
};
String.prototype.designReplaceString = function(e) {
  const a = new RegExp("[" + e + "]", "g");
  return this.replace(a, "");
};
String.prototype.easyEncrypt = function() {
  const e = this, a = window.btoa(window.encodeURIComponent(e)), t = "cBu4UeHf+RFgzOXhlDJn72aoPTLrq5wvj3Yx8VCEi6GtIb0k9NKmydSp=W/MsZ1AQ".split(""), n = t.length - 1, r = new Array(0);
  return a.split("").map((l) => {
    const o = t.indexOf(l) === n ? 0 : t.indexOf(l) + 1;
    r.push(t[o]);
  }), r.join("");
};
String.prototype.easyDecrypt = function() {
  const e = this, a = "cBu4UeHf+RFgzOXhlDJn72aoPTLrq5wvj3Yx8VCEi6GtIb0k9NKmydSp=W/MsZ1AQ".split(""), t = a.length - 1, n = new Array(0);
  return e.split("").map((r) => {
    const l = a.indexOf(r) === 0 ? t : a.indexOf(r) - 1;
    n.push(a[l]);
  }), decodeURIComponent(window.atob(n.join("")));
};
String.prototype.removeHalfSpaceChar = function() {
  return this.replace(/ /g, "");
};
String.prototype.format = function(...e) {
  return this.replace(/%s/g, () => e.shift() || "");
};
String.prototype.removeChars = function(e) {
  const a = new RegExp(`[${e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}]`, "g");
  return this.replace(a, "");
};
class Tl {
  /**
   * コンストラクタ
   * @param textMode テキストボックス用かどうか(デフォルト値はfalse)
   */
  constructor(a = !1) {
    /** テキストボックス用かどうか spinModeで見分ける場合、影響範囲が大きいので新しい変数を定義 */
    te(this, "textMode", !1);
    this.textMode = a;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value, n = !1;
    const r = parseInt(a.min);
    if ((isNaN(r) || r < 0) && a.value.startsWith("-") && (n = !0, a.value === "-" || a.value === "-0")) {
      if (this.textMode)
        return a.value;
      t = "-1";
    }
    if (t = t.removeNotHalfNumber(), n && (t = "-" + t), t == "" || t == null)
      return t;
    let l = parseInt(t);
    const o = parseInt(a.max);
    return isNaN(o) == !1 && o < l && (l = o), Math.trunc(l).toString();
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    return "";
  }
}
class Qi {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value;
    return t = t.removeNotHalfNumberDecimal(), t == "" || t == null, t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    return "";
  }
}
class mo {
  constructor(a) {
    // オプション
    te(this, "option");
    // Optionを適応させる
    te(this, "applyOption", (a) => {
      let t = a;
      return t = this.correctUnuseChars(t), t = this.correctLength(t), t;
    });
    // 使用禁止文字を取り除く
    te(this, "correctUnuseChars", (a) => {
      var t;
      return ((t = this.option) == null ? void 0 : t.unUseChars) === void 0 ? a : a.removeChars(this.option.unUseChars);
    });
    // 文字数の補正を行います
    te(this, "correctLength", (a) => {
      var t;
      return ((t = this.option) == null ? void 0 : t.maxMultiBiteLength) === void 0 ? a : a.trimMaxLengthByMulti(this.option.maxMultiBiteLength);
    });
    this.option = a;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = this.applyOption(t), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCodeAllowNewLine();
    return t = this.applyOption(t), t;
  }
}
class Ki {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.removeNotHalfChar(), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCodeAllowNewLine();
    return t = t.removeNotHalfCharAllowNewLine(), t;
  }
}
class vo {
  constructor(a) {
    // オプション
    te(this, "option");
    // Optionを適応させる
    te(this, "applyOption", (a) => {
      let t = a;
      return t = this.correctUnuseChars(t), t = this.correctLength(t), t;
    });
    // 使用禁止文字を取り除く
    te(this, "correctUnuseChars", (a) => {
      var t;
      return ((t = this.option) == null ? void 0 : t.unUseChars) === void 0 ? a : a.removeChars(this.option.unUseChars);
    });
    // 文字数の補正を行います
    te(this, "correctLength", (a) => {
      var t;
      return ((t = this.option) == null ? void 0 : t.maxMultiBiteLength) === void 0 ? a : a.trimMaxLengthByMulti(this.option.maxMultiBiteLength);
    });
    this.option = a;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.removeNotSJIS(), t = this.applyOption(t), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    if (a == null || a.value === "")
      return "";
    let t = a.value.removeControlCodeAllowNewLine();
    return t = t.removeNotSJIS(), t = this.applyOption(t), t;
  }
}
class Xi {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.removeNotHalfNumber(), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    return "";
  }
}
class Zi {
  constructor(a) {
    te(this, "strDesignText", "");
    this.strDesignText = a;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.removeNotSJIS(), 0 < this.strDesignText.length && (t = t.designString(this.strDesignText)), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    return "";
  }
}
class Ji {
  constructor(a) {
    te(this, "strDesignText", "");
    this.strDesignText = a;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.removeNotSJIS(), 0 < this.strDesignText.length && (t = t.designReplaceString(this.strDesignText)), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    return "";
  }
}
class eu {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.removeNotHalfChar(), t = t.removeHalfSpaceChar(), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCodeAllowNewLine();
    return t = t.removeNotHalfCharAllowNewLine(), t = t.removeHalfSpaceChar(), t;
  }
}
class tu {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.replace(/[^0-9,-]/g, ""), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(a) {
    return "";
  }
}
class au {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(a) {
    if (a == null || a == null || a.value === "")
      return "";
    let t = a.value.removeControlCode();
    return t = t.removeUnUsemailAddressChar(), t;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  convertTextAreaValue(a) {
    return "";
  }
}
const nu = ["value", "placeholder"], ru = ["value", "placeholder"], lu = ["value", "placeholder"], ou = ["value", "placeholder"], su = /* @__PURE__ */ Te({
  __name: "MaskInput",
  props: {
    modelValue: { default: void 0 },
    numValue: { default: void 0 },
    convertType: {},
    nullable: { type: Boolean, default: !1 },
    spinMode: { type: Boolean, default: !1 },
    enableNewLine: { type: Boolean, default: !1 },
    disableResize: { type: Boolean, default: !1 },
    designText: { default: "" },
    placeholder: { default: void 0 },
    unUseChars: { default: void 0 },
    maxMultiBiteLength: { default: void 0 }
  },
  emits: ["update:modelValue", "update:numValue", "modifyText"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = B(""), l = B("");
    let o = new mo({ unUseChars: t.unUseChars, maxMultiBiteLength: t.maxMultiBiteLength });
    switch (t.convertType) {
      case "half-alphanumeric-symbol":
        o = new Ki(), l.value = "半角英数字記号";
        break;
      case "half-number":
        o = new Tl(), t.spinMode || (l.value = "数値");
        break;
      case "text":
        break;
      case "text-sjis":
        o = new vo({ unUseChars: t.unUseChars, maxMultiBiteLength: t.maxMultiBiteLength });
        break;
      case "text-sjis-design":
        o = new Zi(t.designText);
        break;
      case "text-sjis-design-replace":
        o = new Ji(t.designText);
        break;
      case "string-harf-number":
        o = new Xi();
        break;
      case "half-number-version":
        o = new Qi(), l.value = "文字列";
        break;
      case "half-alphanumeric-symbol-prohibit-space":
        o = new eu(), l.value = "半角英数字記号";
        break;
      case "half-number-comma-hyphen":
        o = new tu();
        break;
      case "mail-address":
        o = new au();
        break;
      case "text-half-number":
        o = new Tl(!0);
        break;
    }
    t.placeholder && (l.value = t.placeholder), et(() => t.placeholder, () => {
      l.value = t.placeholder ? t.placeholder : "";
    }), u(), uo(() => {
      u();
    });
    function i(d) {
      if (t.convertType == "half-number" && d.target instanceof HTMLInputElement && t.numValue !== void 0) {
        const f = parseInt(r.value);
        let h = r.value, b = d.target;
        const w = parseInt(b.min);
        isNaN(f) ? isNaN(w) == !1 ? (n("update:numValue", w), h = w.toString()) : t.nullable || (n("update:numValue", 0), h = "0") : isNaN(w) == !1 && w > f && (n("update:numValue", w), h = w.toString()), r.value = h;
      }
    }
    function s(d) {
      if (!(!(d.target instanceof HTMLInputElement) && !(d.target instanceof HTMLTextAreaElement))) {
        var f = new InputEvent("input");
        d.target.dispatchEvent(f);
      }
    }
    function c(d) {
      if (d instanceof InputEvent && d.inputType == "insertCompositionText")
        return;
      let f;
      if (d.target instanceof HTMLInputElement)
        f = d.target;
      else if (d.target instanceof HTMLTextAreaElement)
        f = d.target;
      else
        return;
      if (t.maxMultiBiteLength !== void 0) {
        const T = f.value, g = t.modelValue, M = T.getMultiBytesSize(), A = g.getMultiBytesSize();
        if (M > t.maxMultiBiteLength && M > A && T.length !== f.selectionEnd) {
          const P = f.selectionStart;
          f.value = g;
          const C = T.length - g.length;
          P && f.setSelectionRange(P - C, P - C);
          return;
        }
      }
      var h = f.value.length, b = f.selectionStart;
      b == null && (b = 0);
      var w = f.selectionEnd;
      w == null && (w = 0);
      let D = "";
      if (f instanceof HTMLInputElement ? D = o.convertInputValue(f) : f instanceof HTMLTextAreaElement && (D = o.convertTextAreaValue(f)), r == null && (D = ""), t.modelValue !== void 0)
        n("update:modelValue", D);
      else if (t.numValue !== void 0 && f instanceof HTMLInputElement) {
        const T = parseInt(D);
        isNaN(T) ? (n("update:numValue", null), D = "") : n("update:numValue", T);
      }
      if (f.value = D, r.value = D, !t.spinMode)
        if (r.value.length < h) {
          var $ = h - r.value.length;
          f.setSelectionRange(b - $, w - $);
        } else
          f.setSelectionRange(b, w);
      n("modifyText");
    }
    function u() {
      t.modelValue !== void 0 ? t.modelValue !== null ? r.value = t.modelValue : r.value = "" : t.numValue !== void 0 && (t.numValue !== null ? r.value = t.numValue.toString() : r.value = "");
    }
    return (d, f) => d.spinMode === !0 ? (v(), y("input", {
      key: 0,
      type: "number",
      value: m(r),
      onInput: c,
      onCompositionend: s,
      placeholder: m(l),
      autocomplete: "off",
      onBlur: i
    }, null, 40, nu)) : d.enableNewLine === !1 ? (v(), y("input", {
      key: 1,
      type: "text",
      value: m(r),
      onInput: c,
      onCompositionend: s,
      placeholder: m(l),
      autocomplete: "off",
      onBlur: i
    }, null, 40, ru)) : d.disableResize === !1 ? (v(), y("textarea", {
      key: 2,
      type: "text",
      value: m(r),
      onInput: c,
      onCompositionend: s,
      placeholder: m(l),
      autocomplete: "off"
    }, null, 40, lu)) : (v(), y("textarea", {
      key: 3,
      type: "text",
      value: m(r),
      onInput: c,
      onCompositionend: s,
      placeholder: m(l),
      autocomplete: "off",
      class: "disableResize"
    }, null, 40, ou));
  }
}), ka = /* @__PURE__ */ Ye(su, [["__scopeId", "data-v-3158d59d"]]), iu = /* @__PURE__ */ Te({
  __name: "SearchInput",
  setup(e) {
    return (a, t) => (v(), Pe(ka, {
      convertType: "text",
      class: "input-text-scv searchIcon",
      placeholder: "検索キーワードを入力"
    }));
  }
}), mb = /* @__PURE__ */ Ye(iu, [["__scopeId", "data-v-3b72a709"]]), uu = ["placeholder", "maxLength", "disabled"], cu = {
  key: 0,
  class: "combo-list"
}, du = ["onMousedown"], fu = /* @__PURE__ */ Te({
  __name: "ComboBox",
  props: {
    modelValue: { default: void 0 },
    options: {},
    convertType: {},
    placeholder: { default: void 0 },
    isError: { type: Boolean },
    inputStyles: {},
    maxLength: { default: void 0 },
    maxMultiBiteLength: { default: void 0 },
    disabled: { type: Boolean },
    unUseChars: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    function t(b, w) {
      const D = ($) => {
        !b.value || b.value.contains($.target) || w();
      };
      Xe(() => document.addEventListener("click", D)), Fs(() => document.removeEventListener("click", D));
    }
    const n = e, r = a, l = B(!1), o = B(n.modelValue), i = B(null), s = B(!1);
    t(i, () => l.value = !1), et(
      () => n.modelValue,
      (b) => o.value = b
    );
    let c = new mo({ unUseChars: n.unUseChars, maxMultiBiteLength: n.maxMultiBiteLength });
    switch (n.convertType) {
      case "text-sjis":
        c = new vo({ unUseChars: n.unUseChars, maxMultiBiteLength: n.maxMultiBiteLength });
        break;
    }
    const u = () => {
      l.value = !l.value;
    }, d = (b) => {
      o.value = b, r("update:modelValue", b), l.value = !1;
    }, f = (b) => {
      if (b instanceof InputEvent && b.inputType === "insertCompositionText")
        return;
      let w;
      if ((b.target instanceof HTMLInputElement || b.target instanceof HTMLTextAreaElement) && (w = b.target), w === void 0) return;
      if (n.maxMultiBiteLength !== void 0) {
        const M = w.value, A = n.modelValue, P = M.getMultiBytesSize(), C = A.getMultiBytesSize();
        if (P > n.maxMultiBiteLength && P > C && M.length !== w.selectionEnd) {
          const O = w.selectionStart;
          w.value = A, o.value = A;
          const R = M.length - A.length;
          O && w.setSelectionRange(O - R, O - R);
          return;
        }
      }
      const D = w.value.length, $ = w.selectionStart ?? 0, T = w.selectionEnd ?? 0;
      let g = "";
      if (w instanceof HTMLInputElement ? g = c.convertInputValue(w) : w instanceof HTMLTextAreaElement && (g = c.convertTextAreaValue(w)), w.value = g, o.value = g, r("update:modelValue", o.value), o.value.length < D) {
        const M = D - o.value.length;
        w.setSelectionRange($ - M, T - M);
      } else
        w.setSelectionRange($, T);
    };
    function h(b) {
      if (!(!(b.target instanceof HTMLInputElement) && !(b.target instanceof HTMLTextAreaElement))) {
        var w = new InputEvent("input");
        b.target.dispatchEvent(w);
      }
    }
    return (b, w) => (v(), y("div", {
      class: "combo-box",
      ref_key: "dropdown",
      ref: i
    }, [
      k("div", {
        class: pe(["combo-input-wrapper", { focused: s.value, "input-text-validation-error": n.isError }])
      }, [
        ht(k("input", {
          type: "text",
          "onUpdate:modelValue": w[0] || (w[0] = (D) => o.value = D),
          onInput: f,
          onCompositionend: h,
          placeholder: b.placeholder,
          class: pe(["input-text-scv", "combo-box-input"]),
          style: Be(n.inputStyles),
          maxLength: n.maxLength,
          autocomplete: "off",
          onFocus: w[1] || (w[1] = (D) => s.value = !0),
          onBlur: w[2] || (w[2] = (D) => s.value = !1),
          disabled: n.disabled
        }, null, 44, uu), [
          [Ln, o.value]
        ]),
        k("div", {
          class: "d-flex select-icon",
          onClick: u,
          style: { width: "22px", cursor: "pointer" }
        })
      ], 2),
      l.value && n.options.length ? (v(), y("ul", cu, [
        (v(!0), y(me, null, Me(n.options, (D, $) => (v(), y("li", {
          key: $,
          onMousedown: yt((T) => d(D), ["prevent"]),
          class: "combo-item"
        }, _e(D), 41, du))), 128))
      ])) : Y("", !0)
    ], 512));
  }
}), pu = {
  class: "select-icon",
  style: { width: "fit-content" }
}, mu = ["id"], vu = ["value"], hu = ["value"], yu = /* @__PURE__ */ Te({
  __name: "SelectBox",
  props: {
    numValue: { default: void 0 },
    options: {},
    placeholder: { default: "" },
    placeholderValue: { default: -1 },
    inputWidth: {}
  },
  emits: ["update:numValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = Ya.NewID(), l = B(t.numValue);
    et(() => t.numValue, (i) => l.value = i);
    function o(i) {
      if (i.target.value) {
        const s = Number(i.target.value);
        n("update:numValue", s);
      }
    }
    return (i, s) => (v(), y("div", pu, [
      ht(k("select", {
        class: "input-text-scv over-text",
        id: m(r),
        style: Be({ width: t.inputWidth != 0 ? t.inputWidth + "px" : "" }),
        "onUpdate:modelValue": s[0] || (s[0] = (c) => l.value = c),
        onChange: o
      }, [
        0 < t.placeholder.length ? (v(), y("option", {
          value: t.placeholderValue,
          key: t.placeholderValue,
          hidden: "",
          selected: ""
        }, _e(t.placeholder), 9, vu)) : Y("", !0),
        (v(!0), y(me, null, Me(i.options, (c) => (v(), y("option", {
          value: c.key,
          key: c.key
        }, _e(c.label), 9, hu))), 128))
      ], 44, mu), [
        [On, l.value]
      ])
    ]));
  }
}), gu = /* @__PURE__ */ Te({
  __name: "ValidatedInput",
  props: {
    type: { default: 0 },
    modelValue: {},
    numValue: { default: void 0 },
    inputType: { default: "text" },
    label: { default: "" },
    errorText: { default: () => [] },
    placeHolder: {},
    placeHolderValue: {},
    note: { default: () => [] },
    inputHeight: {},
    inputWidth: {},
    inputDesignText: {},
    maxLength: {},
    maxMultiBiteLength: {},
    labelHeight: {},
    labelWidth: {},
    labelLayout: { default: Kn.Vertical },
    reserveErrorTextArea: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    options: { default: () => [] },
    selectOptions: { default: () => [] },
    unUseChars: { default: void 0 },
    labelTextAlign: { default: "right" },
    enableNewLine: { type: Boolean, default: !1 },
    flexGrow: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:numValue"],
  setup(e, { expose: a, emit: t }) {
    nr((g) => ({
      b541ef6e: m(w) ? "56px" : "84px"
    }));
    const n = e, r = t, l = H({
      get: () => n.modelValue,
      set: (g) => r("update:modelValue", g)
    }), o = H({
      get: () => n.numValue,
      set: (g) => {
        g && r("update:numValue", g);
      }
    }), i = B(null), s = B(null), c = B({}), u = H(() => 0 < n.errorText.length), d = H(() => Tn(n.note).filter((g) => !Tn(n.errorText).includes(g))), f = H(() => Tn(n.errorText)), h = H(() => {
      const g = {};
      if (n.inputHeight && (g.height = `${n.inputHeight}px`), n.inputWidth) {
        const M = n.inputWidth - (n.type === 1 ? 24 : 0);
        g.width = `${M}px`;
      }
      return g;
    }), b = H(() => {
      const g = {
        display: "block",
        textAlign: n.labelTextAlign
      };
      return n.labelHeight && (g.height = `${n.labelHeight}px`), n.labelWidth && (g.width = `${n.labelWidth}px`), g;
    }), w = H(() => Kn.Horizontal === n.labelLayout), { watchElementVisibility: D } = co();
    Xe(() => {
      i.value && Kn.Horizontal === n.labelLayout && D(i.value, {
        onVisibled(g) {
          c.value = {
            marginLeft: `${i.value ? $(i.value) : 0}px`
          };
        },
        options: {
          immediate: !0
        }
      });
    });
    function $(g) {
      const M = g.offsetWidth, A = window.getComputedStyle(g);
      return M + parseFloat(A.marginLeft) + parseFloat(A.marginRight);
    }
    function T() {
      if (s.value) {
        const g = s.value.querySelector(n.type === 2 ? "select" : "input");
        g && g.focus();
      }
    }
    return a({
      focus: T
    }), (g, M) => (v(), y("div", {
      class: pe(["validatedInput", [g.$style.container, g.$style[n.reserveErrorTextArea ? "reserveErrorTextArea" : ""]]])
    }, [
      k("div", {
        class: pe([g.$style[m(w) ? "inputAreaHorizontal" : "inputAreaVertical"]])
      }, [
        0 < n.label.length ? (v(), y("span", {
          key: 0,
          ref_key: "labelRef",
          ref: i,
          style: Be(m(b))
        }, _e(n.label), 5)) : Y("", !0),
        k("div", {
          ref_key: "inputArea",
          ref: s,
          class: pe([g.$style.inputAreaHorizontal, n.flexGrow ? g.$style.flexGrowArea : ""])
        }, [
          g.type === 0 ? (v(), Pe(ka, {
            key: 0,
            modelValue: m(l),
            "onUpdate:modelValue": M[0] || (M[0] = (A) => ma(l) ? l.value = A : null),
            convertType: n.inputType,
            placeholder: n.placeHolder,
            class: pe(["input-text-scv", [{ "input-text-validation-error": m(u) }, n.flexGrow ? g.$style.flexGrowInput : ""]]),
            style: Be(m(h)),
            maxLength: n.maxLength,
            maxMultiBiteLength: n.maxMultiBiteLength,
            designText: n.inputDesignText,
            disabled: n.disabled,
            unUseChars: n.unUseChars,
            enableNewLine: n.enableNewLine
          }, null, 8, ["modelValue", "convertType", "placeholder", "class", "style", "maxLength", "maxMultiBiteLength", "designText", "disabled", "unUseChars", "enableNewLine"])) : Y("", !0),
          g.type === 1 ? (v(), Pe(fu, {
            key: 1,
            modelValue: m(l),
            "onUpdate:modelValue": M[1] || (M[1] = (A) => ma(l) ? l.value = A : null),
            options: n.options,
            convertType: n.inputType,
            placeholder: n.placeHolder,
            isError: m(u),
            inputStyles: m(h),
            maxLength: n.maxLength,
            maxMultiBiteLength: n.maxMultiBiteLength,
            disabled: n.disabled,
            unUseChars: n.unUseChars
          }, null, 8, ["modelValue", "options", "convertType", "placeholder", "isError", "inputStyles", "maxLength", "maxMultiBiteLength", "disabled", "unUseChars"])) : Y("", !0),
          g.type === 2 ? (v(), Pe(yu, {
            key: 2,
            numValue: m(o),
            "onUpdate:numValue": M[2] || (M[2] = (A) => ma(o) ? o.value = A : null),
            options: n.selectOptions,
            placeholder: n.placeHolder,
            placeholderValue: n.placeHolderValue,
            isError: m(u),
            inputWidth: n.inputWidth
          }, null, 8, ["numValue", "options", "placeholder", "placeholderValue", "isError", "inputWidth"])) : Y("", !0),
          ie(g.$slots, "tail")
        ], 2)
      ], 2),
      ie(g.$slots, "input-under"),
      0 < m(d).length ? (v(), y("div", {
        key: 0,
        class: pe(["input-text-annotation", g.$style.errorTextArea]),
        style: Be(m(c))
      }, [
        (v(!0), y(me, null, Me(m(d), (A, P) => (v(), y("span", { key: P }, _e(A), 1))), 128))
      ], 6)) : Y("", !0),
      0 < m(f).length ? (v(), y("div", {
        key: 1,
        class: pe(["input-text-validation-error-message", g.$style.errorTextArea]),
        style: Be(m(c))
      }, [
        (v(!0), y(me, null, Me(m(f), (A, P) => (v(), y("span", { key: P }, _e(A), 1))), 128))
      ], 6)) : Y("", !0)
    ], 2));
  }
}), bu = "_container_1smca_5", wu = "_reserveErrorTextArea_1smca_17", _u = "_inputAreaHorizontal_1smca_27", ku = "_inputAreaVertical_1smca_49", xu = "_errorTextArea_1smca_71", Cu = "_flexGrowArea_1smca_89", Du = "_flexGrowInput_1smca_101", Tu = {
  container: bu,
  reserveErrorTextArea: wu,
  inputAreaHorizontal: _u,
  inputAreaVertical: ku,
  errorTextArea: xu,
  flexGrowArea: Cu,
  flexGrowInput: Du
}, Iu = {
  $style: Tu
}, vb = /* @__PURE__ */ Ye(gu, [["__cssModules", Iu]]), Mu = ["id", "accept"], Su = ["disabled"], hb = /* @__PURE__ */ Te({
  __name: "SelectFileInput",
  props: {
    modelValue: { type: File, default: void 0 },
    // File情報を受け取る変数。「v-model」で指定する
    id: { type: String, default: "SelectFileUtilDF" },
    // 同一Vue内で一意となるように指定する
    textCaption: { type: String, default: "" },
    // ファイルパス入力エリアのキャプション
    selectedTextCaption: { type: String, default: "" },
    // 選択されている時のファイルパス入力エリアのキャプション
    btnCaption: { type: String, default: "参照" },
    // ボタンのキャプション
    accept: { type: String, default: void 0 },
    // ファイル選択ダイアログで指定するファイル拡張子の初期状態
    widthEdit: { type: Number, default: 0 },
    // エディットボックスの幅（0ならflex-grow-1）
    sjisOnlyName: { type: Boolean, default: !1 },
    // sjis範囲内の参照か
    disabled: { type: Boolean, default: !1 }
    // Disabled指定
  },
  emits: ["update:modelValue", "modifyFile"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = B("");
    Vs(() => {
      t.modelValue == null ? r.value = "" : t.selectedTextCaption.length === 0 ? r.value = t.modelValue.name : r.value = t.selectedTextCaption;
    });
    const l = () => {
      const i = document.getElementById(t.id);
      i != null && i != null && (i.value = ""), Oa("#" + t.id).click();
    }, o = (i) => {
      i.preventDefault();
      let s = i.target.files;
      if (s[0] != null && s[0] != null) {
        if (t.sjisOnlyName && s[0].name.includeNotSJIS()) {
          i.stopPropagation(), alert(`指定したファイルは使用できません。\r
ファイル名に使用できない文字が含まれています。`);
          return;
        }
        n("update:modelValue", s[0]), n("modifyFile", s[0]);
      }
    };
    return (i, s) => (v(), y(me, null, [
      k("input", {
        style: { display: "none" },
        id: e.id,
        type: "file",
        accept: e.accept,
        onChange: o
      }, null, 40, Mu),
      k("div", {
        class: pe(["d-flex align-items-center", [e.widthEdit === 0 ? "flex-grow-1" : ""]])
      }, [
        ht(k("input", {
          type: "text",
          class: pe(["input-text-scv", [e.widthEdit === 0 ? "d-flex flex-grow-1" : ""]]),
          "onUpdate:modelValue": s[0] || (s[0] = (c) => r.value = c),
          style: Be([{ width: e.widthEdit != 0 ? e.widthEdit + "px" : "" }, { "margin-right": "8px" }]),
          disabled: ""
        }, null, 6), [
          [Ln, r.value]
        ]),
        k("button", {
          type: "button",
          class: "btn-scv-bgcolor btn-setting-size",
          style: { width: "64px", height: "32px" },
          onClick: l,
          disabled: e.disabled
        }, _e(e.btnCaption), 9, Su)
      ], 2)
    ], 64));
  }
});
class $u {
  /**
   * StandardIPHandlerのコンストラクタ
   * @param octets - IPv4アドレスのオクテット配列のリアクティブ参照
   */
  constructor(a) {
    /** IPv4アドレスの各オクテット値を格納するリアクティブ配列 */
    te(this, "octets");
    this.octets = a;
  }
  /**
   * 入力フィールドの配列を取得
   * @returns 4つのオクテット用入力フィールドの配列
   */
  getInputFields() {
    return this.octets.value.map((a, t) => ({
      value: H({
        get: () => this.octets.value[t],
        set: (n) => this.octets.value[t] = n
      }),
      maxLength: 3,
      placeholder: "",
      separator: t < 3 ? "." : void 0,
      validator: this.isValidOctet
    }));
  }
  /**
   * IPv4アドレス全体の妥当性をチェック
   * @returns 全てのオクテットが有効な場合true
   */
  isValid() {
    return this.octets.value.every((a) => a !== "" && this.isValidOctet(a));
  }
  /**
   * フォーマットされたIPアドレス文字列を取得
   * @returns ドット区切りのIPアドレス文字列（例：192.168.1.1）、全て空の場合は空文字列
   */
  getFormattedValue() {
    return this.octets.value.every((a) => a === "") ? "" : this.octets.value.join(".");
  }
  /**
   * 文字列からIPアドレスを解析して内部状態に設定
   * @param value - 解析対象のIPアドレス文字列
   */
  parseAndSetValue(a) {
    const t = a.split(".");
    t.length === 4 ? this.octets.value = t : this.octets.value.forEach((n) => "");
  }
  /**
   * 入力フィールドの値変更を処理
   * @param fieldIndex - 変更されたフィールドのインデックス（0-3）
   * @param event - 入力イベント
   */
  handleInput(a, t) {
    const n = t.target;
    let r = n.value.replace(/[^0-9]/g, "");
    parseInt(r) > 255 && (r = "255", n.value = r), this.octets.value[a] = r;
  }
  /**
   * キーボード入力を処理してフィールド間のナビゲーションを制御
   * @param fieldIndex - 現在のフィールドインデックス（0-3）
   * @param event - キーボードイベント
   * @param focusInput - フォーカス移動用のコールバック関数
   */
  handleKeydown(a, t, n) {
    const r = t.target, l = r.selectionStart || 0, o = r.value;
    t.key === "ArrowLeft" && l === 0 && a > 0 ? (t.preventDefault(), n(a - 1, "end")) : t.key === "ArrowRight" && l === o.length && a < 3 ? (t.preventDefault(), n(a + 1, "start")) : t.key === "Backspace" && r.value === "" && a > 0 ? n(a - 1) : t.key === "." && a < 3 && (t.preventDefault(), n(a + 1));
  }
  /**
   * ペーストされたテキストを処理してIPアドレスを設定
   * @param pastedText - ペーストされたテキスト
   * @returns 正常に処理された場合true
   */
  handlePaste(a) {
    const t = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, n = a.trim().match(t);
    if (n) {
      const r = n.slice(1, 5);
      if (r.every((l) => {
        const o = parseInt(l, 10);
        return o >= 0 && o <= 255;
      }))
        return this.octets.value = r, !0;
    }
    return !1;
  }
  /**
   * 最大フィールドインデックスを取得
   * @returns 標準IPv4の場合は3（0-3の4フィールド）
   */
  getMaxFieldIndex() {
    return 3;
  }
  /**
   * 単一のオクテット値が有効かどうかをチェック
   * @param value - チェック対象の文字列
   * @returns 0-255の範囲内で有効な数値の場合true
   */
  isValidOctet(a) {
    const t = parseInt(a, 10);
    return !isNaN(t) && t >= 0 && t <= 255 && a === t.toString();
  }
}
class Pu {
  /**
   * CidrIpHandlerのコンストラクタ
   * @param octets - IPv4アドレスのオクテット配列のリアクティブ参照
   * @param cidrPrefix - CIDR接頭辞長のリアクティブ参照
   */
  constructor(a, t) {
    /** IPv4アドレスの各オクテット値を格納するリアクティブ配列 */
    te(this, "octets");
    /** CIDR接頭辞長を格納するリアクティブ変数 */
    te(this, "cidrPrefix");
    this.octets = a, this.cidrPrefix = t;
  }
  /**
   * 入力フィールドの配列を取得
   * @returns 4つのオクテット用フィールド + 1つのCIDR接頭辞用フィールドの配列
   */
  getInputFields() {
    const a = this.octets.value.map((n, r) => ({
      value: H({
        get: () => this.octets.value[r],
        set: (l) => this.octets.value[r] = l
      }),
      maxLength: 3,
      placeholder: "",
      separator: r < 3 ? "." : "/",
      validator: this.isValidOctet
    })), t = {
      value: H({
        get: () => this.cidrPrefix.value,
        set: (n) => this.cidrPrefix.value = n
      }),
      maxLength: 2,
      placeholder: "",
      validator: this.isValidCidrPrefix
    };
    return [...a, t];
  }
  /**
   * CIDR形式のIPアドレス全体の妥当性をチェック
   * @returns 全てのオクテットとCIDR接頭辞が有効な場合true
   */
  isValid() {
    return this.octets.value.every((t) => t !== "" && this.isValidOctet(t)) && this.cidrPrefix.value !== "" && this.isValidCidrPrefix(this.cidrPrefix.value);
  }
  /**
   * フォーマットされたCIDR形式のIPアドレス文字列を取得
   * @returns CIDR表記のIPアドレス文字列（例：192.168.1.0/24）、全て空の場合は空文字列
   */
  getFormattedValue() {
    if (this.octets.value.every((t) => t === ""))
      return "";
    const a = this.octets.value.join(".");
    return this.cidrPrefix.value !== "" ? `${a}/${this.cidrPrefix.value}` : a;
  }
  /**
   * 文字列からCIDR形式のIPアドレスを解析して内部状態に設定
   * @param value - 解析対象のIPアドレス文字列（CIDR形式または通常形式）
   */
  parseAndSetValue(a) {
    if (a.includes("/")) {
      const [t, n] = a.split("/"), r = t.split(".");
      r.length === 4 && (this.octets.value = r, this.cidrPrefix.value = n || "");
    } else {
      const t = a.split(".");
      t.length === 4 && (this.octets.value = t, this.cidrPrefix.value = "");
    }
  }
  /**
   * 入力フィールドの値変更を処理（オクテットまたはCIDR接頭辞）
   * @param fieldIndex - 変更されたフィールドのインデックス（0-3: オクテット, 4: CIDR接頭辞）
   * @param event - 入力イベント
   */
  handleInput(a, t) {
    const n = t.target;
    if (a === 4) {
      let r = n.value.replace(/[^0-9]/g, "");
      parseInt(r) > 32 && (r = "32", n.value = r), this.cidrPrefix.value = r;
    } else {
      let r = n.value.replace(/[^0-9]/g, "");
      parseInt(r) > 255 && (r = "255", n.value = r), this.octets.value[a] = r;
    }
  }
  /**
   * キーボード入力を処理してフィールド間のナビゲーションを制御（CIDR対応）
   * @param fieldIndex - 現在のフィールドインデックス（0-4）
   * @param event - キーボードイベント
   * @param focusInput - フォーカス移動用のコールバック関数
   */
  handleKeydown(a, t, n) {
    const r = t.target, l = r.selectionStart || 0, o = r.value;
    t.key === "ArrowLeft" && l === 0 && a > 0 ? (t.preventDefault(), n(a - 1, "end")) : t.key === "ArrowRight" && l === o.length && a < 4 ? (t.preventDefault(), n(a + 1, "start")) : t.key === "Backspace" && r.value === "" && a > 0 ? n(a - 1) : t.key === "." && a < 3 ? (t.preventDefault(), n(a + 1)) : t.key === "/" && a === 3 && (t.preventDefault(), n(4));
  }
  /**
   * ペーストされたテキストを処理してCIDR形式のIPアドレスを設定
   * @param pastedText - ペーストされたテキスト
   * @returns 正常に処理された場合true
   */
  handlePaste(a) {
    if (a.includes("/")) {
      const t = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\/(\d{1,2})$/, n = a.trim().match(t);
      if (n) {
        const r = n.slice(1, 5), l = n[5];
        if (r.every((o) => {
          const i = parseInt(o, 10);
          return i >= 0 && i <= 255;
        }) && parseInt(l, 10) >= 0 && parseInt(l, 10) <= 32)
          return this.octets.value = r, this.cidrPrefix.value = l, !0;
      }
    } else {
      const t = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, n = a.trim().match(t);
      if (n) {
        const r = n.slice(1, 5);
        if (r.every((l) => {
          const o = parseInt(l, 10);
          return o >= 0 && o <= 255;
        }))
          return this.octets.value = r, this.cidrPrefix.value = "", !0;
      }
    }
    return !1;
  }
  /**
   * 最大フィールドインデックスを取得
   * @returns CIDR形式の場合は4（0-4の5フィールド）
   */
  getMaxFieldIndex() {
    return 4;
  }
  /**
   * 単一のオクテット値が有効かどうかをチェック
   * @param value - チェック対象の文字列
   * @returns 0-255の範囲内で有効な数値の場合true
   */
  isValidOctet(a) {
    const t = parseInt(a, 10);
    return !isNaN(t) && t >= 0 && t <= 255 && a === t.toString();
  }
  /**
   * CIDR接頭辞長が有効かどうかをチェック
   * @param value - チェック対象の文字列
   * @returns 0-32の範囲内で有効な数値の場合true
   */
  isValidCidrPrefix(a) {
    const t = parseInt(a, 10);
    return !isNaN(t) && t >= 0 && t <= 32 && a === t.toString();
  }
}
function Au(e) {
  const a = B(["", "", "", ""]), t = B(""), n = H(() => e.value ? new Pu(a, t) : new $u(a)), r = H(() => n.value.getInputFields()), l = H(() => n.value.isValid()), o = H(() => n.value.getFormattedValue()), i = H(() => n.value.getMaxFieldIndex());
  function s(b) {
    n.value.parseAndSetValue(b);
  }
  function c(b, w) {
    n.value.handleInput(b, w);
  }
  function u(b, w, D) {
    n.value.handleKeydown(b, w, D);
  }
  function d(b) {
    return n.value.handlePaste(b);
  }
  function f(b) {
    const w = r.value[b];
    return !w || w.value.value === "" ? "" : w.validator(w.value.value) ? "valid" : "invalid";
  }
  function h() {
    a.value = ["", "", "", ""], t.value = "";
  }
  return {
    inputFields: r,
    isValid: l,
    formattedValue: o,
    maxFieldIndex: i,
    setValue: s,
    handleInput: c,
    handleKeydown: u,
    handlePaste: d,
    getFieldClass: f,
    clear: h,
    // 内部状態の公開（必要に応じて）
    octets: a,
    cidrPrefix: t
  };
}
const Ou = { class: "ipv4-input-container" }, Ru = ["onUpdate:modelValue", "maxlength", "disabled", "readonly", "onInput", "onKeydown", "placeholder"], Eu = {
  key: 0,
  class: "separator"
}, Nu = {
  key: 0,
  class: "action-buttons"
}, Bu = ["disabled"], Lu = ["disabled"], Fu = /* @__PURE__ */ Te({
  __name: "IPv4Input",
  props: {
    modelValue: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    showCopyPaste: { type: Boolean, default: !1 },
    enableCidr: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t, l = B();
    function o(S) {
      const X = S.closest(".ipv4-input");
      return X == null ? void 0 : X.querySelectorAll("input");
    }
    function i(S, X, re, fe) {
      const I = o(S), V = fe || 3;
      if (I && I[X] && X <= V) {
        const E = I[X];
        E.focus(), re === "start" ? E.setSelectionRange(0, 0) : re === "end" && E.setSelectionRange(E.value.length, E.value.length);
      }
    }
    const s = tn(n, "enableCidr"), {
      inputFields: c,
      isValid: u,
      formattedValue: d,
      maxFieldIndex: f,
      setValue: h,
      handleInput: b,
      handleKeydown: w,
      handlePaste: D,
      getFieldClass: $,
      clear: T
    } = Au(s);
    et(() => n.modelValue, (S) => {
      S && S !== d.value && h(S);
    }, { immediate: !0 }), et(d, (S) => {
      r("update:modelValue", S);
    });
    function g(S, X) {
      b(S, X);
    }
    function M(S, X) {
      const re = X.target;
      if (X.ctrlKey && X.key === "c" && u.value) {
        X.preventDefault(), A();
        return;
      }
      w(S, X, (I, V) => {
        i(re, I, V, f.value);
      });
    }
    async function A() {
      if (u.value)
        try {
          await navigator.clipboard.writeText(d.value);
        } catch (S) {
          console.warn("クリップボードへのコピーに失敗しました:", S);
        }
    }
    async function P() {
      if (!(n.disabled || n.readonly))
        try {
          const S = await navigator.clipboard.readText();
          D(S);
        } catch {
        }
    }
    function C(S) {
      var re;
      if (n.disabled || n.readonly) return;
      const X = (re = S.clipboardData) == null ? void 0 : re.getData("text");
      X && D(X) && S.preventDefault();
    }
    function O(S) {
      S.preventDefault(), S.dataTransfer && (S.dataTransfer.dropEffect = "none");
    }
    function R() {
      var X;
      const S = (X = l.value) == null ? void 0 : X.querySelector("input");
      S && S.focus();
    }
    return a({
      focus: R,
      clear: T
    }), (S, X) => (v(), y("div", Ou, [
      k("div", {
        ref_key: "containerRef",
        ref: l,
        class: pe(["ipv4-input input-text-scv", { disabled: S.disabled, readonly: S.readonly, "input-text-validation-error": S.error }]),
        onPaste: C
      }, [
        (v(!0), y(me, null, Me(m(c), (re, fe) => (v(), y(me, { key: fe }, [
          k("div", {
            class: pe(fe === m(c).length - 1 && S.enableCidr ? "cidr-group" : "octet-group")
          }, [
            ht(k("input", {
              "onUpdate:modelValue": (I) => re.value.value = I,
              type: "text",
              maxlength: re.maxLength,
              class: pe(m($)(fe)),
              disabled: S.disabled,
              readonly: S.readonly,
              onInput: (I) => g(fe, I),
              onKeydown: (I) => M(fe, I),
              onDrop: X[0] || (X[0] = yt(() => {
              }, ["prevent"])),
              onDragover: O,
              onDragenter: O,
              placeholder: re.placeholder
            }, null, 42, Ru), [
              [Ln, re.value.value]
            ])
          ], 2),
          re.separator ? (v(), y("span", Eu, _e(re.separator), 1)) : Y("", !0)
        ], 64))), 128))
      ], 34),
      S.showCopyPaste ? (v(), y("div", Nu, [
        k("button", {
          type: "button",
          class: "action-btn copy-btn",
          disabled: !m(u) || S.disabled,
          onClick: A,
          title: "IPアドレスをコピー"
        }, " 📋 ", 8, Bu),
        k("button", {
          type: "button",
          class: "action-btn paste-btn",
          disabled: S.disabled || S.readonly,
          onClick: P,
          title: "IPアドレスをペースト"
        }, " 📄 ", 8, Lu)
      ])) : Y("", !0)
    ]));
  }
}), yb = /* @__PURE__ */ Ye(Fu, [["__scopeId", "data-v-816ce08d"]]);
function Vu() {
  const e = Array.from({ length: 6 }, (s, c) => ({
    value: B(""),
    maxLength: 2,
    separator: c < 5 ? "-" : void 0,
    placeholder: ""
  })), a = H(() => {
    const s = e.every((u) => u.value.value.length === 2), c = e.every(
      (u) => /^[0-9A-Fa-f]{2}$/.test(u.value.value)
    );
    return s && c;
  }), t = H(() => e.every((s) => s.value.value === "") ? "" : e.map((s) => s.value.value.toUpperCase()).join("-"));
  function n(s) {
    const c = /^([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})$/, u = s.match(c);
    if (u)
      for (let d = 0; d < 6; d++)
        e[d].value.value = u[d + 1].toUpperCase();
    else
      e.forEach((d) => d.value.value = "");
  }
  function r(s, c) {
    const u = c.target;
    let d = u.value.toUpperCase();
    d = d.replace(/[^0-9A-F]/g, ""), d.length > 2 && (d = d.slice(0, 2)), e[s].value.value = d, u.value = d;
  }
  function l(s, c, u) {
    const d = c.target, f = d.selectionStart || 0, h = d.value;
    switch (c.key) {
      case "ArrowRight":
        f === h.length && s < 5 && (c.preventDefault(), u(s + 1, "start"));
        break;
      case "ArrowLeft":
        f === 0 && s > 0 && (c.preventDefault(), u(s - 1, "end"));
        break;
      case "Backspace":
        f === 0 && h === "" && s > 0 && (c.preventDefault(), u(s - 1, "end"));
        break;
      case "Delete":
        f === h.length && s < 5 && e[s + 1].value.value === "" && (c.preventDefault(), u(s + 1, "start"));
        break;
      case ":":
      case "-":
        c.preventDefault(), s < 5 && u(s + 1, "start");
        break;
    }
  }
  function o(s) {
    const c = /^([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})[:-]([0-9A-Fa-f]{2})$/;
    return s.trim().match(c) ? (n(s.trim()), !0) : !1;
  }
  function i() {
    e.forEach((s) => s.value.value = "");
  }
  return {
    inputFields: e,
    isValid: a,
    formattedValue: t,
    setValue: n,
    handleInput: r,
    handleKeydown: l,
    handlePaste: o,
    clear: i
  };
}
const Hu = { class: "mac-address-input-container" }, Yu = { class: "octet-group" }, Wu = ["onUpdate:modelValue", "maxlength", "disabled", "readonly", "onInput", "onKeydown", "placeholder"], Uu = {
  key: 0,
  class: "separator"
}, zu = {
  key: 0,
  class: "action-buttons"
}, qu = ["disabled"], ju = ["disabled"], Gu = /* @__PURE__ */ Te({
  __name: "MACAddressInput",
  props: {
    modelValue: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    showCopyPaste: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t;
    function l(C) {
      const O = C.closest(".mac-address-input");
      return O == null ? void 0 : O.querySelectorAll("input");
    }
    function o(C, O, R) {
      const S = l(C);
      if (S && S[O] && O <= 5) {
        const X = S[O];
        X.focus(), R === "start" ? X.setSelectionRange(0, 0) : R === "end" && X.setSelectionRange(X.value.length, X.value.length);
      }
    }
    const i = B(), {
      inputFields: s,
      isValid: c,
      formattedValue: u,
      setValue: d,
      handleInput: f,
      handleKeydown: h,
      handlePaste: b,
      clear: w
    } = Vu();
    et(() => n.modelValue, (C) => {
      C && C !== u.value && d(C);
    }, { immediate: !0 }), et(u, (C) => {
      r("update:modelValue", C);
    });
    function D(C, O) {
      f(C, O);
    }
    function $(C, O) {
      const R = O.target;
      if (O.ctrlKey && O.key === "c" && c.value) {
        O.preventDefault(), T();
        return;
      }
      h(C, O, (X, re) => {
        o(R, X, re);
      });
    }
    async function T() {
      if (c.value)
        try {
          await navigator.clipboard.writeText(u.value);
        } catch (C) {
          console.warn("クリップボードへのコピーに失敗しました:", C);
        }
    }
    async function g() {
      if (!(n.disabled || n.readonly))
        try {
          const C = await navigator.clipboard.readText();
          b(C);
        } catch {
        }
    }
    function M(C) {
      var R;
      if (n.disabled || n.readonly) return;
      const O = (R = C.clipboardData) == null ? void 0 : R.getData("text");
      O && b(O) && C.preventDefault();
    }
    function A(C) {
      C.preventDefault(), C.dataTransfer && (C.dataTransfer.dropEffect = "none");
    }
    function P() {
      var O;
      const C = (O = i.value) == null ? void 0 : O.querySelector("input");
      C && C.focus();
    }
    return a({
      focus: P,
      clear: w
    }), (C, O) => (v(), y("div", Hu, [
      k("div", {
        ref_key: "containerRef",
        ref: i,
        class: pe(["mac-address-input input-text-scv", { disabled: C.disabled, readonly: C.readonly, "input-text-validation-error": C.error }]),
        onPaste: M
      }, [
        (v(!0), y(me, null, Me(m(s), (R, S) => (v(), y(me, { key: S }, [
          k("div", Yu, [
            ht(k("input", {
              "onUpdate:modelValue": (X) => R.value.value = X,
              type: "text",
              maxlength: R.maxLength,
              disabled: C.disabled,
              readonly: C.readonly,
              onInput: (X) => D(S, X),
              onKeydown: (X) => $(S, X),
              onDrop: O[0] || (O[0] = yt(() => {
              }, ["prevent"])),
              onDragover: A,
              onDragenter: A,
              placeholder: R.placeholder
            }, null, 40, Wu), [
              [Ln, R.value.value]
            ])
          ]),
          R.separator ? (v(), y("span", Uu, _e(R.separator), 1)) : Y("", !0)
        ], 64))), 128))
      ], 34),
      C.showCopyPaste ? (v(), y("div", zu, [
        k("button", {
          type: "button",
          class: "action-btn copy-btn",
          disabled: !m(c) || C.disabled,
          onClick: T,
          title: "MACアドレスをコピー"
        }, " 📋 ", 8, qu),
        k("button", {
          type: "button",
          class: "action-btn paste-btn",
          disabled: C.disabled || C.readonly,
          onClick: g,
          title: "MACアドレスをペースト"
        }, " 📄 ", 8, ju)
      ])) : Y("", !0)
    ]));
  }
}), gb = /* @__PURE__ */ Ye(Gu, [["__scopeId", "data-v-37a6351d"]]), Qu = {
  key: 0,
  class: "required-mark"
}, Ku = { class: "component-content" }, Xu = { class: "slot-label-container" }, Zu = {
  key: 0,
  class: "required-mark"
}, Ju = { class: "messages-container" }, ec = /* @__PURE__ */ Te({
  __name: "LabeledComponent",
  props: {
    label: { default: "" },
    required: { type: Boolean, default: !1 },
    description: { default: "" },
    error: { default: "" },
    disabled: { type: Boolean, default: !1 },
    labelPosition: { default: "top" },
    labelWidth: { default: "120px" },
    labelAlign: { default: "left" },
    reservedErrorArea: { type: Boolean, default: !0 }
  },
  setup(e) {
    nr((u) => ({
      "7a5f442c": u.labelWidth
    }));
    const a = e, t = Ya.NewID(), n = `label-${t}`, r = `desc-${t}`, l = `error-${t}`, o = B(), i = B(), s = B("0px"), c = async () => {
      if (a.labelPosition === "top" || !o.value || !i.value) {
        s.value = "0px";
        return;
      }
      await mt();
      const u = o.value.offsetHeight, d = i.value.offsetHeight, f = Math.max(0, (u - d) / 2);
      s.value = `${f}px`;
    };
    return Xe(() => {
      c(), o.value && window.ResizeObserver && new ResizeObserver(() => {
        c();
      }).observe(o.value);
    }), (u, d) => (v(), y("div", {
      class: pe(["labeled-component", [
        `label-${u.labelPosition}`,
        { disabled: u.disabled, "has-error": u.error }
      ]])
    }, [
      u.label && u.labelPosition === "top" ? (v(), y("label", {
        key: 0,
        id: n,
        class: "component-label"
      }, [
        Je(_e(u.label) + " ", 1),
        u.required ? (v(), y("span", Qu, "*")) : Y("", !0)
      ])) : Y("", !0),
      k("div", Ku, [
        k("div", Xu, [
          u.label && u.labelPosition !== "top" ? (v(), y("label", {
            key: 0,
            ref_key: "labelRef",
            ref: i,
            id: n,
            class: "component-label horizontal-label",
            style: Be({
              width: u.labelWidth,
              marginTop: m(s),
              textAlign: u.labelAlign
            })
          }, [
            Je(_e(u.label) + " ", 1),
            u.required ? (v(), y("span", Zu, "*")) : Y("", !0)
          ], 4)) : Y("", !0),
          k("div", {
            ref_key: "slotRef",
            ref: o,
            class: "component-slot-only"
          }, [
            ie(u.$slots, "default", {
              labelId: n,
              descriptionId: u.description ? r : void 0,
              errorId: u.error ? l : void 0
            }, void 0, !0)
          ], 512)
        ]),
        k("div", Ju, [
          u.description ? (v(), y("div", {
            key: 0,
            id: r,
            class: "input-text-annotation"
          }, _e(u.description), 1)) : Y("", !0),
          u.error || u.reservedErrorArea ? (v(), y("div", {
            key: 1,
            id: l,
            class: pe(["error-message input-text-validation-error-message", [{ "reserved-error-area": u.reservedErrorArea }]]),
            role: "alert",
            "aria-live": "polite"
          }, _e(u.error), 3)) : Y("", !0)
        ])
      ])
    ], 2));
  }
}), bb = /* @__PURE__ */ Ye(ec, [["__scopeId", "data-v-9dfe9f8e"]]);
class wb {
  /// <summary>
  /// コンストラクタ
  /// </summary>
  constructor(a = 0, t = "", n = 0, r = void 0, l = void 0, o = void 0) {
    // カラムID
    te(this, "columnID", 0);
    // テキスト
    te(this, "text", "");
    // データタイプ
    te(this, "dataType", 0);
    // カラム幅
    te(this, "columnWidth");
    // カラム幅の最大幅
    te(this, "columnMaxWidth");
    // カラム幅の最小値
    te(this, "columnMinWidth");
    this.columnID = a, this.text = t, this.dataType = n, this.columnWidth = r, this.columnMaxWidth = l, this.columnMinWidth = o;
  }
}
class Zn {
  constructor() {
    /// <summary>
    /// カラム幅
    /// </summary>
    te(this, "columnWidth");
    /// <summary>
    /// 最小のカラム幅
    /// </summary>
    te(this, "columnMinWidth");
    /// <summary>
    /// 最大のカラム幅
    /// </summary>
    te(this, "columnMaxWidth");
  }
}
var ze = /* @__PURE__ */ ((e) => (e[e.string = 1] = "string", e[e.number = 2] = "number", e[e.icon = 4] = "icon", e[e.link = 8] = "link", e[e.icon_s = 16] = "icon_s", e[e.no_sort = 32] = "no_sort", e[e.html_column = 64] = "html_column", e[e.check_column = 128] = "check_column", e[e.file_size = 256] = "file_size", e[e.external_sort = 512] = "external_sort", e[e.ipv4_address = 1024] = "ipv4_address", e[e.force_click_event = 2048] = "force_click_event", e))(ze || {}), ho = { exports: {} }, At = "top", Ht = "bottom", Yt = "right", Ot = "left", rr = "auto", hn = [At, Ht, Yt, Ot], Ba = "start", an = "end", yo = "clippingParents", Yr = "viewport", Ka = "popper", go = "reference", $r = /* @__PURE__ */ hn.reduce(function(e, a) {
  return e.concat([a + "-" + Ba, a + "-" + an]);
}, []), Wr = /* @__PURE__ */ [].concat(hn, [rr]).reduce(function(e, a) {
  return e.concat([a, a + "-" + Ba, a + "-" + an]);
}, []), bo = "beforeRead", wo = "read", _o = "afterRead", ko = "beforeMain", xo = "main", Co = "afterMain", Do = "beforeWrite", To = "write", Io = "afterWrite", Mo = [bo, wo, _o, ko, xo, Co, Do, To, Io];
function ua(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Wt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var a = e.ownerDocument;
    return a && a.defaultView || window;
  }
  return e;
}
function La(e) {
  var a = Wt(e).Element;
  return e instanceof a || e instanceof Element;
}
function qt(e) {
  var a = Wt(e).HTMLElement;
  return e instanceof a || e instanceof HTMLElement;
}
function Ur(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var a = Wt(e).ShadowRoot;
  return e instanceof a || e instanceof ShadowRoot;
}
function tc(e) {
  var a = e.state;
  Object.keys(a.elements).forEach(function(t) {
    var n = a.styles[t] || {}, r = a.attributes[t] || {}, l = a.elements[t];
    !qt(l) || !ua(l) || (Object.assign(l.style, n), Object.keys(r).forEach(function(o) {
      var i = r[o];
      i === !1 ? l.removeAttribute(o) : l.setAttribute(o, i === !0 ? "" : i);
    }));
  });
}
function ac(e) {
  var a = e.state, t = {
    popper: {
      position: a.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(a.elements.popper.style, t.popper), a.styles = t, a.elements.arrow && Object.assign(a.elements.arrow.style, t.arrow), function() {
    Object.keys(a.elements).forEach(function(n) {
      var r = a.elements[n], l = a.attributes[n] || {}, o = Object.keys(a.styles.hasOwnProperty(n) ? a.styles[n] : t[n]), i = o.reduce(function(s, c) {
        return s[c] = "", s;
      }, {});
      !qt(r) || !ua(r) || (Object.assign(r.style, i), Object.keys(l).forEach(function(s) {
        r.removeAttribute(s);
      }));
    });
  };
}
const zr = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: tc,
  effect: ac,
  requires: ["computeStyles"]
};
function sa(e) {
  return e.split("-")[0];
}
var Ra = Math.max, Jn = Math.min, nn = Math.round;
function Pr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(a) {
    return a.brand + "/" + a.version;
  }).join(" ") : navigator.userAgent;
}
function So() {
  return !/^((?!chrome|android).)*safari/i.test(Pr());
}
function rn(e, a, t) {
  a === void 0 && (a = !1), t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), r = 1, l = 1;
  a && qt(e) && (r = e.offsetWidth > 0 && nn(n.width) / e.offsetWidth || 1, l = e.offsetHeight > 0 && nn(n.height) / e.offsetHeight || 1);
  var o = La(e) ? Wt(e) : window, i = o.visualViewport, s = !So() && t, c = (n.left + (s && i ? i.offsetLeft : 0)) / r, u = (n.top + (s && i ? i.offsetTop : 0)) / l, d = n.width / r, f = n.height / l;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function qr(e) {
  var a = rn(e), t = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(a.width - t) <= 1 && (t = a.width), Math.abs(a.height - n) <= 1 && (n = a.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: n
  };
}
function $o(e, a) {
  var t = a.getRootNode && a.getRootNode();
  if (e.contains(a))
    return !0;
  if (t && Ur(t)) {
    var n = a;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function ha(e) {
  return Wt(e).getComputedStyle(e);
}
function nc(e) {
  return ["table", "td", "th"].indexOf(ua(e)) >= 0;
}
function Ta(e) {
  return ((La(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function lr(e) {
  return ua(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ur(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ta(e)
  );
}
function Il(e) {
  return !qt(e) || // https://github.com/popperjs/popper-core/issues/837
  ha(e).position === "fixed" ? null : e.offsetParent;
}
function rc(e) {
  var a = /firefox/i.test(Pr()), t = /Trident/i.test(Pr());
  if (t && qt(e)) {
    var n = ha(e);
    if (n.position === "fixed")
      return null;
  }
  var r = lr(e);
  for (Ur(r) && (r = r.host); qt(r) && ["html", "body"].indexOf(ua(r)) < 0; ) {
    var l = ha(r);
    if (l.transform !== "none" || l.perspective !== "none" || l.contain === "paint" || ["transform", "perspective"].indexOf(l.willChange) !== -1 || a && l.willChange === "filter" || a && l.filter && l.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Fn(e) {
  for (var a = Wt(e), t = Il(e); t && nc(t) && ha(t).position === "static"; )
    t = Il(t);
  return t && (ua(t) === "html" || ua(t) === "body" && ha(t).position === "static") ? a : t || rc(e) || a;
}
function jr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Mn(e, a, t) {
  return Ra(e, Jn(a, t));
}
function lc(e, a, t) {
  var n = Mn(e, a, t);
  return n > t ? t : n;
}
function Po() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ao(e) {
  return Object.assign({}, Po(), e);
}
function Oo(e, a) {
  return a.reduce(function(t, n) {
    return t[n] = e, t;
  }, {});
}
var oc = function(a, t) {
  return a = typeof a == "function" ? a(Object.assign({}, t.rects, {
    placement: t.placement
  })) : a, Ao(typeof a != "number" ? a : Oo(a, hn));
};
function sc(e) {
  var a, t = e.state, n = e.name, r = e.options, l = t.elements.arrow, o = t.modifiersData.popperOffsets, i = sa(t.placement), s = jr(i), c = [Ot, Yt].indexOf(i) >= 0, u = c ? "height" : "width";
  if (!(!l || !o)) {
    var d = oc(r.padding, t), f = qr(l), h = s === "y" ? At : Ot, b = s === "y" ? Ht : Yt, w = t.rects.reference[u] + t.rects.reference[s] - o[s] - t.rects.popper[u], D = o[s] - t.rects.reference[s], $ = Fn(l), T = $ ? s === "y" ? $.clientHeight || 0 : $.clientWidth || 0 : 0, g = w / 2 - D / 2, M = d[h], A = T - f[u] - d[b], P = T / 2 - f[u] / 2 + g, C = Mn(M, P, A), O = s;
    t.modifiersData[n] = (a = {}, a[O] = C, a.centerOffset = C - P, a);
  }
}
function ic(e) {
  var a = e.state, t = e.options, n = t.element, r = n === void 0 ? "[data-popper-arrow]" : n;
  r != null && (typeof r == "string" && (r = a.elements.popper.querySelector(r), !r) || $o(a.elements.popper, r) && (a.elements.arrow = r));
}
const Ro = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: sc,
  effect: ic,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ln(e) {
  return e.split("-")[1];
}
var uc = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function cc(e, a) {
  var t = e.x, n = e.y, r = a.devicePixelRatio || 1;
  return {
    x: nn(t * r) / r || 0,
    y: nn(n * r) / r || 0
  };
}
function Ml(e) {
  var a, t = e.popper, n = e.popperRect, r = e.placement, l = e.variation, o = e.offsets, i = e.position, s = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, d = e.isFixed, f = o.x, h = f === void 0 ? 0 : f, b = o.y, w = b === void 0 ? 0 : b, D = typeof u == "function" ? u({
    x: h,
    y: w
  }) : {
    x: h,
    y: w
  };
  h = D.x, w = D.y;
  var $ = o.hasOwnProperty("x"), T = o.hasOwnProperty("y"), g = Ot, M = At, A = window;
  if (c) {
    var P = Fn(t), C = "clientHeight", O = "clientWidth";
    if (P === Wt(t) && (P = Ta(t), ha(P).position !== "static" && i === "absolute" && (C = "scrollHeight", O = "scrollWidth")), P = P, r === At || (r === Ot || r === Yt) && l === an) {
      M = Ht;
      var R = d && P === A && A.visualViewport ? A.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        P[C]
      );
      w -= R - n.height, w *= s ? 1 : -1;
    }
    if (r === Ot || (r === At || r === Ht) && l === an) {
      g = Yt;
      var S = d && P === A && A.visualViewport ? A.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        P[O]
      );
      h -= S - n.width, h *= s ? 1 : -1;
    }
  }
  var X = Object.assign({
    position: i
  }, c && uc), re = u === !0 ? cc({
    x: h,
    y: w
  }, Wt(t)) : {
    x: h,
    y: w
  };
  if (h = re.x, w = re.y, s) {
    var fe;
    return Object.assign({}, X, (fe = {}, fe[M] = T ? "0" : "", fe[g] = $ ? "0" : "", fe.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + w + "px)" : "translate3d(" + h + "px, " + w + "px, 0)", fe));
  }
  return Object.assign({}, X, (a = {}, a[M] = T ? w + "px" : "", a[g] = $ ? h + "px" : "", a.transform = "", a));
}
function dc(e) {
  var a = e.state, t = e.options, n = t.gpuAcceleration, r = n === void 0 ? !0 : n, l = t.adaptive, o = l === void 0 ? !0 : l, i = t.roundOffsets, s = i === void 0 ? !0 : i, c = {
    placement: sa(a.placement),
    variation: ln(a.placement),
    popper: a.elements.popper,
    popperRect: a.rects.popper,
    gpuAcceleration: r,
    isFixed: a.options.strategy === "fixed"
  };
  a.modifiersData.popperOffsets != null && (a.styles.popper = Object.assign({}, a.styles.popper, Ml(Object.assign({}, c, {
    offsets: a.modifiersData.popperOffsets,
    position: a.options.strategy,
    adaptive: o,
    roundOffsets: s
  })))), a.modifiersData.arrow != null && (a.styles.arrow = Object.assign({}, a.styles.arrow, Ml(Object.assign({}, c, {
    offsets: a.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-placement": a.placement
  });
}
const Gr = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: dc,
  data: {}
};
var zn = {
  passive: !0
};
function fc(e) {
  var a = e.state, t = e.instance, n = e.options, r = n.scroll, l = r === void 0 ? !0 : r, o = n.resize, i = o === void 0 ? !0 : o, s = Wt(a.elements.popper), c = [].concat(a.scrollParents.reference, a.scrollParents.popper);
  return l && c.forEach(function(u) {
    u.addEventListener("scroll", t.update, zn);
  }), i && s.addEventListener("resize", t.update, zn), function() {
    l && c.forEach(function(u) {
      u.removeEventListener("scroll", t.update, zn);
    }), i && s.removeEventListener("resize", t.update, zn);
  };
}
const Qr = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: fc,
  data: {}
};
var pc = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Xn(e) {
  return e.replace(/left|right|bottom|top/g, function(a) {
    return pc[a];
  });
}
var mc = {
  start: "end",
  end: "start"
};
function Sl(e) {
  return e.replace(/start|end/g, function(a) {
    return mc[a];
  });
}
function Kr(e) {
  var a = Wt(e), t = a.pageXOffset, n = a.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function Xr(e) {
  return rn(Ta(e)).left + Kr(e).scrollLeft;
}
function vc(e, a) {
  var t = Wt(e), n = Ta(e), r = t.visualViewport, l = n.clientWidth, o = n.clientHeight, i = 0, s = 0;
  if (r) {
    l = r.width, o = r.height;
    var c = So();
    (c || !c && a === "fixed") && (i = r.offsetLeft, s = r.offsetTop);
  }
  return {
    width: l,
    height: o,
    x: i + Xr(e),
    y: s
  };
}
function hc(e) {
  var a, t = Ta(e), n = Kr(e), r = (a = e.ownerDocument) == null ? void 0 : a.body, l = Ra(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), o = Ra(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), i = -n.scrollLeft + Xr(e), s = -n.scrollTop;
  return ha(r || t).direction === "rtl" && (i += Ra(t.clientWidth, r ? r.clientWidth : 0) - l), {
    width: l,
    height: o,
    x: i,
    y: s
  };
}
function Zr(e) {
  var a = ha(e), t = a.overflow, n = a.overflowX, r = a.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + r + n);
}
function Eo(e) {
  return ["html", "body", "#document"].indexOf(ua(e)) >= 0 ? e.ownerDocument.body : qt(e) && Zr(e) ? e : Eo(lr(e));
}
function Sn(e, a) {
  var t;
  a === void 0 && (a = []);
  var n = Eo(e), r = n === ((t = e.ownerDocument) == null ? void 0 : t.body), l = Wt(n), o = r ? [l].concat(l.visualViewport || [], Zr(n) ? n : []) : n, i = a.concat(o);
  return r ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(Sn(lr(o)))
  );
}
function Ar(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function yc(e, a) {
  var t = rn(e, !1, a === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function $l(e, a, t) {
  return a === Yr ? Ar(vc(e, t)) : La(a) ? yc(a, t) : Ar(hc(Ta(e)));
}
function gc(e) {
  var a = Sn(lr(e)), t = ["absolute", "fixed"].indexOf(ha(e).position) >= 0, n = t && qt(e) ? Fn(e) : e;
  return La(n) ? a.filter(function(r) {
    return La(r) && $o(r, n) && ua(r) !== "body";
  }) : [];
}
function bc(e, a, t, n) {
  var r = a === "clippingParents" ? gc(e) : [].concat(a), l = [].concat(r, [t]), o = l[0], i = l.reduce(function(s, c) {
    var u = $l(e, c, n);
    return s.top = Ra(u.top, s.top), s.right = Jn(u.right, s.right), s.bottom = Jn(u.bottom, s.bottom), s.left = Ra(u.left, s.left), s;
  }, $l(e, o, n));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function No(e) {
  var a = e.reference, t = e.element, n = e.placement, r = n ? sa(n) : null, l = n ? ln(n) : null, o = a.x + a.width / 2 - t.width / 2, i = a.y + a.height / 2 - t.height / 2, s;
  switch (r) {
    case At:
      s = {
        x: o,
        y: a.y - t.height
      };
      break;
    case Ht:
      s = {
        x: o,
        y: a.y + a.height
      };
      break;
    case Yt:
      s = {
        x: a.x + a.width,
        y: i
      };
      break;
    case Ot:
      s = {
        x: a.x - t.width,
        y: i
      };
      break;
    default:
      s = {
        x: a.x,
        y: a.y
      };
  }
  var c = r ? jr(r) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (l) {
      case Ba:
        s[c] = s[c] - (a[u] / 2 - t[u] / 2);
        break;
      case an:
        s[c] = s[c] + (a[u] / 2 - t[u] / 2);
        break;
    }
  }
  return s;
}
function on(e, a) {
  a === void 0 && (a = {});
  var t = a, n = t.placement, r = n === void 0 ? e.placement : n, l = t.strategy, o = l === void 0 ? e.strategy : l, i = t.boundary, s = i === void 0 ? yo : i, c = t.rootBoundary, u = c === void 0 ? Yr : c, d = t.elementContext, f = d === void 0 ? Ka : d, h = t.altBoundary, b = h === void 0 ? !1 : h, w = t.padding, D = w === void 0 ? 0 : w, $ = Ao(typeof D != "number" ? D : Oo(D, hn)), T = f === Ka ? go : Ka, g = e.rects.popper, M = e.elements[b ? T : f], A = bc(La(M) ? M : M.contextElement || Ta(e.elements.popper), s, u, o), P = rn(e.elements.reference), C = No({
    reference: P,
    element: g,
    placement: r
  }), O = Ar(Object.assign({}, g, C)), R = f === Ka ? O : P, S = {
    top: A.top - R.top + $.top,
    bottom: R.bottom - A.bottom + $.bottom,
    left: A.left - R.left + $.left,
    right: R.right - A.right + $.right
  }, X = e.modifiersData.offset;
  if (f === Ka && X) {
    var re = X[r];
    Object.keys(S).forEach(function(fe) {
      var I = [Yt, Ht].indexOf(fe) >= 0 ? 1 : -1, V = [At, Ht].indexOf(fe) >= 0 ? "y" : "x";
      S[fe] += re[V] * I;
    });
  }
  return S;
}
function wc(e, a) {
  a === void 0 && (a = {});
  var t = a, n = t.placement, r = t.boundary, l = t.rootBoundary, o = t.padding, i = t.flipVariations, s = t.allowedAutoPlacements, c = s === void 0 ? Wr : s, u = ln(n), d = u ? i ? $r : $r.filter(function(b) {
    return ln(b) === u;
  }) : hn, f = d.filter(function(b) {
    return c.indexOf(b) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(b, w) {
    return b[w] = on(e, {
      placement: w,
      boundary: r,
      rootBoundary: l,
      padding: o
    })[sa(w)], b;
  }, {});
  return Object.keys(h).sort(function(b, w) {
    return h[b] - h[w];
  });
}
function _c(e) {
  if (sa(e) === rr)
    return [];
  var a = Xn(e);
  return [Sl(e), a, Sl(a)];
}
function kc(e) {
  var a = e.state, t = e.options, n = e.name;
  if (!a.modifiersData[n]._skip) {
    for (var r = t.mainAxis, l = r === void 0 ? !0 : r, o = t.altAxis, i = o === void 0 ? !0 : o, s = t.fallbackPlacements, c = t.padding, u = t.boundary, d = t.rootBoundary, f = t.altBoundary, h = t.flipVariations, b = h === void 0 ? !0 : h, w = t.allowedAutoPlacements, D = a.options.placement, $ = sa(D), T = $ === D, g = s || (T || !b ? [Xn(D)] : _c(D)), M = [D].concat(g).reduce(function(N, Z) {
      return N.concat(sa(Z) === rr ? wc(a, {
        placement: Z,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: b,
        allowedAutoPlacements: w
      }) : Z);
    }, []), A = a.rects.reference, P = a.rects.popper, C = /* @__PURE__ */ new Map(), O = !0, R = M[0], S = 0; S < M.length; S++) {
      var X = M[S], re = sa(X), fe = ln(X) === Ba, I = [At, Ht].indexOf(re) >= 0, V = I ? "width" : "height", E = on(a, {
        placement: X,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), ee = I ? fe ? Yt : Ot : fe ? Ht : At;
      A[V] > P[V] && (ee = Xn(ee));
      var ce = Xn(ee), q = [];
      if (l && q.push(E[re] <= 0), i && q.push(E[ee] <= 0, E[ce] <= 0), q.every(function(N) {
        return N;
      })) {
        R = X, O = !1;
        break;
      }
      C.set(X, q);
    }
    if (O)
      for (var J = b ? 3 : 1, L = function(Z) {
        var ae = M.find(function(p) {
          var W = C.get(p);
          if (W)
            return W.slice(0, Z).every(function(ve) {
              return ve;
            });
        });
        if (ae)
          return R = ae, "break";
      }, F = J; F > 0; F--) {
        var x = L(F);
        if (x === "break") break;
      }
    a.placement !== R && (a.modifiersData[n]._skip = !0, a.placement = R, a.reset = !0);
  }
}
const Bo = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: kc,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Pl(e, a, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - a.height - t.y,
    right: e.right - a.width + t.x,
    bottom: e.bottom - a.height + t.y,
    left: e.left - a.width - t.x
  };
}
function Al(e) {
  return [At, Yt, Ht, Ot].some(function(a) {
    return e[a] >= 0;
  });
}
function xc(e) {
  var a = e.state, t = e.name, n = a.rects.reference, r = a.rects.popper, l = a.modifiersData.preventOverflow, o = on(a, {
    elementContext: "reference"
  }), i = on(a, {
    altBoundary: !0
  }), s = Pl(o, n), c = Pl(i, r, l), u = Al(s), d = Al(c);
  a.modifiersData[t] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const Lo = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: xc
};
function Cc(e, a, t) {
  var n = sa(e), r = [Ot, At].indexOf(n) >= 0 ? -1 : 1, l = typeof t == "function" ? t(Object.assign({}, a, {
    placement: e
  })) : t, o = l[0], i = l[1];
  return o = o || 0, i = (i || 0) * r, [Ot, Yt].indexOf(n) >= 0 ? {
    x: i,
    y: o
  } : {
    x: o,
    y: i
  };
}
function Dc(e) {
  var a = e.state, t = e.options, n = e.name, r = t.offset, l = r === void 0 ? [0, 0] : r, o = Wr.reduce(function(u, d) {
    return u[d] = Cc(d, a.rects, l), u;
  }, {}), i = o[a.placement], s = i.x, c = i.y;
  a.modifiersData.popperOffsets != null && (a.modifiersData.popperOffsets.x += s, a.modifiersData.popperOffsets.y += c), a.modifiersData[n] = o;
}
const Fo = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Dc
};
function Tc(e) {
  var a = e.state, t = e.name;
  a.modifiersData[t] = No({
    reference: a.rects.reference,
    element: a.rects.popper,
    placement: a.placement
  });
}
const Jr = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Tc,
  data: {}
};
function Ic(e) {
  return e === "x" ? "y" : "x";
}
function Mc(e) {
  var a = e.state, t = e.options, n = e.name, r = t.mainAxis, l = r === void 0 ? !0 : r, o = t.altAxis, i = o === void 0 ? !1 : o, s = t.boundary, c = t.rootBoundary, u = t.altBoundary, d = t.padding, f = t.tether, h = f === void 0 ? !0 : f, b = t.tetherOffset, w = b === void 0 ? 0 : b, D = on(a, {
    boundary: s,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), $ = sa(a.placement), T = ln(a.placement), g = !T, M = jr($), A = Ic(M), P = a.modifiersData.popperOffsets, C = a.rects.reference, O = a.rects.popper, R = typeof w == "function" ? w(Object.assign({}, a.rects, {
    placement: a.placement
  })) : w, S = typeof R == "number" ? {
    mainAxis: R,
    altAxis: R
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, R), X = a.modifiersData.offset ? a.modifiersData.offset[a.placement] : null, re = {
    x: 0,
    y: 0
  };
  if (P) {
    if (l) {
      var fe, I = M === "y" ? At : Ot, V = M === "y" ? Ht : Yt, E = M === "y" ? "height" : "width", ee = P[M], ce = ee + D[I], q = ee - D[V], J = h ? -O[E] / 2 : 0, L = T === Ba ? C[E] : O[E], F = T === Ba ? -O[E] : -C[E], x = a.elements.arrow, N = h && x ? qr(x) : {
        width: 0,
        height: 0
      }, Z = a.modifiersData["arrow#persistent"] ? a.modifiersData["arrow#persistent"].padding : Po(), ae = Z[I], p = Z[V], W = Mn(0, C[E], N[E]), ve = g ? C[E] / 2 - J - W - ae - S.mainAxis : L - W - ae - S.mainAxis, Fe = g ? -C[E] / 2 + J + W + p + S.mainAxis : F + W + p + S.mainAxis, K = a.elements.arrow && Fn(a.elements.arrow), Ee = K ? M === "y" ? K.clientTop || 0 : K.clientLeft || 0 : 0, ue = (fe = X == null ? void 0 : X[M]) != null ? fe : 0, ye = ee + ve - ue - Ee, _ = ee + Fe - ue, j = Mn(h ? Jn(ce, ye) : ce, ee, h ? Ra(q, _) : q);
      P[M] = j, re[M] = j - ee;
    }
    if (i) {
      var U, Q = M === "x" ? At : Ot, we = M === "x" ? Ht : Yt, ge = P[A], Oe = A === "y" ? "height" : "width", Le = ge + D[Q], z = ge - D[we], he = [At, Ot].indexOf($) !== -1, Se = (U = X == null ? void 0 : X[A]) != null ? U : 0, He = he ? Le : ge - C[Oe] - O[Oe] - Se + S.altAxis, Ge = he ? ge + C[Oe] + O[Oe] - Se - S.altAxis : z, xe = h && he ? lc(He, ge, Ge) : Mn(h ? He : Le, ge, h ? Ge : z);
      P[A] = xe, re[A] = xe - ge;
    }
    a.modifiersData[n] = re;
  }
}
const Vo = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Mc,
  requiresIfExists: ["offset"]
};
function Sc(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function $c(e) {
  return e === Wt(e) || !qt(e) ? Kr(e) : Sc(e);
}
function Pc(e) {
  var a = e.getBoundingClientRect(), t = nn(a.width) / e.offsetWidth || 1, n = nn(a.height) / e.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function Ac(e, a, t) {
  t === void 0 && (t = !1);
  var n = qt(a), r = qt(a) && Pc(a), l = Ta(a), o = rn(e, r, t), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((ua(a) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Zr(l)) && (i = $c(a)), qt(a) ? (s = rn(a, !0), s.x += a.clientLeft, s.y += a.clientTop) : l && (s.x = Xr(l))), {
    x: o.left + i.scrollLeft - s.x,
    y: o.top + i.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function Oc(e) {
  var a = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(l) {
    a.set(l.name, l);
  });
  function r(l) {
    t.add(l.name);
    var o = [].concat(l.requires || [], l.requiresIfExists || []);
    o.forEach(function(i) {
      if (!t.has(i)) {
        var s = a.get(i);
        s && r(s);
      }
    }), n.push(l);
  }
  return e.forEach(function(l) {
    t.has(l.name) || r(l);
  }), n;
}
function Rc(e) {
  var a = Oc(e);
  return Mo.reduce(function(t, n) {
    return t.concat(a.filter(function(r) {
      return r.phase === n;
    }));
  }, []);
}
function Ec(e) {
  var a;
  return function() {
    return a || (a = new Promise(function(t) {
      Promise.resolve().then(function() {
        a = void 0, t(e());
      });
    })), a;
  };
}
function Nc(e) {
  var a = e.reduce(function(t, n) {
    var r = t[n.name];
    return t[n.name] = r ? Object.assign({}, r, n, {
      options: Object.assign({}, r.options, n.options),
      data: Object.assign({}, r.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(a).map(function(t) {
    return a[t];
  });
}
var Ol = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Rl() {
  for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++)
    a[t] = arguments[t];
  return !a.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function or(e) {
  e === void 0 && (e = {});
  var a = e, t = a.defaultModifiers, n = t === void 0 ? [] : t, r = a.defaultOptions, l = r === void 0 ? Ol : r;
  return function(i, s, c) {
    c === void 0 && (c = l);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ol, l),
      modifiersData: {},
      elements: {
        reference: i,
        popper: s
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function($) {
        var T = typeof $ == "function" ? $(u.options) : $;
        w(), u.options = Object.assign({}, l, u.options, T), u.scrollParents = {
          reference: La(i) ? Sn(i) : i.contextElement ? Sn(i.contextElement) : [],
          popper: Sn(s)
        };
        var g = Rc(Nc([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = g.filter(function(M) {
          return M.enabled;
        }), b(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var $ = u.elements, T = $.reference, g = $.popper;
          if (Rl(T, g)) {
            u.rects = {
              reference: Ac(T, Fn(g), u.options.strategy === "fixed"),
              popper: qr(g)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(S) {
              return u.modifiersData[S.name] = Object.assign({}, S.data);
            });
            for (var M = 0; M < u.orderedModifiers.length; M++) {
              if (u.reset === !0) {
                u.reset = !1, M = -1;
                continue;
              }
              var A = u.orderedModifiers[M], P = A.fn, C = A.options, O = C === void 0 ? {} : C, R = A.name;
              typeof P == "function" && (u = P({
                state: u,
                options: O,
                name: R,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ec(function() {
        return new Promise(function(D) {
          h.forceUpdate(), D(u);
        });
      }),
      destroy: function() {
        w(), f = !0;
      }
    };
    if (!Rl(i, s))
      return h;
    h.setOptions(c).then(function(D) {
      !f && c.onFirstUpdate && c.onFirstUpdate(D);
    });
    function b() {
      u.orderedModifiers.forEach(function(D) {
        var $ = D.name, T = D.options, g = T === void 0 ? {} : T, M = D.effect;
        if (typeof M == "function") {
          var A = M({
            state: u,
            name: $,
            instance: h,
            options: g
          }), P = function() {
          };
          d.push(A || P);
        }
      });
    }
    function w() {
      d.forEach(function(D) {
        return D();
      }), d = [];
    }
    return h;
  };
}
var Bc = /* @__PURE__ */ or(), Lc = [Qr, Jr, Gr, zr], Fc = /* @__PURE__ */ or({
  defaultModifiers: Lc
}), Vc = [Qr, Jr, Gr, zr, Fo, Bo, Vo, Ro, Lo], Hc = /* @__PURE__ */ or({
  defaultModifiers: Vc
});
const Yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterMain: Co,
  afterRead: _o,
  afterWrite: Io,
  applyStyles: zr,
  arrow: Ro,
  auto: rr,
  basePlacements: hn,
  beforeMain: ko,
  beforeRead: bo,
  beforeWrite: Do,
  bottom: Ht,
  clippingParents: yo,
  computeStyles: Gr,
  createPopper: Hc,
  createPopperBase: Bc,
  createPopperLite: Fc,
  detectOverflow: on,
  end: an,
  eventListeners: Qr,
  flip: Bo,
  hide: Lo,
  left: Ot,
  main: xo,
  modifierPhases: Mo,
  offset: Fo,
  placements: Wr,
  popper: Ka,
  popperGenerator: or,
  popperOffsets: Jr,
  preventOverflow: Vo,
  read: wo,
  reference: go,
  right: Yt,
  start: Ba,
  top: At,
  variationPlacements: $r,
  viewport: Yr,
  write: To
}, Symbol.toStringTag, { value: "Module" })), Wc = /* @__PURE__ */ Zs(Yc);
var qn = { exports: {} };
/*!
  * Bootstrap sanitizer.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var El;
function Ho() {
  return El || (El = 1, function(e, a) {
    (function(t, n) {
      n(a);
    })(Hr, function(t) {
      const r = {
        // Global attributes allowed on any supplied element below.
        "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
        a: ["target", "href", "title", "rel"],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: ["src", "srcset", "alt", "title", "width", "height"],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
      }, l = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), o = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, i = (c, u) => {
        const d = c.nodeName.toLowerCase();
        return u.includes(d) ? l.has(d) ? !!o.test(c.nodeValue) : !0 : u.filter((f) => f instanceof RegExp).some((f) => f.test(d));
      };
      function s(c, u, d) {
        if (!c.length)
          return c;
        if (d && typeof d == "function")
          return d(c);
        const h = new window.DOMParser().parseFromString(c, "text/html"), b = [].concat(...h.body.querySelectorAll("*"));
        for (const w of b) {
          const D = w.nodeName.toLowerCase();
          if (!Object.keys(u).includes(D)) {
            w.remove();
            continue;
          }
          const $ = [].concat(...w.attributes), T = [].concat(u["*"] || [], u[D] || []);
          for (const g of $)
            i(g, T) || w.removeAttribute(g.nodeName);
        }
        return h.body.innerHTML;
      }
      t.DefaultAllowlist = r, t.sanitizeHtml = s, Object.defineProperty(t, Symbol.toStringTag, { value: "Module" });
    });
  }(qn, qn.exports)), qn.exports;
}
var vr = { exports: {} };
/*!
  * Bootstrap template-factory.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Nl;
function Uc() {
  return Nl || (Nl = 1, function(e, a) {
    (function(t, n) {
      e.exports = n(Js(), ei(), Ho(), fo());
    })(Hr, function(t, n, r, l) {
      const o = "TemplateFactory", i = {
        allowList: r.DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: "",
        html: !1,
        sanitize: !0,
        sanitizeFn: null,
        template: "<div></div>"
      }, s = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
      }, c = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
      };
      class u extends n {
        constructor(f) {
          super(), this._config = this._getConfig(f);
        }
        // Getters
        static get Default() {
          return i;
        }
        static get DefaultType() {
          return s;
        }
        static get NAME() {
          return o;
        }
        // Public
        getContent() {
          return Object.values(this._config.content).map((f) => this._resolvePossibleFunction(f)).filter(Boolean);
        }
        hasContent() {
          return this.getContent().length > 0;
        }
        changeContent(f) {
          return this._checkContent(f), this._config.content = {
            ...this._config.content,
            ...f
          }, this;
        }
        toHtml() {
          const f = document.createElement("div");
          f.innerHTML = this._maybeSanitize(this._config.template);
          for (const [w, D] of Object.entries(this._config.content))
            this._setContent(f, D, w);
          const h = f.children[0], b = this._resolvePossibleFunction(this._config.extraClass);
          return b && h.classList.add(...b.split(" ")), h;
        }
        // Private
        _typeCheckConfig(f) {
          super._typeCheckConfig(f), this._checkContent(f.content);
        }
        _checkContent(f) {
          for (const [h, b] of Object.entries(f))
            super._typeCheckConfig({
              selector: h,
              entry: b
            }, c);
        }
        _setContent(f, h, b) {
          const w = t.findOne(b, f);
          if (w) {
            if (h = this._resolvePossibleFunction(h), !h) {
              w.remove();
              return;
            }
            if (l.isElement(h)) {
              this._putElementInTemplate(l.getElement(h), w);
              return;
            }
            if (this._config.html) {
              w.innerHTML = this._maybeSanitize(h);
              return;
            }
            w.textContent = h;
          }
        }
        _maybeSanitize(f) {
          return this._config.sanitize ? r.sanitizeHtml(f, this._config.allowList, this._config.sanitizeFn) : f;
        }
        _resolvePossibleFunction(f) {
          return l.execute(f, [this]);
        }
        _putElementInTemplate(f, h) {
          if (this._config.html) {
            h.innerHTML = "", h.append(f);
            return;
          }
          h.textContent = f.textContent;
        }
      }
      return u;
    });
  }(vr)), vr.exports;
}
/*!
  * Bootstrap tooltip.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function(e, a) {
  (function(t, n) {
    e.exports = n(Wc, ti(), ai(), ni(), fo(), Ho(), Uc());
  })(Hr, function(t, n, r, l, o, i, s) {
    function c(L) {
      const F = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
      if (L) {
        for (const x in L)
          if (x !== "default") {
            const N = Object.getOwnPropertyDescriptor(L, x);
            Object.defineProperty(F, x, N.get ? N : {
              enumerable: !0,
              get: () => L[x]
            });
          }
      }
      return F.default = L, Object.freeze(F);
    }
    const u = /* @__PURE__ */ c(t), d = "tooltip", f = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), h = "fade", b = "modal", w = "show", D = ".tooltip-inner", $ = `.${b}`, T = "hide.bs.modal", g = "hover", M = "focus", A = "click", P = "manual", C = "hide", O = "hidden", R = "show", S = "shown", X = "inserted", re = "click", fe = "focusin", I = "focusout", V = "mouseenter", E = "mouseleave", ee = {
      AUTO: "auto",
      TOP: "top",
      RIGHT: o.isRTL() ? "left" : "right",
      BOTTOM: "bottom",
      LEFT: o.isRTL() ? "right" : "left"
    }, ce = {
      allowList: i.DefaultAllowlist,
      animation: !0,
      boundary: "clippingParents",
      container: !1,
      customClass: "",
      delay: 0,
      fallbackPlacements: ["top", "right", "bottom", "left"],
      html: !1,
      offset: [0, 6],
      placement: "top",
      popperConfig: null,
      sanitize: !0,
      sanitizeFn: null,
      selector: !1,
      template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      title: "",
      trigger: "hover focus"
    }, q = {
      allowList: "object",
      animation: "boolean",
      boundary: "(string|element)",
      container: "(string|element|boolean)",
      customClass: "(string|function)",
      delay: "(number|object)",
      fallbackPlacements: "array",
      html: "boolean",
      offset: "(array|string|function)",
      placement: "(string|function)",
      popperConfig: "(null|object|function)",
      sanitize: "boolean",
      sanitizeFn: "(null|function)",
      selector: "(string|boolean)",
      template: "string",
      title: "(string|element|function)",
      trigger: "string"
    };
    class J extends n {
      constructor(F, x) {
        if (typeof u > "u")
          throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(F, x), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
      }
      // Getters
      static get Default() {
        return ce;
      }
      static get DefaultType() {
        return q;
      }
      static get NAME() {
        return d;
      }
      // Public
      enable() {
        this._isEnabled = !0;
      }
      disable() {
        this._isEnabled = !1;
      }
      toggleEnabled() {
        this._isEnabled = !this._isEnabled;
      }
      toggle() {
        if (this._isEnabled) {
          if (this._activeTrigger.click = !this._activeTrigger.click, this._isShown()) {
            this._leave();
            return;
          }
          this._enter();
        }
      }
      dispose() {
        clearTimeout(this._timeout), r.off(this._element.closest($), T, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
      }
      show() {
        if (this._element.style.display === "none")
          throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled))
          return;
        const F = r.trigger(this._element, this.constructor.eventName(R)), N = (o.findShadowRoot(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
        if (F.defaultPrevented || !N)
          return;
        this._disposePopper();
        const Z = this._getTipElement();
        this._element.setAttribute("aria-describedby", Z.getAttribute("id"));
        const {
          container: ae
        } = this._config;
        if (this._element.ownerDocument.documentElement.contains(this.tip) || (ae.append(Z), r.trigger(this._element, this.constructor.eventName(X))), this._popper = this._createPopper(Z), Z.classList.add(w), "ontouchstart" in document.documentElement)
          for (const W of [].concat(...document.body.children))
            r.on(W, "mouseover", o.noop);
        const p = () => {
          r.trigger(this._element, this.constructor.eventName(S)), this._isHovered === !1 && this._leave(), this._isHovered = !1;
        };
        this._queueCallback(p, this.tip, this._isAnimated());
      }
      hide() {
        if (!this._isShown() || r.trigger(this._element, this.constructor.eventName(C)).defaultPrevented)
          return;
        if (this._getTipElement().classList.remove(w), "ontouchstart" in document.documentElement)
          for (const Z of [].concat(...document.body.children))
            r.off(Z, "mouseover", o.noop);
        this._activeTrigger[A] = !1, this._activeTrigger[M] = !1, this._activeTrigger[g] = !1, this._isHovered = null;
        const N = () => {
          this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), r.trigger(this._element, this.constructor.eventName(O)));
        };
        this._queueCallback(N, this.tip, this._isAnimated());
      }
      update() {
        this._popper && this._popper.update();
      }
      // Protected
      _isWithContent() {
        return !!this._getTitle();
      }
      _getTipElement() {
        return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
      }
      _createTipElement(F) {
        const x = this._getTemplateFactory(F).toHtml();
        if (!x)
          return null;
        x.classList.remove(h, w), x.classList.add(`bs-${this.constructor.NAME}-auto`);
        const N = o.getUID(this.constructor.NAME).toString();
        return x.setAttribute("id", N), this._isAnimated() && x.classList.add(h), x;
      }
      setContent(F) {
        this._newContent = F, this._isShown() && (this._disposePopper(), this.show());
      }
      _getTemplateFactory(F) {
        return this._templateFactory ? this._templateFactory.changeContent(F) : this._templateFactory = new s({
          ...this._config,
          // the `content` var has to be after `this._config`
          // to override config.content in case of popover
          content: F,
          extraClass: this._resolvePossibleFunction(this._config.customClass)
        }), this._templateFactory;
      }
      _getContentForTemplate() {
        return {
          [D]: this._getTitle()
        };
      }
      _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
      }
      // Private
      _initializeOnDelegatedTarget(F) {
        return this.constructor.getOrCreateInstance(F.delegateTarget, this._getDelegateConfig());
      }
      _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains(h);
      }
      _isShown() {
        return this.tip && this.tip.classList.contains(w);
      }
      _createPopper(F) {
        const x = o.execute(this._config.placement, [this, F, this._element]), N = ee[x.toUpperCase()];
        return u.createPopper(this._element, F, this._getPopperConfig(N));
      }
      _getOffset() {
        const {
          offset: F
        } = this._config;
        return typeof F == "string" ? F.split(",").map((x) => Number.parseInt(x, 10)) : typeof F == "function" ? (x) => F(x, this._element) : F;
      }
      _resolvePossibleFunction(F) {
        return o.execute(F, [this._element]);
      }
      _getPopperConfig(F) {
        const x = {
          placement: F,
          modifiers: [{
            name: "flip",
            options: {
              fallbackPlacements: this._config.fallbackPlacements
            }
          }, {
            name: "offset",
            options: {
              offset: this._getOffset()
            }
          }, {
            name: "preventOverflow",
            options: {
              boundary: this._config.boundary
            }
          }, {
            name: "arrow",
            options: {
              element: `.${this.constructor.NAME}-arrow`
            }
          }, {
            name: "preSetPlacement",
            enabled: !0,
            phase: "beforeMain",
            fn: (N) => {
              this._getTipElement().setAttribute("data-popper-placement", N.state.placement);
            }
          }]
        };
        return {
          ...x,
          ...o.execute(this._config.popperConfig, [x])
        };
      }
      _setListeners() {
        const F = this._config.trigger.split(" ");
        for (const x of F)
          if (x === "click")
            r.on(this._element, this.constructor.eventName(re), this._config.selector, (N) => {
              this._initializeOnDelegatedTarget(N).toggle();
            });
          else if (x !== P) {
            const N = x === g ? this.constructor.eventName(V) : this.constructor.eventName(fe), Z = x === g ? this.constructor.eventName(E) : this.constructor.eventName(I);
            r.on(this._element, N, this._config.selector, (ae) => {
              const p = this._initializeOnDelegatedTarget(ae);
              p._activeTrigger[ae.type === "focusin" ? M : g] = !0, p._enter();
            }), r.on(this._element, Z, this._config.selector, (ae) => {
              const p = this._initializeOnDelegatedTarget(ae);
              p._activeTrigger[ae.type === "focusout" ? M : g] = p._element.contains(ae.relatedTarget), p._leave();
            });
          }
        this._hideModalHandler = () => {
          this._element && this.hide();
        }, r.on(this._element.closest($), T, this._hideModalHandler);
      }
      _fixTitle() {
        const F = this._element.getAttribute("title");
        F && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", F), this._element.setAttribute("data-bs-original-title", F), this._element.removeAttribute("title"));
      }
      _enter() {
        if (this._isShown() || this._isHovered) {
          this._isHovered = !0;
          return;
        }
        this._isHovered = !0, this._setTimeout(() => {
          this._isHovered && this.show();
        }, this._config.delay.show);
      }
      _leave() {
        this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(() => {
          this._isHovered || this.hide();
        }, this._config.delay.hide));
      }
      _setTimeout(F, x) {
        clearTimeout(this._timeout), this._timeout = setTimeout(F, x);
      }
      _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(!0);
      }
      _getConfig(F) {
        const x = l.getDataAttributes(this._element);
        for (const N of Object.keys(x))
          f.has(N) && delete x[N];
        return F = {
          ...x,
          ...typeof F == "object" && F ? F : {}
        }, F = this._mergeConfigObj(F), F = this._configAfterMerge(F), this._typeCheckConfig(F), F;
      }
      _configAfterMerge(F) {
        return F.container = F.container === !1 ? document.body : o.getElement(F.container), typeof F.delay == "number" && (F.delay = {
          show: F.delay,
          hide: F.delay
        }), typeof F.title == "number" && (F.title = F.title.toString()), typeof F.content == "number" && (F.content = F.content.toString()), F;
      }
      _getDelegateConfig() {
        const F = {};
        for (const [x, N] of Object.entries(this._config))
          this.constructor.Default[x] !== N && (F[x] = N);
        return F.selector = !1, F.trigger = "manual", F;
      }
      _disposePopper() {
        this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
      }
      // Static
      static jQueryInterface(F) {
        return this.each(function() {
          const x = J.getOrCreateInstance(this, F);
          if (typeof F == "string") {
            if (typeof x[F] > "u")
              throw new TypeError(`No method named "${F}"`);
            x[F]();
          }
        });
      }
    }
    return o.defineJQueryPlugin(J), J;
  });
})(ho);
var zc = ho.exports;
const qc = /* @__PURE__ */ ri(zc), jc = { class: "container" }, Gc = { class: "img-wrapper" }, Qc = ["data-bs-toggle", "src"], Kc = /* @__PURE__ */ Te({
  __name: "ImageHover",
  props: {
    imageUrl_small: { type: String, required: !0 },
    // 画像のURL
    imageUrl_big: { type: String, required: !0 }
    // 画像のURL
  },
  setup(e) {
    const a = e, t = B(""), n = B("tooltip tooltip-font scv-tooltip-manual"), r = B(null), l = B(null), o = B(!1), i = B(!1), s = (d) => {
      if (o.value) {
        d();
        return;
      }
      const f = new Image();
      f.src = a.imageUrl_big, f.onload = () => {
        t.value = `<img id="hoverImage" src="${a.imageUrl_big}">`, o.value = !0, d();
      };
    }, c = () => {
      l.value && (i.value || (i.value = !0, s(() => {
        l.value && (r.value || (r.value = new qc(l.value, {
          title: t.value,
          html: !0,
          placement: "bottom",
          template: '<div class="tooltip tooltip-font scv-image-hover" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
          fallbackPlacements: ["top", "bottom"]
          // 自動調整される位置を指定
        }), i.value && r.value.show()));
      })));
    }, u = () => {
      i.value = !1, r.value && (r.value.dispose(), r.value = null);
    };
    return (d, f) => (v(), y("div", jc, [
      k("div", Gc, [
        k("img", {
          "data-bs-toggle": n.value,
          src: e.imageUrl_small,
          class: pe({ "half-opacity": i.value }),
          onMouseover: c,
          onMouseout: u,
          ref_key: "imageElement",
          ref: l
        }, null, 42, Qc)
      ])
    ]));
  }
}), Xc = /* @__PURE__ */ Ye(Kc, [["__scopeId", "data-v-67279d2e"]]), Yo = (e) => (Tt("data-v-1123c940"), e = e(), It(), e), Zc = {
  class: "sticky-top",
  style: { "z-index": "990" }
}, Jc = {
  key: 0,
  style: { width: "30px" }
}, ed = ["checked", "disabled"], td = ["onClick"], ad = {
  class: "d-flex flex-row align-items-center",
  style: { position: "relative", height: "100%", "align-items": "center" }
}, nd = {
  key: 0,
  class: "ellipsis"
}, rd = ["innerHTML"], ld = {
  key: 0,
  class: "icon-font-slategray"
}, od = /* @__PURE__ */ Yo(() => /* @__PURE__ */ k("i", { class: "icon-arrow2top" }, null, -1)), sd = [
  od
], id = {
  key: 1,
  class: "icon-font-slategray"
}, ud = /* @__PURE__ */ Yo(() => /* @__PURE__ */ k("i", { class: "icon-arrow2down" }, null, -1)), cd = [
  ud
], dd = ["onMousedown"], fd = {
  key: 1,
  style: { padding: "0" }
}, pd = {
  key: 2,
  style: { width: "0px", padding: "0", border: "none" }
}, md = ["onClick"], vd = {
  key: 0,
  style: { width: "36px" }
}, hd = ["onClick", "checked"], yd = ["innerHTML", "onClick"], gd = ["id", "checked", "onClick", "disabled"], bd = ["onClick"], wd = {
  key: 1,
  style: { padding: "0" }
}, _d = {
  key: 2,
  style: { width: "0px", padding: "0", border: "none" }
}, jn = 100, kd = 50, xd = /* @__PURE__ */ Te({
  __name: "ListCtrl",
  props: {
    columns: { type: Array, required: !0 },
    // 対象カラム(Array<SearchColumnData>)
    selectType: { type: Number, default: 0 },
    // 0:選択なし 1:単数選択 2:複数選択 3:チェックボックス付複数選択
    saveMemoryMode: { type: Boolean, default: !1 },
    // 省メモリモード（ソートやページネーションなどをメモリ上で行わず、SQLなどで行うときにtrueにします）
    sortDeleteIndex: { type: Boolean, default: !0 },
    // true: ソート時に選択状態を忘れる
    enableAllCheck: { type: Boolean, default: !0 },
    // false: ヘッダのチェックボックスがなくなる
    enableSetting: { type: Boolean, default: !0 },
    // false: リストを無効化する
    /*
     * 通常テキストのcell文言作成
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのテキスト
     */
    getCellTextFunc: { type: Function, default: null },
    getImageFunc: { type: Function, default: null },
    getCellCheckFunc: { type: Function, default: null },
    // 特殊なソートを行いたいときのcompare関数
    // l < r :-1
    // l = r :0
    // l > r :1
    externalCompareFunc: { type: Function, default: null },
    /*
     * アイコンとかリンクとかにしたいときcellのHTMLを取得
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのクラス名
     */
    getCellHTMLFunc: { type: Function, default: null },
    /*
     * cellの個別のクラス名を取得
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのクラス名
     */
    getCellClassFunc: { type: Function, default: null },
    /*
     * cellの個別のstyleを取得
     * @param[in]   column: カラム
     * return cellのクラス名
     */
    getCellStyleFunc: { type: Function, default: null },
    /*
     * 行が選択された時の個別のstyleを取得
     * @param[in]   index: 行インデックス
     */
    getSelectRowStyleFunc: { type: Function, default: null },
    /* 行ごとのクラス名を取得 */
    getRowClassFunc: { type: Function, default: null },
    /* 複数行表示かどうか（paddingが前後に4px付くようになるだけ） */
    multiLine: { type: Boolean, default: !1 },
    /* チェックボックス押下時（変更前） */
    selectRowCheckButtonFunc: { type: Function, default: null },
    /* ヘッダのチェックボックス押下時（変更前） */
    selectHeaderCheckButtonFunc: { type: Function, default: null },
    /* バリデーションエラーかどうか（リストのボーダーが赤色になる） */
    hasError: { type: Boolean, default: !1 },
    /* 部署などを跨いだ総選択数 */
    totalSelectCount: { type: Number, default: 0 }
  },
  emits: ["onClickCell", "onSelectIndexChanged", "onColumnHeaderClick"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t;
    let l = 0, o = B(new Array()), i = B(new Array()), s = B(/* @__PURE__ */ new Set()), c = -1;
    const u = B(-1), d = B(!0);
    let f = "", h = -1, b = -1, w = ze.no_sort, D = ze.html_column, $ = ze.check_column, T = B(new Array()), g = 0, M = B(0), A = B(40), P = B(32), C = B(), O = B(), R = null, S, X = window.innerWidth, re = B(/* @__PURE__ */ new Map()), fe = B();
    const I = B([]);
    let V = 0, E = 0, ee, ce = !1, q = !1, J = !1, L = B(!1);
    const F = H(() => n.columns.reduce((ne, le) => (ne.set(le.columnID, le), ne), /* @__PURE__ */ new Map()));
    Xe(() => {
      R = new ResizeObserver(() => N()), R.observe(C.value);
    }), et(
      i,
      () => {
        s.value = new Set(i.value);
      },
      {
        deep: !0
      }
    );
    const x = H(() => Array.from(re.value.values())), N = () => {
      0 < S || (S = setTimeout(() => {
        X != window.innerWidth && (L.value = !0, X = window.innerWidth), wt(), S = 0;
      }, 15));
    }, Z = (ne) => {
      n.selectType != 0 && n.selectType != 3 && (i.value.splice(0, i.value.length), i.value.push(ne), c = ne, r("onSelectIndexChanged", jt()));
    }, ae = (ne) => {
      n.selectType != 0 && n.selectType != 3 && (c = ne, Q(ne));
    }, p = (ne) => {
      if (n.selectType != 0 && n.selectType != 3) {
        if (n.selectType == 1) {
          Z(ne);
          return;
        }
        if (c != ne) {
          c == -1 && (c = o.value[0]);
          var le = o.value.findIndex((De) => De == c), oe = o.value.findIndex((De) => De == ne);
          i.value.splice(0, i.value.length);
          var Ce = 0;
          if (le < oe)
            for (Ce = le; Ce <= oe; ++Ce)
              i.value.push(o.value[Ce]);
          else
            for (Ce = le; oe <= Ce; --Ce)
              i.value.push(o.value[Ce]);
          i.value.sort(function(De, xt) {
            return De - xt;
          }), r("onSelectIndexChanged", jt());
        }
      }
    }, W = (ne = new Event("default")) => {
      if (i.value.length == o.value.length && i.value.length > 0)
        i.value.splice(0, i.value.length);
      else {
        if (n.selectHeaderCheckButtonFunc != null && ne.type != "default") {
          const oe = new Set(i.value), Ce = o.value.filter((De) => !oe.has(De)).length;
          if (!n.selectHeaderCheckButtonFunc(o.value, ne, n.totalSelectCount, Ce))
            return;
        }
        i.value.splice(0, i.value.length);
        const le = o.value.length;
        for (let oe = 0; oe < le; ++oe)
          i.value.push(o.value[oe]);
      }
      i.value.sort(function(le, oe) {
        return le - oe;
      }), r("onSelectIndexChanged", jt());
    }, ve = (ne) => {
      if (!ce) {
        for (let le of n.columns)
          if (le.columnID == ne && ze.no_sort & le.dataType)
            return;
        u.value == ne ? d.value = !d.value : d.value = !0, u.value = ne, r("onColumnHeaderClick", u.value, d.value), n.saveMemoryMode || (j(), r("onSelectIndexChanged", jt()));
      }
    }, Fe = (ne, le) => {
      n.selectType == 3 && Q(le, ne);
    }, K = (ne, le, oe) => {
      oe && r("onClickCell", le, ne);
    }, Ee = () => {
      wt();
    }, ue = (ne, le, oe) => {
      V = ne.clientX, E = I.value[oe].offsetWidth, ee = le, ce = !0, L.value = !0, J || (q = !0), document.addEventListener("mousemove", ye), document.addEventListener("mouseup", _), document.body.style.userSelect = "none";
    }, ye = (ne) => {
      if (ee === void 0) return;
      const le = F.value.get(ee), oe = re.value.get(ee);
      if (!oe || !le) return;
      const Ce = ne.clientX - V, De = E + Ce;
      (le.columnMinWidth ?? kd) <= De && (oe.columnWidth = De, oe.columnMinWidth = De, oe.columnMaxWidth = De);
    }, _ = () => {
      document.removeEventListener("mousemove", ye), document.removeEventListener("mouseup", _), ee = void 0, document.body.style.userSelect = "", J || (q = !1), setTimeout(() => {
        ce = !1;
      }, 0);
    }, j = () => {
      let ne = new Array(), le = -1;
      if (n.sortDeleteIndex || (ne = jt(), le = c), C.value != null && (g == 0 && (g = Sa(C.value.scrollTop)), C.value.scrollTop = 0), i.value.splice(0, i.value.length), o.value.splice(0, o.value.length), c = -1, n.saveMemoryMode)
        for (let Ce = 0; Ce < l; Ce++)
          o.value.push(Ce);
      else {
        var oe = U(n.columns, u.value, d.value, f);
        oe.forEach((Ce) => o.value.push(Ce)), o.value.length != 0 && -1 < h && -1 < b && h <= b && (o.value = o.value.slice(h, b + 1));
      }
      n.sortDeleteIndex || (Ie(ne), c = le), wt();
    }, U = (ne, le, oe, Ce) => {
      let De = new Array();
      if (Ce.length == 0)
        for (let Mt = 0; Mt < l; ++Mt)
          De.push(Mt);
      else {
        const Mt = Ce.split(" ");
        for (let ca = 0; ca < l; ca++)
          for (const Lt of Mt) {
            if (Lt.length === 0)
              continue;
            let Nt = !1;
            for (let na = 0; na < n.columns.length && (Nt = ge(n.columns[na].columnID, n.columns[na].dataType, ca, !1).toLowerCase().indexOf(Lt.toLowerCase()) !== -1, !Nt); ++na)
              ;
            Nt && (De.includes(ca) || De.push(ca));
          }
      }
      let xt = -1, Rt = -1;
      for (let Mt = 0; Mt < ne.length; Mt++)
        if (ne[Mt].columnID == le) {
          xt = Mt, Rt = ne[Mt].dataType;
          break;
        }
      let Et = -1;
      return oe && (Et = 1), xt != -1 && Rt != -1 && De.sort((Mt, ca) => {
        if (n.externalCompareFunc && ze.external_sort & Rt)
          return n.externalCompareFunc(le, Mt, ca) * Et;
        let Lt = "", Nt = "";
        if (ze.check_column & Rt ? (Lt = Oe(le, Mt) ? "1" : "0", Nt = Oe(le, ca) ? "1" : "0") : (Lt = we(le, Mt, !1), Nt = we(le, ca, !1)), ze.number & Rt || ze.check_column & Rt || ze.file_size & Rt) {
          const na = parseInt(Lt), ja = parseInt(Nt);
          return isNaN(na) && isNaN(ja) ? Lt.compareSort(Nt) * Et : isNaN(na) ? -1 * Et : isNaN(ja) ? 1 * Et : (na - ja) * Et;
        } else if (ze.ipv4_address & Rt) {
          const na = Lt == null || Lt === "", ja = Nt == null || Nt === "", pr = na ? -1 : kl.fromString(Lt).toInt(), mr = ja ? -1 : kl.fromString(Nt).toInt();
          return isNaN(pr) && isNaN(mr) ? Lt.compareSort(Nt) * Et : isNaN(pr) ? -1 * Et : isNaN(mr) ? 1 * Et : (pr - mr) * Et;
        } else
          return Lt.toLocaleLowerCase().compareSort(Nt.toLocaleLowerCase()) * Et;
      }), De;
    }, Q = (ne, le = new Event("default")) => {
      if (n.selectType == 1) {
        Z(ne);
        return;
      }
      if (n.selectRowCheckButtonFunc != null && le.type != "default")
        i.value = n.selectRowCheckButtonFunc(i.value, ne, le, n.totalSelectCount);
      else {
        var oe = i.value.indexOf(ne);
        0 <= oe ? i.value.splice(oe, 1) : i.value.push(ne);
      }
      i.value.sort(function(Ce, De) {
        return Ce - De;
      }), r("onSelectIndexChanged", jt());
    }, we = (ne, le, oe) => {
      let Ce = "", De = !1;
      if (n.getCellHTMLFunc != null) {
        const xt = n.getCellHTMLFunc(ne, le);
        xt != "" && (Ce = oe ? xt : Oa.parseHTML(xt).reduce((Rt, Et) => Et.textContent ? Rt + Et.textContent : Rt, ""), De = !0);
      }
      return n.getCellTextFunc != null && !De && (Ce = n.getCellTextFunc(ne, le)), Ce;
    }, ge = (ne, le, oe, Ce) => {
      if (ze.file_size & le && n.getCellTextFunc != null) {
        const De = n.getCellTextFunc(ne, oe), xt = parseInt(De);
        return isNaN(xt) ? De : si.ConvStorage(xt);
      }
      return we(ne, oe, Ce);
    }, Oe = (ne, le) => {
      let oe = !1;
      return n.getCellCheckFunc != null && (oe = n.getCellCheckFunc(ne, le)), oe;
    }, Le = (ne) => {
      var le = "";
      if (s.value.has(ne) && n.selectType != 3) {
        let oe = "";
        n.getSelectRowStyleFunc != null && (oe = n.getSelectRowStyleFunc(ne)), oe != null && 0 < oe.length ? le += " " + oe : le += " table-common-scv-select-cell-color";
      }
      return le;
    }, z = (ne, le) => {
      var oe = "";
      if (n.getCellClassFunc != null) {
        let Ce = n.getCellClassFunc(ne, le);
        Ce != null && 0 < Ce.length && (oe = " " + Ce);
      }
      return oe;
    }, he = (ne) => {
      let le = "df-list-ctrl-cell";
      return ze.icon & ne ? le += " df-list-ctrl-cell-icon" : ze.icon_s & ne && (le += " df-list-ctrl-cell-icon-s"), le;
    }, Se = (ne) => {
      let le = {};
      if (n.getCellStyleFunc != null) {
        let Ce = n.getCellStyleFunc(ne);
        Ce != null && (le = Ce);
      }
      const oe = n.columns.find((Ce) => Ce.columnID === ne);
      if (oe && ze.check_column & oe.dataType && (le["text-align"] = "center"), re.value.has(ne)) {
        let Ce = re.value.get(ne);
        Ce != null && Ce.columnMaxWidth != null && (le["max-Width"] = Ce.columnMaxWidth + "px");
      }
      return le;
    }, He = (ne) => {
      var oe;
      let le = {};
      if (le.cursor = w & ne.dataType ? "default" : "pointer", le.overflow = "hidden", re.value.has(ne.columnID)) {
        let Ce = (oe = re.value.get(ne.columnID)) == null ? void 0 : oe.columnMaxWidth;
        Ce != null && 0 < Ce && (le["max-width"] = Ce + "px");
      }
      return le;
    }, Ge = (ne, le) => n.getImageFunc != null && n.getImageFunc(le, ne, !1) != "", xe = (ne, le) => n.getCellHTMLFunc != null && n.getCellHTMLFunc(le, ne) != "", tt = (ne) => !!(ze.link & ne || ze.check_column & ne || ze.force_click_event & ne), wt = () => {
      let ne = 0;
      if (C.value != null && (ne = Sa(C.value.scrollTop)), O.value != null) {
        const le = O.value.getElementsByTagName("td")[0];
        le != null && le.offsetHeight != 0 && (P.value = le.offsetHeight);
      }
      if (C.value != null) {
        let le = ne / P.value, oe = Math.floor(le / jn) * jn, Ce = jn / 2;
        oe = Ce < oe ? oe - Ce : oe, M.value = oe;
        let De = jn * 2, xt = oe + De;
        T.value = o.value.slice(M.value, xt);
      }
      mt(() => {
        za(), fe.value != null && C.value != null && 0 < g && (g < fe.value.clientHeight ? C.value.scrollTop = Sa(g) : C.value.scrollTop = Sa(fe.value.clientHeight), g = 0);
      });
    }, Ua = () => {
      if (n.selectType == 3) {
        let le = new Zn();
        le.columnWidth = 36, le.columnMinWidth = 36, le.columnMaxWidth = 36, re.value.set(-1, le);
      }
      let ne = !0;
      for (let le = 0; le < n.columns.length; ++le) {
        let oe = new Zn();
        oe.columnWidth = 0 < (n.columns[le].columnWidth ?? 0) ? n.columns[le].columnWidth : void 0, oe.columnMaxWidth = 0 < (n.columns[le].columnMaxWidth ?? 0) ? n.columns[le].columnMaxWidth : void 0, ne && oe.columnWidth == null && (ne = !1), re.value.set(n.columns[le].columnID, oe);
      }
      0 < n.columns.length && ne && (J = !0, q = !0);
    }, za = () => {
      if (n.columns.length != 0 && (re.value.size == 0 && Ua(), I.value != null))
        for (let ne = 0; ne < I.value.length; ++ne) {
          const le = n.columns[ne], Ce = I.value[ne].getBoundingClientRect();
          if (0 < Ce.width) {
            if (!re.value.has(le.columnID) || le.columnMaxWidth !== void 0 && le.columnMaxWidth === le.columnMinWidth)
              continue;
            let De = re.value.get(le.columnID);
            De != null && (De.columnMinWidth == null || De.columnMinWidth < Ce.width) && (De.columnMinWidth = Ce.width, De.columnWidth = Ce.width);
          }
        }
    }, qa = (ne) => {
      l = ne, re.value = /* @__PURE__ */ new Map(), L.value = !1, J = !1, q = !1, j(), mt(() => {
        Ua(), wt();
      });
    }, gn = (ne, le) => {
      f = le, qa(ne);
    }, jt = () => {
      let ne = new Array();
      return ne = Sa(i.value), ne.sort(function(le, oe) {
        return le - oe;
      }), ne;
    }, bn = () => Sa(o.value), wn = () => Sa(T.value), G = (ne) => {
      f = ne, j();
    }, be = (ne, le) => {
      for (let oe of n.columns)
        if (oe.columnID == ne && ze.no_sort & oe.dataType)
          return;
      u.value = ne, d.value = le;
    }, $e = () => u.value, Ve = () => d.value, se = (ne, le) => {
      h = ne, b = le, j();
    }, ke = (ne) => {
      if (ne < 0 || l <= ne)
        return;
      let le = o.value[ne];
      i.value.splice(0, i.value.length), i.value.push(le), c = le;
    }, Ie = (ne, le = !0) => {
      i.value.splice(0, i.value.length), le && (c = -1);
      let oe = new Set(o.value);
      for (let Ce = 0; Ce < ne.length; Ce++) {
        const De = ne[Ce];
        De < 0 || l <= De || oe.has(De) && i.value.push(De);
      }
    };
    return a({
      updateList: qa,
      updateListWithSearchText: gn,
      getSelectListIndex: jt,
      getDisplayListIndex: bn,
      getVisibleListIndex: wn,
      search: G,
      setSort: be,
      getSortColumnID: $e,
      getIsAsc: Ve,
      setPaginationIndex: se,
      selectRow: ke,
      selectRows: Ie,
      selectRowAll: () => {
        i.value.splice(0, i.value.length), c = -1;
        for (let ne of o.value)
          ne != -1 && i.value.push(ne);
      }
    }), (ne, le) => (v(), y("div", {
      class: pe(["overflow-auto table-common-scv-out-border table-common-scv-bg", [n.enableSetting ? "" : "disabled", n.hasError ? "border-validation-error" : ""]]),
      ref_key: "ref_list",
      ref: C,
      onScroll: Ee
    }, [
      k("div", {
        class: "virtual-area",
        ref_key: "ref_virtualArea",
        ref: fe,
        style: Be({ height: m(P) * m(o).length + m(A) + "px" })
      }, [
        k("table", {
          class: pe(["table-common-scv text-nowrap table-striped view-area", [n.multiLine ? "table-common-scv-multiline" : ""]]),
          ref_key: "ref_table",
          ref: O,
          frame: "box",
          bordercolor: "lightgray",
          style: Be({ top: m(P) * m(M) + "px", "table-layout": m(q) ? "fixed" : "auto" })
        }, [
          k("colgroup", null, [
            (v(!0), y(me, null, Me(x.value, (oe, Ce) => (v(), y("col", {
              key: Ce,
              style: Be({ minWidth: oe.columnMinWidth + "px", width: oe.columnWidth + "px", maxWidth: oe.columnMaxWidth + "px" })
            }, null, 4))), 128))
          ]),
          k("thead", Zc, [
            k("tr", null, [
              n.selectType === 3 ? (v(), y("th", Jc, [
                n.enableAllCheck ? (v(), y("input", {
                  key: 0,
                  type: "checkbox",
                  onClick: le[0] || (le[0] = (oe) => W(oe)),
                  checked: m(i).length == m(o).length && m(i).length > 0,
                  disabled: m(o).length == 0
                }, null, 8, ed)) : Y("", !0)
              ])) : Y("", !0),
              (v(!0), y(me, null, Me(n.columns, (oe, Ce) => (v(), y("th", {
                key: Ce,
                ref_for: !0,
                ref_key: "ref_tableHeader",
                ref: I,
                onClick: (De) => ve(oe.columnID),
                style: Be(He(oe))
              }, [
                k("div", ad, [
                  m(D) & oe.dataType ? (v(), y("span", {
                    key: 1,
                    innerHTML: oe.text
                  }, null, 8, rd)) : (v(), y("span", nd, _e(oe.text), 1)),
                  u.value === oe.columnID ? (v(), y(me, { key: 2 }, [
                    d.value ? (v(), y("div", ld, sd)) : (v(), y("div", id, cd))
                  ], 64)) : Y("", !0),
                  k("div", {
                    class: "resizer",
                    onMousedown: (De) => ue(De, oe.columnID, Ce)
                  }, null, 40, dd)
                ])
              ], 12, td))), 128)),
              m(L) ? (v(), y("th", fd)) : (v(), y("th", pd))
            ])
          ]),
          k("tbody", null, [
            (v(!0), y(me, null, Me(m(T), (oe, Ce) => (v(), y("tr", {
              class: pe([n.getRowClassFunc ? n.getRowClassFunc(oe) : ""]),
              key: Ce,
              onClick: [
                yt((De) => Z(oe), ["exact"]),
                yt((De) => ae(oe), ["ctrl", "exact"]),
                yt((De) => p(oe), ["shift", "exact"])
              ]
            }, [
              n.selectType === 3 ? (v(), y("td", vd, [
                k("input", {
                  type: "checkbox",
                  onClick: (De) => Fe(De, oe),
                  checked: m(s).has(oe)
                }, null, 8, hd)
              ])) : Y("", !0),
              ie(ne.$slots, "row", { rowIndex: oe }, () => [
                (v(!0), y(me, null, Me(n.columns, (De, xt) => (v(), y("td", {
                  key: xt,
                  class: pe(he(De.dataType) + Le(oe) + z(De.columnID, oe)),
                  style: Be(Se(De.columnID))
                }, [
                  Ge(oe, De.columnID) ? (v(), Pe(Xc, {
                    key: 0,
                    imageUrl_small: e.getImageFunc(De.columnID, oe, !1),
                    imageUrl_big: e.getImageFunc(De.columnID, oe, !0)
                  }, null, 8, ["imageUrl_small", "imageUrl_big"])) : xe(oe, De.columnID) ? (v(), y("span", {
                    key: 1,
                    innerHTML: ge(De.columnID, De.dataType, oe, !0),
                    onClick: (Rt) => K(oe, De.columnID, tt(De.dataType))
                  }, null, 8, yd)) : m($) & De.dataType ? (v(), y("input", {
                    key: 2,
                    type: "checkbox",
                    id: "checkbox" + xt,
                    checked: Oe(De.columnID, oe),
                    onClick: (Rt) => K(oe, De.columnID, tt(De.dataType)),
                    disabled: !n.enableSetting
                  }, null, 8, gd)) : (v(), y("span", {
                    key: 3,
                    onClick: (Rt) => K(oe, De.columnID, tt(De.dataType))
                  }, _e(ge(
                    De.columnID,
                    De.dataType,
                    oe,
                    !1
                  )), 9, bd))
                ], 6))), 128))
              ], !0),
              m(L) ? (v(), y("td", wd)) : (v(), y("td", _d))
            ], 10, md))), 128))
          ])
        ], 6)
      ], 4)
    ], 34));
  }
}), Cd = /* @__PURE__ */ Ye(xd, [["__scopeId", "data-v-1123c940"]]), sr = (e) => (Tt("data-v-6b54a587"), e = e(), It(), e), Dd = { class: "pagination" }, Td = /* @__PURE__ */ sr(() => /* @__PURE__ */ k("div", {
  class: "d-flex align-items-center justify-content-center",
  style: { height: "100%" },
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ k("div", { class: "icon-font-size" }, [
    /* @__PURE__ */ k("i", { class: "icon-page_first" })
  ])
], -1)), Id = [
  Td
], Md = /* @__PURE__ */ sr(() => /* @__PURE__ */ k("span", { "aria-hidden": "true" }, "前へ", -1)), Sd = [
  Md
], $d = ["onClick"], Pd = /* @__PURE__ */ sr(() => /* @__PURE__ */ k("span", { "aria-hidden": "true" }, "次へ", -1)), Ad = [
  Pd
], Od = /* @__PURE__ */ sr(() => /* @__PURE__ */ k("div", {
  class: "d-flex align-items-center justify-content-center",
  style: { height: "100%" },
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ k("div", { class: "icon-font-size" }, [
    /* @__PURE__ */ k("i", { class: "icon-page_last" })
  ])
], -1)), Rd = [
  Od
], Bl = 8, Ed = /* @__PURE__ */ Te({
  __name: "PaginationUtil",
  props: {
    totalPageNum: { type: Number, default: 1 }
    // 総ページ数
  },
  emits: ["onChanged"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t, l = B(1), o = () => {
      l.value = 1, r("onChanged");
    }, i = () => {
      l.value !== 1 && (l.value = l.value - 1, r("onChanged"));
    }, s = () => {
      n.totalPageNum !== l.value && (l.value = l.value + 1, r("onChanged"));
    }, c = () => {
      l.value = n.totalPageNum, r("onChanged");
    }, u = (b) => {
      l.value = b, r("onChanged");
    }, d = (b) => {
      const w = Math.max(1, l.value - Bl / 2 + 1), D = Math.min(n.totalPageNum, w + Bl - 1);
      return w <= b && b <= D;
    };
    return a({
      get: () => l.value,
      set: (b) => {
        l.value = b;
      }
    }), (b, w) => (v(), y("nav", null, [
      k("ul", Dd, [
        k("li", {
          class: pe(["page-item", { disabled: l.value === 1 }])
        }, [
          k("a", {
            class: "page-link",
            "aria-label": "First",
            onClick: o
          }, Id)
        ], 2),
        k("li", {
          class: pe(["page-item", { disabled: 1 >= l.value }])
        }, [
          k("a", {
            class: "page-link",
            "aria-label": "Previous",
            onClick: i
          }, Sd)
        ], 2),
        (v(!0), y(me, null, Me(e.totalPageNum, (D) => (v(), y(me, { key: D }, [
          d(D) ? (v(), y("li", {
            key: 0,
            class: pe(["page-item", { active: l.value === D }])
          }, [
            k("a", {
              class: "page-link",
              onClick: ($) => u(D)
            }, _e(D), 9, $d)
          ], 2)) : Y("", !0)
        ], 64))), 128)),
        k("li", {
          class: pe(["page-item", { disabled: e.totalPageNum <= l.value }])
        }, [
          k("a", {
            class: "page-link",
            "aria-label": "Next",
            onClick: s
          }, Ad)
        ], 2),
        k("li", {
          class: pe(["page-item", { disabled: l.value === e.totalPageNum }])
        }, [
          k("a", {
            class: "page-link",
            "aria-label": "Last",
            onClick: c
          }, Rd)
        ], 2)
      ])
    ]));
  }
}), Nd = /* @__PURE__ */ Ye(Ed, [["__scopeId", "data-v-6b54a587"]]), Wo = (e) => (Tt("data-v-9129c2e8"), e = e(), It(), e), Bd = { class: "paginationArea d-flex align-items-center" }, Ld = /* @__PURE__ */ Wo(() => /* @__PURE__ */ k("span", null, "1ページに", -1)), Fd = {
  class: "select-icon",
  style: { margin: "0px 8px" }
}, Vd = ["value"], Hd = /* @__PURE__ */ Wo(() => /* @__PURE__ */ k("span", { style: { "margin-right": "24px" } }, "件表示", -1)), Yd = { class: "ms-auto" }, Wd = /* @__PURE__ */ Te({
  __name: "PaginationArea",
  props: {
    selectChangeList: { type: Array, default: [10, 100, 1e3] },
    defaultSelect: { type: Number, default: 100 }
  },
  emits: ["onChanged"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t, l = B(0), o = B(0), i = B(0), s = B(1), c = B(n.defaultSelect), u = B(), d = () => {
      w(), f();
    }, f = () => {
      r("onChanged");
    }, h = () => {
      const D = new Array();
      return D.push((u.value.get() - 1) * c.value + 1), D.push(c.value), D;
    }, b = (D, $) => {
      if (D == 0)
        l.value = 0, o.value = 0;
      else {
        const T = (u.value.get() - 1) * c.value;
        l.value = T + 1, o.value = T + D;
      }
      s.value = Math.ceil($ / c.value), s.value == 0 && (s.value = 1), i.value = $;
    }, w = () => {
      l.value = 0, o.value = 0, i.value = 0, s.value = 1, u.value.set(1);
    };
    return a({
      get: h,
      set: b,
      reset: w
    }), (D, $) => (v(), y("div", Bd, [
      Ld,
      k("div", Fd, [
        ht(k("select", {
          class: "input-text-scv",
          style: { "min-width": "80px" },
          "onUpdate:modelValue": $[0] || ($[0] = (T) => c.value = T),
          onChange: d
        }, [
          (v(!0), y(me, null, Me(e.selectChangeList, (T) => (v(), y("option", {
            value: T,
            key: T
          }, _e(T), 9, Vd))), 128))
        ], 544), [
          [On, c.value]
        ])
      ]),
      Hd,
      qe(Nd, {
        ref_key: "ref_PaginationUtil",
        ref: u,
        totalPageNum: s.value,
        onOnChanged: f
      }, null, 8, ["totalPageNum"]),
      k("div", Yd, _e(l.value) + "-" + _e(o.value) + "件表示中/全" + _e(i.value) + "件", 1)
    ]));
  }
}), Ud = /* @__PURE__ */ Ye(Wd, [["__scopeId", "data-v-9129c2e8"]]);
var Dn = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.Single = 1] = "Single", e[e.Multiple = 2] = "Multiple", e[e.CheckBox = 3] = "CheckBox", e[e.CheckBoxWithoutSelectAll = 4] = "CheckBoxWithoutSelectAll", e))(Dn || {}), Xa = /* @__PURE__ */ ((e) => (e[e.Minimum = 0] = "Minimum", e[e.ShowDropdownMenu = 1] = "ShowDropdownMenu", e[e.ShowExpantionButton = 2] = "ShowExpantionButton", e[e.DisposePagination = 4] = "DisposePagination", e[e.ShowPaginationIfNeeded = 8] = "ShowPaginationIfNeeded", e))(Xa || {});
function zd(e) {
  const a = B({}), t = B([]), n = H(() => {
    var u;
    const s = new Set(t.value), c = Object.entries(a.value).filter(([d, f]) => s.has(f)).map(([d, f]) => Number.parseInt(d));
    if (e.value) {
      const [d, f] = (u = e.value) == null ? void 0 : u.get(), h = d - 1;
      return c.filter((b) => h <= b && b < h + f).map((b) => b - h);
    } else
      return c;
  });
  function r(s) {
    const c = new Set(l(n.value)), u = t.value.filter((d) => !c.has(d));
    t.value = [
      ...u,
      ...l(s)
    ];
  }
  function l(s) {
    var u;
    let c = 0;
    if (e.value) {
      const [d, f] = (u = e.value) == null ? void 0 : u.get();
      c = d - 1;
    }
    return Array.isArray(s) ? s.map((d) => a.value[d + c]) : a.value[s + c];
  }
  function o(s, c, u, d) {
    a.value = {}, 0 <= s.columnId ? Array.from({ length: c }, (f, h) => h).map((f) => ({
      index: f,
      value: u(s.columnId, f),
      required: d(f)
    })).sort((f, h) => {
      let b = i(f, h, s.columnType);
      return f.required && !h.required ? b = s.ascending ? -1 : 1 : !f.required && h.required && (b = s.ascending ? 1 : -1), s.ascending ? b : -b;
    }).forEach((f, h) => {
      a.value[h] = f.index;
    }) : Array.from({ length: c }, (f, h) => h).forEach((f) => {
      a.value[f] = f;
    });
  }
  function i(s, c, u) {
    if (u & ze.check_column || u & ze.file_size || u & ze.number) {
      if (Number.isNaN(s.value) && Number.isNaN(c.value))
        return s.value.localeCompare(c.value);
      if (Number.isNaN(s.value))
        return -1;
      if (Number.isNaN(c.value))
        return 1;
      const d = Number.parseInt(s.value), f = Number.parseInt(c.value);
      return d - f;
    } else
      return s.value.localeCompare(c.value);
  }
  return {
    selectedItemIndexes: t,
    displayedSelectedRowIndexes: n,
    updateSelectedItemIndexes: r,
    rowIndexToItemIndex: l,
    performLogicalSort: o
  };
}
const qd = (e) => (Tt("data-v-bcd9549c"), e = e(), It(), e), jd = { class: "paginated-list-ctrl" }, Gd = { class: "listArea d-flex flex-column flex-grow-1" }, Qd = {
  key: 0,
  class: "title-belt-table"
}, Kd = {
  key: 0,
  class: "d-flex align-items-center ms-auto"
}, Xd = /* @__PURE__ */ qd(() => /* @__PURE__ */ k("button", {
  class: "btn-scv-bgcolor btn-icon",
  id: "navbarDropdown",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  style: { "margin-left": "8px" }
}, [
  /* @__PURE__ */ k("div", { class: "d-flex align-items-center justify-content-center" }, [
    /* @__PURE__ */ k("div", { class: "icon-font-deepblue" }, [
      /* @__PURE__ */ k("i", { class: "icon-menu" })
    ])
  ])
], -1)), Zd = {
  class: "dropdown-menu scv-dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}, Jd = ["onClick"], ef = { class: "d-flex align-items-center justify-content-center" }, tf = { class: "icon-font-deepblue" }, af = {
  key: 1,
  style: { height: "16px" }
}, nf = { key: 3 }, rf = /* @__PURE__ */ Te({
  __name: "PaginatedListCtrl",
  props: {
    dataGetter: { type: Function, default: (e, a) => "" },
    columns: {},
    totalItems: {},
    styles: { default: Xa.Minimum },
    selection: { default: Dn.None },
    forgetSelectionAfterSort: { type: Boolean, default: !0 },
    selectedItemIndexes: {},
    checkStateGetter: { type: Function, default: (e, a) => !1 },
    columnStylesGetter: { type: Function, default: () => ({}) },
    rowClassGetter: { type: Function, default: () => "" },
    selectedColumnStylesGetter: { type: Function, default: () => ({}) },
    rowSelectionCommitter: { type: Function, default: (e, a, t) => !0 },
    selectAllCommitter: { type: Function, default: (e, a) => !0 },
    itemsDisplayedPerPageChoices: { default: () => [10, 100, 1e3] },
    itemsDisplayedPerPage: { default: 100 },
    disbled: { type: Boolean, default: !1 },
    useMultiline: { type: Boolean, default: !1 },
    expandList: { type: Boolean, default: !1 },
    decorator: {},
    revision: { default: 0 },
    hasError: { type: Boolean, default: !1 }
  },
  emits: ["cellClicked", "selectionChanged", "toggleExpantion", "menuClicked", "columnClicked"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t, l = ea(), o = B(null), i = B(null), {
      selectedItemIndexes: s,
      displayedSelectedRowIndexes: c,
      updateSelectedItemIndexes: u,
      rowIndexToItemIndex: d,
      performLogicalSort: f
    } = zd(i), h = B(n.expandList), b = H(() => Dn.CheckBoxWithoutSelectAll === n.selection ? Dn.CheckBox : n.selection), w = H(() => Dn.CheckBoxWithoutSelectAll !== n.selection), D = H(() => (Xa.ShowDropdownMenu & n.styles) !== 0 && !!l.menu), $ = H(() => (Xa.ShowExpantionButton & n.styles) !== 0), T = H(() => !!l.header || D.value || $.value), g = H(() => l.menu ? l.menu() : []), M = H(() => Xa.DisposePagination & n.styles ? !1 : Xa.ShowPaginationIfNeeded & n.styles ? Math.min(...n.itemsDisplayedPerPageChoices) < n.totalItems : !0), A = H(() => {
      if (!M.value)
        return n.totalItems;
      const J = n.itemsDisplayedPerPageChoices.find((x) => x === n.itemsDisplayedPerPage);
      if (J)
        return J;
      const L = Math.min(...n.itemsDisplayedPerPageChoices);
      if (n.itemsDisplayedPerPage <= L)
        return L;
      const F = Math.max(...n.itemsDisplayedPerPageChoices);
      return F <= n.itemsDisplayedPerPage ? F : n.itemsDisplayedPerPageChoices.reduce((x, N) => Math.abs(N - n.itemsDisplayedPerPage) < Math.abs(x - n.itemsDisplayedPerPage) ? N : x);
    });
    et(() => n.selectedItemIndexes, () => {
      var J, L;
      ii(xl(s.value), xl(n.selectedItemIndexes)) || (s.value = n.selectedItemIndexes ?? [], (L = o.value) == null || L.selectRows(
        (J = n.decorator) != null && J.getSelectedRowIndexesInPage ? n.decorator.getSelectedRowIndexesInPage(0, A.value) : c.value
      ));
    }), et(s, (J, L) => {
      r("selectionChanged", s.value);
    }, { immediate: !0 }), et(() => n.totalItems, () => {
      s.value = n.selectedItemIndexes ?? [], mt(() => {
        P();
      });
    }), et(() => n.revision, () => {
      mt(() => {
        P();
      });
    }), Xe(() => {
      s.value = n.selectedItemIndexes ?? [], mt(() => {
        P();
      });
    });
    function P() {
      var J, L, F, x, N, Z, ae, p;
      if ((J = i.value) == null || J.set(A.value, n.totalItems), (L = o.value) == null || L.updateList(Math.min(n.totalItems, A.value)), o.value) {
        const W = o.value.getSortColumnID(), ve = {
          columnId: W,
          ascending: o.value.getIsAsc(),
          columnType: ((F = n.columns.find((Fe) => Fe.columnID === W)) == null ? void 0 : F.dataType) ?? 0
        };
        if ((x = n.decorator) != null && x.performLogicalSort)
          n.decorator.performLogicalSort(ve.columnId, ve.ascending);
        else {
          const Fe = () => !1;
          f(
            ve,
            n.totalItems,
            ((N = n.decorator) == null ? void 0 : N.getCellSortText) ?? n.dataGetter,
            ((Z = n.decorator) == null ? void 0 : Z.isRequired) ?? Fe
          );
        }
      }
      (p = o.value) == null || p.selectRows(
        (ae = n.decorator) != null && ae.getSelectedRowIndexesInPage ? n.decorator.getSelectedRowIndexesInPage(0, A.value) : c.value
      );
    }
    function C(J, L) {
      return n.dataGetter(J, d(L));
    }
    function O(J) {
      return n.columnStylesGetter(J);
    }
    function R(J) {
      return n.rowClassGetter(d(J));
    }
    function S(J) {
      return n.selectedColumnStylesGetter(d(J));
    }
    function X(J, L, F) {
      const x = new Set(J);
      return n.rowSelectionCommitter(
        new Set(d(J)),
        d(L),
        F
      ) ? x.has(L) ? x.delete(L) : x.add(L) : F.preventDefault(), Array.from(x);
    }
    function re(J, L) {
      return n.selectAllCommitter(d(J), L);
    }
    function fe(J, L) {
      return n.checkStateGetter(J, d(L));
    }
    function I(J, L) {
      r("cellClicked", J, d(L));
    }
    function V(J) {
      u(J);
    }
    function E() {
      var F, x, N, Z, ae;
      let [J, L] = (F = i.value) == null ? void 0 : F.get();
      n.totalItems < J - 1 + L && (L -= J + L - 1 - n.totalItems), (x = i.value) == null || x.set(L, n.totalItems), (N = o.value) == null || N.updateList(Math.min(n.totalItems, L)), (ae = o.value) == null || ae.selectRows(
        (Z = n.decorator) != null && Z.getSelectedRowIndexesInPage ? n.decorator.getSelectedRowIndexesInPage(J, L) : c.value
      );
    }
    function ee(J, L) {
      var x, N, Z, ae, p, W, ve, Fe;
      n.forgetSelectionAfterSort && (s.value = []);
      const F = {
        columnId: J,
        ascending: L,
        columnType: ((x = n.columns.find((K) => K.columnID === J)) == null ? void 0 : x.dataType) ?? 0
      };
      if ((N = n.decorator) != null && N.performLogicalSort) {
        n.decorator.performLogicalSort(F.columnId, F.ascending);
        let [K, Ee] = (Z = i.value) == null ? void 0 : Z.get();
        n.totalItems < K - 1 + Ee && (Ee -= K + Ee - 1 - n.totalItems), (ae = n.decorator) != null && ae.getSelectedRowIndexesInPage && ((p = o.value) == null || p.selectRows(
          n.decorator.getSelectedRowIndexesInPage(K, Ee)
        ));
      } else {
        const K = () => !1;
        f(
          F,
          n.totalItems,
          ((W = n.decorator) == null ? void 0 : W.getCellSortText) ?? n.dataGetter,
          ((ve = n.decorator) == null ? void 0 : ve.isRequired) ?? K
        ), (Fe = o.value) == null || Fe.selectRows(c.value);
      }
      r("columnClicked", F.columnId, F.ascending);
    }
    function ce() {
      h.value = !h.value, r("toggleExpantion", h.value);
    }
    function q(J) {
      r("menuClicked", J);
    }
    return a({
      onGetCellText: C
    }), (J, L) => (v(), y("div", jd, [
      k("div", Gd, [
        m(T) ? (v(), y("div", Qd, [
          ie(J.$slots, "header", {}, void 0, !0),
          m(D) || m($) ? (v(), y("div", Kd, [
            m(D) ? (v(), y(me, { key: 0 }, [
              Xd,
              k("div", Zd, [
                (v(!0), y(me, null, Me(m(g), (F, x) => (v(), y("div", {
                  key: x,
                  class: "scv-dropdown-menu-button"
                }, [
                  k("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0);",
                    onClick: (N) => q(x)
                  }, [
                    (v(), Pe(Va(F)))
                  ], 8, Jd)
                ]))), 128))
              ])
            ], 64)) : Y("", !0),
            m($) ? (v(), y("button", {
              key: 1,
              class: "btn-scv-bgcolor btn-icon",
              onClick: ce,
              style: { "margin-left": "8px" }
            }, [
              k("div", ef, [
                k("div", tf, [
                  k("i", {
                    class: pe([m(h) ? "icon-screen_undo" : "icon-screen_full"])
                  }, null, 2)
                ])
              ])
            ])) : Y("", !0)
          ])) : Y("", !0)
        ])) : Y("", !0),
        qe(Cd, {
          ref_key: "listCtrl",
          ref: o,
          class: "flex-grow-1",
          columns: n.columns,
          selectType: m(b),
          sortDeleteIndex: n.forgetSelectionAfterSort,
          enableSetting: !n.disbled,
          enableAllCheck: m(w),
          "multi-line": n.useMultiline,
          saveMemoryMode: !0,
          getCellTextFunc: C,
          getCellHTMLFunc: C,
          getCellCheckFunc: fe,
          getCellStyleFunc: O,
          getRowClassFunc: R,
          getSelectRowStyleFunc: S,
          selectRowCheckButtonFunc: X,
          selectHeaderCheckButtonFunc: re,
          hasError: n.hasError,
          onOnClickCell: I,
          onOnSelectIndexChanged: V,
          onOnColumnHeaderClick: ee
        }, {
          row: Ae(({ rowIndex: F }) => [
            ie(J.$slots, "row", {
              itemIndex: m(d)(F)
            }, void 0, !0)
          ]),
          _: 3
        }, 8, ["columns", "selectType", "sortDeleteIndex", "enableSetting", "enableAllCheck", "multi-line", "hasError"]),
        m(M) || J.$slots.footer ? (v(), y("div", af)) : Y("", !0),
        m(M) ? (v(), Pe(Ud, {
          key: 2,
          ref_key: "paginationArea",
          ref: i,
          selectChangeList: n.itemsDisplayedPerPageChoices,
          defaultSelect: m(A),
          onOnChanged: E
        }, null, 8, ["selectChangeList", "defaultSelect"])) : Y("", !0),
        J.$slots.footer ? (v(), y("div", nf, [
          ie(J.$slots, "footer", {}, void 0, !0)
        ])) : Y("", !0)
      ])
    ]));
  }
}), _b = /* @__PURE__ */ Ye(rf, [["__scopeId", "data-v-bcd9549c"]]), Uo = (e) => (Tt("data-v-c8b9e6ce"), e = e(), It(), e), lf = { class: "overflow-auto table-common-scv-out-border table-common-scv-bg" }, of = {
  class: "sticky-top",
  style: { "z-index": "990" }
}, sf = {
  key: 0,
  style: { width: "30px" }
}, uf = ["checked", "disabled"], cf = ["onClick"], df = {
  class: "d-flex flex-row align-items-center",
  style: { position: "relative", height: "100%", "align-items": "center" }
}, ff = {
  key: 0,
  class: "ellipsis"
}, pf = ["innerHTML"], mf = {
  key: 0,
  class: "icon-font-slategray"
}, vf = /* @__PURE__ */ Uo(() => /* @__PURE__ */ k("i", { class: "icon-arrow2top" }, null, -1)), hf = [
  vf
], yf = {
  key: 1,
  class: "icon-font-slategray"
}, gf = /* @__PURE__ */ Uo(() => /* @__PURE__ */ k("i", { class: "icon-arrow2down" }, null, -1)), bf = [
  gf
], wf = ["onMousedown"], _f = { key: 1 }, kf = {
  key: 2,
  style: { width: "0px", padding: "0 !important", border: "none" }
}, xf = ["onClick"], Cf = { key: 0 }, Df = ["onClick", "checked"], Tf = ["innerHTML", "onClick"], If = ["onClick"], Mf = { key: 1 }, Sf = {
  key: 2,
  style: { width: "0px", padding: "0 !important", border: "none" }
}, $f = 36, Pf = /* @__PURE__ */ Te({
  __name: "VariableListCtrl",
  props: {
    columns: { type: Array, required: !0 },
    // 対象カラム(Array<SearchColumnData>)
    selectType: { type: Number, default: 0 },
    // 0:選択なし 1:単数選択 2:複数選択 3:チェックボックス付複数選択
    saveMemoryMode: { type: Boolean, default: !1 },
    // 省メモリモード（ソートやページネーションなどをメモリ上で行わず、SQLなどで行うときにtrueにします）
    sortDeleteIndex: { type: Boolean, default: !0 },
    // true: ソート時に選択状態を忘れる
    /*
     * 通常テキストのcell文言作成
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのテキスト
     */
    getCellTextFunc: { type: Function, default: null },
    /*
     * アイコンとかリンクとかにしたいときcellのHTMLを取得
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのクラス名
     */
    getCellHTMLFunc: { type: Function, default: null },
    /*
     * cellの個別のstyleを取得
     * @param[in]   column: カラム
     * return cellのクラス名
     */
    getCellStyleFunc: { type: Function, default: null },
    /*
     * 行が選択された時の個別のstyleを取得
     * @param[in]   index: 行インデックス
     */
    getSelectRowStyleFunc: { type: Function, default: null },
    /* 行ごとのクラス名を取得 */
    getRowClassFunc: { type: Function, default: null },
    /* 複数行表示かどうか（paddingが前後に4px付くようになるだけ） */
    MultiLine: { type: Boolean, default: !1 }
  },
  emits: ["onClickCell", "onSelectIndexChanged", "onColumnHeaderClick"],
  setup(e, { expose: a, emit: t }) {
    class n {
      constructor() {
        /// <summary>
        /// カラムID
        /// </summary>
        te(this, "columnID", 0);
        /// <summary>
        /// 表示内容（includingHtmlがtrueならhtml文）
        /// </summary>
        te(this, "text", "");
        /// <summary>
        /// クラス名
        /// </summary>
        te(this, "className", "");
        /// <summary>
        /// HTML表示かどうか
        /// </summary>
        te(this, "includingHtml", !1);
        /// <summary>
        /// クリック時に親にイベントを返すかどうか
        /// </summary>
        te(this, "notifyClickEvent", !1);
        /// <summary>
        /// スタイル
        /// </summary>
        te(this, "style");
      }
    }
    class r {
      constructor() {
        /// <summary>
        /// セルデータ
        /// </summary>
        te(this, "cells", new Array());
        /// <summary>
        /// ID
        /// </summary>
        te(this, "id", 0);
      }
    }
    const l = e, o = t;
    let i = _a(new Array()), s = _a(new Array()), c = _a(new Array()), u = new Array(), d = -1, f = !0, h = "", b = -1, w = ze.no_sort, D = ze.html_column;
    const $ = B(), T = B([]);
    let g = 0, M = 0, A, P = !1, C = B(!1), O = B(/* @__PURE__ */ new Map()), R = null, S, X = window.innerWidth;
    Xe(() => {
      R = new ResizeObserver(() => fe()), R.observe($.value);
    });
    const re = H(() => Array.from(O.value.values())), fe = () => {
      0 < S || (S = window.setTimeout(() => {
        X != window.innerWidth && (C.value = !0, X = window.innerWidth), S = 0;
      }, 15));
    }, I = (j) => {
      l.selectType != 0 && l.selectType != 3 && (c.splice(0, c.length), c.push(j), o("onSelectIndexChanged", K()));
    }, V = (j) => {
      l.selectType != 0 && l.selectType != 3 && ae(j);
    }, E = (j) => {
      if (l.selectType != 0 && l.selectType != 3) {
        if (l.selectType == 1 || c.length == 0) {
          I(j);
          return;
        }
        var U = c[0];
        if (U != j) {
          c.splice(0, c.length);
          var Q = 0;
          if (U < j)
            for (Q = U; Q <= j; ++Q)
              c.push(Q);
          else
            for (Q = U; j <= Q; --Q)
              c.push(Q);
          c.sort(function(we, ge) {
            return we - ge;
          }), o("onSelectIndexChanged", K());
        }
      }
    }, ee = () => {
      if (c.length == s.length && c.length > 0)
        c.splice(0, c.length);
      else {
        c.splice(0, c.length);
        const j = s.length;
        for (let U = 0; U < j; ++U)
          c.push(U);
      }
      c.sort(function(j, U) {
        return j - U;
      }), o("onSelectIndexChanged", K());
    }, ce = (j) => {
      if (!P) {
        for (let U of l.columns)
          if (U.columnID == j && ze.no_sort & U.dataType)
            return;
        d == j ? f = !f : f = !0, d = j, l.saveMemoryMode || (N(), o("onSelectIndexChanged", K())), o("onColumnHeaderClick", d, f);
      }
    }, q = (j) => {
      l.selectType == 3 && ae(j);
    }, J = (j, U, Q) => {
      Q && o("onClickCell", U, j);
    }, L = (j, U, Q) => {
      g = j.clientX, M = T.value[Q].offsetWidth, A = U, P = !0, C.value = !0, document.addEventListener("mousemove", F), document.addEventListener("mouseup", x), document.body.style.userSelect = "none";
    }, F = (j) => {
      var U;
      if (A !== void 0) {
        const Q = j.clientX - g, we = M + Q;
        if (we >= $f && O.value.has(A)) {
          let ge = (U = O.value) == null ? void 0 : U.get(A);
          ge != null && (ge.columnWidth = we, ge.columnMinWidth = we, ge.columnMaxWidth = we);
        }
      }
    }, x = () => {
      document.removeEventListener("mousemove", F), document.removeEventListener("mouseup", x), A = void 0, document.body.style.userSelect = "", setTimeout(() => {
        P = !1;
      }, 0);
    }, N = () => {
      let j = new Array();
      if (l.sortDeleteIndex || (j = K()), c.splice(0, c.length), s.splice(0, s.length), l.saveMemoryMode)
        for (let Q = 0; Q < i.length; Q++)
          s.push(Q);
      else {
        var U = Z(l.columns, i, d, f, h);
        U.forEach((Q) => s.push(Q)), s.length != 0 && -1 < b;
      }
      l.sortDeleteIndex || _(j), mt(() => {
        ve();
      });
    }, Z = (j, U, Q, we, ge) => {
      const Oe = new Array();
      if (ge.length == 0)
        for (let Se = 0; Se < U.length; Se++)
          Oe.push(Se);
      else {
        const Se = ge.split(" ");
        for (let He = 0; He < U.length; He++)
          for (const Ge of Se) {
            if (Ge.length === 0)
              continue;
            U[He].cells.some((tt) => {
              if (tt.includingHtml) {
                const wt = Oa(tt.text).text();
                if (wt != null)
                  return wt.toLowerCase().indexOf(Ge.toLowerCase()) !== -1;
              }
              return tt.text.toLowerCase().indexOf(Ge.toLowerCase()) !== -1;
            }) && (Oe.includes(He) || Oe.push(He));
          }
      }
      let Le = -1, z = -1;
      for (let Se = 0; Se < j.length; Se++)
        if (j[Se].columnID == Q) {
          Le = Se, z = j[Se].dataType;
          break;
        }
      let he = -1;
      return we && (he = 1), Le != -1 && z != -1 && Oe.sort((Se, He) => {
        if (U[Se].cells.length <= Le)
          return 0;
        if (U[He].cells.length <= Le)
          return 0;
        if (ze.number & z) {
          const Ge = parseInt(U[Se].cells[Le].text), xe = parseInt(U[He].cells[Le].text);
          return isNaN(Ge) && isNaN(xe) ? U[Se].cells[Le].text.compareSort(U[He].cells[Le].text) * he : isNaN(Ge) ? -1 * he : isNaN(xe) ? 1 * he : (Ge - xe) * he;
        } else {
          let Ge = "";
          U[Se].cells[Le].includingHtml && !((ze.icon | ze.icon_s) & z) ? (Ge = Oa(U[Se].cells[Le].text).text(), Ge == null && (Ge = U[Se].cells[Le].text)) : Ge = U[Se].cells[Le].text;
          let xe = "";
          return U[He].cells[Le].includingHtml && !((ze.icon | ze.icon_s) & z) ? (xe = Oa(U[He].cells[Le].text).text(), xe == null && (xe = U[He].cells[Le].text)) : xe = U[He].cells[Le].text, Ge.toLocaleLowerCase().compareSort(xe.toLocaleLowerCase()) * he;
        }
      }), Oe;
    }, ae = (j) => {
      if (l.selectType == 1) {
        I(j);
        return;
      }
      var U = c.indexOf(j);
      0 <= U ? c.splice(U, 1) : c.push(j), c.sort(function(Q, we) {
        return Q - we;
      }), o("onSelectIndexChanged", K());
    }, p = (j) => {
      var U = "";
      if (c.includes(j) && l.selectType != 3) {
        let Q = "";
        l.getSelectRowStyleFunc != null && (Q = l.getSelectRowStyleFunc(j)), Q != null && 0 < Q.length ? U += " " + Q : U += " table-common-scv-select-cell-color";
      }
      return U;
    }, W = () => {
      if (O.value = /* @__PURE__ */ new Map(), C.value = !1, l.selectType == 3) {
        let U = new Zn();
        U.columnWidth = 36, U.columnMinWidth = 36, U.columnMaxWidth = 36, O.value.set(-1, U);
      }
      let j = !0;
      for (let U = 0; U < l.columns.length; ++U) {
        j && l.columns[U].columnWidth == null && (j = !1);
        let Q = new Zn();
        Q.columnWidth = 0 < (l.columns[U].columnWidth ?? 0) ? l.columns[U].columnWidth : void 0, Q.columnMaxWidth = 0 < (l.columns[U].columnMaxWidth ?? 0) ? l.columns[U].columnMaxWidth : void 0, O.value.set(l.columns[U].columnID, Q);
      }
    }, ve = () => {
      if (l.columns.length != 0 && (O.value.size == 0 && W(), T.value != null))
        for (let j = 0; j < T.value.length; ++j) {
          const Q = T.value[j].getBoundingClientRect();
          if (!O.value.has(l.columns[j].columnID))
            continue;
          let we = O.value.get(l.columns[j].columnID);
          we != null && (we.columnMinWidth == null || we.columnMinWidth < Q.width) && (we.columnMinWidth = Q.width, we.columnWidth = Q.width);
        }
    }, Fe = (j) => {
      i.splice(0, i.length), s.splice(0, s.length), c.splice(0, c.length), u = new Array();
      for (let U = 0; U < j; U++) {
        let Q = new r();
        l.getRowClassFunc != null && (u[U] = l.getRowClassFunc(U)), l.columns.forEach((we) => {
          let ge = new n();
          if (ge.columnID = we.columnID, l.getCellTextFunc != null && (ge.text = l.getCellTextFunc(we.columnID, U)), ge.className = "df-list-ctrl-cell", l.getCellStyleFunc != null) {
            const Oe = l.getCellStyleFunc(we.columnID);
            Oe != null && (ge.style = Oe);
          }
          if (l.getCellHTMLFunc != null) {
            const Oe = l.getCellHTMLFunc(we.columnID, U);
            Oe != "" && (ge.text = Oe, ge.includingHtml = !0);
          }
          ze.icon & we.dataType ? ge.className += " df-list-ctrl-cell-icon" : ze.icon_s & we.dataType && (ge.className += " df-list-ctrl-cell-icon-s"), ze.link & we.dataType && (ge.notifyClickEvent = !0), Q.cells.push(ge);
        }), i.push(Q);
      }
      W(), N();
    }, K = () => {
      let j = new Array();
      return c.forEach((U) => {
        U < s.length && j.push(s[U]);
      }), j.sort(function(U, Q) {
        return U - Q;
      }), j;
    }, Ee = (j, U) => {
      for (let Q of l.columns)
        if (Q.columnID == j && ze.no_sort & Q.dataType)
          return;
      d = j, f = U;
    }, ue = () => d, ye = () => f, _ = (j) => {
      c.splice(0, c.length);
      for (let U = 0; U < j.length; U++) {
        const Q = j[U];
        if (Q < 0 || i.length <= Q)
          continue;
        let we = s.indexOf(Q);
        we != -1 && c.push(we);
      }
    };
    return a({
      updateList: Fe,
      getSelectListIndex: K,
      setSort: Ee,
      getSortColumnID: ue,
      getIsAsc: ye,
      selectRows: _
    }), (j, U) => (v(), y("div", lf, [
      k("table", {
        ref_key: "ref_table",
        ref: $,
        class: pe(["table-common-scv text-nowrap table-striped", [e.MultiLine ? "table-common-scv-multiline" : ""]]),
        frame: "box",
        bordercolor: "lightgray",
        style: Be({ "table-layout": m(C) ? "fixed" : "auto" })
      }, [
        k("colgroup", null, [
          (v(!0), y(me, null, Me(re.value, (Q, we) => (v(), y("col", {
            key: we,
            style: Be({ minWidth: Q.columnMinWidth + "px", width: Q.columnWidth + "px", maxWidth: Q.columnMaxWidth + "px" })
          }, null, 4))), 128))
        ]),
        k("thead", of, [
          k("tr", null, [
            e.selectType === 3 ? (v(), y("th", sf, [
              k("input", {
                type: "checkbox",
                onClick: ee,
                checked: m(c).length == m(s).length && m(c).length > 0,
                disabled: m(s).length == 0
              }, null, 8, uf)
            ])) : Y("", !0),
            (v(!0), y(me, null, Me(e.columns, (Q, we) => (v(), y("th", {
              key: we,
              ref_for: !0,
              ref_key: "ref_tableHeader",
              ref: T,
              onClick: (ge) => ce(Q.columnID),
              style: Be({ cursor: m(w) & Q.dataType ? "default" : "pointer", overflow: "hidden" })
            }, [
              k("div", df, [
                m(D) & Q.dataType ? (v(), y("span", {
                  key: 1,
                  innerHTML: Q.text
                }, null, 8, pf)) : (v(), y("span", ff, _e(Q.text), 1)),
                m(d) === Q.columnID ? (v(), y(me, { key: 2 }, [
                  m(f) ? (v(), y("div", mf, hf)) : (v(), y("div", yf, bf))
                ], 64)) : Y("", !0),
                k("div", {
                  class: "resizer",
                  onMousedown: (ge) => L(ge, Q.columnID, we)
                }, null, 40, wf)
              ])
            ], 12, cf))), 128)),
            m(C) ? (v(), y("th", _f)) : (v(), y("th", kf))
          ])
        ]),
        k("tbody", null, [
          (v(!0), y(me, null, Me(m(s), (Q, we) => (v(), y("tr", {
            class: pe([Q < m(u).length ? m(u)[Q] : ""]),
            key: we,
            onClick: [
              yt((ge) => I(we), ["exact"]),
              yt((ge) => V(we), ["ctrl", "exact"]),
              yt((ge) => E(we), ["shift", "exact"])
            ]
          }, [
            e.selectType === 3 ? (v(), y("td", Cf, [
              k("input", {
                type: "checkbox",
                onClick: (ge) => q(we),
                checked: m(c).includes(we)
              }, null, 8, Df)
            ])) : Y("", !0),
            (v(!0), y(me, null, Me(m(i)[Q].cells, (ge, Oe) => (v(), y("td", {
              key: Oe,
              class: pe(ge.className + p(we)),
              style: Be(ge.style)
            }, [
              ge.includingHtml ? (v(), y("span", {
                key: 0,
                innerHTML: ge.text,
                onClick: (Le) => J(Q, ge.columnID, ge.notifyClickEvent)
              }, null, 8, Tf)) : (v(), y("span", {
                key: 1,
                onClick: (Le) => J(Q, ge.columnID, ge.notifyClickEvent)
              }, _e(ge.text), 9, If))
            ], 6))), 128)),
            m(C) ? (v(), y("td", Mf)) : (v(), y("td", Sf))
          ], 10, xf))), 128))
        ])
      ], 6)
    ]));
  }
}), kb = /* @__PURE__ */ Ye(Pf, [["__scopeId", "data-v-c8b9e6ce"]]), Vn = (e) => (Tt("data-v-1c9d1511"), e = e(), It(), e), Af = { class: "d-flex flex-wrap title-belt-table" }, Of = {
  class: "d-flex",
  style: { "min-height": "43px" }
}, Rf = {
  key: 0,
  class: "d-flex",
  style: { height: "40px", "border-radius": "4px", "background-color": "#64CDFF" }
}, Ef = { class: "d-flex align-items-center" }, Nf = { style: { "margin-left": "16px", "margin-right": "16px", "font-size": "14px", "font-weight": "700", color: "#fff" } }, Bf = { class: "d-flex align-items-center" }, Lf = { class: "dropdown-menu scv-dropdown-menu" }, Ff = {
  key: 1,
  class: "title-belt-table-text"
}, Vf = /* @__PURE__ */ Vn(() => /* @__PURE__ */ k("div", { style: { "min-width": "12px" } }, null, -1)), Hf = {
  class: "d-flex flex-row full-width flex-grow-1",
  style: { "padding-top": "4px", height: "43px" }
}, Yf = { class: "dropdown-menu keep-open-on-click scv-dropdown-menu" }, Wf = /* @__PURE__ */ Vn(() => /* @__PURE__ */ k("div", { style: { "min-width": "16px" } }, null, -1)), Uf = ["disabled"], zf = {
  key: 0,
  style: { "min-width": "16px" }
}, qf = {
  key: 0,
  style: { margin: "0px 8px" }
}, jf = ["disabled"], Gf = {
  key: 0,
  style: { "margin-left": "8px" }
}, Qf = {
  key: 1,
  style: { margin: "0px 8px" }
}, Kf = ["disabled"], Xf = {
  key: 0,
  style: { "margin-left": "8px" }
}, Zf = {
  key: 1,
  style: { margin: "0px 8px" }
}, Jf = ["disabled"], ep = {
  key: 0,
  style: { "margin-left": "8px" }
}, tp = {
  key: 1,
  style: { margin: "0px 8px" }
}, ap = ["disabled"], np = {
  key: 4,
  class: "d-flex flex-row ms-auto align-items-start"
}, rp = /* @__PURE__ */ Vn(() => /* @__PURE__ */ k("div", { style: { "min-width": "24px" } }, null, -1)), lp = {
  key: 0,
  style: { "margin-left": "8px" }
}, op = ["disabled"], sp = {
  key: 0,
  style: { "margin-left": "16px" }
}, ip = /* @__PURE__ */ Vn(() => /* @__PURE__ */ k("button", {
  class: "btn-scv-bgcolor btn-icon",
  "data-bs-toggle": "dropdown"
}, [
  /* @__PURE__ */ k("div", { class: "d-flex align-items-center justify-content-center" }, [
    /* @__PURE__ */ k("div", { class: "icon-font-deepblue" }, [
      /* @__PURE__ */ k("i", { class: "icon-menu" })
    ])
  ])
], -1)), up = { class: "dropdown-menu scv-dropdown-menu" }, cp = /* @__PURE__ */ Vn(() => /* @__PURE__ */ k("div", { style: { width: "16px" } }, null, -1)), dp = ["value"], fp = {
  key: 3,
  class: "right-text"
}, pp = /* @__PURE__ */ Te({
  __name: "ListTitleBar",
  props: {
    /*
     * タイトル
     */
    titleCaption: { type: String, default: "aaa" },
    /*
     * タイトルボタン
     */
    titleBotton_1: { type: String },
    /*
     * ボタン名
     */
    btnCaption_1: { type: String },
    btnCaption_2: { type: String },
    btnCaption_3: { type: String },
    btnCaption_4: { type: String },
    btnCaption_r1: { type: String },
    // 右寄り
    /*
     * ボタン説明テキスト(ボタンの前に表示されます。例：ADEプロファイル管理画面)
     */
    btnDescription_1: { type: String },
    btnDescription_2: { type: String },
    btnDescription_3: { type: String },
    btnDescription_4: { type: String },
    /*
     * ボタン説明テキストのスタイル
     */
    btnDescriptionStyle_1: { type: String },
    btnDescriptionStyle_2: { type: String },
    btnDescriptionStyle_3: { type: String },
    btnDescriptionStyle_4: { type: String },
    /*
     * 0(null) : 常にアクティブ
     * 1 : 単一選択時にのみアクティブ
     * 2 : 複数選択時にのみアクティブ
     * 3 : 単一又は複数選択時にのみアクティブ
     * 4 : リストにデータが1つ以上あるときのみアクティブ
     */
    btnActiveType_Title1: { type: Number, default: 0 },
    btnActiveType_1: { type: Number, default: 0 },
    btnActiveType_2: { type: Number, default: 0 },
    btnActiveType_3: { type: Number, default: 0 },
    btnActiveType_4: { type: Number, default: 0 },
    btnActiveType_r1: { type: Number, default: 0 },
    // 右寄り
    /*
     * ボタンのスタイル
     */
    additionalTitleClass_1: { type: Object, default: {} },
    additionalClass_1: { type: Object, default: {} },
    additionalClass_2: { type: Object, default: {} },
    additionalClass_3: { type: Object, default: {} },
    additionalClass_4: { type: Object, default: {} },
    additionalClass_r1: { type: Object, default: {} },
    // 右寄り(★ClassではなくStyle)
    additionalClassName_r1: { type: String, default: "btn-scv-white-small" },
    // 右寄りのクラス
    isBtndisabled_1: { type: Boolean, default: !1 },
    /* 強制的にボタン1をDisableにする*/
    isBtndisabled_2: { type: Boolean, default: !1 },
    /* 強制的にボタン2をDisableにする*/
    isBtndisabled_3: { type: Boolean, default: !1 },
    /* 強制的にボタン3をDisableにする*/
    /*
     * カウンター
     */
    rowCountArea: { type: Boolean, default: !1 },
    /* カウンターの有無 */
    rowCount: { type: Number, default: 0 },
    /* カウント数 */
    /*
     * その他
     */
    disabled: { type: Boolean, default: !1 },
    /* 強制的にボタンをDisableにする*/
    selectCount: { type: Number, default: 0 },
    /* 現在の選択数（ボタンのDisable判定に利用） */
    /*
     * 文字検索(非対応)
     */
    enableSearchText: { type: Boolean, default: !1 },
    /* 文字列検索バーの有無 */
    /*操作ボタン押下時のリスト: Array<DropdownItemBase> */
    menuItemList: { type: Object, default: {} },
    /*操作ボタンを使用するか */
    isUseMenuItemList: { type: Boolean, default: !1 },
    /*表示設定押下時のリスト: Array<DropdownItemBase> */
    selectmenuItemList: { type: Object, default: {} },
    /*表示設定ボタンを使用するか */
    isUseSelectMenuItemList: { type: Boolean, default: !1 },
    /*「三」押下時のリスト: Array<DropdownItemBase> */
    rightMenuItemList: { type: Object, default: {} },
    /*表示設定ボタンを使用するか */
    isUseRightMenuItemList: { type: Boolean, default: !1 },
    /* 右側に表示する文字列 */
    rightText: { type: String, default: "" }
  },
  emits: ["onBtnTitleClicked_1", "onBtnClicked_1", "onBtnClicked_2", "onBtnClicked_3", "onBtnClicked_4", "onBtnClicked_r1", "onClickMenuItem", "onChangeMenuItem", "onClickRightMenuItem"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = () => {
      n("onBtnTitleClicked_1");
    }, l = () => {
      n("onBtnClicked_1");
    }, o = () => {
      n("onBtnClicked_2");
    }, i = () => {
      n("onBtnClicked_3");
    }, s = () => {
      n("onBtnClicked_4");
    }, c = () => {
      n("onBtnClicked_r1");
    }, u = (b) => {
      n("onClickMenuItem", b);
    }, d = (b) => {
      n("onChangeMenuItem", b);
    }, f = (b) => {
      n("onClickRightMenuItem", b);
    }, h = (b) => {
      switch (b) {
        case 1:
          if (t.selectCount == 1)
            return !1;
          break;
        case 2:
          if (2 <= t.selectCount)
            return !1;
          break;
        case 3:
          if (1 <= t.selectCount)
            return !1;
          break;
        case 4:
          if (1 <= t.rowCount)
            return !1;
          break;
        case 0:
        default:
          return !1;
      }
      return !0;
    };
    return (b, w) => (v(), y("div", Af, [
      k("div", Of, [
        e.isUseMenuItemList === !0 && e.selectCount > 0 ? (v(), y("div", Rf, [
          k("div", Ef, [
            k("span", Nf, _e(e.selectCount) + "件選択中", 1)
          ]),
          k("div", Bf, [
            qe(Cl, { style: { width: "88px", "margin-right": "4px" } }, {
              text: Ae(() => [
                Je(" 操作 ")
              ]),
              _: 1
            }),
            k("div", Lf, [
              qe(Dl, {
                models: e.menuItemList,
                onOnClickMenuItem: u
              }, null, 8, ["models"])
            ])
          ])
        ])) : (v(), y("span", Ff, _e(e.titleCaption), 1)),
        Vf
      ]),
      k("div", Hf, [
        ie(b.$slots, "label", {}, void 0, !0),
        e.isUseSelectMenuItemList ? (v(), y(me, { key: 0 }, [
          qe(Cl, { style: { width: "119px", height: "32px" } }, {
            text: Ae(() => [
              Je(" 表示設定 ")
            ]),
            _: 1
          }),
          k("div", Yf, [
            qe(Gi, {
              models: e.selectmenuItemList,
              onOnChangeMenuItem: d
            }, null, 8, ["models"])
          ]),
          Wf
        ], 64)) : Y("", !0),
        e.titleBotton_1 ? (v(), y("button", {
          key: 1,
          type: "button",
          class: "btn-scv-white-small listBtnLayout",
          disabled: e.disabled || h(e.btnActiveType_Title1),
          onClick: r,
          style: Be(e.additionalTitleClass_1)
        }, _e(e.titleBotton_1), 13, Uf)) : Y("", !0),
        e.btnCaption_1 || e.btnCaption_2 || e.btnCaption_3 ? (v(), y(me, { key: 2 }, [
          e.titleBotton_1 ? (v(), y("div", zf)) : Y("", !0),
          e.btnCaption_1 ? (v(), y(me, { key: 1 }, [
            e.btnDescription_1 ? (v(), y("div", qf, [
              k("span", {
                class: "title-belt-table-no-center-text",
                style: Be(e.btnDescriptionStyle_1)
              }, _e(e.btnDescription_1), 5)
            ])) : Y("", !0),
            k("button", {
              type: "button",
              class: "btn-scv-white-small listBtnLayout",
              disabled: e.disabled || h(e.btnActiveType_1) || e.isBtndisabled_1,
              onClick: l,
              style: Be(e.additionalClass_1)
            }, _e(e.btnCaption_1), 13, jf)
          ], 64)) : Y("", !0),
          e.btnCaption_2 ? (v(), y(me, { key: 2 }, [
            e.btnCaption_1 ? (v(), y("div", Gf)) : Y("", !0),
            e.btnDescription_2 ? (v(), y("div", Qf, [
              k("span", {
                class: "title-belt-table-no-center-text",
                style: Be(e.btnDescriptionStyle_2)
              }, _e(e.btnDescription_2), 5)
            ])) : Y("", !0),
            k("button", {
              type: "button",
              class: "btn-scv-white-small listBtnLayout",
              disabled: e.disabled || h(e.btnActiveType_2) || e.isBtndisabled_2,
              onClick: o,
              style: Be(e.additionalClass_2)
            }, _e(e.btnCaption_2), 13, Kf)
          ], 64)) : Y("", !0),
          e.btnCaption_3 ? (v(), y(me, { key: 3 }, [
            e.btnCaption_1 || e.btnCaption_2 ? (v(), y("div", Xf)) : Y("", !0),
            e.btnDescription_3 ? (v(), y("div", Zf, [
              k("span", {
                class: "title-belt-table-no-center-text",
                style: Be(e.btnDescriptionStyle_3)
              }, _e(e.btnDescription_3), 5)
            ])) : Y("", !0),
            k("button", {
              type: "button",
              class: "btn-scv-white-small listBtnLayout",
              disabled: e.disabled || h(e.btnActiveType_3) || e.isBtndisabled_3,
              onClick: i,
              style: Be(e.additionalClass_3)
            }, _e(e.btnCaption_3), 13, Jf)
          ], 64)) : Y("", !0)
        ], 64)) : Y("", !0),
        e.btnCaption_4 ? (v(), y(me, { key: 3 }, [
          e.btnCaption_1 || e.btnCaption_2 || e.btnCaption_3 ? (v(), y("div", ep)) : Y("", !0),
          e.btnDescription_4 ? (v(), y("div", tp, [
            k("span", {
              class: "title-belt-table-no-center-text",
              style: Be(e.btnDescriptionStyle_4)
            }, _e(e.btnDescription_4), 5)
          ])) : Y("", !0),
          k("button", {
            type: "button",
            class: "btn-scv-white-small listBtnLayout",
            disabled: e.disabled || h(e.btnActiveType_4),
            onClick: s,
            style: Be(e.additionalClass_4)
          }, _e(e.btnCaption_4), 13, ap)
        ], 64)) : Y("", !0),
        e.enableSearchText || e.btnCaption_r1 || e.rowCountArea || e.isUseRightMenuItemList || e.rightText.length > 0 ? (v(), y("div", np, [
          rp,
          e.btnCaption_r1 ? (v(), y(me, { key: 0 }, [
            e.enableSearchText ? (v(), y("div", lp)) : Y("", !0),
            k("button", {
              type: "button",
              class: pe(e.additionalClassName_r1),
              disabled: e.disabled || h(e.btnActiveType_r1),
              onClick: c,
              style: Be(e.additionalClass_r1)
            }, _e(e.btnCaption_r1), 15, op)
          ], 64)) : Y("", !0),
          e.isUseRightMenuItemList ? (v(), y(me, { key: 1 }, [
            e.enableSearchText || e.btnCaption_r1 ? (v(), y("div", sp)) : Y("", !0),
            ip,
            k("div", up, [
              qe(Dl, {
                models: e.rightMenuItemList,
                onOnClickMenuItem: f
              }, null, 8, ["models"])
            ])
          ], 64)) : Y("", !0),
          e.rowCountArea ? (v(), y(me, { key: 2 }, [
            cp,
            k("input", {
              type: "text",
              class: "input-text-scv ms-auto",
              style: { width: "64px", height: "32px" },
              value: e.rowCount,
              readonly: ""
            }, null, 8, dp)
          ], 64)) : Y("", !0),
          e.rightText.length > 0 ? (v(), y("span", fp, _e(e.rightText), 1)) : Y("", !0)
        ])) : Y("", !0)
      ])
    ]));
  }
}), xb = /* @__PURE__ */ Ye(pp, [["__scopeId", "data-v-1c9d1511"]]), mp = ["id"], vp = /* @__PURE__ */ Hs('<div class="loader" data-v-be979695><div class="loader-one" data-v-be979695></div><div class="loader-two" data-v-be979695></div><div class="loader-three" data-v-be979695></div><div class="loader-four" data-v-be979695></div></div>', 1), hp = [
  vp
], yp = /* @__PURE__ */ Te({
  __name: "GlobalLoading",
  setup(e, { expose: a }) {
    const t = B("loading_global");
    Xe(() => {
      r();
    });
    const n = () => {
      let l = document.getElementById(t.value);
      l != null && (l.style.display = "flex");
    }, r = () => {
      let l = document.getElementById(t.value);
      l != null && (l.style.display = "none");
    };
    return a({
      start: n,
      stop: r
    }), (l, o) => (v(), y("div", {
      id: t.value,
      class: "loading"
    }, hp, 8, mp));
  }
}), Cb = /* @__PURE__ */ Ye(yp, [["__scopeId", "data-v-be979695"]]), Ut = class Ut {
  /*
   * ローディング開始
   */
  static Start() {
    Ut.loadingRef != null && (Ut.loadingcount++, Ut.loadingRef.start());
  }
  /*
   * ローディング終了
   */
  static Stop() {
    Ut.loadingRef != null && (Ut.loadingcount--, !(0 < Ut.loadingcount) && Ut.loadingRef.stop());
  }
  /* 
   * ローディング画面の参照を登録
   * ★App.vue意外から呼び出さないこと★
   */
  static SetLoading(a) {
    Ut.loadingRef = a;
  }
};
// 参照カウンタ
te(Ut, "loadingcount", 0), /*
 * ローディング画面のrefs
 */
te(Ut, "loadingRef");
let Ll = Ut;
const gp = (e) => (Tt("data-v-1cf65b3f"), e = e(), It(), e), bp = ["id"], wp = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scv-cmn",
  role: "document"
}, _p = { class: "modal-content modal-content-scv-cmn" }, kp = { class: "modal-header modal-header-scv-cmn" }, xp = { class: "modal-header-text-box-scv-cmn" }, Cp = { class: "modal-header-text-scv-cmn" }, Dp = /* @__PURE__ */ gp(() => /* @__PURE__ */ k("div", { class: "icon-font-slategray" }, [
  /* @__PURE__ */ k("i", { class: "icon-delete" })
], -1)), Tp = [
  Dp
], Ip = ["id"], Mp = { class: "modal-footer modal-footer-scv-cmn" }, Sp = { class: "d-flex justify-content-center" }, $p = /* @__PURE__ */ Te({
  __name: "TemplateModal",
  props: {
    modalId: { type: String, required: !0 },
    // モーダルのID
    autoClose: { type: Boolean, default: !0 },
    // 閉じるや×ボタンでモーダルを自動で閉じるかどうか
    hide_btn_ok: { type: Boolean, default: !1 },
    // OKボタンを非表示
    showScroll: { type: Boolean, default: !1 },
    // スクロールバーを表示するかどうか
    isFooterPositionCenter: { type: Boolean, default: !0 }
    // ボタン中央寄せするかどうか
  },
  emits: ["onOk", "onCancel", "onHidden"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t;
    let l;
    Xe(async () => {
      const u = document.getElementById(n.modalId);
      u != null && (u.addEventListener("shown.bs.modal", () => {
        u.focus();
      }), u.addEventListener("hidden.bs.modal", () => {
        r("onHidden");
      }), l = new li(u, {
        backdrop: "static",
        /* 背景をクリックしても閉じないように */
        focus: !0,
        keyboard: !1
        /* エスケープキーで閉じないように */
      }));
    });
    const o = () => {
      r("onOk");
    }, i = () => {
      r("onCancel"), n.autoClose && c();
    }, s = () => {
      l != null && l.show();
    }, c = () => {
      l != null && l.hide();
    };
    return a({
      show: s,
      hide: c
    }), (u, d) => (v(), y("div", {
      class: "modal fade",
      id: e.modalId,
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "modalFileUpload",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      k("div", wp, [
        k("div", _p, [
          k("div", kp, [
            k("div", xp, [
              k("div", Cp, [
                ie(u.$slots, "title", {}, () => [
                  Je("タイトル")
                ], !0)
              ])
            ]),
            k("a", {
              class: "btn-scv-cmn-close",
              onClick: i
            }, Tp)
          ]),
          k("div", {
            id: n.modalId + "scroll",
            class: pe(["modal-body modal-body-scv-cmn", { scroll: n.showScroll }])
          }, [
            ie(u.$slots, "body", {}, () => [
              Je(" ボディ部 ")
            ], !0)
          ], 10, Ip),
          k("div", Mp, [
            k("div", Sp, [
              k("div", {
                class: pe(["zero-font", [n.isFooterPositionCenter ? "" : "templateModalExFooter"]])
              }, [
                ie(u.$slots, "footer", {}, () => [
                  e.hide_btn_ok ? Y("", !0) : (v(), y("button", {
                    key: 0,
                    type: "button",
                    class: "btn-scv-blue",
                    style: { "margin-right": "40px" },
                    onClick: o
                  }, [
                    ie(u.$slots, "ok_text", {}, () => [
                      Je(" OK ")
                    ], !0)
                  ])),
                  k("button", {
                    type: "button",
                    class: "btn-scv-white",
                    onClick: i
                  }, [
                    ie(u.$slots, "cancel_text", {}, () => [
                      Je(" キャンセル ")
                    ], !0)
                  ])
                ], !0)
              ], 2)
            ])
          ])
        ])
      ])
    ], 8, bp));
  }
}), Pp = /* @__PURE__ */ Ye($p, [["__scopeId", "data-v-1cf65b3f"]]), Ap = {
  key: 0,
  class: "d-flex flex-row"
}, Op = ["src"], Rp = ["innerHTML"], Ep = {
  key: 1,
  class: "d-flex flex-row"
}, Np = ["src"], Bp = ["innerHTML"], Lp = {
  key: 2,
  class: "d-flex flex-row align-items-center"
}, Fp = ["src"], Vp = ["innerHTML"], Db = /* @__PURE__ */ Te({
  __name: "MessageBox",
  props: {
    info_icon: { type: String, default: "" },
    // 情報アイコンのパス
    alert_icon: { type: String, default: "" },
    // 警告アイコンのパス
    error_icon: { type: String, default: "" },
    // エラーアイコンのパス
    question_icon: { type: String, default: "" }
    // 確認アイコンのパス
  },
  emits: ["onOk", "onCancel"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t;
    Xe(async () => {
      const I = document.getElementById("modal_message_box");
      I != null && (I.addEventListener("shown.bs.modal", () => {
        $ ? Oa("#btn_cancel_modal_message_box").focus() : Oa("#btnOk_modal_message_box").focus(), P = !0;
      }), I.addEventListener("hidden.bs.modal", () => {
        u.value = da.Information, f.value = "", h.value = !1, b.value = !1, D = null, w.value = "OK", d.value = "", g.value = "", T = null, $ = !1, P = !1, M.value = !1, A.value = !0;
      }));
    });
    const l = (I) => {
      b.value = !I;
    }, o = (I) => {
      $ = I;
    }, i = () => P, s = (I, V, E, ee, ce = void 0, q = void 0, J = void 0, L, F) => {
      let x = !1;
      0 < f.value.length && (x = !0), f.value = I, u.value = V, D = E, ce == null || ce == "" ? d.value = "" : d.value = ce, fe(u.value) ? (q == null || q == "" ? w.value = "はい" : w.value = q, J == null || J == "" ? g.value = "いいえ" : g.value = J, T = ee) : q == null || q == "" ? w.value = "OK" : w.value = q, M.value = L, A.value = F, x || C.value.show();
    }, c = () => {
      C.value.hide();
    };
    a({
      ShowIcon: l,
      Show: s,
      Hide: c,
      SetCancelFocus: o,
      IsShown: i
    });
    const u = B(da.Information), d = B(""), f = B(""), h = B(!1), b = B(!1), w = B("");
    let D = null, $ = !1, T = null;
    const g = B(""), M = B(!1), A = B(!0);
    let P = !1;
    const C = B(), O = () => {
      A.value && c(), r("onOk", D);
    }, R = () => {
      fe(u.value) ? (c(), r("onCancel", T)) : r("onOk", D);
    }, S = (I) => d.value != "" ? d.value : I === da.Error ? "エラー" : I === da.Warning ? "警告" : I === da.Question ? "確認" : "情報", X = (I) => 0 <= I.indexOf("<br"), re = (I) => I === da.Error ? n.error_icon : I === da.Warning ? n.alert_icon : I === da.Question ? n.question_icon : n.info_icon, fe = (I) => I === da.Question;
    return (I, V) => (v(), Pe(Pp, {
      modalId: "modal_message_box",
      onOnCancel: R,
      autoClose: A.value,
      ref_key: "ref_TemplateModal",
      ref: C
    }, {
      title: Ae(() => [
        Je(_e(S(u.value)), 1)
      ]),
      body: Ae(() => [
        X(f.value) === !0 && h.value ? (v(), y("div", Ap, [
          ht(k("img", {
            src: re(u.value),
            height: "24",
            style: { "margin-right": "8px" }
          }, null, 8, Op), [
            [Aa, !b.value]
          ]),
          k("span", {
            innerHTML: f.value,
            style: { "margin-top": "4px", "overflow-y": "auto", "min-height": "50px", "max-height": "500px", "word-break": "break-all" }
          }, null, 8, Rp)
        ])) : X(f.value) === !0 ? (v(), y("div", Ep, [
          ht(k("img", {
            src: re(u.value),
            height: "24",
            style: { "margin-right": "8px" }
          }, null, 8, Np), [
            [Aa, !b.value]
          ]),
          k("span", {
            innerHTML: f.value,
            style: { "margin-top": "4px" }
          }, null, 8, Bp)
        ])) : (v(), y("div", Lp, [
          ht(k("img", {
            src: re(u.value),
            height: "24",
            style: { "margin-right": "8px" }
          }, null, 8, Fp), [
            [Aa, !b.value]
          ]),
          k("span", { innerHTML: f.value }, null, 8, Vp)
        ]))
      ]),
      footer: Ae(() => [
        fe(u.value) ? (v(), y(me, { key: 1 }, [
          k("button", {
            id: "btnOk_modal_message_box",
            type: "button",
            class: pe([M.value ? "btn-scv-white" : "btn-scv-blue"]),
            style: { "margin-right": "40px" },
            onClick: O
          }, _e(w.value), 3),
          k("button", {
            id: "btn_cancel_modal_message_box",
            type: "button",
            class: "btn-scv-white",
            onClick: R
          }, _e(g.value), 1)
        ], 64)) : (v(), y("button", {
          key: 0,
          id: "btnOk_modal_message_box",
          type: "button",
          class: pe([M.value ? "btn-scv-white" : "btn-scv-blue"]),
          onClick: O
        }, _e(w.value), 3))
      ]),
      _: 1
    }, 8, ["autoClose"]));
  }
}), Hp = (e) => (Tt("data-v-e8df1083"), e = e(), It(), e), Yp = ["id"], Wp = { class: "modal-content modal-content-scv-cmn" }, Up = { class: "modal-header modal-header-scv-cmn" }, zp = { class: "modal-header-text-box-scv-cmn" }, qp = { class: "modal-header-text-scv-cmn" }, jp = /* @__PURE__ */ Hp(() => /* @__PURE__ */ k("div", { class: "icon-font-slategray" }, [
  /* @__PURE__ */ k("i", { class: "icon-delete" })
], -1)), Gp = [
  jp
], Qp = {
  key: 0,
  class: "modal-footer modal-footer-scv-cmn"
}, Kp = { class: "d-flex justify-content-center" }, Xp = { class: "zero-font templateModalExFooter" }, Zp = /* @__PURE__ */ Te({
  __name: "TemplateModalEx",
  props: {
    show: { type: Boolean },
    showFooter: { type: Boolean, default: !0 },
    showScrollBar: { type: Boolean, default: !1 }
  },
  emits: ["update:show", "close", "ok", "shown", "hidden"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t, l = B(Ya.NewID()), { hideModal: o } = Ks(l.value, H({
      get: () => n.show,
      set: (d) => r("update:show", d)
    })), i = B(null);
    Xe(async () => {
      const d = document.getElementById(l.value);
      d != null && (d.addEventListener("shown.bs.modal", () => {
        d.focus(), r("shown");
      }), d.addEventListener("hidden.bs.modal", () => {
        r("hidden");
      }));
    });
    function s() {
      r("close"), o();
    }
    function c() {
      r("ok"), o();
    }
    function u() {
      i.value && (i.value.scrollTop = 0);
    }
    return a({
      scrollTop: u
    }), (d, f) => (v(), y("div", {
      class: "modal fade",
      id: m(l),
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "modalFileUpload",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      k("div", {
        class: pe(["modal-dialog modal-dialog-centered modal-dialog-scv-cmn", { "modal-dialog-scrollable": n.showScrollBar }]),
        role: "document"
      }, [
        k("div", Wp, [
          k("div", Up, [
            k("div", zp, [
              k("div", qp, [
                ie(d.$slots, "title", {}, () => [
                  Je("タイトル")
                ], !0)
              ])
            ]),
            k("a", {
              class: "btn-scv-cmn-close",
              onClick: s
            }, Gp)
          ]),
          k("div", {
            class: pe(["modal-body modal-body-scv-cmn", { hideFooter: !n.showFooter }]),
            ref_key: "modalBody",
            ref: i
          }, [
            ie(d.$slots, "body", {}, () => [
              Je(" ボディ部 ")
            ], !0)
          ], 2),
          n.showFooter ? (v(), y("div", Qp, [
            k("div", Kp, [
              k("div", Xp, [
                ie(d.$slots, "footer", {}, () => [
                  k("button", {
                    type: "button",
                    class: "btn-scv-blue",
                    style: { "margin-right": "40px" },
                    onClick: c
                  }, [
                    ie(d.$slots, "labelOk", {}, () => [
                      Je(" OK ")
                    ], !0)
                  ]),
                  k("button", {
                    type: "button",
                    class: "btn-scv-white",
                    onClick: s
                  }, [
                    ie(d.$slots, "labelCancel", {}, () => [
                      Je(" キャンセル ")
                    ], !0)
                  ])
                ], !0)
              ])
            ])
          ])) : Y("", !0)
        ])
      ], 2)
    ], 8, Yp));
  }
}), Tb = /* @__PURE__ */ Ye(Zp, [["__scopeId", "data-v-e8df1083"]]), Jp = { class: "d-flex align-items-center radio-height" }, em = ["id", "name", "value", "checked", "disabled"], tm = ["id", "for"], am = /* @__PURE__ */ Te({
  __name: "Radio",
  props: {
    name: { default: "" },
    modelValue: {},
    innerValue: {},
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    labelWidth: { default: void 0 },
    marginLeft: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = B(Ya.NewID()), l = H({
      get: () => t.modelValue,
      set: (i) => {
        n("update:modelValue", i);
      }
    });
    Xe(() => {
      o();
    }), et(() => t.label, (i) => {
      o();
    }, { immediate: !0 });
    function o() {
      const i = document.getElementById(r.value + "label");
      i && (i.innerText = t.label);
    }
    return (i, s) => (v(), y("div", Jp, [
      ht(k("input", {
        id: m(r),
        name: t.name,
        type: "radio",
        "onUpdate:modelValue": s[0] || (s[0] = (c) => ma(l) ? l.value = c : null),
        value: t.innerValue,
        checked: t.innerValue === t.modelValue,
        style: Be({ "margin-left": t.marginLeft + "px" }),
        disabled: t.disabled
      }, null, 12, em), [
        [Ys, m(l)]
      ]),
      ie(i.$slots, "default", {}, void 0, !0),
      k("div", {
        style: Be({
          width: t.labelWidth != null ? typeof t.labelWidth == "number" ? t.labelWidth + "px" : t.labelWidth : ""
        })
      }, [
        k("label", {
          id: m(r) + "label",
          for: m(r),
          class: "margin-l"
        }, null, 8, tm)
      ], 4)
    ]));
  }
}), Ib = /* @__PURE__ */ Ye(am, [["__scopeId", "data-v-040e14d7"]]);
class Fl {
  /// <summary>
  /// コンストラクタ
  /// </summary>
  constructor(a = 0, t = "", n = 0) {
    /// <summary>
    /// 検索ID
    /// </summary>
    te(this, "searchID", 0);
    /// <summary>
    /// 名称
    /// </summary>
    te(this, "strName", "");
    /// <summary>
    /// 選択タイプ
    /// </summary>
    te(this, "type", 0);
    this.searchID = a, this.strName = t, this.type = n;
  }
}
var va = /* @__PURE__ */ ((e) => (e[e.Text = 0] = "Text", e[e.Size = 1] = "Size", e[e.DateTimeRange = 2] = "DateTimeRange", e))(va || {});
class ir {
  constructor() {
    // 一意となるID
    te(this, "searchID", 0);
    // 検索の種類
    te(this, "searchType", va.Text);
    // ======================================
    // テキストデータ
    // ======================================
    // すべてを含む
    te(this, "strAndCondition", "");
    // いずれか含み
    te(this, "strOrCondition", "");
    // 含まない
    te(this, "strNotCondition", "");
    // ======================================
    // 数値データ
    // ======================================
    // 開始（nullは未入力）
    te(this, "num1", null);
    // 終了（nullは未入力）
    te(this, "num2", null);
    // ======================================
    // 日付データ
    // ======================================
    // 開始（nullは未入力） ※JSTで入れる想定。Webサーバーにアップロードしたときに勝手にUTCに変わる
    te(this, "dateTime1", null);
    // 終了（nullは未入力） ※JSTで入れる想定。Webサーバーにアップロードしたときに勝手にUTCに変わる
    te(this, "dateTime2", null);
  }
}
const el = (e) => (Tt("data-v-52c79c48"), e = e(), It(), e), nm = { class: "d-flex flex-row align-items-center" }, rm = /* @__PURE__ */ el(() => /* @__PURE__ */ k("span", {
  class: "search-keyword-text-text",
  style: { "min-width": "84px" }
}, "をすべて含み", -1)), lm = /* @__PURE__ */ el(() => /* @__PURE__ */ k("span", {
  class: "search-keyword-text-text",
  style: { "min-width": "98px" }
}, "をいずれか含み", -1)), om = /* @__PURE__ */ el(() => /* @__PURE__ */ k("span", {
  class: "search-keyword-text-text",
  style: { "min-width": "70px" }
}, "を含まない", -1)), hr = 100, sm = /* @__PURE__ */ Te({
  __name: "SearchKeywordTypeText",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(e, { expose: a }) {
    const t = e, n = B(new ir()), r = () => n.value.strAndCondition.trim().length != 0 || n.value.strOrCondition.trim().length != 0 || n.value.strNotCondition.trim().length != 0;
    return a({
      getData: () => r() ? (n.value.searchType = va.Text, n.value.searchID = t.searchID, n.value) : null,
      clearData: () => {
        n.value.strAndCondition = "", n.value.strOrCondition = "", n.value.strNotCondition = "";
      }
    }), (i, s) => (v(), y("div", nm, [
      qe(ka, {
        modelValue: n.value.strAndCondition,
        "onUpdate:modelValue": s[0] || (s[0] = (c) => n.value.strAndCondition = c),
        class: "input-text-scv input-text-scv-search-keyword-text",
        convertType: "text",
        placeholder: "文字列",
        maxlength: hr
      }, null, 8, ["modelValue"]),
      rm,
      qe(ka, {
        modelValue: n.value.strOrCondition,
        "onUpdate:modelValue": s[1] || (s[1] = (c) => n.value.strOrCondition = c),
        class: "input-text-scv input-text-scv-search-keyword-text",
        convertType: "text",
        placeholder: "文字列",
        maxlength: hr
      }, null, 8, ["modelValue"]),
      lm,
      qe(ka, {
        modelValue: n.value.strNotCondition,
        "onUpdate:modelValue": s[2] || (s[2] = (c) => n.value.strNotCondition = c),
        class: "input-text-scv input-text-scv-search-keyword-text",
        convertType: "text",
        placeholder: "文字列",
        maxlength: hr
      }, null, 8, ["modelValue"]),
      om
    ]));
  }
}), im = /* @__PURE__ */ Ye(sm, [["__scopeId", "data-v-52c79c48"]]), um = (e) => (Tt("data-v-a7da5350"), e = e(), It(), e), cm = { class: "d-flex flex-row align-items-center" }, dm = { class: "select-icon" }, fm = ["value"], pm = /* @__PURE__ */ um(() => /* @__PURE__ */ k("span", { class: "search-keyword-size-center-text" }, "～", -1)), mm = { class: "select-icon" }, vm = ["value"], hm = /* @__PURE__ */ Te({
  __name: "SearchKeywordTypeSize",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(e, { expose: a }) {
    const t = e, n = B(""), r = B(1024), l = B(""), o = B(1024), i = [
      { text: "Bytes", mul: 1 },
      { text: "KB", mul: 1024 },
      { text: "MB", mul: 1024 * 1024 },
      { text: "GB", mul: 1024 * 1024 * 1024 }
    ];
    return a({
      getData: () => {
        const c = n.value.trim(), u = l.value.trim();
        if (c == "" && u == "")
          return null;
        const d = new ir();
        if (d.searchID = t.searchID, d.searchType = va.Size, c != "") {
          const f = parseInt(c);
          isNaN(f) || (d.num1 = f * r.value);
        }
        if (u != "") {
          const f = parseInt(u);
          isNaN(f) || (d.num2 = f * o.value);
        }
        return d;
      }
    }), (c, u) => (v(), y("div", cm, [
      qe(ka, {
        modelValue: n.value,
        "onUpdate:modelValue": u[0] || (u[0] = (d) => n.value = d),
        class: "input-text-scv input-text-scv-search-keyword-size",
        convertType: "half-number",
        min: "0",
        max: "9999"
      }, null, 8, ["modelValue"]),
      k("div", dm, [
        ht(k("select", {
          class: "input-text-scv search-keyword-size-select-units",
          "onUpdate:modelValue": u[1] || (u[1] = (d) => r.value = d)
        }, [
          (v(), y(me, null, Me(i, (d) => k("option", {
            key: d.text,
            value: d.mul
          }, _e(d.text), 9, fm)), 64))
        ], 512), [
          [On, r.value]
        ])
      ]),
      pm,
      qe(ka, {
        modelValue: l.value,
        "onUpdate:modelValue": u[2] || (u[2] = (d) => l.value = d),
        class: "input-text-scv input-text-scv-search-keyword-size",
        convertType: "half-number",
        min: "0",
        max: "9999"
      }, null, 8, ["modelValue"]),
      k("div", mm, [
        ht(k("select", {
          class: "input-text-scv search-keyword-size-select-units",
          "onUpdate:modelValue": u[3] || (u[3] = (d) => o.value = d)
        }, [
          (v(), y(me, null, Me(i, (d) => k("option", {
            key: d.text,
            value: d.mul
          }, _e(d.text), 9, vm)), 64))
        ], 512), [
          [On, o.value]
        ])
      ])
    ]));
  }
}), ym = /* @__PURE__ */ Ye(hm, [["__scopeId", "data-v-a7da5350"]]), zo = 6048e5, gm = 864e5, bm = 6e4, qo = 36e5, wm = 1e3, Vl = Symbol.for("constructDateFrom");
function Ke(e, a) {
  return typeof e == "function" ? e(a) : e && typeof e == "object" && Vl in e ? e[Vl](a) : e instanceof Date ? new e.constructor(a) : new Date(a);
}
function Re(e, a) {
  return Ke(a || e, e);
}
function zt(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in);
  return isNaN(a) ? Ke((t == null ? void 0 : t.in) || e, NaN) : (a && n.setDate(n.getDate() + a), n);
}
function Zt(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in);
  if (isNaN(a)) return Ke(e, NaN);
  if (!a)
    return n;
  const r = n.getDate(), l = Ke(e, n.getTime());
  l.setMonth(n.getMonth() + a + 1, 0);
  const o = l.getDate();
  return r >= o ? l : (n.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    r
  ), n);
}
function jo(e, a, t) {
  const {
    years: n = 0,
    months: r = 0,
    weeks: l = 0,
    days: o = 0,
    hours: i = 0,
    minutes: s = 0,
    seconds: c = 0
  } = a, u = Re(e, t == null ? void 0 : t.in), d = r || n ? Zt(u, r + n * 12) : u, f = o || l ? zt(d, o + l * 7) : d, h = s + i * 60, w = (c + h * 60) * 1e3;
  return Ke(e, +f + w);
}
function _m(e, a, t) {
  return Ke(e, +Re(e) + a);
}
function km(e, a, t) {
  return _m(e, a * qo);
}
let xm = {};
function Wa() {
  return xm;
}
function Jt(e, a) {
  var i, s, c, u;
  const t = Wa(), n = (a == null ? void 0 : a.weekStartsOn) ?? ((s = (i = a == null ? void 0 : a.locale) == null ? void 0 : i.options) == null ? void 0 : s.weekStartsOn) ?? t.weekStartsOn ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = Re(e, a == null ? void 0 : a.in), l = r.getDay(), o = (l < n ? 7 : 0) + l - n;
  return r.setDate(r.getDate() - o), r.setHours(0, 0, 0, 0), r;
}
function sn(e, a) {
  return Jt(e, { ...a, weekStartsOn: 1 });
}
function Go(e, a) {
  const t = Re(e, a == null ? void 0 : a.in), n = t.getFullYear(), r = Ke(t, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const l = sn(r), o = Ke(t, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const i = sn(o);
  return t.getTime() >= l.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function er(e) {
  const a = Re(e), t = new Date(
    Date.UTC(
      a.getFullYear(),
      a.getMonth(),
      a.getDate(),
      a.getHours(),
      a.getMinutes(),
      a.getSeconds(),
      a.getMilliseconds()
    )
  );
  return t.setUTCFullYear(a.getFullYear()), +e - +t;
}
function Hn(e, ...a) {
  const t = Ke.bind(
    null,
    a.find((n) => typeof n == "object")
  );
  return a.map(t);
}
function Hl(e, a) {
  const t = Re(e, a == null ? void 0 : a.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Qo(e, a, t) {
  const [n, r] = Hn(
    t == null ? void 0 : t.in,
    e,
    a
  ), l = Hl(n), o = Hl(r), i = +l - er(l), s = +o - er(o);
  return Math.round((i - s) / gm);
}
function Cm(e, a) {
  const t = Go(e, a), n = Ke(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), sn(n);
}
function Dm(e, a, t) {
  return Zt(e, a * 3, t);
}
function tl(e, a, t) {
  return Zt(e, a * 12, t);
}
function Yl(e, a) {
  const t = +Re(e) - +Re(a);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function Ko(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function $n(e) {
  return !(!Ko(e) && typeof e != "number" || isNaN(+Re(e)));
}
function Wl(e, a) {
  const t = Re(e, a == null ? void 0 : a.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function Tm(e, a, t) {
  const [n, r] = Hn(
    t == null ? void 0 : t.in,
    e,
    a
  );
  return n.getFullYear() - r.getFullYear();
}
function Im(e, a, t) {
  const [n, r] = Hn(
    t == null ? void 0 : t.in,
    e,
    a
  ), l = Yl(n, r), o = Math.abs(Tm(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  const i = Yl(n, r) === -l, s = l * (o - +i);
  return s === 0 ? 0 : s;
}
function Xo(e, a) {
  const [t, n] = Hn(e, a.start, a.end);
  return { start: t, end: n };
}
function Zo(e, a) {
  const { start: t, end: n } = Xo(a == null ? void 0 : a.in, e);
  let r = +t > +n;
  const l = r ? +t : +n, o = r ? n : t;
  o.setHours(0, 0, 0, 0);
  let i = 1;
  const s = [];
  for (; +o <= l; )
    s.push(Ke(t, o)), o.setDate(o.getDate() + i), o.setHours(0, 0, 0, 0);
  return r ? s.reverse() : s;
}
function Pa(e, a) {
  const t = Re(e, a == null ? void 0 : a.in), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function Mm(e, a) {
  const { start: t, end: n } = Xo(a == null ? void 0 : a.in, e);
  let r = +t > +n;
  const l = r ? +Pa(t) : +Pa(n);
  let o = Pa(r ? n : t), i = 1;
  const s = [];
  for (; +o <= l; )
    s.push(Ke(t, o)), o = Dm(o, i);
  return r ? s.reverse() : s;
}
function Sm(e, a) {
  const t = Re(e, a == null ? void 0 : a.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Jo(e, a) {
  const t = Re(e, a == null ? void 0 : a.in), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Rn(e, a) {
  const t = Re(e, a == null ? void 0 : a.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function es(e, a) {
  var i, s, c, u;
  const t = Wa(), n = (a == null ? void 0 : a.weekStartsOn) ?? ((s = (i = a == null ? void 0 : a.locale) == null ? void 0 : i.options) == null ? void 0 : s.weekStartsOn) ?? t.weekStartsOn ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = Re(e, a == null ? void 0 : a.in), l = r.getDay(), o = (l < n ? -7 : 0) + 6 - (l - n);
  return r.setDate(r.getDate() + o), r.setHours(23, 59, 59, 999), r;
}
function Ul(e, a) {
  const t = Re(e, a == null ? void 0 : a.in), n = t.getMonth(), r = n - n % 3 + 3;
  return t.setMonth(r, 0), t.setHours(23, 59, 59, 999), t;
}
const $m = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Pm = (e, a, t) => {
  let n;
  const r = $m[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function yr(e) {
  return (a = {}) => {
    const t = a.width ? String(a.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Am = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Om = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Rm = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Em = {
  date: yr({
    formats: Am,
    defaultWidth: "full"
  }),
  time: yr({
    formats: Om,
    defaultWidth: "full"
  }),
  dateTime: yr({
    formats: Rm,
    defaultWidth: "full"
  })
}, Nm = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Bm = (e, a, t, n) => Nm[e];
function _n(e) {
  return (a, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let r;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : o;
      r = e.formattingValues[i] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      r = e.values[i] || e.values[o];
    }
    const l = e.argumentCallback ? e.argumentCallback(a) : a;
    return r[l];
  };
}
const Lm = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Fm = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Vm = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Hm = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Ym = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Wm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Um = (e, a) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, zm = {
  ordinalNumber: Um,
  era: _n({
    values: Lm,
    defaultWidth: "wide"
  }),
  quarter: _n({
    values: Fm,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: _n({
    values: Vm,
    defaultWidth: "wide"
  }),
  day: _n({
    values: Hm,
    defaultWidth: "wide"
  }),
  dayPeriod: _n({
    values: Ym,
    defaultWidth: "wide",
    formattingValues: Wm,
    defaultFormattingWidth: "wide"
  })
};
function kn(e) {
  return (a, t = {}) => {
    const n = t.width, r = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], l = a.match(r);
    if (!l)
      return null;
    const o = l[0], i = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(i) ? jm(i, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      qm(i, (d) => d.test(o))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(s) : s, c = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(c)
    ) : c;
    const u = a.slice(o.length);
    return { value: c, rest: u };
  };
}
function qm(e, a) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && a(e[t]))
      return t;
}
function jm(e, a) {
  for (let t = 0; t < e.length; t++)
    if (a(e[t]))
      return t;
}
function Gm(e) {
  return (a, t = {}) => {
    const n = a.match(e.matchPattern);
    if (!n) return null;
    const r = n[0], l = a.match(e.parsePattern);
    if (!l) return null;
    let o = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const i = a.slice(r.length);
    return { value: o, rest: i };
  };
}
const Qm = /^(\d+)(th|st|nd|rd)?/i, Km = /\d+/i, Xm = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Zm = {
  any: [/^b/i, /^(a|c)/i]
}, Jm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ev = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, av = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, nv = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, rv = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, lv = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ov = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, sv = {
  ordinalNumber: Gm({
    matchPattern: Qm,
    parsePattern: Km,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: kn({
    matchPatterns: Xm,
    defaultMatchWidth: "wide",
    parsePatterns: Zm,
    defaultParseWidth: "any"
  }),
  quarter: kn({
    matchPatterns: Jm,
    defaultMatchWidth: "wide",
    parsePatterns: ev,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: kn({
    matchPatterns: tv,
    defaultMatchWidth: "wide",
    parsePatterns: av,
    defaultParseWidth: "any"
  }),
  day: kn({
    matchPatterns: nv,
    defaultMatchWidth: "wide",
    parsePatterns: rv,
    defaultParseWidth: "any"
  }),
  dayPeriod: kn({
    matchPatterns: lv,
    defaultMatchWidth: "any",
    parsePatterns: ov,
    defaultParseWidth: "any"
  })
}, ts = {
  code: "en-US",
  formatDistance: Pm,
  formatLong: Em,
  formatRelative: Bm,
  localize: zm,
  match: sv,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function iv(e, a) {
  const t = Re(e, a == null ? void 0 : a.in);
  return Qo(t, Rn(t)) + 1;
}
function al(e, a) {
  const t = Re(e, a == null ? void 0 : a.in), n = +sn(t) - +Cm(t);
  return Math.round(n / zo) + 1;
}
function nl(e, a) {
  var u, d, f, h;
  const t = Re(e, a == null ? void 0 : a.in), n = t.getFullYear(), r = Wa(), l = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((d = (u = a == null ? void 0 : a.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = Ke((a == null ? void 0 : a.in) || e, 0);
  o.setFullYear(n + 1, 0, l), o.setHours(0, 0, 0, 0);
  const i = Jt(o, a), s = Ke((a == null ? void 0 : a.in) || e, 0);
  s.setFullYear(n, 0, l), s.setHours(0, 0, 0, 0);
  const c = Jt(s, a);
  return +t >= +i ? n + 1 : +t >= +c ? n : n - 1;
}
function uv(e, a) {
  var i, s, c, u;
  const t = Wa(), n = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((s = (i = a == null ? void 0 : a.locale) == null ? void 0 : i.options) == null ? void 0 : s.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((u = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, r = nl(e, a), l = Ke((a == null ? void 0 : a.in) || e, 0);
  return l.setFullYear(r, 0, n), l.setHours(0, 0, 0, 0), Jt(l, a);
}
function rl(e, a) {
  const t = Re(e, a == null ? void 0 : a.in), n = +Jt(t, a) - +uv(t, a);
  return Math.round(n / zo) + 1;
}
function Qe(e, a) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(a, "0");
  return t + n;
}
const ga = {
  // Year
  y(e, a) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return Qe(a === "yy" ? n % 100 : n, a.length);
  },
  // Month
  M(e, a) {
    const t = e.getMonth();
    return a === "M" ? String(t + 1) : Qe(t + 1, 2);
  },
  // Day of the month
  d(e, a) {
    return Qe(e.getDate(), a.length);
  },
  // AM or PM
  a(e, a) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, a) {
    return Qe(e.getHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H(e, a) {
    return Qe(e.getHours(), a.length);
  },
  // Minute
  m(e, a) {
    return Qe(e.getMinutes(), a.length);
  },
  // Second
  s(e, a) {
    return Qe(e.getSeconds(), a.length);
  },
  // Fraction of second
  S(e, a) {
    const t = a.length, n = e.getMilliseconds(), r = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return Qe(r, a.length);
  }
}, Ga = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, zl = {
  // Era
  G: function(e, a, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, a, t) {
    if (a === "yo") {
      const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
      return t.ordinalNumber(r, { unit: "year" });
    }
    return ga.y(e, a);
  },
  // Local week-numbering year
  Y: function(e, a, t, n) {
    const r = nl(e, n), l = r > 0 ? r : 1 - r;
    if (a === "YY") {
      const o = l % 100;
      return Qe(o, 2);
    }
    return a === "Yo" ? t.ordinalNumber(l, { unit: "year" }) : Qe(l, a.length);
  },
  // ISO week-numbering year
  R: function(e, a) {
    const t = Go(e);
    return Qe(t, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, a) {
    const t = e.getFullYear();
    return Qe(t, a.length);
  },
  // Quarter
  Q: function(e, a, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "Q":
        return String(n);
      case "QQ":
        return Qe(n, 2);
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, a, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "q":
        return String(n);
      case "qq":
        return Qe(n, 2);
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, a, t) {
    const n = e.getMonth();
    switch (a) {
      case "M":
      case "MM":
        return ga.M(e, a);
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, a, t) {
    const n = e.getMonth();
    switch (a) {
      case "L":
        return String(n + 1);
      case "LL":
        return Qe(n + 1, 2);
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, a, t, n) {
    const r = rl(e, n);
    return a === "wo" ? t.ordinalNumber(r, { unit: "week" }) : Qe(r, a.length);
  },
  // ISO week of year
  I: function(e, a, t) {
    const n = al(e);
    return a === "Io" ? t.ordinalNumber(n, { unit: "week" }) : Qe(n, a.length);
  },
  // Day of the month
  d: function(e, a, t) {
    return a === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : ga.d(e, a);
  },
  // Day of year
  D: function(e, a, t) {
    const n = iv(e);
    return a === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : Qe(n, a.length);
  },
  // Day of week
  E: function(e, a, t) {
    const n = e.getDay();
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, a, t, n) {
    const r = e.getDay(), l = (r - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "e":
        return String(l);
      case "ee":
        return Qe(l, 2);
      case "eo":
        return t.ordinalNumber(l, { unit: "day" });
      case "eee":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, a, t, n) {
    const r = e.getDay(), l = (r - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "c":
        return String(l);
      case "cc":
        return Qe(l, a.length);
      case "co":
        return t.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return t.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, a, t) {
    const n = e.getDay(), r = n === 0 ? 7 : n;
    switch (a) {
      case "i":
        return String(r);
      case "ii":
        return Qe(r, a.length);
      case "io":
        return t.ordinalNumber(r, { unit: "day" });
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, a, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, a, t) {
    const n = e.getHours();
    let r;
    switch (n === 12 ? r = Ga.noon : n === 0 ? r = Ga.midnight : r = n / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, a, t) {
    const n = e.getHours();
    let r;
    switch (n >= 17 ? r = Ga.evening : n >= 12 ? r = Ga.afternoon : n >= 4 ? r = Ga.morning : r = Ga.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, a, t) {
    if (a === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return ga.h(e, a);
  },
  // Hour [0-23]
  H: function(e, a, t) {
    return a === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : ga.H(e, a);
  },
  // Hour [0-11]
  K: function(e, a, t) {
    const n = e.getHours() % 12;
    return a === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : Qe(n, a.length);
  },
  // Hour [1-24]
  k: function(e, a, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), a === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : Qe(n, a.length);
  },
  // Minute
  m: function(e, a, t) {
    return a === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ga.m(e, a);
  },
  // Second
  s: function(e, a, t) {
    return a === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : ga.s(e, a);
  },
  // Fraction of second
  S: function(e, a) {
    return ga.S(e, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, a, t) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (a) {
      case "X":
        return jl(n);
      case "XXXX":
      case "XX":
        return $a(n);
      case "XXXXX":
      case "XXX":
      default:
        return $a(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      case "x":
        return jl(n);
      case "xxxx":
      case "xx":
        return $a(n);
      case "xxxxx":
      case "xxx":
      default:
        return $a(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ql(n, ":");
      case "OOOO":
      default:
        return "GMT" + $a(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ql(n, ":");
      case "zzzz":
      default:
        return "GMT" + $a(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, a, t) {
    const n = Math.trunc(+e / 1e3);
    return Qe(n, a.length);
  },
  // Milliseconds timestamp
  T: function(e, a, t) {
    return Qe(+e, a.length);
  }
};
function ql(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.trunc(n / 60), l = n % 60;
  return l === 0 ? t + String(r) : t + String(r) + a + Qe(l, 2);
}
function jl(e, a) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Qe(Math.abs(e) / 60, 2) : $a(e, a);
}
function $a(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), r = Qe(Math.trunc(n / 60), 2), l = Qe(n % 60, 2);
  return t + r + a + l;
}
const Gl = (e, a) => {
  switch (e) {
    case "P":
      return a.date({ width: "short" });
    case "PP":
      return a.date({ width: "medium" });
    case "PPP":
      return a.date({ width: "long" });
    case "PPPP":
    default:
      return a.date({ width: "full" });
  }
}, as = (e, a) => {
  switch (e) {
    case "p":
      return a.time({ width: "short" });
    case "pp":
      return a.time({ width: "medium" });
    case "ppp":
      return a.time({ width: "long" });
    case "pppp":
    default:
      return a.time({ width: "full" });
  }
}, cv = (e, a) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], r = t[2];
  if (!r)
    return Gl(e, a);
  let l;
  switch (n) {
    case "P":
      l = a.dateTime({ width: "short" });
      break;
    case "PP":
      l = a.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = a.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      l = a.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", Gl(n, a)).replace("{{time}}", as(r, a));
}, Or = {
  p: as,
  P: cv
}, dv = /^D+$/, fv = /^Y+$/, pv = ["D", "DD", "YY", "YYYY"];
function ns(e) {
  return dv.test(e);
}
function rs(e) {
  return fv.test(e);
}
function Rr(e, a, t) {
  const n = mv(e, a, t);
  if (console.warn(n), pv.includes(e)) throw new RangeError(n);
}
function mv(e, a, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${a}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const vv = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, hv = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yv = /^'([^]*?)'?$/, gv = /''/g, bv = /[a-zA-Z]/;
function ia(e, a, t) {
  var u, d, f, h, b, w, D, $;
  const n = Wa(), r = (t == null ? void 0 : t.locale) ?? n.locale ?? ts, l = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((h = (f = n.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = (t == null ? void 0 : t.weekStartsOn) ?? ((w = (b = t == null ? void 0 : t.locale) == null ? void 0 : b.options) == null ? void 0 : w.weekStartsOn) ?? n.weekStartsOn ?? (($ = (D = n.locale) == null ? void 0 : D.options) == null ? void 0 : $.weekStartsOn) ?? 0, i = Re(e, t == null ? void 0 : t.in);
  if (!$n(i))
    throw new RangeError("Invalid time value");
  let s = a.match(hv).map((T) => {
    const g = T[0];
    if (g === "p" || g === "P") {
      const M = Or[g];
      return M(T, r.formatLong);
    }
    return T;
  }).join("").match(vv).map((T) => {
    if (T === "''")
      return { isToken: !1, value: "'" };
    const g = T[0];
    if (g === "'")
      return { isToken: !1, value: wv(T) };
    if (zl[g])
      return { isToken: !0, value: T };
    if (g.match(bv))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: T };
  });
  r.localize.preprocessor && (s = r.localize.preprocessor(i, s));
  const c = {
    firstWeekContainsDate: l,
    weekStartsOn: o,
    locale: r
  };
  return s.map((T) => {
    if (!T.isToken) return T.value;
    const g = T.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && rs(g) || !(t != null && t.useAdditionalDayOfYearTokens) && ns(g)) && Rr(g, a, String(e));
    const M = zl[g[0]];
    return M(i, g, r.localize, c);
  }).join("");
}
function wv(e) {
  const a = e.match(yv);
  return a ? a[1].replace(gv, "'") : e;
}
function _v(e, a) {
  return Re(e, a == null ? void 0 : a.in).getDay();
}
function kv(e, a) {
  const t = Re(e, a == null ? void 0 : a.in), n = t.getFullYear(), r = t.getMonth(), l = Ke(t, 0);
  return l.setFullYear(n, r + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function xv() {
  return Object.assign({}, Wa());
}
function ya(e, a) {
  return Re(e, a == null ? void 0 : a.in).getHours();
}
function Cv(e, a) {
  const t = Re(e, a == null ? void 0 : a.in).getDay();
  return t === 0 ? 7 : t;
}
function Da(e, a) {
  return Re(e, a == null ? void 0 : a.in).getMinutes();
}
function We(e, a) {
  return Re(e, a == null ? void 0 : a.in).getMonth();
}
function un(e) {
  return Re(e).getSeconds();
}
function Ne(e, a) {
  return Re(e, a == null ? void 0 : a.in).getFullYear();
}
function Fa(e, a) {
  return +Re(e) > +Re(a);
}
function cn(e, a) {
  return +Re(e) < +Re(a);
}
function Ja(e, a) {
  return +Re(e) == +Re(a);
}
function Dv(e, a) {
  const t = Tv(a) ? new a(0) : Ke(a, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function Tv(e) {
  var a;
  return typeof e == "function" && ((a = e.prototype) == null ? void 0 : a.constructor) === e;
}
const Iv = 10;
class ls {
  constructor() {
    te(this, "subPriority", 0);
  }
  validate(a, t) {
    return !0;
  }
}
class Mv extends ls {
  constructor(a, t, n, r, l) {
    super(), this.value = a, this.validateValue = t, this.setValue = n, this.priority = r, l && (this.subPriority = l);
  }
  validate(a, t) {
    return this.validateValue(a, this.value, t);
  }
  set(a, t, n) {
    return this.setValue(a, t, this.value, n);
  }
}
class Sv extends ls {
  constructor(t, n) {
    super();
    te(this, "priority", Iv);
    te(this, "subPriority", -1);
    this.context = t || ((r) => Ke(n, r));
  }
  set(t, n) {
    return n.timestampIsSet ? t : Ke(t, Dv(t, this.context));
  }
}
class je {
  run(a, t, n, r) {
    const l = this.parse(a, t, n, r);
    return l ? {
      setter: new Mv(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(a, t, n) {
    return !0;
  }
}
class $v extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 140);
    te(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, n, r) {
    return n.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const ft = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ra = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function pt(e, a) {
  return e && {
    value: a(e.value),
    rest: e.rest
  };
}
function lt(e, a) {
  const t = a.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: a.slice(t[0].length)
  } : null;
}
function la(e, a) {
  const t = a.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  const n = t[1] === "+" ? 1 : -1, r = t[2] ? parseInt(t[2], 10) : 0, l = t[3] ? parseInt(t[3], 10) : 0, o = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (r * qo + l * bm + o * wm),
    rest: a.slice(t[0].length)
  };
}
function os(e) {
  return lt(ft.anyDigitsSigned, e);
}
function st(e, a) {
  switch (e) {
    case 1:
      return lt(ft.singleDigit, a);
    case 2:
      return lt(ft.twoDigits, a);
    case 3:
      return lt(ft.threeDigits, a);
    case 4:
      return lt(ft.fourDigits, a);
    default:
      return lt(new RegExp("^\\d{1," + e + "}"), a);
  }
}
function tr(e, a) {
  switch (e) {
    case 1:
      return lt(ft.singleDigitSigned, a);
    case 2:
      return lt(ft.twoDigitsSigned, a);
    case 3:
      return lt(ft.threeDigitsSigned, a);
    case 4:
      return lt(ft.fourDigitsSigned, a);
    default:
      return lt(new RegExp("^-?\\d{1," + e + "}"), a);
  }
}
function ll(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function ss(e, a) {
  const t = a > 0, n = t ? a : 1 - a;
  let r;
  if (n <= 50)
    r = e || 100;
  else {
    const l = n + 50, o = Math.trunc(l / 100) * 100, i = e >= l % 100;
    r = e + o - (i ? 100 : 0);
  }
  return t ? r : 1 - r;
}
function is(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Pv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, r) {
    const l = (o) => ({
      year: o,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return pt(st(4, t), l);
      case "yo":
        return pt(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return pt(st(n.length, t), l);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, r) {
    const l = t.getFullYear();
    if (r.isTwoDigitYear) {
      const i = ss(
        r.year,
        l
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const o = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Av extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    const l = (o) => ({
      year: o,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return pt(st(4, t), l);
      case "Yo":
        return pt(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return pt(st(n.length, t), l);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, r, l) {
    const o = nl(t, l);
    if (r.isTwoDigitYear) {
      const s = ss(
        r.year,
        o
      );
      return t.setFullYear(
        s,
        0,
        l.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), Jt(t, l);
    }
    const i = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, l.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Jt(t, l);
  }
}
class Ov extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n) {
    return tr(n === "R" ? 4 : n.length, t);
  }
  set(t, n, r) {
    const l = Ke(t, 0);
    return l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0), sn(l);
  }
}
class Rv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n) {
    return tr(n === "u" ? 4 : n.length, t);
  }
  set(t, n, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Ev extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 120);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    switch (n) {
      case "Q":
      case "QQ":
        return st(n.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Nv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 120);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    switch (n) {
      case "q":
      case "qq":
        return st(n.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Bv extends je {
  constructor() {
    super(...arguments);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    te(this, "priority", 110);
  }
  parse(t, n, r) {
    const l = (o) => o - 1;
    switch (n) {
      case "M":
        return pt(
          lt(ft.month, t),
          l
        );
      case "MM":
        return pt(st(2, t), l);
      case "Mo":
        return pt(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Lv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 110);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    const l = (o) => o - 1;
    switch (n) {
      case "L":
        return pt(
          lt(ft.month, t),
          l
        );
      case "LL":
        return pt(st(2, t), l);
      case "Lo":
        return pt(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Fv(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in), r = rl(n, t) - a;
  return n.setDate(n.getDate() - r * 7), Re(n, t == null ? void 0 : t.in);
}
class Vv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 100);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    switch (n) {
      case "w":
        return lt(ft.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, r, l) {
    return Jt(Fv(t, r, l), l);
  }
}
function Hv(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in), r = al(n, t) - a;
  return n.setDate(n.getDate() - r * 7), n;
}
class Yv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 100);
    te(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    switch (n) {
      case "I":
        return lt(ft.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, r) {
    return sn(Hv(t, r));
  }
}
const Wv = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Uv = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class zv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "subPriority", 1);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    switch (n) {
      case "d":
        return lt(ft.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    const r = t.getFullYear(), l = is(r), o = t.getMonth();
    return l ? n >= 1 && n <= Uv[o] : n >= 1 && n <= Wv[o];
  }
  set(t, n, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}
class qv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "subpriority", 1);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    switch (n) {
      case "D":
      case "DD":
        return lt(ft.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    const r = t.getFullYear();
    return is(r) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
}
function ol(e, a, t) {
  var d, f, h, b;
  const n = Wa(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((b = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : b.weekStartsOn) ?? 0, l = Re(e, t == null ? void 0 : t.in), o = l.getDay(), s = (a % 7 + 7) % 7, c = 7 - r, u = a < 0 || a > 6 ? a - (o + c) % 7 : (s + c) % 7 - (o + c) % 7;
  return zt(l, u, t);
}
class jv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, r, l) {
    return t = ol(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
class Gv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r, l) {
    const o = (i) => {
      const s = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + s;
    };
    switch (n) {
      case "e":
      case "ee":
        return pt(st(n.length, t), o);
      case "eo":
        return pt(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, r, l) {
    return t = ol(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
class Qv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, n, r, l) {
    const o = (i) => {
      const s = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + s;
    };
    switch (n) {
      case "c":
      case "cc":
        return pt(st(n.length, t), o);
      case "co":
        return pt(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, r, l) {
    return t = ol(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
function Kv(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in), r = Cv(n, t), l = a - r;
  return zt(n, l, t);
}
class Xv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, r) {
    const l = (o) => o === 0 ? 7 : o;
    switch (n) {
      case "i":
      case "ii":
        return st(n.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return pt(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiiii":
        return pt(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiiiii":
        return pt(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiii":
      default:
        return pt(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, r) {
    return t = Kv(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
class Zv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 80);
    te(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, r) {
    return t.setHours(ll(r), 0, 0, 0), t;
  }
}
class Jv extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 80);
    te(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, r) {
    return t.setHours(ll(r), 0, 0, 0), t;
  }
}
class eh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 80);
    te(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, r) {
    return t.setHours(ll(r), 0, 0, 0), t;
  }
}
class th extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "h":
        return lt(ft.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, r) {
    const l = t.getHours() >= 12;
    return l && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !l && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class ah extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "H":
        return lt(ft.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
}
class nh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "K":
        return lt(ft.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class rh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "k":
        return lt(ft.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, r) {
    const l = r <= 24 ? r % 24 : r;
    return t.setHours(l, 0, 0, 0), t;
  }
}
class lh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 60);
    te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "m":
        return lt(ft.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class oh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 50);
    te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, r) {
    switch (n) {
      case "s":
        return lt(ft.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return st(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, r) {
    return t.setSeconds(r, 0), t;
  }
}
class sh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 30);
    te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n) {
    const r = (l) => Math.trunc(l * Math.pow(10, -n.length + 3));
    return pt(st(n.length, t), r);
  }
  set(t, n, r) {
    return t.setMilliseconds(r), t;
  }
}
class ih extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 10);
    te(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, n) {
    switch (n) {
      case "X":
        return la(
          ra.basicOptionalMinutes,
          t
        );
      case "XX":
        return la(ra.basic, t);
      case "XXXX":
        return la(
          ra.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return la(
          ra.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return la(ra.extended, t);
    }
  }
  set(t, n, r) {
    return n.timestampIsSet ? t : Ke(
      t,
      t.getTime() - er(t) - r
    );
  }
}
class uh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 10);
    te(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, n) {
    switch (n) {
      case "x":
        return la(
          ra.basicOptionalMinutes,
          t
        );
      case "xx":
        return la(ra.basic, t);
      case "xxxx":
        return la(
          ra.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return la(
          ra.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return la(ra.extended, t);
    }
  }
  set(t, n, r) {
    return n.timestampIsSet ? t : Ke(
      t,
      t.getTime() - er(t) - r
    );
  }
}
class ch extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 40);
    te(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return os(t);
  }
  set(t, n, r) {
    return [Ke(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class dh extends je {
  constructor() {
    super(...arguments);
    te(this, "priority", 20);
    te(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return os(t);
  }
  set(t, n, r) {
    return [Ke(t, r), { timestampIsSet: !0 }];
  }
}
const fh = {
  G: new $v(),
  y: new Pv(),
  Y: new Av(),
  R: new Ov(),
  u: new Rv(),
  Q: new Ev(),
  q: new Nv(),
  M: new Bv(),
  L: new Lv(),
  w: new Vv(),
  I: new Yv(),
  d: new zv(),
  D: new qv(),
  E: new jv(),
  e: new Gv(),
  c: new Qv(),
  i: new Xv(),
  a: new Zv(),
  b: new Jv(),
  B: new eh(),
  h: new th(),
  H: new ah(),
  K: new nh(),
  k: new rh(),
  m: new lh(),
  s: new oh(),
  S: new sh(),
  X: new ih(),
  x: new uh(),
  t: new ch(),
  T: new dh()
}, ph = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, mh = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, vh = /^'([^]*?)'?$/, hh = /''/g, yh = /\S/, gh = /[a-zA-Z]/;
function Er(e, a, t, n) {
  var D, $, T, g, M, A, P, C;
  const r = () => Ke((n == null ? void 0 : n.in) || t, NaN), l = xv(), o = (n == null ? void 0 : n.locale) ?? l.locale ?? ts, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? (($ = (D = n == null ? void 0 : n.locale) == null ? void 0 : D.options) == null ? void 0 : $.firstWeekContainsDate) ?? l.firstWeekContainsDate ?? ((g = (T = l.locale) == null ? void 0 : T.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((A = (M = n == null ? void 0 : n.locale) == null ? void 0 : M.options) == null ? void 0 : A.weekStartsOn) ?? l.weekStartsOn ?? ((C = (P = l.locale) == null ? void 0 : P.options) == null ? void 0 : C.weekStartsOn) ?? 0;
  if (!a)
    return e ? r() : Re(t, n == null ? void 0 : n.in);
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  }, u = [new Sv(n == null ? void 0 : n.in, t)], d = a.match(mh).map((O) => {
    const R = O[0];
    if (R in Or) {
      const S = Or[R];
      return S(O, o.formatLong);
    }
    return O;
  }).join("").match(ph), f = [];
  for (let O of d) {
    !(n != null && n.useAdditionalWeekYearTokens) && rs(O) && Rr(O, a, e), !(n != null && n.useAdditionalDayOfYearTokens) && ns(O) && Rr(O, a, e);
    const R = O[0], S = fh[R];
    if (S) {
      const { incompatibleTokens: X } = S;
      if (Array.isArray(X)) {
        const fe = f.find(
          (I) => X.includes(I.token) || I.token === R
        );
        if (fe)
          throw new RangeError(
            `The format string mustn't contain \`${fe.fullToken}\` and \`${O}\` at the same time`
          );
      } else if (S.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${O}\` and any other token at the same time`
        );
      f.push({ token: R, fullToken: O });
      const re = S.run(
        e,
        O,
        o.match,
        c
      );
      if (!re)
        return r();
      u.push(re.setter), e = re.rest;
    } else {
      if (R.match(gh))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + R + "`"
        );
      if (O === "''" ? O = "'" : R === "'" && (O = bh(O)), e.indexOf(O) === 0)
        e = e.slice(O.length);
      else
        return r();
    }
  }
  if (e.length > 0 && yh.test(e))
    return r();
  const h = u.map((O) => O.priority).sort((O, R) => R - O).filter((O, R, S) => S.indexOf(O) === R).map(
    (O) => u.filter((R) => R.priority === O).sort((R, S) => S.subPriority - R.subPriority)
  ).map((O) => O[0]);
  let b = Re(t, n == null ? void 0 : n.in);
  if (isNaN(+b)) return r();
  const w = {};
  for (const O of h) {
    if (!O.validate(b, c))
      return r();
    const R = O.set(b, w, c);
    Array.isArray(R) ? (b = R[0], Object.assign(w, R[1])) : b = R;
  }
  return b;
}
function bh(e) {
  return e.match(vh)[1].replace(hh, "'");
}
function Ql(e, a, t) {
  const [n, r] = Hn(
    t == null ? void 0 : t.in,
    e,
    a
  );
  return +Pa(n) == +Pa(r);
}
function us(e, a, t) {
  return zt(e, -a, t);
}
function cs(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in), r = n.getFullYear(), l = n.getDate(), o = Ke(e, 0);
  o.setFullYear(r, a, 15), o.setHours(0, 0, 0, 0);
  const i = kv(o);
  return n.setMonth(a, Math.min(l, i)), n;
}
function Ze(e, a, t) {
  let n = Re(e, t == null ? void 0 : t.in);
  return isNaN(+n) ? Ke(e, NaN) : (a.year != null && n.setFullYear(a.year), a.month != null && (n = cs(n, a.month)), a.date != null && n.setDate(a.date), a.hours != null && n.setHours(a.hours), a.minutes != null && n.setMinutes(a.minutes), a.seconds != null && n.setSeconds(a.seconds), a.milliseconds != null && n.setMilliseconds(a.milliseconds), n);
}
function wh(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in);
  return n.setHours(a), n;
}
function ds(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in);
  return n.setMilliseconds(a), n;
}
function _h(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in);
  return n.setMinutes(a), n;
}
function fs(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in);
  return n.setSeconds(a), n;
}
function oa(e, a, t) {
  const n = Re(e, t == null ? void 0 : t.in);
  return isNaN(+n) ? Ke(e, NaN) : (n.setFullYear(a), n);
}
function dn(e, a, t) {
  return Zt(e, -a, t);
}
function kh(e, a, t) {
  const {
    years: n = 0,
    months: r = 0,
    weeks: l = 0,
    days: o = 0,
    hours: i = 0,
    minutes: s = 0,
    seconds: c = 0
  } = a, u = dn(e, r + n * 12, t), d = us(u, o + l * 7, t), f = s + i * 60, b = (c + f * 60) * 1e3;
  return Ke(e, +d - b);
}
function ps(e, a, t) {
  return tl(e, -a, t);
}
function yn() {
  const e = io();
  return v(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...e
    },
    [
      k("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      k("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      k("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      k("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
yn.compatConfig = {
  MODE: 3
};
function ms() {
  return v(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      k("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      k("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
ms.compatConfig = {
  MODE: 3
};
function sl() {
  return v(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      k("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
sl.compatConfig = {
  MODE: 3
};
function il() {
  return v(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      k("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
il.compatConfig = {
  MODE: 3
};
function ul() {
  return v(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      k("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      k("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
ul.compatConfig = {
  MODE: 3
};
function cl() {
  return v(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      k("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
cl.compatConfig = {
  MODE: 3
};
function dl() {
  return v(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      k("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
dl.compatConfig = {
  MODE: 3
};
const Bt = (e, a) => a ? new Date(e.toLocaleString("en-US", { timeZone: a })) : new Date(e), fl = (e, a, t) => Nr(e, a, t) || de(), xh = (e, a, t) => {
  const n = a.dateInTz ? Bt(new Date(e), a.dateInTz) : de(e);
  return t ? kt(n, !0) : n;
}, Nr = (e, a, t) => {
  if (!e) return null;
  const n = t ? kt(de(e), !0) : de(e);
  return a ? a.exactMatch ? xh(e, a, t) : Bt(n, a.timezone) : n;
}, Ch = (e) => {
  const a = new Date(e.getFullYear(), 0, 1).getTimezoneOffset();
  return e.getTimezoneOffset() < a;
}, Dh = (e, a) => {
  if (!e) return 0;
  const t = /* @__PURE__ */ new Date(), n = new Date(t.toLocaleString("en-US", { timeZone: "UTC" })), r = new Date(t.toLocaleString("en-US", { timeZone: e })), l = (Ch(a ?? r) ? r : a ?? r).getTimezoneOffset() / 60;
  return (+n - +r) / (1e3 * 60 * 60) - l;
};
var Gt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(Gt || {}), Qt = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(Qt || {}), Ea = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(Ea || {}), Dt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Dt || {});
const Th = ["timestamp", "date", "iso"];
var St = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(St || {}), nt = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(nt || {}), en = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(en || {});
function Kl(e) {
  return (a) => {
    const t = new Intl.DateTimeFormat(e, {
      weekday: "short",
      timeZone: "UTC"
    }).format(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`));
    return e === "ar" ? t.slice(2, 5) : t.slice(0, 2);
  };
}
function Ih(e) {
  return (a) => ia(Bt(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const Mh = (e, a, t) => {
  const n = [1, 2, 3, 4, 5, 6, 7];
  let r;
  if (e !== null)
    try {
      r = n.map(Ih(e));
    } catch {
      r = n.map(Kl(a));
    }
  else
    r = n.map(Kl(a));
  const l = r.slice(0, t), o = r.slice(t + 1, r.length);
  return [r[t]].concat(...o).concat(...l);
}, pl = (e, a, t) => {
  const n = [];
  for (let r = +e[0]; r <= +e[1]; r++)
    n.push({ value: +r, text: gs(r, a) });
  return t ? n.reverse() : n;
}, vs = (e, a, t) => {
  const n = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((l) => {
    const o = l < 10 ? `0${l}` : l;
    return /* @__PURE__ */ new Date(`2017-${o}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const l = t === "long" ? "LLLL" : "LLL";
      return n.map((o, i) => {
        const s = ia(Bt(o, "UTC"), l, { locale: e });
        return {
          text: s.charAt(0).toUpperCase() + s.substring(1),
          value: i
        };
      });
    } catch {
    }
  const r = new Intl.DateTimeFormat(a, { month: t, timeZone: "UTC" });
  return n.map((l, o) => {
    const i = r.format(l);
    return {
      text: i.charAt(0).toUpperCase() + i.substring(1),
      value: o
    };
  });
}, Sh = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], vt = (e) => {
  const a = m(e);
  return a != null && a.$el ? a == null ? void 0 : a.$el : a;
}, $h = (e) => ({ type: "dot", ...e ?? {} }), hs = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, ml = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, _t = (e) => e, Xl = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, Zl = (e) => e === null, ys = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, Ph = (e) => {
  const a = [], t = (n) => n.filter((r) => r);
  for (let n = 0; n < e.length; n += 3) {
    const r = [e[n], e[n + 1], e[n + 2]];
    a.push(t(r));
  }
  return a;
}, En = (e, a, t) => {
  const n = t != null, r = a != null;
  if (!n && !r) return !1;
  const l = +t, o = +a;
  return n && r ? +e > l || +e < o : n ? +e > l : r ? +e < o : !1;
}, fn = (e, a) => Ph(e).map((t) => t.map((n) => {
  const { active: r, disabled: l, isBetween: o, highlighted: i } = a(n);
  return {
    ...n,
    active: r,
    disabled: l,
    className: {
      dp__overlay_cell_active: r,
      dp__overlay_cell: !r,
      dp__overlay_cell_disabled: l,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: l && r,
      dp__cell_in_between: o,
      "dp--highlighted": i
    }
  };
})), xa = (e, a, t = !1) => {
  e && a.allowStopPropagation && (t && e.stopImmediatePropagation(), e.stopPropagation());
}, Ah = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function Oh(e, a) {
  let t = [...document.querySelectorAll(Ah())];
  t = t.filter((r) => !e.contains(r) || r.hasAttribute("data-datepicker-instance"));
  const n = t.indexOf(e);
  if (n >= 0 && (a ? n - 1 >= 0 : n + 1 <= t.length))
    return t[n + (a ? -1 : 1)];
}
const Br = (e, a) => e == null ? void 0 : e.querySelector(`[data-dp-element="${a}"]`), gs = (e, a) => new Intl.NumberFormat(a, { useGrouping: !1, style: "decimal" }).format(e), vl = (e, a) => ia(e, a ?? en.DATE), gr = (e) => Array.isArray(e), ar = (e, a, t) => a.get(vl(e, t)), Rh = (e, a) => e ? a ? a instanceof Map ? !!ar(e, a) : a(de(e)) : !1 : !0, Pt = (e, a, t = !1, n) => {
  if (e.key === nt.enter || e.key === nt.space)
    return t && e.preventDefault(), a();
  if (n) return n(e);
}, Eh = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, bs = (e, a) => e ? en.MONTH_AND_YEAR : a ? en.YEAR : en.DATE, ws = (e) => e < 10 ? `0${e}` : e, Jl = (e, a, t, n, r, l) => {
  const o = Er(e, a.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: l });
  return $n(o) && Ko(o) ? n || r ? o : Ze(o, {
    hours: +t.hours,
    minutes: +(t == null ? void 0 : t.minutes),
    seconds: +(t == null ? void 0 : t.seconds),
    milliseconds: 0
  }) : null;
}, Nh = (e, a, t, n, r, l) => {
  const o = Array.isArray(t) ? t[0] : t;
  if (typeof a == "string")
    return Jl(e, a, o, n, r, l);
  if (Array.isArray(a)) {
    let i = null;
    for (const s of a)
      if (i = Jl(e, s, o, n, r, l), i)
        break;
    return i;
  }
  return typeof a == "function" ? a(e) : null;
}, de = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), Bh = (e, a, t) => {
  if (a) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"), l = e.getDate().toString().padStart(2, "0"), o = e.getHours().toString().padStart(2, "0"), i = e.getMinutes().toString().padStart(2, "0"), s = t ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${r}-${l}T${o}:${i}:${s}.000Z`;
  }
  const n = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(n).toISOString();
}, kt = (e, a) => {
  const t = de(JSON.parse(JSON.stringify(e))), n = Ze(t, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return a ? Sm(n) : n;
}, Ca = (e, a, t, n) => {
  let r = e ? de(e) : de();
  return (a || a === 0) && (r = wh(r, +a)), (t || t === 0) && (r = _h(r, +t)), (n || n === 0) && (r = fs(r, +n)), ds(r, 0);
}, ot = (e, a) => !e || !a ? !1 : cn(kt(e), kt(a)), Ue = (e, a) => !e || !a ? !1 : Ja(kt(e), kt(a)), ct = (e, a) => !e || !a ? !1 : Fa(kt(e), kt(a)), Nn = (e, a, t) => e != null && e[0] && e != null && e[1] ? ct(t, e[0]) && ot(t, e[1]) : e != null && e[0] && a ? ct(t, e[0]) && ot(t, a) || ot(t, e[0]) && ct(t, a) : !1, Xt = (e) => {
  const a = Ze(new Date(e), { date: 1 });
  return kt(a);
}, br = (e, a, t) => a && (t || t === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((n) => n === a ? [n, t] : [n, isNaN(+e[n]) ? void 0 : +e[n]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, Na = (e) => ({
  hours: ya(e),
  minutes: Da(e),
  seconds: un(e)
}), _s = (e, a) => {
  if (a) {
    const t = Ne(de(a));
    if (t > e) return 12;
    if (t === e) return We(de(a));
  }
}, ks = (e, a) => {
  if (a) {
    const t = Ne(de(a));
    return t < e ? -1 : t === e ? We(de(a)) : void 0;
  }
}, pn = (e) => {
  if (e) return Ne(de(e));
}, xs = (e, a) => {
  const t = ct(e, a) ? a : e, n = ct(a, e) ? a : e;
  return Zo({ start: t, end: n });
}, Lh = (e) => {
  const a = Zt(e, 1);
  return { month: We(a), year: Ne(a) };
}, fa = (e, a) => {
  const t = Jt(e, { weekStartsOn: +a }), n = es(e, { weekStartsOn: +a });
  return [t, n];
}, Cs = (e, a) => {
  const t = {
    hours: ya(de()),
    minutes: Da(de()),
    seconds: a ? un(de()) : 0
  };
  return Object.assign(t, e);
}, wa = (e, a, t) => [Ze(de(e), { date: 1 }), Ze(de(), { month: a, year: t, date: 1 })], pa = (e, a, t) => {
  let n = e ? de(e) : de();
  return (a || a === 0) && (n = cs(n, a)), t && (n = oa(n, t)), n;
}, Ds = (e, a, t, n, r) => {
  if (!n || r && !a || !r && !t) return !1;
  const l = r ? Zt(e, 1) : dn(e, 1), o = [We(l), Ne(l)];
  return r ? !Vh(...o, a) : !Fh(...o, t);
}, Fh = (e, a, t) => ot(...wa(t, e, a)) || Ue(...wa(t, e, a)), Vh = (e, a, t) => ct(...wa(t, e, a)) || Ue(...wa(t, e, a)), Ts = (e, a, t, n, r, l, o) => {
  if (typeof a == "function" && !o) return a(e);
  const i = t ? { locale: t } : void 0;
  return Array.isArray(e) ? `${ia(e[0], l, i)}${r && !e[1] ? "" : n}${e[1] ? ia(e[1], l, i) : ""}` : ia(e, l, i);
}, Qa = (e) => {
  if (e) return null;
  throw new Error(ml.prop("partial-range"));
}, Gn = (e, a) => {
  if (a) return e();
  throw new Error(ml.prop("range"));
}, Lr = (e) => Array.isArray(e) ? $n(e[0]) && (e[1] ? $n(e[1]) : !0) : e ? $n(e) : !1, Hh = (e, a) => Ze(a ?? de(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), wr = (e, a, t, n) => {
  if (!e) return !0;
  if (n) {
    const r = t === "max" ? cn(e, a) : Fa(e, a), l = { seconds: 0, milliseconds: 0 };
    return r || Ja(Ze(e, l), Ze(a, l));
  }
  return t === "max" ? e.getTime() <= a.getTime() : e.getTime() >= a.getTime();
}, _r = (e, a, t) => e ? Hh(e, a) : de(t ?? a), eo = (e, a, t, n, r) => {
  if (Array.isArray(n)) {
    const o = _r(e, n[0], a), i = _r(e, n[1], a);
    return wr(n[0], o, t, !!a) && wr(n[1], i, t, !!a) && r;
  }
  const l = _r(e, n, a);
  return wr(n, l, t, !!a) && r;
}, kr = (e) => Ze(de(), Na(e)), Yh = (e, a, t) => {
  if (e instanceof Map) {
    const n = `${ws(t + 1)}-${a}`;
    return e.size ? e.has(n) : !1;
  }
  return typeof e == "function" ? e(kt(Ze(de(), { month: t, year: a }), !0)) : !1;
}, Wh = (e, a, t) => {
  if (e instanceof Map) {
    const n = `${ws(t + 1)}-${a}`;
    return e.size ? e.has(n) : !0;
  }
  return !0;
}, Is = (e, a, t) => typeof e == "function" ? e({ month: a, year: t }) : !!e.months.find((n) => n.month === a && n.year === t), hl = (e, a) => typeof e == "function" ? e(a) : e.years.includes(a), Fr = (e) => `dp-${ia(e, "yyyy-MM-dd")}`, to = (e, a) => {
  const t = us(kt(a), e), n = zt(kt(a), e);
  return { before: t, after: n };
}, xn = _a({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Ms = () => {
  const e = (t) => {
    xn.menuFocused = t;
  }, a = (t) => {
    xn.shiftKeyInMenu !== t && (xn.shiftKeyInMenu = t);
  };
  return {
    control: H(() => ({ shiftKeyInMenu: xn.shiftKeyInMenu, menuFocused: xn.menuFocused })),
    setMenuFocused: e,
    setShiftKey: a
  };
}, at = _a({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), xr = B(null), Qn = B(!1), Cr = B(!1), Dr = B(!1), Tr = B(!1), Ct = B(0), it = B(0), Ia = () => {
  const e = H(() => Qn.value ? [...at.selectionGrid, at.actionRow].filter((d) => d.length) : Cr.value ? [
    ...at.timePicker[0],
    ...at.timePicker[1],
    Tr.value ? [] : [xr.value],
    at.actionRow
  ].filter((d) => d.length) : Dr.value ? [...at.monthPicker, at.actionRow] : [at.monthYear, ...at.calendar, at.time, at.actionRow].filter((d) => d.length)), a = (d) => {
    Ct.value = d ? Ct.value + 1 : Ct.value - 1;
    let f = null;
    e.value[it.value] && (f = e.value[it.value][Ct.value]), !f && e.value[it.value + (d ? 1 : -1)] ? (it.value = it.value + (d ? 1 : -1), Ct.value = d ? 0 : e.value[it.value].length - 1) : f || (Ct.value = d ? Ct.value - 1 : Ct.value + 1);
  }, t = (d) => {
    it.value === 0 && !d || it.value === e.value.length && d || (it.value = d ? it.value + 1 : it.value - 1, e.value[it.value] ? e.value[it.value] && !e.value[it.value][Ct.value] && Ct.value !== 0 && (Ct.value = e.value[it.value].length - 1) : it.value = d ? it.value - 1 : it.value + 1);
  }, n = (d) => {
    let f = null;
    e.value[it.value] && (f = e.value[it.value][Ct.value]), f ? f.focus({ preventScroll: !Qn.value }) : Ct.value = d ? Ct.value - 1 : Ct.value + 1;
  }, r = () => {
    a(!0), n(!0);
  }, l = () => {
    a(!1), n(!1);
  }, o = () => {
    t(!1), n(!0);
  }, i = () => {
    t(!0), n(!0);
  }, s = (d, f) => {
    at[f] = d;
  }, c = (d, f) => {
    at[f] = d;
  }, u = () => {
    Ct.value = 0, it.value = 0;
  };
  return {
    buildMatrix: s,
    buildMultiLevelMatrix: c,
    setTimePickerBackRef: (d) => {
      xr.value = d;
    },
    setSelectionGrid: (d) => {
      Qn.value = d, u(), d || (at.selectionGrid = []);
    },
    setTimePicker: (d, f = !1) => {
      Cr.value = d, Tr.value = f, u(), d || (at.timePicker[0] = [], at.timePicker[1] = []);
    },
    setTimePickerElements: (d, f = 0) => {
      at.timePicker[f] = d;
    },
    arrowRight: r,
    arrowLeft: l,
    arrowUp: o,
    arrowDown: i,
    clearArrowNav: () => {
      at.monthYear = [], at.calendar = [], at.time = [], at.actionRow = [], at.selectionGrid = [], at.timePicker[0] = [], at.timePicker[1] = [], Qn.value = !1, Cr.value = !1, Tr.value = !1, Dr.value = !1, u(), xr.value = null;
    },
    setMonthPicker: (d) => {
      Dr.value = d, u();
    },
    refSets: at
    // exposed for testing
  };
}, ao = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), Uh = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (a) => `Increment ${a}`,
  decrementValue: (a) => `Decrement ${a}`,
  openTpOverlay: (a) => `Open ${a} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (a) => `Month picker${a ? " overlay" : ""}`,
  yearPicker: (a) => `Year picker${a ? " overlay" : ""}`,
  timeOverlay: (a) => `${a} overlay`,
  ...e ?? {}
}), no = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, zh = (e) => {
  const a = typeof e == "object" && e, t = {
    static: !0,
    solo: !1
  };
  if (!e) return { ...t, count: no(!1) };
  const n = a ? e : {}, r = a ? n.count ?? !0 : e, l = no(r);
  return Object.assign(t, n, { count: l });
}, qh = (e, a, t) => e || (typeof t == "string" ? t : a), jh = (e) => typeof e == "boolean" ? e ? ao({}) : !1 : ao(e), Gh = (e) => {
  const a = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof e == "object" ? { ...a, ...e ?? {}, enabled: !0 } : { ...a, enabled: e };
}, Qh = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), Kh = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), Xh = (e) => {
  const a = { input: !1 };
  return typeof e == "object" ? { ...a, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...a
  };
}, Zh = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...e ?? {} }), Jh = (e) => {
  const a = {
    dates: Array.isArray(e) ? e.map((t) => de(t)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...a, ...e ?? {} };
}, ey = (e) => typeof e == "object" ? {
  type: (e == null ? void 0 : e.type) ?? "local",
  hideOnOffsetDates: (e == null ? void 0 : e.hideOnOffsetDates) ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, ty = (e) => {
  const a = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof e == "object" ? { enabled: !0, ...a, ...e } : {
    enabled: e,
    ...a
  };
}, ay = (e) => e ? typeof e == "string" ? {
  timezone: e,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: e.emitTimezone ?? void 0,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, Ir = (e, a, t, n) => new Map(
  e.map((r) => {
    const l = fl(r, a, n);
    return [vl(l, t), l];
  })
), ny = (e, a) => e.length ? new Map(
  e.map((t) => {
    const n = fl(t.date, a);
    return [vl(n, en.DATE), t];
  })
) : null, ry = (e) => {
  var a;
  const t = bs(e.isMonthPicker, e.isYearPicker);
  return {
    minDate: Nr(e.minDate, e.timezone, e.isSpecific),
    maxDate: Nr(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: gr(e.disabledDates) ? Ir(e.disabledDates, e.timezone, t, e.isSpecific) : e.disabledDates,
    allowedDates: gr(e.allowedDates) ? Ir(e.allowedDates, e.timezone, t, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && gr((a = e.highlight) == null ? void 0 : a.dates) ? Ir(e.highlight.dates, e.timezone, t) : e.highlight,
    markers: ny(e.markers, e.timezone)
  };
}, ly = (e) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: null } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, oy = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((a) => {
      const t = a, n = e[t], r = typeof e[t] == "string" ? { [n]: !0 } : Object.fromEntries(n.map((l) => [l, !0]));
      return [a, r];
    })
  )
}), rt = (e) => {
  const a = () => {
    const P = e.enableSeconds ? ":ss" : "", C = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${C}${P}` : `hh${C}${P} aa`;
  }, t = () => {
    var P;
    return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? a() : e.weekPicker ? `${((P = D.value) == null ? void 0 : P.type) === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${a()}` : "MM/dd/yyyy";
  }, n = (P) => Cs(P, e.enableSeconds), r = () => M.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [n(e.startTime[0]), n(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? n(e.startTime) : null, l = H(() => zh(e.multiCalendars)), o = H(() => r()), i = H(() => Uh(e.ariaLabels)), s = H(() => Qh(e.filters)), c = H(() => jh(e.transitions)), u = H(() => Kh(e.actionRow)), d = H(
    () => qh(e.previewFormat, e.format, t())
  ), f = H(() => Gh(e.textInput)), h = H(() => Xh(e.inline)), b = H(() => Zh(e.config)), w = H(() => Jh(e.highlight)), D = H(() => ey(e.weekNumbers)), $ = H(() => ay(e.timezone)), T = H(() => ly(e.multiDates)), g = H(
    () => ry({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: w.value,
      markers: e.markers,
      timezone: $.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker,
      isMonthPicker: e.monthPicker,
      isYearPicker: e.yearPicker
    })
  ), M = H(() => ty(e.range)), A = H(() => oy(e.ui));
  return {
    defaultedTransitions: c,
    defaultedMultiCalendars: l,
    defaultedStartTime: o,
    defaultedAriaLabels: i,
    defaultedFilters: s,
    defaultedActionRow: u,
    defaultedPreviewFormat: d,
    defaultedTextInput: f,
    defaultedInline: h,
    defaultedConfig: b,
    defaultedHighlight: w,
    defaultedWeekNumbers: D,
    defaultedRange: M,
    propDates: g,
    defaultedTz: $,
    defaultedMultiDates: T,
    defaultedUI: A,
    getDefaultPattern: t,
    getDefaultStartTime: r,
    handleEventPropagation: (P) => {
      b.value.allowStopPropagation && P.stopPropagation(), b.value.allowPreventDefault && P.preventDefault();
    }
  };
}, sy = (e, a, t) => {
  const n = B(), { defaultedTextInput: r, defaultedRange: l, defaultedTz: o, defaultedMultiDates: i, getDefaultPattern: s } = rt(a), c = B(""), u = tn(a, "format"), d = tn(a, "formatLocale");
  et(
    n,
    () => {
      typeof a.onInternalModelChange == "function" && e("internal-model-change", n.value, ae(!0));
    },
    { deep: !0 }
  ), et(l, (p, W) => {
    p.enabled !== W.enabled && (n.value = null);
  }), et(u, () => {
    ce();
  });
  const f = (p) => o.value.timezone && o.value.convertModel ? Bt(p, o.value.timezone) : p, h = (p) => {
    if (o.value.timezone && o.value.convertModel) {
      const W = Dh(o.value.timezone, p);
      return km(p, W);
    }
    return p;
  }, b = (p, W, ve = !1) => Ts(
    p,
    a.format,
    a.formatLocale,
    r.value.rangeSeparator,
    a.modelAuto,
    W ?? s(),
    ve
  ), w = (p) => p ? a.modelType ? J(p) : {
    hours: ya(p),
    minutes: Da(p),
    seconds: a.enableSeconds ? un(p) : 0
  } : null, D = (p) => a.modelType ? J(p) : { month: We(p), year: Ne(p) }, $ = (p) => Array.isArray(p) ? i.value.enabled ? p.map((W) => T(W, oa(de(), W))) : Gn(
    () => [
      oa(de(), p[0]),
      p[1] ? oa(de(), p[1]) : Qa(l.value.partialRange)
    ],
    l.value.enabled
  ) : oa(de(), +p), T = (p, W) => (typeof p == "string" || typeof p == "number") && a.modelType ? q(p) : W, g = (p) => Array.isArray(p) ? [
    T(
      p[0],
      Ca(null, +p[0].hours, +p[0].minutes, p[0].seconds)
    ),
    T(
      p[1],
      Ca(null, +p[1].hours, +p[1].minutes, p[1].seconds)
    )
  ] : T(p, Ca(null, p.hours, p.minutes, p.seconds)), M = (p) => {
    const W = Ze(de(), { date: 1 });
    return Array.isArray(p) ? i.value.enabled ? p.map((ve) => T(ve, pa(W, +ve.month, +ve.year))) : Gn(
      () => [
        T(p[0], pa(W, +p[0].month, +p[0].year)),
        T(
          p[1],
          p[1] ? pa(W, +p[1].month, +p[1].year) : Qa(l.value.partialRange)
        )
      ],
      l.value.enabled
    ) : T(p, pa(W, +p.month, +p.year));
  }, A = (p) => {
    if (Array.isArray(p))
      return p.map((W) => q(W));
    throw new Error(ml.dateArr("multi-dates"));
  }, P = (p) => {
    if (Array.isArray(p) && l.value.enabled) {
      const W = p[0], ve = p[1];
      return [
        de(Array.isArray(W) ? W[0] : null),
        Array.isArray(ve) && ve.length ? de(ve[0]) : null
      ];
    }
    return de(p[0]);
  }, C = (p) => a.modelAuto ? Array.isArray(p) ? [q(p[0]), q(p[1])] : a.autoApply ? [q(p)] : [q(p), null] : Array.isArray(p) ? Gn(
    () => p[1] ? [
      q(p[0]),
      p[1] ? q(p[1]) : Qa(l.value.partialRange)
    ] : [q(p[0])],
    l.value.enabled
  ) : q(p), O = () => {
    Array.isArray(n.value) && l.value.enabled && n.value.length === 1 && n.value.push(Qa(l.value.partialRange));
  }, R = () => {
    const p = n.value;
    return [
      J(p[0]),
      p[1] ? J(p[1]) : Qa(l.value.partialRange)
    ];
  }, S = () => Array.isArray(n.value) ? n.value[1] ? R() : J(_t(n.value[0])) : [], X = () => (n.value || []).map((p) => J(p)), re = (p = !1) => (p || O(), a.modelAuto ? S() : i.value.enabled ? X() : Array.isArray(n.value) ? Gn(() => R(), l.value.enabled) : J(_t(n.value))), fe = (p) => !p || Array.isArray(p) && !p.length ? null : a.timePicker ? g(_t(p)) : a.monthPicker ? M(_t(p)) : a.yearPicker ? $(_t(p)) : i.value.enabled ? A(_t(p)) : a.weekPicker ? P(_t(p)) : C(_t(p)), I = (p) => {
    const W = fe(p);
    Lr(_t(W)) ? (n.value = _t(W), ce()) : (n.value = null, c.value = "");
  }, V = () => {
    const p = (W) => ia(W, r.value.format);
    return `${p(n.value[0])} ${r.value.rangeSeparator} ${n.value[1] ? p(n.value[1]) : ""}`;
  }, E = () => t.value && n.value ? Array.isArray(n.value) ? V() : ia(n.value, r.value.format) : b(n.value), ee = () => n.value ? i.value.enabled ? n.value.map((p) => b(p)).join("; ") : r.value.enabled && typeof r.value.format == "string" ? E() : b(n.value) : "", ce = () => {
    !a.format || typeof a.format == "string" || r.value.enabled && typeof r.value.format == "string" ? c.value = ee() : c.value = a.format(n.value);
  }, q = (p) => {
    if (a.utc) {
      const W = new Date(p);
      return a.utc === "preserve" ? new Date(W.getTime() + W.getTimezoneOffset() * 6e4) : W;
    }
    return a.modelType ? Th.includes(a.modelType) ? f(new Date(p)) : a.modelType === "format" && (typeof a.format == "string" || !a.format) ? f(
      Er(p, s(), /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(
      Er(p, a.modelType, /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(new Date(p));
  }, J = (p) => p ? a.utc ? Bh(p, a.utc === "preserve", a.enableSeconds) : a.modelType ? a.modelType === "timestamp" ? +h(p) : a.modelType === "iso" ? h(p).toISOString() : a.modelType === "format" && (typeof a.format == "string" || !a.format) ? b(h(p)) : b(h(p), a.modelType, !0) : h(p) : "", L = (p, W = !1, ve = !1) => {
    if (ve) return p;
    if (e("update:model-value", p), o.value.emitTimezone && W) {
      const Fe = Array.isArray(p) ? p.map((K) => Bt(_t(K), o.value.emitTimezone)) : Bt(_t(p), o.value.emitTimezone);
      e("update:model-timezone-value", Fe);
    }
  }, F = (p) => Array.isArray(n.value) ? i.value.enabled ? n.value.map((W) => p(W)) : [
    p(n.value[0]),
    n.value[1] ? p(n.value[1]) : Qa(l.value.partialRange)
  ] : p(_t(n.value)), x = () => {
    if (Array.isArray(n.value)) {
      const p = fa(n.value[0], a.weekStart), W = n.value[1] ? fa(n.value[1], a.weekStart) : [];
      return [p.map((ve) => de(ve)), W.map((ve) => de(ve))];
    }
    return fa(n.value, a.weekStart).map((p) => de(p));
  }, N = (p, W) => L(_t(F(p)), !1, W), Z = (p) => {
    const W = x();
    return p ? W : e("update:model-value", x());
  }, ae = (p = !1) => (p || ce(), a.monthPicker ? N(D, p) : a.timePicker ? N(w, p) : a.yearPicker ? N(Ne, p) : a.weekPicker ? Z(p) : L(re(p), !0, p));
  return {
    inputValue: c,
    internalModelValue: n,
    checkBeforeEmit: () => n.value ? l.value.enabled ? l.value.partialRange ? n.value.length >= 1 : n.value.length === 2 : !!n.value : !1,
    parseExternalModelValue: I,
    formatInputValue: ce,
    emitModelValue: ae
  };
}, iy = (e, a) => {
  const { defaultedFilters: t, propDates: n } = rt(e), { validateMonthYearInRange: r } = Ma(e), l = (u, d) => {
    let f = u;
    return t.value.months.includes(We(f)) ? (f = d ? Zt(u, 1) : dn(u, 1), l(f, d)) : f;
  }, o = (u, d) => {
    let f = u;
    return t.value.years.includes(Ne(f)) ? (f = d ? tl(u, 1) : ps(u, 1), o(f, d)) : f;
  }, i = (u, d = !1) => {
    const f = Ze(de(), { month: e.month, year: e.year });
    let h = u ? Zt(f, 1) : dn(f, 1);
    e.disableYearSelect && (h = oa(h, e.year));
    let b = We(h), w = Ne(h);
    t.value.months.includes(b) && (h = l(h, u), b = We(h), w = Ne(h)), t.value.years.includes(w) && (h = o(h, u), w = Ne(h)), r(b, w, u, e.preventMinMaxNavigation) && s(b, w, d);
  }, s = (u, d, f) => {
    a("update-month-year", { month: u, year: d, fromNav: f });
  }, c = H(() => (u) => Ds(
    Ze(de(), { month: e.month, year: e.year }),
    n.value.maxDate,
    n.value.minDate,
    e.preventMinMaxNavigation,
    u
  ));
  return { handleMonthYearChange: i, isDisabled: c, updateMonthYear: s };
}, ur = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, ta = {
  ...ur,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, uy = ["title"], cy = ["disabled"], dy = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...ta
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: a }) {
    const t = a, n = e, {
      defaultedActionRow: r,
      defaultedPreviewFormat: l,
      defaultedMultiCalendars: o,
      defaultedTextInput: i,
      defaultedInline: s,
      defaultedRange: c,
      defaultedMultiDates: u
    } = rt(n), { isTimeValid: d, isMonthValid: f } = Ma(n), { buildMatrix: h } = Ia(), b = B(null), w = B(null), D = B(!1), $ = B({}), T = B(null), g = B(null);
    Xe(() => {
      n.arrowNavigation && h([vt(b), vt(w)], "actionRow"), M(), window.addEventListener("resize", M);
    }), vn(() => {
      window.removeEventListener("resize", M);
    });
    const M = () => {
      D.value = !1, setTimeout(() => {
        var I, V;
        const E = (I = T.value) == null ? void 0 : I.getBoundingClientRect(), ee = (V = g.value) == null ? void 0 : V.getBoundingClientRect();
        E && ee && ($.value.maxWidth = `${ee.width - E.width - 20}px`), D.value = !0;
      }, 0);
    }, A = H(() => c.value.enabled && !c.value.partialRange && n.internalModelValue ? n.internalModelValue.length === 2 : !0), P = H(
      () => !d.value(n.internalModelValue) || !f.value(n.internalModelValue) || !A.value
    ), C = () => {
      const I = l.value;
      return n.timePicker || n.monthPicker, I(_t(n.internalModelValue));
    }, O = () => {
      const I = n.internalModelValue;
      return o.value.count > 0 ? `${R(I[0])} - ${R(I[1])}` : [R(I[0]), R(I[1])];
    }, R = (I) => Ts(
      I,
      l.value,
      n.formatLocale,
      i.value.rangeSeparator,
      n.modelAuto,
      l.value
    ), S = H(() => !n.internalModelValue || !n.menuMount ? "" : typeof l.value == "string" ? Array.isArray(n.internalModelValue) ? n.internalModelValue.length === 2 && n.internalModelValue[1] ? O() : u.value.enabled ? n.internalModelValue.map((I) => `${R(I)}`) : n.modelAuto ? `${R(n.internalModelValue[0])}` : `${R(n.internalModelValue[0])} -` : R(n.internalModelValue) : C()), X = () => u.value.enabled ? "; " : " - ", re = H(
      () => Array.isArray(S.value) ? S.value.join(X()) : S.value
    ), fe = () => {
      d.value(n.internalModelValue) && f.value(n.internalModelValue) && A.value ? t("select-date") : t("invalid-select");
    };
    return (I, V) => (v(), y("div", {
      ref_key: "actionRowRef",
      ref: g,
      class: "dp__action_row"
    }, [
      I.$slots["action-row"] ? ie(I.$slots, "action-row", gt(dt({ key: 0 }, {
        internalModelValue: I.internalModelValue,
        disabled: P.value,
        selectDate: () => I.$emit("select-date"),
        closePicker: () => I.$emit("close-picker")
      }))) : (v(), y(me, { key: 1 }, [
        m(r).showPreview ? (v(), y("div", {
          key: 0,
          class: "dp__selection_preview",
          title: re.value,
          style: Be($.value)
        }, [
          I.$slots["action-preview"] && D.value ? ie(I.$slots, "action-preview", {
            key: 0,
            value: I.internalModelValue
          }) : Y("", !0),
          !I.$slots["action-preview"] && D.value ? (v(), y(me, { key: 1 }, [
            Je(_e(re.value), 1)
          ], 64)) : Y("", !0)
        ], 12, uy)) : Y("", !0),
        k("div", {
          ref_key: "actionBtnContainer",
          ref: T,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          I.$slots["action-buttons"] ? ie(I.$slots, "action-buttons", {
            key: 0,
            value: I.internalModelValue
          }) : Y("", !0),
          I.$slots["action-buttons"] ? Y("", !0) : (v(), y(me, { key: 1 }, [
            !m(s).enabled && m(r).showCancel ? (v(), y("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: b,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: V[0] || (V[0] = (E) => I.$emit("close-picker")),
              onKeydown: V[1] || (V[1] = (E) => m(Pt)(E, () => I.$emit("close-picker")))
            }, _e(I.cancelText), 545)) : Y("", !0),
            m(r).showNow ? (v(), y("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: V[2] || (V[2] = (E) => I.$emit("select-now")),
              onKeydown: V[3] || (V[3] = (E) => m(Pt)(E, () => I.$emit("select-now")))
            }, _e(I.nowButtonLabel), 33)) : Y("", !0),
            m(r).showSelect ? (v(), y("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: w,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: P.value,
              "data-test-id": "select-button",
              onKeydown: V[4] || (V[4] = (E) => m(Pt)(E, () => fe())),
              onClick: fe
            }, _e(I.selectText), 41, cy)) : Y("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), fy = ["role", "aria-label", "tabindex"], py = { class: "dp__selection_grid_header" }, my = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], vy = ["aria-label"], Yn = /* @__PURE__ */ Te({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: a, emit: t }) {
    const { setSelectionGrid: n, buildMultiLevelMatrix: r, setMonthPicker: l } = Ia(), o = t, i = e, { defaultedAriaLabels: s, defaultedTextInput: c, defaultedConfig: u, handleEventPropagation: d } = rt(
      i
    ), { hideNavigationButtons: f } = fr(), h = B(!1), b = B(null), w = B(null), D = B([]), $ = B(), T = B(null), g = B(0), M = B(null);
    uo(() => {
      b.value = null;
    }), Xe(() => {
      mt().then(() => re()), i.noOverlayFocus || P(), A(!0);
    }), vn(() => A(!1));
    const A = (x) => {
      var N;
      i.arrowNavigation && ((N = i.headerRefs) != null && N.length ? l(x) : n(x));
    }, P = () => {
      var x;
      const N = vt(w);
      N && (c.value.enabled || (b.value ? (x = b.value) == null || x.focus({ preventScroll: !0 }) : N.focus({ preventScroll: !0 })), h.value = N.clientHeight < N.scrollHeight);
    }, C = H(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !i.useRelative,
        "dp--overlay-relative": i.useRelative
      })
    ), O = H(
      () => i.useRelative ? { height: `${i.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), R = H(() => ({
      dp__overlay_col: !0
    })), S = H(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: h.value,
        dp__button_bottom: i.isLast
      })
    ), X = H(() => {
      var x, N;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((x = i.items) == null ? void 0 : x.length) <= 6,
        dp__container_block: ((N = i.items) == null ? void 0 : N.length) > 6
      };
    });
    et(
      () => i.items,
      () => re(!1),
      { deep: !0 }
    );
    const re = (x = !0) => {
      mt().then(() => {
        const N = vt(b), Z = vt(w), ae = vt(T), p = vt(M), W = ae ? ae.getBoundingClientRect().height : 0;
        Z && (Z.getBoundingClientRect().height ? g.value = Z.getBoundingClientRect().height - W : g.value = u.value.modeHeight - W), N && p && x && (p.scrollTop = N.offsetTop - p.offsetTop - (g.value / 2 - N.getBoundingClientRect().height) - W);
      });
    }, fe = (x) => {
      x.disabled || o("selected", x.value);
    }, I = () => {
      o("toggle"), o("reset-flow");
    }, V = (x) => {
      i.escClose && (I(), d(x));
    }, E = (x, N, Z, ae) => {
      x && ((N.active || N.value === i.focusValue) && (b.value = x), i.arrowNavigation && (Array.isArray(D.value[Z]) ? D.value[Z][ae] = x : D.value[Z] = [x], ee()));
    }, ee = () => {
      var x, N;
      const Z = (x = i.headerRefs) != null && x.length ? [i.headerRefs].concat(D.value) : D.value.concat([i.skipButtonRef ? [] : [T.value]]);
      r(_t(Z), (N = i.headerRefs) != null && N.length ? "monthPicker" : "selectionGrid");
    }, ce = (x) => {
      i.arrowNavigation || xa(x, u.value, !0);
    }, q = (x) => {
      $.value = x, o("hover-value", x);
    }, J = () => {
      if (I(), !i.isLast) {
        const x = Br(i.menuWrapRef ?? null, "action-row");
        if (x) {
          const N = ys(x);
          N == null || N.focus();
        }
      }
    }, L = (x) => {
      switch (x.key) {
        case nt.esc:
          return V(x);
        case nt.arrowLeft:
          return ce(x);
        case nt.arrowRight:
          return ce(x);
        case nt.arrowUp:
          return ce(x);
        case nt.arrowDown:
          return ce(x);
        default:
          return;
      }
    }, F = (x) => {
      if (x.key === nt.enter) return I();
      if (x.key === nt.tab) return J();
    };
    return a({ focusGrid: P }), (x, N) => {
      var Z;
      return v(), y("div", {
        ref_key: "gridWrapRef",
        ref: w,
        class: pe(C.value),
        style: Be(O.value),
        role: x.useRelative ? void 0 : "dialog",
        "aria-label": x.overlayLabel,
        tabindex: x.useRelative ? void 0 : "0",
        onKeydown: L,
        onClick: N[0] || (N[0] = yt(() => {
        }, ["prevent"]))
      }, [
        k("div", {
          ref_key: "containerRef",
          ref: M,
          class: pe(X.value),
          style: Be({ "--dp-overlay-height": `${g.value}px` }),
          role: "grid"
        }, [
          k("div", py, [
            ie(x.$slots, "header")
          ]),
          x.$slots.overlay ? ie(x.$slots, "overlay", { key: 0 }) : (v(!0), y(me, { key: 1 }, Me(x.items, (ae, p) => (v(), y("div", {
            key: p,
            class: pe(["dp__overlay_row", { dp__flex_row: x.items.length >= 3 }]),
            role: "row"
          }, [
            (v(!0), y(me, null, Me(ae, (W, ve) => (v(), y("div", {
              key: W.value,
              ref_for: !0,
              ref: (Fe) => E(Fe, W, p, ve),
              role: "gridcell",
              class: pe(R.value),
              "aria-selected": W.active || void 0,
              "aria-disabled": W.disabled || void 0,
              tabindex: "0",
              "data-test-id": W.text,
              onClick: yt((Fe) => fe(W), ["prevent"]),
              onKeydown: (Fe) => m(Pt)(Fe, () => fe(W), !0),
              onMouseover: (Fe) => q(W.value)
            }, [
              k("div", {
                class: pe(W.className)
              }, [
                x.$slots.item ? ie(x.$slots, "item", {
                  key: 0,
                  item: W
                }) : Y("", !0),
                x.$slots.item ? Y("", !0) : (v(), y(me, { key: 1 }, [
                  Je(_e(W.text), 1)
                ], 64))
              ], 2)
            ], 42, my))), 128))
          ], 2))), 128))
        ], 6),
        x.$slots["button-icon"] ? ht((v(), y("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: T,
          type: "button",
          "aria-label": (Z = m(s)) == null ? void 0 : Z.toggleOverlay,
          class: pe(S.value),
          tabindex: "0",
          onClick: I,
          onKeydown: F
        }, [
          ie(x.$slots, "button-icon")
        ], 42, vy)), [
          [Aa, !m(f)(x.hideNavigation, x.type)]
        ]) : Y("", !0)
      ], 46, fy);
    };
  }
}), hy = ["data-dp-mobile"], cr = /* @__PURE__ */ Te({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(e) {
    const a = e, t = H(
      () => a.multiCalendars > 0 ? [...Array(a.multiCalendars).keys()] : [0]
    ), n = H(() => ({
      dp__instance_calendar: a.multiCalendars > 0
    }));
    return (r, l) => (v(), y("div", {
      class: pe({
        dp__menu_inner: !r.stretch,
        "dp--menu--inner-stretched": r.stretch,
        dp__flex_display: r.multiCalendars > 0,
        "dp--flex-display-collapsed": r.collapse
      }),
      "data-dp-mobile": r.isMobile
    }, [
      (v(!0), y(me, null, Me(t.value, (o, i) => (v(), y("div", {
        key: o,
        class: pe(n.value)
      }, [
        ie(r.$slots, "default", {
          instance: o,
          index: i
        })
      ], 2))), 128))
    ], 10, hy));
  }
}), yy = ["data-dp-element", "aria-label", "aria-disabled"], Pn = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: a }) {
    const t = a, n = B(null);
    return Xe(() => t("set-ref", n)), (r, l) => (v(), y("button", {
      ref_key: "elRef",
      ref: n,
      type: "button",
      "data-dp-element": r.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": r.ariaLabel,
      "aria-disabled": r.disabled || void 0,
      onClick: l[0] || (l[0] = (o) => r.$emit("activate")),
      onKeydown: l[1] || (l[1] = (o) => m(Pt)(o, () => r.$emit("activate"), !0))
    }, [
      k("span", {
        class: pe(["dp__inner_nav", { dp__inner_nav_disabled: r.disabled }])
      }, [
        ie(r.$slots, "default")
      ], 2)
    ], 40, yy));
  }
}), gy = ["aria-label", "data-test-id"], Ss = /* @__PURE__ */ Te({
  __name: "YearModePicker",
  props: {
    ...ta,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: a }) {
    const t = a, n = e, { showRightIcon: r, showLeftIcon: l } = fr(), { defaultedConfig: o, defaultedMultiCalendars: i, defaultedAriaLabels: s, defaultedTransitions: c, defaultedUI: u } = rt(n), { showTransition: d, transitionName: f } = Wn(c), h = B(!1), b = ($ = !1, T) => {
      h.value = !h.value, t("toggle-year-picker", { flow: $, show: T });
    }, w = ($) => {
      h.value = !1, t("year-select", $);
    }, D = ($ = !1) => {
      t("handle-year", $);
    };
    return ($, T) => {
      var g, M, A, P, C;
      return v(), y(me, null, [
        k("div", {
          class: pe(["dp--year-mode-picker", { "dp--hidden-el": h.value }])
        }, [
          m(l)(m(i), e.instance) ? (v(), Pe(Pn, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (g = m(s)) == null ? void 0 : g.prevYear,
            disabled: e.isDisabled(!1),
            class: pe((M = m(u)) == null ? void 0 : M.navBtnPrev),
            onActivate: T[0] || (T[0] = (O) => D(!1))
          }, {
            default: Ae(() => [
              $.$slots["arrow-left"] ? ie($.$slots, "arrow-left", { key: 0 }) : Y("", !0),
              $.$slots["arrow-left"] ? Y("", !0) : (v(), Pe(m(sl), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : Y("", !0),
          k("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${(A = m(s)) == null ? void 0 : A.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${e.instance}`,
            onClick: T[1] || (T[1] = () => b(!1)),
            onKeydown: T[2] || (T[2] = Cn(() => b(!1), ["enter"]))
          }, [
            $.$slots.year ? ie($.$slots, "year", {
              key: 0,
              year: e.year
            }) : Y("", !0),
            $.$slots.year ? Y("", !0) : (v(), y(me, { key: 1 }, [
              Je(_e(e.year), 1)
            ], 64))
          ], 40, gy),
          m(r)(m(i), e.instance) ? (v(), Pe(Pn, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (P = m(s)) == null ? void 0 : P.nextYear,
            disabled: e.isDisabled(!0),
            class: pe((C = m(u)) == null ? void 0 : C.navBtnNext),
            onActivate: T[3] || (T[3] = (O) => D(!0))
          }, {
            default: Ae(() => [
              $.$slots["arrow-right"] ? ie($.$slots, "arrow-right", { key: 0 }) : Y("", !0),
              $.$slots["arrow-right"] ? Y("", !0) : (v(), Pe(m(il), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : Y("", !0)
        ], 2),
        qe(Ha, {
          name: m(f)(e.showYearPicker),
          css: m(d)
        }, {
          default: Ae(() => {
            var O, R;
            return [
              e.showYearPicker ? (v(), Pe(Yn, {
                key: 0,
                items: e.items,
                "text-input": $.textInput,
                "esc-close": $.escClose,
                config: $.config,
                "is-last": $.autoApply && !m(o).keepActionRow,
                "hide-navigation": $.hideNavigation,
                "aria-labels": $.ariaLabels,
                "overlay-label": (R = (O = m(s)) == null ? void 0 : O.yearPicker) == null ? void 0 : R.call(O, !0),
                type: "year",
                onToggle: b,
                onSelected: T[4] || (T[4] = (S) => w(S))
              }, bt({
                "button-icon": Ae(() => [
                  $.$slots["calendar-icon"] ? ie($.$slots, "calendar-icon", { key: 0 }) : Y("", !0),
                  $.$slots["calendar-icon"] ? Y("", !0) : (v(), Pe(m(yn), { key: 1 }))
                ]),
                _: 2
              }, [
                $.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: Ae(({ item: S }) => [
                    ie($.$slots, "year-overlay-value", {
                      text: S.text,
                      value: S.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : Y("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), yl = (e, a, t) => {
  if (a.value && Array.isArray(a.value))
    if (a.value.some((n) => Ue(e, n))) {
      const n = a.value.filter((r) => !Ue(r, e));
      a.value = n.length ? n : null;
    } else (t && +t > a.value.length || !t) && a.value.push(e);
  else
    a.value = [e];
}, gl = (e, a, t) => {
  let n = e.value ? e.value.slice() : [];
  return n.length === 2 && n[1] !== null && (n = []), n.length ? (ot(a, n[0]) ? n.unshift(a) : n[1] = a, t("range-end", a)) : (n = [a], t("range-start", a)), n;
}, dr = (e, a, t, n) => {
  e && (e[0] && e[1] && t && a("auto-apply"), e[0] && !e[1] && n && t && a("auto-apply"));
}, $s = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((a) => Bt(de(a), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Bt(de(e.value), e.timezone));
}, Ps = (e, a, t, n) => Array.isArray(a.value) && (a.value.length === 2 || a.value.length === 1 && n.value.partialRange) ? n.value.fixedStart && (ct(e, a.value[0]) || Ue(e, a.value[0])) ? [a.value[0], e] : n.value.fixedEnd && (ot(e, a.value[1]) || Ue(e, a.value[1])) ? [e, a.value[1]] : (t("invalid-fixed-range", e), a.value) : [], As = ({
  multiCalendars: e,
  range: a,
  highlight: t,
  propDates: n,
  calendars: r,
  modelValue: l,
  props: o,
  filters: i,
  year: s,
  month: c,
  emit: u
}) => {
  const d = H(() => pl(o.yearRange, o.locale, o.reverseYears)), f = B([!1]), h = H(() => (S, X) => {
    const re = Ze(Xt(/* @__PURE__ */ new Date()), {
      month: c.value(S),
      year: s.value(S)
    }), fe = X ? Jo(re) : Rn(re);
    return Ds(
      fe,
      n.value.maxDate,
      n.value.minDate,
      o.preventMinMaxNavigation,
      X
    );
  }), b = () => Array.isArray(l.value) && e.value.solo && l.value[1], w = () => {
    for (let S = 0; S < e.value.count; S++)
      if (S === 0)
        r.value[S] = r.value[0];
      else if (S === e.value.count - 1 && b())
        r.value[S] = {
          month: We(l.value[1]),
          year: Ne(l.value[1])
        };
      else {
        const X = Ze(de(), r.value[S - 1]);
        r.value[S] = { month: We(X), year: Ne(tl(X, 1)) };
      }
  }, D = (S) => {
    if (!S) return w();
    const X = Ze(de(), r.value[S]);
    return r.value[0].year = Ne(ps(X, e.value.count - 1)), w();
  }, $ = (S, X) => {
    const re = Im(X, S);
    return a.value.showLastInRange && re > 1 ? X : S;
  }, T = (S) => o.focusStartDate || e.value.solo ? S[0] : S[1] ? $(S[0], S[1]) : S[0], g = () => {
    if (l.value) {
      const S = Array.isArray(l.value) ? T(l.value) : l.value;
      r.value[0] = { month: We(S), year: Ne(S) };
    }
  }, M = () => {
    g(), e.value.count && w();
  };
  et(l, (S, X) => {
    o.isTextInputDate && JSON.stringify(S ?? {}) !== JSON.stringify(X ?? {}) && M();
  }), Xe(() => {
    M();
  });
  const A = (S, X) => {
    r.value[X].year = S, u("update-month-year", { instance: X, year: S, month: r.value[X].month }), e.value.count && !e.value.solo && D(X);
  }, P = H(() => (S) => fn(d.value, (X) => {
    var re;
    const fe = s.value(S) === X.value, I = En(
      X.value,
      pn(n.value.minDate),
      pn(n.value.maxDate)
    ) || ((re = i.value.years) == null ? void 0 : re.includes(s.value(S))), V = hl(t.value, X.value);
    return { active: fe, disabled: I, highlighted: V };
  })), C = (S, X) => {
    A(S, X), R(X);
  }, O = (S, X = !1) => {
    if (!h.value(S, X)) {
      const re = X ? s.value(S) + 1 : s.value(S) - 1;
      A(re, S);
    }
  }, R = (S, X = !1, re) => {
    X || u("reset-flow"), re !== void 0 ? f.value[S] = re : f.value[S] = !f.value[S], f.value[S] ? u("overlay-toggle", { open: !0, overlay: Dt.year }) : (u("overlay-closed"), u("overlay-toggle", { open: !1, overlay: Dt.year }));
  };
  return {
    isDisabled: h,
    groupedYears: P,
    showYearPicker: f,
    selectYear: A,
    toggleYearPicker: R,
    handleYearSelect: C,
    handleYear: O
  };
}, by = (e, a) => {
  const {
    defaultedMultiCalendars: t,
    defaultedAriaLabels: n,
    defaultedTransitions: r,
    defaultedConfig: l,
    defaultedRange: o,
    defaultedHighlight: i,
    propDates: s,
    defaultedTz: c,
    defaultedFilters: u,
    defaultedMultiDates: d
  } = rt(e), f = () => {
    e.isTextInputDate && M(Ne(de(e.startDate)), 0);
  }, { modelValue: h, year: b, month: w, calendars: D } = Un(e, a, f), $ = H(() => vs(e.formatLocale, e.locale, e.monthNameFormat)), T = B(null), { checkMinMaxRange: g } = Ma(e), {
    selectYear: M,
    groupedYears: A,
    showYearPicker: P,
    toggleYearPicker: C,
    handleYearSelect: O,
    handleYear: R,
    isDisabled: S
  } = As({
    modelValue: h,
    multiCalendars: t,
    range: o,
    highlight: i,
    calendars: D,
    year: b,
    propDates: s,
    month: w,
    filters: u,
    props: e,
    emit: a
  });
  Xe(() => {
    e.startDate && (h.value && e.focusStartDate || !h.value) && M(Ne(de(e.startDate)), 0);
  });
  const X = (N) => N ? { month: We(N), year: Ne(N) } : { month: null, year: null }, re = () => h.value ? Array.isArray(h.value) ? h.value.map((N) => X(N)) : X(h.value) : X(), fe = (N, Z) => {
    const ae = D.value[N], p = re();
    return Array.isArray(p) ? p.some((W) => W.year === (ae == null ? void 0 : ae.year) && W.month === Z) : (ae == null ? void 0 : ae.year) === p.year && Z === p.month;
  }, I = (N, Z, ae) => {
    var p, W;
    const ve = re();
    return Array.isArray(ve) ? b.value(Z) === ((p = ve[ae]) == null ? void 0 : p.year) && N === ((W = ve[ae]) == null ? void 0 : W.month) : !1;
  }, V = (N, Z) => {
    if (o.value.enabled) {
      const ae = re();
      if (Array.isArray(h.value) && Array.isArray(ae)) {
        const p = I(N, Z, 0) || I(N, Z, 1), W = pa(Xt(de()), N, b.value(Z));
        return Nn(h.value, T.value, W) && !p;
      }
      return !1;
    }
    return !1;
  }, E = H(() => (N) => fn($.value, (Z) => {
    var ae;
    const p = fe(N, Z.value), W = En(
      Z.value,
      _s(b.value(N), s.value.minDate),
      ks(b.value(N), s.value.maxDate)
    ) || Yh(s.value.disabledDates, b.value(N), Z.value) || ((ae = u.value.months) == null ? void 0 : ae.includes(Z.value)) || !Wh(s.value.allowedDates, b.value(N), Z.value), ve = V(Z.value, N), Fe = Is(i.value, Z.value, b.value(N));
    return { active: p, disabled: W, isBetween: ve, highlighted: Fe };
  })), ee = (N, Z) => pa(Xt(de()), N, b.value(Z)), ce = (N, Z) => {
    const ae = h.value ? h.value : Xt(/* @__PURE__ */ new Date());
    h.value = pa(ae, N, b.value(Z)), a("auto-apply"), a("update-flow-step");
  }, q = (N, Z) => {
    const ae = ee(N, Z);
    o.value.fixedEnd || o.value.fixedStart ? h.value = Ps(ae, h, a, o) : h.value ? g(ae, h.value) && (h.value = gl(h, ee(N, Z), a)) : h.value = [ee(N, Z)], mt().then(() => {
      dr(h.value, a, e.autoApply, e.modelAuto);
    });
  }, J = (N, Z) => {
    yl(ee(N, Z), h, d.value.limit), a("auto-apply", !0);
  }, L = (N, Z) => (D.value[Z].month = N, x(Z, D.value[Z].year, N), d.value.enabled ? J(N, Z) : o.value.enabled ? q(N, Z) : ce(N, Z)), F = (N, Z) => {
    M(N, Z), x(Z, N, null);
  }, x = (N, Z, ae) => {
    let p = ae;
    if (!p && p !== 0) {
      const W = re();
      p = Array.isArray(W) ? W[N].month : W.month;
    }
    a("update-month-year", { instance: N, year: Z, month: p });
  };
  return {
    groupedMonths: E,
    groupedYears: A,
    year: b,
    isDisabled: S,
    defaultedMultiCalendars: t,
    defaultedAriaLabels: n,
    defaultedTransitions: r,
    defaultedConfig: l,
    showYearPicker: P,
    modelValue: h,
    presetDate: (N, Z) => {
      $s({
        value: N,
        modelValue: h,
        range: o.value.enabled,
        timezone: Z ? void 0 : c.value.timezone
      }), a("auto-apply");
    },
    setHoverDate: (N, Z) => {
      T.value = ee(N, Z);
    },
    selectMonth: L,
    selectYear: F,
    toggleYearPicker: C,
    handleYearSelect: O,
    handleYear: R,
    getModelMonthYear: re
  };
}, wy = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...ta
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = ea(), l = Ft(r, "yearMode"), o = e;
    Xe(() => {
      o.shadow || n("mount", null);
    });
    const {
      groupedMonths: i,
      groupedYears: s,
      year: c,
      isDisabled: u,
      defaultedMultiCalendars: d,
      defaultedConfig: f,
      showYearPicker: h,
      modelValue: b,
      presetDate: w,
      setHoverDate: D,
      selectMonth: $,
      selectYear: T,
      toggleYearPicker: g,
      handleYearSelect: M,
      handleYear: A,
      getModelMonthYear: P
    } = by(o, n);
    return a({ getSidebarProps: () => ({
      modelValue: b,
      year: c,
      getModelMonthYear: P,
      selectMonth: $,
      selectYear: T,
      handleYear: A
    }), presetDate: w, toggleYearPicker: (C) => g(0, C) }), (C, O) => (v(), Pe(cr, {
      "multi-calendars": m(d).count,
      collapse: C.collapse,
      stretch: "",
      "is-mobile": C.isMobile
    }, {
      default: Ae(({ instance: R }) => [
        C.$slots["top-extra"] ? ie(C.$slots, "top-extra", {
          key: 0,
          value: C.internalModelValue
        }) : Y("", !0),
        C.$slots["month-year"] ? ie(C.$slots, "month-year", gt(dt({ key: 1 }, {
          year: m(c),
          months: m(i)(R),
          years: m(s)(R),
          selectMonth: m($),
          selectYear: m(T),
          instance: R
        }))) : (v(), Pe(Yn, {
          key: 2,
          items: m(i)(R),
          "arrow-navigation": C.arrowNavigation,
          "is-last": C.autoApply && !m(f).keepActionRow,
          "esc-close": C.escClose,
          height: m(f).modeHeight,
          config: C.config,
          "no-overlay-focus": !!(C.noOverlayFocus || C.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (S) => m($)(S, R),
          onHoverValue: (S) => m(D)(S, R)
        }, bt({
          header: Ae(() => [
            qe(Ss, dt(C.$props, {
              items: m(s)(R),
              instance: R,
              "show-year-picker": m(h)[R],
              year: m(c)(R),
              "is-disabled": (S) => m(u)(R, S),
              onHandleYear: (S) => m(A)(R, S),
              onYearSelect: (S) => m(M)(S, R),
              onToggleYearPicker: (S) => m(g)(R, S == null ? void 0 : S.flow, S == null ? void 0 : S.show)
            }), bt({ _: 2 }, [
              Me(m(l), (S, X) => ({
                name: S,
                fn: Ae((re) => [
                  ie(C.$slots, S, gt($t(re)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          C.$slots["month-overlay-value"] ? {
            name: "item",
            fn: Ae(({ item: S }) => [
              ie(C.$slots, "month-overlay-value", {
                text: S.text,
                value: S.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), _y = (e, a) => {
  const t = () => {
    e.isTextInputDate && (u.value = Ne(de(e.startDate)));
  }, { modelValue: n } = Un(e, a, t), r = B(null), { defaultedHighlight: l, defaultedMultiDates: o, defaultedFilters: i, defaultedRange: s, propDates: c } = rt(e), u = B();
  Xe(() => {
    e.startDate && (n.value && e.focusStartDate || !n.value) && (u.value = Ne(de(e.startDate)));
  });
  const d = ($) => Array.isArray(n.value) ? n.value.some((T) => Ne(T) === $) : n.value ? Ne(n.value) === $ : !1, f = ($) => s.value.enabled && Array.isArray(n.value) ? Nn(n.value, r.value, D($)) : !1, h = ($) => c.value.allowedDates instanceof Map ? c.value.allowedDates.size ? c.value.allowedDates.has(`${$}`) : !1 : !0, b = ($) => c.value.disabledDates instanceof Map ? c.value.disabledDates.size ? c.value.disabledDates.has(`${$}`) : !1 : !0, w = H(() => fn(pl(e.yearRange, e.locale, e.reverseYears), ($) => {
    const T = d($.value), g = En(
      $.value,
      pn(c.value.minDate),
      pn(c.value.maxDate)
    ) || i.value.years.includes($.value) || !h($.value) || b($.value), M = f($.value) && !T, A = hl(l.value, $.value);
    return { active: T, disabled: g, isBetween: M, highlighted: A };
  })), D = ($) => oa(Xt(Rn(/* @__PURE__ */ new Date())), $);
  return {
    groupedYears: w,
    modelValue: n,
    focusYear: u,
    setHoverValue: ($) => {
      r.value = oa(Xt(/* @__PURE__ */ new Date()), $);
    },
    selectYear: ($) => {
      var T;
      if (a("update-month-year", { instance: 0, year: $ }), o.value.enabled)
        return n.value ? Array.isArray(n.value) && (((T = n.value) == null ? void 0 : T.map((g) => Ne(g))).includes($) ? n.value = n.value.filter((g) => Ne(g) !== $) : n.value.push(oa(kt(de()), $))) : n.value = [oa(kt(Rn(de())), $)], a("auto-apply", !0);
      s.value.enabled ? (n.value = gl(n, D($), a), mt().then(() => {
        dr(n.value, a, e.autoApply, e.modelAuto);
      })) : (n.value = D($), a("auto-apply"));
    }
  };
}, ky = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...ta
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, { groupedYears: l, modelValue: o, focusYear: i, selectYear: s, setHoverValue: c } = _y(r, n), { defaultedConfig: u } = rt(r);
    return a({ getSidebarProps: () => ({
      modelValue: o,
      selectYear: s
    }) }), (d, f) => (v(), y("div", null, [
      d.$slots["top-extra"] ? ie(d.$slots, "top-extra", {
        key: 0,
        value: d.internalModelValue
      }) : Y("", !0),
      d.$slots["month-year"] ? ie(d.$slots, "month-year", gt(dt({ key: 1 }, {
        years: m(l),
        selectYear: m(s)
      }))) : (v(), Pe(Yn, {
        key: 2,
        items: m(l),
        "is-last": d.autoApply && !m(u).keepActionRow,
        height: m(u).modeHeight,
        config: d.config,
        "no-overlay-focus": !!(d.noOverlayFocus || d.textInput),
        "focus-value": m(i),
        type: "year",
        "use-relative": "",
        onSelected: m(s),
        onHoverValue: m(c)
      }, bt({ _: 2 }, [
        d.$slots["year-overlay-value"] ? {
          name: "item",
          fn: Ae(({ item: h }) => [
            ie(d.$slots, "year-overlay-value", {
              text: h.text,
              value: h.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), xy = {
  key: 0,
  class: "dp__time_input"
}, Cy = ["data-compact", "data-collapsed"], Dy = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], Ty = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], Iy = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], My = { key: 0 }, Sy = ["aria-label", "data-compact"], $y = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...ta
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, { setTimePickerElements: l, setTimePickerBackRef: o } = Ia(), {
      defaultedAriaLabels: i,
      defaultedTransitions: s,
      defaultedFilters: c,
      defaultedConfig: u,
      defaultedRange: d,
      defaultedMultiCalendars: f
    } = rt(r), { transitionName: h, showTransition: b } = Wn(s), w = _a({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), D = B("AM"), $ = B(null), T = B([]), g = B(), M = B(!1);
    Xe(() => {
      n("mounted");
    });
    const A = (_) => Ze(/* @__PURE__ */ new Date(), {
      hours: _.hours,
      minutes: _.minutes,
      seconds: r.enableSeconds ? _.seconds : 0,
      milliseconds: 0
    }), P = H(
      () => (_) => q(_, r[_]) || O(_, r[_])
    ), C = H(() => ({ hours: r.hours, minutes: r.minutes, seconds: r.seconds })), O = (_, j) => d.value.enabled && !d.value.disableTimeRangeValidation ? !r.validateTime(_, j) : !1, R = (_, j) => {
      if (d.value.enabled && !d.value.disableTimeRangeValidation) {
        const U = j ? +r[`${_}Increment`] : -+r[`${_}Increment`], Q = r[_] + U;
        return !r.validateTime(_, Q);
      }
      return !1;
    }, S = H(() => (_) => !N(+r[_] + +r[`${_}Increment`], _) || R(_, !0)), X = H(() => (_) => !N(+r[_] - +r[`${_}Increment`], _) || R(_, !1)), re = (_, j) => jo(Ze(de(), _), j), fe = (_, j) => kh(Ze(de(), _), j), I = H(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !r.timePickerInline,
        dp__time_col_reg_block: !r.enableSeconds && r.is24 && !r.timePickerInline,
        dp__time_col_reg_inline: !r.enableSeconds && r.is24 && r.timePickerInline,
        dp__time_col_reg_with_button: !r.enableSeconds && !r.is24,
        dp__time_col_sec: r.enableSeconds && r.is24,
        dp__time_col_sec_with_button: r.enableSeconds && !r.is24
      })
    ), V = H(
      () => r.timePickerInline && d.value.enabled && !f.value.count
    ), E = H(() => {
      const _ = [{ type: "hours" }];
      return r.enableMinutes && _.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), r.enableSeconds && _.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), _;
    }), ee = H(() => E.value.filter((_) => !_.separator)), ce = H(() => (_) => {
      if (_ === "hours") {
        const j = Fe(+r.hours);
        return { text: j < 10 ? `0${j}` : `${j}`, value: j };
      }
      return { text: r[_] < 10 ? `0${r[_]}` : `${r[_]}`, value: r[_] };
    }), q = (_, j) => {
      var U;
      if (!r.disabledTimesConfig) return !1;
      const Q = r.disabledTimesConfig(r.order, _ === "hours" ? j : void 0);
      return Q[_] ? !!((U = Q[_]) != null && U.includes(j)) : !0;
    }, J = (_, j) => j !== "hours" || D.value === "AM" ? _ : _ + 12, L = (_) => {
      const j = r.is24 ? 24 : 12, U = _ === "hours" ? j : 60, Q = +r[`${_}GridIncrement`], we = _ === "hours" && !r.is24 ? Q : 0, ge = [];
      for (let Oe = we; Oe < U; Oe += Q)
        ge.push({ value: r.is24 ? Oe : J(Oe, _), text: Oe < 10 ? `0${Oe}` : `${Oe}` });
      return _ === "hours" && !r.is24 && ge.unshift({ value: D.value === "PM" ? 12 : 0, text: "12" }), fn(ge, (Oe) => ({ active: !1, disabled: c.value.times[_].includes(Oe.value) || !N(Oe.value, _) || q(_, Oe.value) || O(_, Oe.value) }));
    }, F = (_) => _ >= 0 ? _ : 59, x = (_) => _ >= 0 ? _ : 23, N = (_, j) => {
      const U = r.minTime ? A(br(r.minTime)) : null, Q = r.maxTime ? A(br(r.maxTime)) : null, we = A(
        br(
          C.value,
          j,
          j === "minutes" || j === "seconds" ? F(_) : x(_)
        )
      );
      return U && Q ? (cn(we, Q) || Ja(we, Q)) && (Fa(we, U) || Ja(we, U)) : U ? Fa(we, U) || Ja(we, U) : Q ? cn(we, Q) || Ja(we, Q) : !0;
    }, Z = (_) => r[`no${_[0].toUpperCase() + _.slice(1)}Overlay`], ae = (_) => {
      Z(_) || (w[_] = !w[_], w[_] ? (M.value = !0, n("overlay-opened", _)) : (M.value = !1, n("overlay-closed", _)));
    }, p = (_) => _ === "hours" ? ya : _ === "minutes" ? Da : un, W = () => {
      g.value && clearTimeout(g.value);
    }, ve = (_, j = !0, U) => {
      const Q = j ? re : fe, we = j ? +r[`${_}Increment`] : -+r[`${_}Increment`];
      N(+r[_] + we, _) && n(
        `update:${_}`,
        p(_)(Q({ [_]: +r[_] }, { [_]: +r[`${_}Increment`] }))
      ), !(U != null && U.keyboard) && u.value.timeArrowHoldThreshold && (g.value = setTimeout(() => {
        ve(_, j);
      }, u.value.timeArrowHoldThreshold));
    }, Fe = (_) => r.is24 ? _ : (_ >= 12 ? D.value = "PM" : D.value = "AM", Sh(_)), K = () => {
      D.value === "PM" ? (D.value = "AM", n("update:hours", r.hours - 12)) : (D.value = "PM", n("update:hours", r.hours + 12)), n("am-pm-change", D.value);
    }, Ee = (_) => {
      w[_] = !0;
    }, ue = (_, j, U) => {
      if (_ && r.arrowNavigation) {
        Array.isArray(T.value[j]) ? T.value[j][U] = _ : T.value[j] = [_];
        const Q = T.value.reduce(
          (we, ge) => ge.map((Oe, Le) => [...we[Le] || [], ge[Le]]),
          []
        );
        o(r.closeTimePickerBtn), $.value && (Q[1] = Q[1].concat($.value)), l(Q, r.order);
      }
    }, ye = (_, j) => (ae(_), n(`update:${_}`, j));
    return a({ openChildCmp: Ee }), (_, j) => {
      var U;
      return _.disabled ? Y("", !0) : (v(), y("div", xy, [
        (v(!0), y(me, null, Me(E.value, (Q, we) => {
          var ge, Oe, Le;
          return v(), y("div", {
            key: we,
            class: pe(I.value),
            "data-compact": V.value && !_.enableSeconds,
            "data-collapsed": V.value && _.enableSeconds
          }, [
            Q.separator ? (v(), y(me, { key: 0 }, [
              M.value ? Y("", !0) : (v(), y(me, { key: 0 }, [
                Je(":")
              ], 64))
            ], 64)) : (v(), y(me, { key: 1 }, [
              k("button", {
                ref_for: !0,
                ref: (z) => ue(z, we, 0),
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !_.timePickerInline,
                  dp__inc_dec_button_inline: _.timePickerInline,
                  dp__tp_inline_btn_top: _.timePickerInline,
                  dp__inc_dec_button_disabled: S.value(Q.type),
                  "dp--hidden-el": M.value
                }),
                "data-test-id": `${Q.type}-time-inc-btn-${r.order}`,
                "aria-label": (ge = m(i)) == null ? void 0 : ge.incrementValue(Q.type),
                tabindex: "0",
                onKeydown: (z) => m(Pt)(z, () => ve(Q.type, !0, { keyboard: !0 }), !0),
                onClick: (z) => m(u).timeArrowHoldThreshold ? void 0 : ve(Q.type, !0),
                onMousedown: (z) => m(u).timeArrowHoldThreshold ? ve(Q.type, !0) : void 0,
                onMouseup: W
              }, [
                r.timePickerInline ? (v(), y(me, { key: 1 }, [
                  _.$slots["tp-inline-arrow-up"] ? ie(_.$slots, "tp-inline-arrow-up", { key: 0 }) : (v(), y(me, { key: 1 }, [
                    j[2] || (j[2] = k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    j[3] || (j[3] = k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (v(), y(me, { key: 0 }, [
                  _.$slots["arrow-up"] ? ie(_.$slots, "arrow-up", { key: 0 }) : Y("", !0),
                  _.$slots["arrow-up"] ? Y("", !0) : (v(), Pe(m(cl), { key: 1 }))
                ], 64))
              ], 42, Dy),
              k("button", {
                ref_for: !0,
                ref: (z) => ue(z, we, 1),
                type: "button",
                "aria-label": `${ce.value(Q.type).text}-${(Oe = m(i)) == null ? void 0 : Oe.openTpOverlay(Q.type)}`,
                class: pe({
                  dp__time_display: !0,
                  dp__time_display_block: !_.timePickerInline,
                  dp__time_display_inline: _.timePickerInline,
                  "dp--time-invalid": P.value(Q.type),
                  "dp--time-overlay-btn": !P.value(Q.type),
                  "dp--hidden-el": M.value
                }),
                disabled: Z(Q.type),
                tabindex: "0",
                "data-test-id": `${Q.type}-toggle-overlay-btn-${r.order}`,
                onKeydown: (z) => m(Pt)(z, () => ae(Q.type), !0),
                onClick: (z) => ae(Q.type)
              }, [
                _.$slots[Q.type] ? ie(_.$slots, Q.type, {
                  key: 0,
                  text: ce.value(Q.type).text,
                  value: ce.value(Q.type).value
                }) : Y("", !0),
                _.$slots[Q.type] ? Y("", !0) : (v(), y(me, { key: 1 }, [
                  Je(_e(ce.value(Q.type).text), 1)
                ], 64))
              ], 42, Ty),
              k("button", {
                ref_for: !0,
                ref: (z) => ue(z, we, 2),
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !_.timePickerInline,
                  dp__inc_dec_button_inline: _.timePickerInline,
                  dp__tp_inline_btn_bottom: _.timePickerInline,
                  dp__inc_dec_button_disabled: X.value(Q.type),
                  "dp--hidden-el": M.value
                }),
                "data-test-id": `${Q.type}-time-dec-btn-${r.order}`,
                "aria-label": (Le = m(i)) == null ? void 0 : Le.decrementValue(Q.type),
                tabindex: "0",
                onKeydown: (z) => m(Pt)(z, () => ve(Q.type, !1, { keyboard: !0 }), !0),
                onClick: (z) => m(u).timeArrowHoldThreshold ? void 0 : ve(Q.type, !1),
                onMousedown: (z) => m(u).timeArrowHoldThreshold ? ve(Q.type, !1) : void 0,
                onMouseup: W
              }, [
                r.timePickerInline ? (v(), y(me, { key: 1 }, [
                  _.$slots["tp-inline-arrow-down"] ? ie(_.$slots, "tp-inline-arrow-down", { key: 0 }) : (v(), y(me, { key: 1 }, [
                    j[4] || (j[4] = k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    j[5] || (j[5] = k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (v(), y(me, { key: 0 }, [
                  _.$slots["arrow-down"] ? ie(_.$slots, "arrow-down", { key: 0 }) : Y("", !0),
                  _.$slots["arrow-down"] ? Y("", !0) : (v(), Pe(m(dl), { key: 1 }))
                ], 64))
              ], 42, Iy)
            ], 64))
          ], 10, Cy);
        }), 128)),
        _.is24 ? Y("", !0) : (v(), y("div", My, [
          _.$slots["am-pm-button"] ? ie(_.$slots, "am-pm-button", {
            key: 0,
            toggle: K,
            value: D.value
          }) : Y("", !0),
          _.$slots["am-pm-button"] ? Y("", !0) : (v(), y("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: $,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (U = m(i)) == null ? void 0 : U.amPmButton,
            tabindex: "0",
            "data-compact": V.value,
            onClick: K,
            onKeydown: j[0] || (j[0] = (Q) => m(Pt)(Q, () => K(), !0))
          }, _e(D.value), 41, Sy))
        ])),
        (v(!0), y(me, null, Me(ee.value, (Q, we) => (v(), Pe(Ha, {
          key: we,
          name: m(h)(w[Q.type]),
          css: m(b)
        }, {
          default: Ae(() => {
            var ge, Oe;
            return [
              w[Q.type] ? (v(), Pe(Yn, {
                key: 0,
                items: L(Q.type),
                "is-last": _.autoApply && !m(u).keepActionRow,
                "esc-close": _.escClose,
                type: Q.type,
                "text-input": _.textInput,
                config: _.config,
                "arrow-navigation": _.arrowNavigation,
                "aria-labels": _.ariaLabels,
                "overlay-label": (Oe = (ge = m(i)).timeOverlay) == null ? void 0 : Oe.call(ge, Q.type),
                onSelected: (Le) => ye(Q.type, Le),
                onToggle: (Le) => ae(Q.type),
                onResetFlow: j[1] || (j[1] = (Le) => _.$emit("reset-flow"))
              }, bt({
                "button-icon": Ae(() => [
                  _.$slots["clock-icon"] ? ie(_.$slots, "clock-icon", { key: 0 }) : Y("", !0),
                  _.$slots["clock-icon"] ? Y("", !0) : (v(), Pe(Va(_.timePickerInline ? m(yn) : m(ul)), { key: 1 }))
                ]),
                _: 2
              }, [
                _.$slots[`${Q.type}-overlay-value`] ? {
                  name: "item",
                  fn: Ae(({ item: Le }) => [
                    ie(_.$slots, `${Q.type}-overlay-value`, {
                      text: Le.text,
                      value: Le.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                _.$slots[`${Q.type}-overlay-header`] ? {
                  name: "header",
                  fn: Ae(() => [
                    ie(_.$slots, `${Q.type}-overlay-header`, {
                      toggle: () => ae(Q.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : Y("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), Py = ["data-dp-mobile"], Ay = ["aria-label", "tabindex"], Oy = ["role", "aria-label", "tabindex"], Ry = ["aria-label"], Os = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...ta
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, { buildMatrix: l, setTimePicker: o } = Ia(), i = ea(), { defaultedTransitions: s, defaultedAriaLabels: c, defaultedTextInput: u, defaultedConfig: d, defaultedRange: f } = rt(r), { transitionName: h, showTransition: b } = Wn(s), { hideNavigationButtons: w } = fr(), D = B(null), $ = B(null), T = B([]), g = B(null), M = B(!1);
    Xe(() => {
      n("mount"), !r.timePicker && r.arrowNavigation ? l([vt(D.value)], "time") : o(!0, r.timePicker);
    });
    const A = H(() => f.value.enabled && r.modelAuto ? hs(r.internalModelValue) : !0), P = B(!1), C = (q) => ({
      hours: Array.isArray(r.hours) ? r.hours[q] : r.hours,
      minutes: Array.isArray(r.minutes) ? r.minutes[q] : r.minutes,
      seconds: Array.isArray(r.seconds) ? r.seconds[q] : r.seconds
    }), O = H(() => {
      const q = [];
      if (f.value.enabled)
        for (let J = 0; J < 2; J++)
          q.push(C(J));
      else
        q.push(C(0));
      return q;
    }), R = (q, J = !1, L = "") => {
      J || n("reset-flow"), P.value = q, n(q ? "overlay-opened" : "overlay-closed", Dt.time), r.arrowNavigation && o(q), mt(() => {
        L !== "" && T.value[0] && T.value[0].openChildCmp(L);
      });
    }, S = H(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: r.autoApply && !d.value.keepActionRow
    })), X = Ft(i, "timePicker"), re = (q, J, L) => f.value.enabled ? J === 0 ? [q, O.value[1][L]] : [O.value[0][L], q] : q, fe = (q) => {
      n("update:hours", q);
    }, I = (q) => {
      n("update:minutes", q);
    }, V = (q) => {
      n("update:seconds", q);
    }, E = () => {
      if (g.value && !u.value.enabled && !r.noOverlayFocus) {
        const q = ys(g.value);
        q && q.focus({ preventScroll: !0 });
      }
    }, ee = (q) => {
      M.value = !1, n("overlay-closed", q);
    }, ce = (q) => {
      M.value = !0, n("overlay-opened", q);
    };
    return a({ toggleTimePicker: R }), (q, J) => {
      var L;
      return v(), y("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": q.isMobile
      }, [
        !q.timePicker && !q.timePickerInline ? ht((v(), y("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: D,
          type: "button",
          class: pe({ ...S.value, "dp--hidden-el": P.value }),
          "aria-label": (L = m(c)) == null ? void 0 : L.openTimePicker,
          tabindex: q.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: J[0] || (J[0] = (F) => m(Pt)(F, () => R(!0))),
          onClick: J[1] || (J[1] = (F) => R(!0))
        }, [
          q.$slots["clock-icon"] ? ie(q.$slots, "clock-icon", { key: 0 }) : Y("", !0),
          q.$slots["clock-icon"] ? Y("", !0) : (v(), Pe(m(ul), { key: 1 }))
        ], 42, Ay)), [
          [Aa, !m(w)(q.hideNavigation, "time")]
        ]) : Y("", !0),
        qe(Ha, {
          name: m(h)(P.value),
          css: m(b) && !q.timePickerInline
        }, {
          default: Ae(() => {
            var F, x;
            return [
              P.value || q.timePicker || q.timePickerInline ? (v(), y("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: g,
                role: q.timePickerInline ? void 0 : "dialog",
                class: pe({
                  dp__overlay: !q.timePickerInline,
                  "dp--overlay-absolute": !r.timePicker && !q.timePickerInline,
                  "dp--overlay-relative": r.timePicker
                }),
                style: Be(q.timePicker ? { height: `${m(d).modeHeight}px` } : void 0),
                "aria-label": (F = m(c)) == null ? void 0 : F.timePicker,
                tabindex: q.timePickerInline ? void 0 : 0
              }, [
                k("div", {
                  class: pe(
                    q.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  q.$slots["time-picker-overlay"] ? ie(q.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: fe,
                    setMinutes: I,
                    setSeconds: V
                  }) : Y("", !0),
                  q.$slots["time-picker-overlay"] ? Y("", !0) : (v(), y("div", {
                    key: 1,
                    class: pe(q.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (v(!0), y(me, null, Me(O.value, (N, Z) => ht((v(), Pe($y, dt({
                      key: Z,
                      ref_for: !0
                    }, {
                      ...q.$props,
                      order: Z,
                      hours: N.hours,
                      minutes: N.minutes,
                      seconds: N.seconds,
                      closeTimePickerBtn: $.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: Z === 0 ? m(f).fixedStart : m(f).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: T,
                      "validate-time": (ae, p) => e.validateTime(ae, re(p, Z, ae)),
                      "onUpdate:hours": (ae) => fe(re(ae, Z, "hours")),
                      "onUpdate:minutes": (ae) => I(re(ae, Z, "minutes")),
                      "onUpdate:seconds": (ae) => V(re(ae, Z, "seconds")),
                      onMounted: E,
                      onOverlayClosed: ee,
                      onOverlayOpened: ce,
                      onAmPmChange: J[2] || (J[2] = (ae) => q.$emit("am-pm-change", ae))
                    }), bt({ _: 2 }, [
                      Me(m(X), (ae, p) => ({
                        name: ae,
                        fn: Ae((W) => [
                          ie(q.$slots, ae, dt({ ref_for: !0 }, W))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Aa, Z === 0 ? !0 : A.value]
                    ])), 128))
                  ], 2)),
                  !q.timePicker && !q.timePickerInline ? ht((v(), y("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: $,
                    type: "button",
                    class: pe({ ...S.value, "dp--hidden-el": M.value }),
                    "aria-label": (x = m(c)) == null ? void 0 : x.closeTimePicker,
                    tabindex: "0",
                    onKeydown: J[3] || (J[3] = (N) => m(Pt)(N, () => R(!1))),
                    onClick: J[4] || (J[4] = (N) => R(!1))
                  }, [
                    q.$slots["calendar-icon"] ? ie(q.$slots, "calendar-icon", { key: 0 }) : Y("", !0),
                    q.$slots["calendar-icon"] ? Y("", !0) : (v(), Pe(m(yn), { key: 1 }))
                  ], 42, Ry)), [
                    [Aa, !m(w)(q.hideNavigation, "time")]
                  ]) : Y("", !0)
                ], 2)
              ], 14, Oy)) : Y("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, Py);
    };
  }
}), Rs = (e, a, t, n) => {
  const { defaultedRange: r } = rt(e), l = (g, M) => Array.isArray(a[g]) ? a[g][M] : a[g], o = (g) => e.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[g] : a.seconds : 0, i = (g, M) => g ? M !== void 0 ? Ca(g, l("hours", M), l("minutes", M), o(M)) : Ca(g, a.hours, a.minutes, o()) : fs(de(), o(M)), s = (g, M) => {
    a[g] = M;
  }, c = H(() => e.modelAuto && r.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : r.value.enabled), u = (g, M) => {
    const A = Object.fromEntries(
      Object.keys(a).map((P) => P === g ? [P, M] : [P, a[P]].slice())
    );
    if (c.value && !r.value.disableTimeRangeValidation) {
      const P = (O) => t.value ? Ca(
        t.value[O],
        A.hours[O],
        A.minutes[O],
        A.seconds[O]
      ) : null, C = (O) => ds(t.value[O], 0);
      return !(Ue(P(0), P(1)) && (Fa(P(0), C(1)) || cn(P(1), C(0))));
    }
    return !0;
  }, d = (g, M) => {
    u(g, M) && (s(g, M), n && n());
  }, f = (g) => {
    d("hours", g);
  }, h = (g) => {
    d("minutes", g);
  }, b = (g) => {
    d("seconds", g);
  }, w = (g, M, A, P) => {
    M && f(g), !M && !A && h(g), A && b(g), t.value && P(t.value);
  }, D = (g) => {
    if (g) {
      const M = Array.isArray(g), A = M ? [+g[0].hours, +g[1].hours] : +g.hours, P = M ? [+g[0].minutes, +g[1].minutes] : +g.minutes, C = M ? [+g[0].seconds, +g[1].seconds] : +g.seconds;
      s("hours", A), s("minutes", P), e.enableSeconds && s("seconds", C);
    }
  }, $ = (g, M) => {
    const A = {
      hours: Array.isArray(a.hours) ? a.hours[g] : a.hours,
      disabledArr: []
    };
    return (M || M === 0) && (A.hours = M), Array.isArray(e.disabledTimes) && (A.disabledArr = r.value.enabled && Array.isArray(e.disabledTimes[g]) ? e.disabledTimes[g] : e.disabledTimes), A;
  }, T = H(() => (g, M) => {
    var A;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: P, hours: C } = $(g, M), O = P.filter((R) => +R.hours === C);
      return ((A = O[0]) == null ? void 0 : A.minutes) === "*" ? { hours: [C], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (O == null ? void 0 : O.map((R) => +R.minutes)) ?? [],
        seconds: (O == null ? void 0 : O.map((R) => R.seconds ? +R.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: s,
    updateHours: f,
    updateMinutes: h,
    updateSeconds: b,
    getSetDateTime: i,
    updateTimeValues: w,
    getSecondsValue: o,
    assignStartTime: D,
    validateTime: u,
    disabledTimesConfig: T
  };
}, Ey = (e, a) => {
  const t = () => {
    e.isTextInputDate && M();
  }, { modelValue: n, time: r } = Un(e, a, t), { defaultedStartTime: l, defaultedRange: o, defaultedTz: i } = rt(e), { updateTimeValues: s, getSetDateTime: c, setTime: u, assignStartTime: d, disabledTimesConfig: f, validateTime: h } = Rs(e, r, n, b);
  function b() {
    a("update-flow-step");
  }
  const w = (P) => {
    const { hours: C, minutes: O, seconds: R } = P;
    return { hours: +C, minutes: +O, seconds: R ? +R : 0 };
  }, D = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const C = w(e.startTime[0]), O = w(e.startTime[1]);
        return [Ze(de(), C), Ze(de(), O)];
      }
      const P = w(e.startTime);
      return Ze(de(), P);
    }
    return o.value.enabled ? [null, null] : null;
  }, $ = () => {
    if (o.value.enabled) {
      const [P, C] = D();
      n.value = [
        Bt(c(P, 0), i.value.timezone),
        Bt(c(C, 1), i.value.timezone)
      ];
    } else
      n.value = Bt(c(D()), i.value.timezone);
  }, T = (P) => Array.isArray(P) ? [Na(de(P[0])), Na(de(P[1]))] : [Na(P ?? de())], g = (P, C, O) => {
    u("hours", P), u("minutes", C), u("seconds", e.enableSeconds ? O : 0);
  }, M = () => {
    const [P, C] = T(n.value);
    return o.value.enabled ? g(
      [P.hours, C.hours],
      [P.minutes, C.minutes],
      [P.seconds, C.seconds]
    ) : g(P.hours, P.minutes, P.seconds);
  };
  Xe(() => {
    if (!e.shadow)
      return d(l.value), n.value ? M() : $();
  });
  const A = () => {
    Array.isArray(n.value) ? n.value = n.value.map((P, C) => P && c(P, C)) : n.value = c(n.value), a("time-update");
  };
  return {
    modelValue: n,
    time: r,
    disabledTimesConfig: f,
    updateTime: (P, C = !0, O = !1) => {
      s(P, C, O, A);
    },
    validateTime: h
  };
}, Ny = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...ta
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, l = ea(), o = Ft(l, "timePicker"), i = B(null), { time: s, modelValue: c, disabledTimesConfig: u, updateTime: d, validateTime: f } = Ey(r, n);
    return Xe(() => {
      r.shadow || n("mount", null);
    }), a({ getSidebarProps: () => ({
      modelValue: c,
      time: s,
      updateTime: d
    }), toggleTimePicker: (h, b = !1, w = "") => {
      var D;
      (D = i.value) == null || D.toggleTimePicker(h, b, w);
    } }), (h, b) => (v(), Pe(cr, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": h.isMobile
    }, {
      default: Ae(() => [
        qe(Os, dt({
          ref_key: "tpRef",
          ref: i
        }, h.$props, {
          hours: m(s).hours,
          minutes: m(s).minutes,
          seconds: m(s).seconds,
          "internal-model-value": h.internalModelValue,
          "disabled-times-config": m(u),
          "validate-time": m(f),
          "onUpdate:hours": b[0] || (b[0] = (w) => m(d)(w)),
          "onUpdate:minutes": b[1] || (b[1] = (w) => m(d)(w, !1)),
          "onUpdate:seconds": b[2] || (b[2] = (w) => m(d)(w, !1, !0)),
          onAmPmChange: b[3] || (b[3] = (w) => h.$emit("am-pm-change", w)),
          onResetFlow: b[4] || (b[4] = (w) => h.$emit("reset-flow")),
          onOverlayClosed: b[5] || (b[5] = (w) => h.$emit("overlay-toggle", { open: !1, overlay: w })),
          onOverlayOpened: b[6] || (b[6] = (w) => h.$emit("overlay-toggle", { open: !0, overlay: w }))
        }), bt({ _: 2 }, [
          Me(m(o), (w, D) => ({
            name: w,
            fn: Ae(($) => [
              ie(h.$slots, w, gt($t($)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), By = { class: "dp--header-wrap" }, Ly = {
  key: 0,
  class: "dp__month_year_wrap"
}, Fy = { key: 0 }, Vy = { class: "dp__month_year_wrap" }, Hy = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], Yy = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...ta
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, {
      defaultedTransitions: l,
      defaultedAriaLabels: o,
      defaultedMultiCalendars: i,
      defaultedFilters: s,
      defaultedConfig: c,
      defaultedHighlight: u,
      propDates: d,
      defaultedUI: f
    } = rt(r), { transitionName: h, showTransition: b } = Wn(l), { buildMatrix: w } = Ia(), { handleMonthYearChange: D, isDisabled: $, updateMonthYear: T } = iy(r, n), { showLeftIcon: g, showRightIcon: M } = fr(), A = B(!1), P = B(!1), C = B(!1), O = B([null, null, null, null]);
    Xe(() => {
      n("mount");
    });
    const R = (x) => ({
      get: () => r[x],
      set: (N) => {
        const Z = x === Gt.month ? Gt.year : Gt.month;
        n("update-month-year", { [x]: N, [Z]: r[Z] }), x === Gt.month ? ee(!0) : ce(!0);
      }
    }), S = H(R(Gt.month)), X = H(R(Gt.year)), re = H(() => (x) => ({
      month: r.month,
      year: r.year,
      items: x === Gt.month ? r.months : r.years,
      instance: r.instance,
      updateMonthYear: T,
      toggle: x === Gt.month ? ee : ce
    })), fe = H(() => r.months.find((N) => N.value === r.month) || { text: "", value: 0 }), I = H(() => fn(r.months, (x) => {
      const N = r.month === x.value, Z = En(
        x.value,
        _s(r.year, d.value.minDate),
        ks(r.year, d.value.maxDate)
      ) || s.value.months.includes(x.value), ae = Is(u.value, x.value, r.year);
      return { active: N, disabled: Z, highlighted: ae };
    })), V = H(() => fn(r.years, (x) => {
      const N = r.year === x.value, Z = En(
        x.value,
        pn(d.value.minDate),
        pn(d.value.maxDate)
      ) || s.value.years.includes(x.value), ae = hl(u.value, x.value);
      return { active: N, disabled: Z, highlighted: ae };
    })), E = (x, N, Z) => {
      Z !== void 0 ? x.value = Z : x.value = !x.value, x.value ? (C.value = !0, n("overlay-opened", N)) : (C.value = !1, n("overlay-closed", N));
    }, ee = (x = !1, N) => {
      q(x), E(A, Dt.month, N);
    }, ce = (x = !1, N) => {
      q(x), E(P, Dt.year, N);
    }, q = (x) => {
      x || n("reset-flow");
    }, J = (x, N) => {
      r.arrowNavigation && (O.value[N] = vt(x), w(O.value, "monthYear"));
    }, L = H(() => {
      var x, N, Z, ae, p, W;
      return [
        {
          type: Gt.month,
          index: 1,
          toggle: ee,
          modelValue: S.value,
          updateModelValue: (ve) => S.value = ve,
          text: fe.value.text,
          showSelectionGrid: A.value,
          items: I.value,
          ariaLabel: (x = o.value) == null ? void 0 : x.openMonthsOverlay,
          overlayLabel: ((Z = (N = o.value).monthPicker) == null ? void 0 : Z.call(N, !0)) ?? void 0
        },
        {
          type: Gt.year,
          index: 2,
          toggle: ce,
          modelValue: X.value,
          updateModelValue: (ve) => X.value = ve,
          text: gs(r.year, r.locale),
          showSelectionGrid: P.value,
          items: V.value,
          ariaLabel: (ae = o.value) == null ? void 0 : ae.openYearsOverlay,
          overlayLabel: ((W = (p = o.value).yearPicker) == null ? void 0 : W.call(p, !0)) ?? void 0
        }
      ];
    }), F = H(() => r.disableYearSelect ? [L.value[0]] : r.yearFirst ? [...L.value].reverse() : L.value);
    return a({
      toggleMonthPicker: ee,
      toggleYearPicker: ce,
      handleMonthYearChange: D
    }), (x, N) => {
      var Z, ae, p, W, ve, Fe;
      return v(), y("div", By, [
        x.$slots["month-year"] ? (v(), y("div", Ly, [
          ie(x.$slots, "month-year", gt($t({
            month: e.month,
            year: e.year,
            months: e.months,
            years: e.years,
            updateMonthYear: m(T),
            handleMonthYearChange: m(D),
            instance: e.instance,
            isDisabled: m($)
          })))
        ])) : (v(), y(me, { key: 1 }, [
          x.$slots["top-extra"] ? (v(), y("div", Fy, [
            ie(x.$slots, "top-extra", { value: x.internalModelValue })
          ])) : Y("", !0),
          k("div", Vy, [
            m(g)(m(i), e.instance) && !x.vertical ? (v(), Pe(Pn, {
              key: 0,
              "aria-label": (Z = m(o)) == null ? void 0 : Z.prevMonth,
              disabled: m($)(!1),
              class: pe((ae = m(f)) == null ? void 0 : ae.navBtnPrev),
              "el-name": "action-prev",
              onActivate: N[0] || (N[0] = (K) => m(D)(!1, !0)),
              onSetRef: N[1] || (N[1] = (K) => J(K, 0))
            }, {
              default: Ae(() => [
                x.$slots["arrow-left"] ? ie(x.$slots, "arrow-left", { key: 0 }) : Y("", !0),
                x.$slots["arrow-left"] ? Y("", !0) : (v(), Pe(m(sl), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : Y("", !0),
            k("div", {
              class: pe(["dp__month_year_wrap", {
                dp__year_disable_select: x.disableYearSelect
              }])
            }, [
              (v(!0), y(me, null, Me(F.value, (K, Ee) => (v(), y(me, {
                key: K.type
              }, [
                k("button", {
                  ref_for: !0,
                  ref: (ue) => J(ue, Ee + 1),
                  type: "button",
                  "data-dp-element": `overlay-${K.type}`,
                  class: pe(["dp__btn dp__month_year_select", { "dp--hidden-el": C.value }]),
                  "aria-label": `${K.text}-${K.ariaLabel}`,
                  "data-test-id": `${K.type}-toggle-overlay-${e.instance}`,
                  onClick: K.toggle,
                  onKeydown: (ue) => m(Pt)(ue, () => K.toggle(), !0)
                }, [
                  x.$slots[K.type] ? ie(x.$slots, K.type, {
                    key: 0,
                    text: K.text,
                    value: r[K.type]
                  }) : Y("", !0),
                  x.$slots[K.type] ? Y("", !0) : (v(), y(me, { key: 1 }, [
                    Je(_e(K.text), 1)
                  ], 64))
                ], 42, Hy),
                qe(Ha, {
                  name: m(h)(K.showSelectionGrid),
                  css: m(b)
                }, {
                  default: Ae(() => [
                    K.showSelectionGrid ? (v(), Pe(Yn, {
                      key: 0,
                      items: K.items,
                      "arrow-navigation": x.arrowNavigation,
                      "hide-navigation": x.hideNavigation,
                      "is-last": x.autoApply && !m(c).keepActionRow,
                      "skip-button-ref": !1,
                      config: x.config,
                      type: K.type,
                      "header-refs": [],
                      "esc-close": x.escClose,
                      "menu-wrap-ref": x.menuWrapRef,
                      "text-input": x.textInput,
                      "aria-labels": x.ariaLabels,
                      "overlay-label": K.overlayLabel,
                      onSelected: K.updateModelValue,
                      onToggle: K.toggle
                    }, bt({
                      "button-icon": Ae(() => [
                        x.$slots["calendar-icon"] ? ie(x.$slots, "calendar-icon", { key: 0 }) : Y("", !0),
                        x.$slots["calendar-icon"] ? Y("", !0) : (v(), Pe(m(yn), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      x.$slots[`${K.type}-overlay-value`] ? {
                        name: "item",
                        fn: Ae(({ item: ue }) => [
                          ie(x.$slots, `${K.type}-overlay-value`, {
                            text: ue.text,
                            value: ue.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      x.$slots[`${K.type}-overlay`] ? {
                        name: "overlay",
                        fn: Ae(() => [
                          ie(x.$slots, `${K.type}-overlay`, dt({ ref_for: !0 }, re.value(K.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      x.$slots[`${K.type}-overlay-header`] ? {
                        name: "header",
                        fn: Ae(() => [
                          ie(x.$slots, `${K.type}-overlay-header`, {
                            toggle: K.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : Y("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            m(g)(m(i), e.instance) && x.vertical ? (v(), Pe(Pn, {
              key: 1,
              "aria-label": (p = m(o)) == null ? void 0 : p.prevMonth,
              "el-name": "action-prev",
              disabled: m($)(!1),
              class: pe((W = m(f)) == null ? void 0 : W.navBtnPrev),
              onActivate: N[2] || (N[2] = (K) => m(D)(!1, !0))
            }, {
              default: Ae(() => [
                x.$slots["arrow-up"] ? ie(x.$slots, "arrow-up", { key: 0 }) : Y("", !0),
                x.$slots["arrow-up"] ? Y("", !0) : (v(), Pe(m(cl), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : Y("", !0),
            m(M)(m(i), e.instance) ? (v(), Pe(Pn, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: m($)(!0),
              "aria-label": (ve = m(o)) == null ? void 0 : ve.nextMonth,
              class: pe((Fe = m(f)) == null ? void 0 : Fe.navBtnNext),
              onActivate: N[3] || (N[3] = (K) => m(D)(!0, !0)),
              onSetRef: N[4] || (N[4] = (K) => J(K, x.disableYearSelect ? 2 : 3))
            }, {
              default: Ae(() => [
                x.$slots[x.vertical ? "arrow-down" : "arrow-right"] ? ie(x.$slots, x.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : Y("", !0),
                x.$slots[x.vertical ? "arrow-down" : "arrow-right"] ? Y("", !0) : (v(), Pe(Va(x.vertical ? m(dl) : m(il)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : Y("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), Wy = {
  class: "dp__calendar_header",
  role: "row"
}, Uy = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, zy = ["aria-label"], qy = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, jy = { class: "dp__cell_inner" }, Gy = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], Qy = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...ta
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, { buildMultiLevelMatrix: l } = Ia(), {
      defaultedTransitions: o,
      defaultedConfig: i,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: c,
      defaultedWeekNumbers: u,
      defaultedMultiDates: d,
      defaultedUI: f
    } = rt(r), h = B(null), b = B({
      bottom: "",
      left: "",
      transform: ""
    }), w = B([]), D = B(null), $ = B(!0), T = B(""), g = B({ startX: 0, endX: 0, startY: 0, endY: 0 }), M = B([]), A = B({ left: "50%" }), P = B(!1), C = H(() => r.calendar ? r.calendar(r.mappedDates) : r.mappedDates), O = H(() => r.dayNames ? Array.isArray(r.dayNames) ? r.dayNames : r.dayNames(r.locale, +r.weekStart) : Mh(r.formatLocale, r.locale, +r.weekStart));
    Xe(() => {
      n("mount", { cmp: "calendar", refs: w }), i.value.noSwipe || D.value && (D.value.addEventListener("touchstart", J, { passive: !1 }), D.value.addEventListener("touchend", L, { passive: !1 }), D.value.addEventListener("touchmove", F, { passive: !1 })), r.monthChangeOnScroll && D.value && D.value.addEventListener("wheel", Z, { passive: !1 });
    }), vn(() => {
      i.value.noSwipe || D.value && (D.value.removeEventListener("touchstart", J), D.value.removeEventListener("touchend", L), D.value.removeEventListener("touchmove", F)), r.monthChangeOnScroll && D.value && D.value.removeEventListener("wheel", Z);
    });
    const R = (K) => K ? r.vertical ? "vNext" : "next" : r.vertical ? "vPrevious" : "previous", S = (K, Ee) => {
      if (r.transitions) {
        const ue = kt(pa(de(), r.month, r.year));
        T.value = ct(kt(pa(de(), K, Ee)), ue) ? o.value[R(!0)] : o.value[R(!1)], $.value = !1, mt(() => {
          $.value = !0;
        });
      }
    }, X = H(
      () => ({
        ...f.value.calendar ?? {}
      })
    ), re = H(() => (K) => {
      const Ee = $h(K);
      return {
        dp__marker_dot: Ee.type === "dot",
        dp__marker_line: Ee.type === "line"
      };
    }), fe = H(() => (K) => Ue(K, h.value)), I = H(() => ({
      dp__calendar: !0,
      dp__calendar_next: c.value.count > 0 && r.instance !== 0
    })), V = H(() => (K) => r.hideOffsetDates ? K.current : !0), E = async (K, Ee) => {
      const { width: ue, height: ye } = K.getBoundingClientRect();
      h.value = Ee.value;
      let _ = { left: `${ue / 2}px` }, j = -50;
      if (await mt(), M.value[0]) {
        const { left: U, width: Q } = M.value[0].getBoundingClientRect();
        U < 0 && (_ = { left: "0" }, j = 0, A.value.left = `${ue / 2}px`), window.innerWidth < U + Q && (_ = { right: "0" }, j = 0, A.value.left = `${Q - ue / 2}px`);
      }
      b.value = {
        bottom: `${ye}px`,
        ..._,
        transform: `translateX(${j}%)`
      };
    }, ee = async (K, Ee, ue) => {
      var ye, _, j;
      const U = vt(w.value[Ee][ue]);
      U && ((ye = K.marker) != null && ye.customPosition && (j = (_ = K.marker) == null ? void 0 : _.tooltip) != null && j.length ? b.value = K.marker.customPosition(U) : await E(U, K), n("tooltip-open", K.marker));
    }, ce = async (K, Ee, ue) => {
      var ye, _;
      if (P.value && d.value.enabled && d.value.dragSelect)
        return n("select-date", K);
      if (n("set-hover-date", K), (_ = (ye = K.marker) == null ? void 0 : ye.tooltip) != null && _.length) {
        if (r.hideOffsetDates && !K.current) return;
        await ee(K, Ee, ue);
      }
    }, q = (K) => {
      h.value && (h.value = null, b.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), n("tooltip-close", K.marker));
    }, J = (K) => {
      g.value.startX = K.changedTouches[0].screenX, g.value.startY = K.changedTouches[0].screenY;
    }, L = (K) => {
      g.value.endX = K.changedTouches[0].screenX, g.value.endY = K.changedTouches[0].screenY, x();
    }, F = (K) => {
      r.vertical && !r.inline && K.preventDefault();
    }, x = () => {
      const K = r.vertical ? "Y" : "X";
      Math.abs(g.value[`start${K}`] - g.value[`end${K}`]) > 10 && n("handle-swipe", g.value[`start${K}`] > g.value[`end${K}`] ? "right" : "left");
    }, N = (K, Ee, ue) => {
      K && (Array.isArray(w.value[Ee]) ? w.value[Ee][ue] = K : w.value[Ee] = [K]), r.arrowNavigation && l(w.value, "calendar");
    }, Z = (K) => {
      r.monthChangeOnScroll && (K.preventDefault(), n("handle-scroll", K));
    }, ae = (K) => u.value.type === "local" ? rl(K.value, { weekStartsOn: +r.weekStart }) : u.value.type === "iso" ? al(K.value) : typeof u.value.type == "function" ? u.value.type(K.value) : "", p = (K) => {
      const Ee = K[0];
      return u.value.hideOnOffsetDates ? K.some((ue) => ue.current) ? ae(Ee) : "" : ae(Ee);
    }, W = (K, Ee, ue = !0) => {
      !ue && Eh() || (!d.value.enabled || i.value.allowPreventDefault) && (xa(K, i.value), n("select-date", Ee));
    }, ve = (K) => {
      xa(K, i.value);
    }, Fe = (K) => {
      d.value.enabled && d.value.dragSelect ? (P.value = !0, n("select-date", K)) : d.value.enabled && n("select-date", K);
    };
    return a({ triggerTransition: S }), (K, Ee) => (v(), y("div", {
      class: pe(I.value)
    }, [
      k("div", {
        ref_key: "calendarWrapRef",
        ref: D,
        class: pe(X.value),
        role: "grid"
      }, [
        k("div", Wy, [
          K.weekNumbers ? (v(), y("div", Uy, _e(K.weekNumName), 1)) : Y("", !0),
          (v(!0), y(me, null, Me(O.value, (ue, ye) => {
            var _, j;
            return v(), y("div", {
              key: ye,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (j = (_ = m(s)) == null ? void 0 : _.weekDay) == null ? void 0 : j.call(_, ye)
            }, [
              K.$slots["calendar-header"] ? ie(K.$slots, "calendar-header", {
                key: 0,
                day: ue,
                index: ye
              }) : Y("", !0),
              K.$slots["calendar-header"] ? Y("", !0) : (v(), y(me, { key: 1 }, [
                Je(_e(ue), 1)
              ], 64))
            ], 8, zy);
          }), 128))
        ]),
        Ee[2] || (Ee[2] = k("div", { class: "dp__calendar_header_separator" }, null, -1)),
        qe(Ha, {
          name: T.value,
          css: !!K.transitions
        }, {
          default: Ae(() => [
            $.value ? (v(), y("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: Ee[1] || (Ee[1] = (ue) => P.value = !1)
            }, [
              (v(!0), y(me, null, Me(C.value, (ue, ye) => (v(), y("div", {
                key: ye,
                class: "dp__calendar_row",
                role: "row"
              }, [
                K.weekNumbers ? (v(), y("div", qy, [
                  k("div", jy, _e(p(ue.days)), 1)
                ])) : Y("", !0),
                (v(!0), y(me, null, Me(ue.days, (_, j) => {
                  var U, Q, we;
                  return v(), y("div", {
                    id: m(Fr)(_.value),
                    ref_for: !0,
                    ref: (ge) => N(ge, ye, j),
                    key: j + ye,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (_.classData.dp__active_date || _.classData.dp__range_start || _.classData.dp__range_start) ?? void 0,
                    "aria-disabled": _.classData.dp__cell_disabled || void 0,
                    "aria-label": (Q = (U = m(s)) == null ? void 0 : U.day) == null ? void 0 : Q.call(U, _),
                    tabindex: !_.current && K.hideOffsetDates ? void 0 : 0,
                    "data-test-id": m(Fr)(_.value),
                    onClick: yt((ge) => W(ge, _), ["prevent"]),
                    onTouchend: (ge) => W(ge, _, !1),
                    onKeydown: (ge) => m(Pt)(ge, () => K.$emit("select-date", _)),
                    onMouseenter: (ge) => ce(_, ye, j),
                    onMouseleave: (ge) => q(_),
                    onMousedown: (ge) => Fe(_),
                    onMouseup: Ee[0] || (Ee[0] = (ge) => P.value = !1)
                  }, [
                    k("div", {
                      class: pe(["dp__cell_inner", _.classData])
                    }, [
                      K.$slots.day && V.value(_) ? ie(K.$slots, "day", {
                        key: 0,
                        day: +_.text,
                        date: _.value
                      }) : Y("", !0),
                      K.$slots.day ? Y("", !0) : (v(), y(me, { key: 1 }, [
                        Je(_e(_.text), 1)
                      ], 64)),
                      _.marker && V.value(_) ? (v(), y(me, { key: 2 }, [
                        K.$slots.marker ? ie(K.$slots, "marker", {
                          key: 0,
                          marker: _.marker,
                          day: +_.text,
                          date: _.value
                        }) : (v(), y("div", {
                          key: 1,
                          class: pe(re.value(_.marker)),
                          style: Be(_.marker.color ? { backgroundColor: _.marker.color } : {})
                        }, null, 6))
                      ], 64)) : Y("", !0),
                      fe.value(_.value) ? (v(), y("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: M,
                        class: "dp__marker_tooltip",
                        style: Be(b.value)
                      }, [
                        (we = _.marker) != null && we.tooltip ? (v(), y("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: ve
                        }, [
                          (v(!0), y(me, null, Me(_.marker.tooltip, (ge, Oe) => (v(), y("div", {
                            key: Oe,
                            class: "dp__tooltip_text"
                          }, [
                            K.$slots["marker-tooltip"] ? ie(K.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: ge,
                              day: _.value
                            }) : Y("", !0),
                            K.$slots["marker-tooltip"] ? Y("", !0) : (v(), y(me, { key: 1 }, [
                              k("div", {
                                class: "dp__tooltip_mark",
                                style: Be(ge.color ? { backgroundColor: ge.color } : {})
                              }, null, 4),
                              k("div", null, _e(ge.text), 1)
                            ], 64))
                          ]))), 128)),
                          k("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Be(A.value)
                          }, null, 4)
                        ])) : Y("", !0)
                      ], 4)) : Y("", !0)
                    ], 2)
                  ], 40, Gy);
                }), 128))
              ]))), 128))
            ], 32)) : Y("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), ro = (e) => Array.isArray(e), Ky = (e, a, t, n) => {
  const r = B([]), l = B(/* @__PURE__ */ new Date()), o = B(), i = () => L(e.isTextInputDate), { modelValue: s, calendars: c, time: u, today: d } = Un(e, a, i), {
    defaultedMultiCalendars: f,
    defaultedStartTime: h,
    defaultedRange: b,
    defaultedConfig: w,
    defaultedTz: D,
    propDates: $,
    defaultedMultiDates: T
  } = rt(e), { validateMonthYearInRange: g, isDisabled: M, isDateRangeAllowed: A, checkMinMaxRange: P } = Ma(e), { updateTimeValues: C, getSetDateTime: O, setTime: R, assignStartTime: S, validateTime: X, disabledTimesConfig: re } = Rs(e, u, s, n), fe = H(
    () => (G) => c.value[G] ? c.value[G].month : 0
  ), I = H(
    () => (G) => c.value[G] ? c.value[G].year : 0
  ), V = (G) => !w.value.keepViewOnOffsetClick || G ? !0 : !o.value, E = (G, be, $e, Ve = !1) => {
    var se, ke;
    V(Ve) && (c.value[G] || (c.value[G] = { month: 0, year: 0 }), c.value[G].month = Zl(be) ? (se = c.value[G]) == null ? void 0 : se.month : be, c.value[G].year = Zl($e) ? (ke = c.value[G]) == null ? void 0 : ke.year : $e);
  }, ee = () => {
    e.autoApply && a("select-date");
  }, ce = () => {
    h.value && S(h.value);
  };
  Xe(() => {
    e.shadow || (s.value || (Ee(), ce()), L(!0), e.focusStartDate && e.startDate && Ee());
  });
  const q = H(() => {
    var G;
    return (G = e.flow) != null && G.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), J = () => {
    e.autoApply && q.value && a("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
  }, L = (G = !1) => {
    if (s.value)
      return Array.isArray(s.value) ? (r.value = s.value, W(G)) : N(s.value, G);
    if (f.value.count && G && !e.startDate)
      return x(de(), G);
  }, F = () => Array.isArray(s.value) && b.value.enabled ? We(s.value[0]) === We(s.value[1] ?? s.value[0]) : !1, x = (G = /* @__PURE__ */ new Date(), be = !1) => {
    if ((!f.value.count || !f.value.static || be) && E(0, We(G), Ne(G)), f.value.count && (!s.value || F() || !f.value.solo) && (!f.value.solo || be))
      for (let $e = 1; $e < f.value.count; $e++) {
        const Ve = Ze(de(), { month: fe.value($e - 1), year: I.value($e - 1) }), se = jo(Ve, { months: 1 });
        c.value[$e] = { month: We(se), year: Ne(se) };
      }
  }, N = (G, be) => {
    x(G), R("hours", ya(G)), R("minutes", Da(G)), R("seconds", un(G)), f.value.count && be && K();
  }, Z = (G) => {
    if (f.value.count) {
      if (f.value.solo) return 0;
      const be = We(G[0]), $e = We(G[1]);
      return Math.abs($e - be) < f.value.count ? 0 : 1;
    }
    return 1;
  }, ae = (G, be) => {
    G[1] && b.value.showLastInRange ? x(G[Z(G)], be) : x(G[0], be);
    const $e = (Ve, se) => [
      Ve(G[0]),
      G[1] ? Ve(G[1]) : u[se][1]
    ];
    R("hours", $e(ya, "hours")), R("minutes", $e(Da, "minutes")), R("seconds", $e(un, "seconds"));
  }, p = (G, be) => {
    if ((b.value.enabled || e.weekPicker) && !T.value.enabled)
      return ae(G, be);
    if (T.value.enabled && be) {
      const $e = G[G.length - 1];
      return N($e, be);
    }
  }, W = (G) => {
    const be = s.value;
    p(be, G), f.value.count && f.value.solo && K();
  }, ve = (G, be) => {
    const $e = Ze(de(), { month: fe.value(be), year: I.value(be) }), Ve = G < 0 ? Zt($e, 1) : dn($e, 1);
    g(We(Ve), Ne(Ve), G < 0, e.preventMinMaxNavigation) && (E(be, We(Ve), Ne(Ve)), a("update-month-year", { instance: be, month: We(Ve), year: Ne(Ve) }), f.value.count && !f.value.solo && Fe(be), t());
  }, Fe = (G) => {
    for (let be = G - 1; be >= 0; be--) {
      const $e = dn(Ze(de(), { month: fe.value(be + 1), year: I.value(be + 1) }), 1);
      E(be, We($e), Ne($e));
    }
    for (let be = G + 1; be <= f.value.count - 1; be++) {
      const $e = Zt(Ze(de(), { month: fe.value(be - 1), year: I.value(be - 1) }), 1);
      E(be, We($e), Ne($e));
    }
  }, K = () => {
    if (Array.isArray(s.value) && s.value.length === 2) {
      const G = de(
        de(s.value[1] ? s.value[1] : Zt(s.value[0], 1))
      ), [be, $e] = [We(s.value[0]), Ne(s.value[0])], [Ve, se] = [We(s.value[1]), Ne(s.value[1])];
      (be !== Ve || be === Ve && $e !== se) && f.value.solo && E(1, We(G), Ne(G));
    } else s.value && !Array.isArray(s.value) && (E(0, We(s.value), Ne(s.value)), x(de()));
  }, Ee = () => {
    e.startDate && (E(0, We(de(e.startDate)), Ne(de(e.startDate))), f.value.count && Fe(0));
  }, ue = (G, be) => {
    if (e.monthChangeOnScroll) {
      const $e = (/* @__PURE__ */ new Date()).getTime() - l.value.getTime(), Ve = Math.abs(G.deltaY);
      let se = 500;
      Ve > 1 && (se = 100), Ve > 100 && (se = 0), $e > se && (l.value = /* @__PURE__ */ new Date(), ve(e.monthChangeOnScroll !== "inverse" ? -G.deltaY : G.deltaY, be));
    }
  }, ye = (G, be, $e = !1) => {
    e.monthChangeOnArrows && e.vertical === $e && _(G, be);
  }, _ = (G, be) => {
    ve(G === "right" ? -1 : 1, be);
  }, j = (G) => {
    if ($.value.markers)
      return ar(G.value, $.value.markers);
  }, U = (G, be) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [G == 0, !0];
      case "fair":
        return [G == 0 || be > G, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Q = (G, be, $e, Ve) => {
    if (e.sixWeeks && G.length < 6) {
      const se = 6 - G.length, ke = (be.getDay() + 7 - Ve) % 7, Ie = 6 - ($e.getDay() + 7 - Ve) % 7, [aa, ne] = U(ke, Ie);
      for (let le = 1; le <= se; le++)
        if (ne ? !!(le % 2) == aa : aa) {
          const oe = G[0].days[0], Ce = we(zt(oe.value, -7), We(be));
          G.unshift({ days: Ce });
        } else {
          const oe = G[G.length - 1], Ce = oe.days[oe.days.length - 1], De = we(zt(Ce.value, 1), We(be));
          G.push({ days: De });
        }
    }
    return G;
  }, we = (G, be) => {
    const $e = de(G), Ve = [];
    for (let se = 0; se < 7; se++) {
      const ke = zt($e, se), Ie = We(ke) !== be;
      Ve.push({
        text: e.hideOffsetDates && Ie ? "" : ke.getDate(),
        value: ke,
        current: !Ie,
        classData: {}
      });
    }
    return Ve;
  }, ge = (G, be) => {
    const $e = [], Ve = new Date(be, G), se = new Date(be, G + 1, 0), ke = e.weekStart, Ie = Jt(Ve, { weekStartsOn: ke }), aa = (ne) => {
      const le = we(ne, G);
      if ($e.push({ days: le }), !$e[$e.length - 1].days.some(
        (oe) => Ue(kt(oe.value), kt(se))
      )) {
        const oe = zt(ne, 7);
        aa(oe);
      }
    };
    return aa(Ie), Q($e, Ve, se, ke);
  }, Oe = (G) => {
    const be = Ca(de(G.value), u.hours, u.minutes, xe());
    a("date-update", be), T.value.enabled ? yl(be, s, T.value.limit) : s.value = be, n(), mt().then(() => {
      J();
    });
  }, Le = (G) => b.value.noDisabledRange ? xs(r.value[0], G).some((be) => M(be)) : !1, z = () => {
    r.value = s.value ? s.value.slice() : [], r.value.length === 2 && !(b.value.fixedStart || b.value.fixedEnd) && (r.value = []);
  }, he = (G, be) => {
    const $e = [
      de(G.value),
      zt(de(G.value), +b.value.autoRange)
    ];
    A($e) ? (be && Se(G.value), r.value = $e) : a("invalid-date", G.value);
  }, Se = (G) => {
    const be = We(de(G)), $e = Ne(de(G));
    if (E(0, be, $e), f.value.count > 0)
      for (let Ve = 1; Ve < f.value.count; Ve++) {
        const se = Lh(
          Ze(de(G), { year: I.value(Ve - 1), month: fe.value(Ve - 1) })
        );
        E(Ve, se.month, se.year);
      }
  }, He = (G) => {
    if (Le(G.value) || !P(G.value, s.value, b.value.fixedStart ? 0 : 1))
      return a("invalid-date", G.value);
    r.value = Ps(de(G.value), s, a, b);
  }, Ge = (G, be) => {
    if (z(), b.value.autoRange) return he(G, be);
    if (b.value.fixedStart || b.value.fixedEnd) return He(G);
    r.value[0] ? P(de(G.value), s.value) && !Le(G.value) ? ot(de(G.value), de(r.value[0])) ? (r.value.unshift(de(G.value)), a("range-end", r.value[0])) : (r.value[1] = de(G.value), a("range-end", r.value[1])) : (e.autoApply && a("auto-apply-invalid", G.value), a("invalid-date", G.value)) : (r.value[0] = de(G.value), a("range-start", r.value[0]));
  }, xe = (G = !0) => e.enableSeconds ? Array.isArray(u.seconds) ? G ? u.seconds[0] : u.seconds[1] : u.seconds : 0, tt = (G) => {
    r.value[G] = Ca(
      r.value[G],
      u.hours[G],
      u.minutes[G],
      xe(G !== 1)
    );
  }, wt = () => {
    var G, be;
    r.value[0] && r.value[1] && +((G = r.value) == null ? void 0 : G[0]) > +((be = r.value) == null ? void 0 : be[1]) && (r.value.reverse(), a("range-start", r.value[0]), a("range-end", r.value[1]));
  }, Ua = () => {
    r.value.length && (r.value[0] && !r.value[1] ? tt(0) : (tt(0), tt(1), n()), wt(), s.value = r.value.slice(), dr(r.value, a, e.autoApply, e.modelAuto));
  }, za = (G, be = !1) => {
    if (M(G.value) || !G.current && e.hideOffsetDates) return a("invalid-date", G.value);
    if (o.value = JSON.parse(JSON.stringify(G)), !b.value.enabled) return Oe(G);
    ro(u.hours) && ro(u.minutes) && !T.value.enabled && (Ge(G, be), Ua());
  }, qa = (G, be) => {
    var $e;
    E(G, be.month, be.year, !0), f.value.count && !f.value.solo && Fe(G), a("update-month-year", { instance: G, month: be.month, year: be.year }), t(f.value.solo ? G : void 0);
    const Ve = ($e = e.flow) != null && $e.length ? e.flow[e.flowStep] : void 0;
    !be.fromNav && (Ve === Dt.month || Ve === Dt.year) && n();
  }, gn = (G, be) => {
    $s({
      value: G,
      modelValue: s,
      range: b.value.enabled,
      timezone: be ? void 0 : D.value.timezone
    }), ee(), e.multiCalendars && mt().then(() => L(!0));
  }, jt = () => {
    const G = fl(de(), D.value);
    !b.value.enabled && !T.value.enabled ? s.value = G : s.value && Array.isArray(s.value) && s.value[0] ? T.value.enabled ? s.value = [...s.value, G] : s.value = ot(G, s.value[0]) ? [G, s.value[0]] : [s.value[0], G] : s.value = [G], ee();
  }, bn = () => {
    if (Array.isArray(s.value))
      if (T.value.enabled) {
        const G = wn();
        s.value[s.value.length - 1] = O(G);
      } else
        s.value = s.value.map((G, be) => G && O(G, be));
    else
      s.value = O(s.value);
    a("time-update");
  }, wn = () => Array.isArray(s.value) && s.value.length ? s.value[s.value.length - 1] : null;
  return {
    calendars: c,
    modelValue: s,
    month: fe,
    year: I,
    time: u,
    disabledTimesConfig: re,
    today: d,
    validateTime: X,
    getCalendarDays: ge,
    getMarker: j,
    handleScroll: ue,
    handleSwipe: _,
    handleArrow: ye,
    selectDate: za,
    updateMonthYear: qa,
    presetDate: gn,
    selectCurrentDate: jt,
    updateTime: (G, be = !0, $e = !1) => {
      C(G, be, $e, bn);
    },
    assignMonthAndYear: x,
    setStartTime: ce
  };
}, Xy = { key: 0 }, Zy = /* @__PURE__ */ Te({
  __name: "DatePicker",
  props: {
    ...ta
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, {
      calendars: l,
      month: o,
      year: i,
      modelValue: s,
      time: c,
      disabledTimesConfig: u,
      today: d,
      validateTime: f,
      getCalendarDays: h,
      getMarker: b,
      handleArrow: w,
      handleScroll: D,
      handleSwipe: $,
      selectDate: T,
      updateMonthYear: g,
      presetDate: M,
      selectCurrentDate: A,
      updateTime: P,
      assignMonthAndYear: C,
      setStartTime: O
    } = Ky(r, n, F, x), R = ea(), { setHoverDate: S, getDayClassData: X, clearHoverDate: re } = vg(s, r), { defaultedMultiCalendars: fe } = rt(r), I = B([]), V = B([]), E = B(null), ee = Ft(R, "calendar"), ce = Ft(R, "monthYear"), q = Ft(R, "timePicker"), J = (ue) => {
      r.shadow || n("mount", ue);
    };
    et(
      l,
      () => {
        r.shadow || setTimeout(() => {
          n("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), et(
      fe,
      (ue, ye) => {
        ue.count - ye.count > 0 && C();
      },
      { deep: !0 }
    );
    const L = H(() => (ue) => h(o.value(ue), i.value(ue)).map((ye) => ({
      ...ye,
      days: ye.days.map((_) => (_.marker = b(_), _.classData = X(_), _))
    })));
    function F(ue) {
      var ye;
      ue || ue === 0 ? (ye = V.value[ue]) == null || ye.triggerTransition(o.value(ue), i.value(ue)) : V.value.forEach((_, j) => _.triggerTransition(o.value(j), i.value(j)));
    }
    function x() {
      n("update-flow-step");
    }
    const N = (ue, ye = !1) => {
      T(ue, ye), r.spaceConfirm && n("select-date");
    }, Z = (ue, ye, _ = 0) => {
      var j;
      (j = I.value[_]) == null || j.toggleMonthPicker(ue, ye);
    }, ae = (ue, ye, _ = 0) => {
      var j;
      (j = I.value[_]) == null || j.toggleYearPicker(ue, ye);
    }, p = (ue, ye, _) => {
      var j;
      (j = E.value) == null || j.toggleTimePicker(ue, ye, _);
    }, W = (ue, ye) => {
      var _;
      if (!r.range) {
        const j = s.value ? s.value : d, U = ye ? new Date(ye) : j, Q = ue ? Jt(U, { weekStartsOn: 1 }) : es(U, { weekStartsOn: 1 });
        T({
          value: Q,
          current: We(U) === o.value(0),
          text: "",
          classData: {}
        }), (_ = document.getElementById(Fr(Q))) == null || _.focus();
      }
    }, ve = (ue) => {
      var ye;
      (ye = I.value[0]) == null || ye.handleMonthYearChange(ue, !0);
    }, Fe = (ue) => {
      g(0, { month: o.value(0), year: i.value(0) + (ue ? 1 : -1), fromNav: !0 });
    }, K = (ue, ye) => {
      ue === Dt.time && n(`time-picker-${ye ? "open" : "close"}`), n("overlay-toggle", { open: ye, overlay: ue });
    }, Ee = (ue) => {
      n("overlay-toggle", { open: !1, overlay: ue }), n("focus-menu");
    };
    return a({
      clearHoverDate: re,
      presetDate: M,
      selectCurrentDate: A,
      toggleMonthPicker: Z,
      toggleYearPicker: ae,
      toggleTimePicker: p,
      handleArrow: w,
      updateMonthYear: g,
      getSidebarProps: () => ({
        modelValue: s,
        month: o,
        year: i,
        time: c,
        updateTime: P,
        updateMonthYear: g,
        selectDate: T,
        presetDate: M
      }),
      changeMonth: ve,
      changeYear: Fe,
      selectWeekDate: W,
      setStartTime: O
    }), (ue, ye) => (v(), y(me, null, [
      qe(cr, {
        "multi-calendars": m(fe).count,
        collapse: ue.collapse,
        "is-mobile": ue.isMobile
      }, {
        default: Ae(({ instance: _, index: j }) => [
          ue.disableMonthYearSelect ? Y("", !0) : (v(), Pe(Yy, dt({
            key: 0,
            ref: (U) => {
              U && (I.value[j] = U);
            },
            months: m(vs)(ue.formatLocale, ue.locale, ue.monthNameFormat),
            years: m(pl)(ue.yearRange, ue.locale, ue.reverseYears),
            month: m(o)(_),
            year: m(i)(_),
            instance: _
          }, ue.$props, {
            onMount: ye[0] || (ye[0] = (U) => J(m(Ea).header)),
            onResetFlow: ye[1] || (ye[1] = (U) => ue.$emit("reset-flow")),
            onUpdateMonthYear: (U) => m(g)(_, U),
            onOverlayClosed: Ee,
            onOverlayOpened: ye[2] || (ye[2] = (U) => ue.$emit("overlay-toggle", { open: !0, overlay: U }))
          }), bt({ _: 2 }, [
            Me(m(ce), (U, Q) => ({
              name: U,
              fn: Ae((we) => [
                ie(ue.$slots, U, gt($t(we)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          qe(Qy, dt({
            ref: (U) => {
              U && (V.value[j] = U);
            },
            "mapped-dates": L.value(_),
            month: m(o)(_),
            year: m(i)(_),
            instance: _
          }, ue.$props, {
            onSelectDate: (U) => m(T)(U, _ !== 1),
            onHandleSpace: (U) => N(U, _ !== 1),
            onSetHoverDate: ye[3] || (ye[3] = (U) => m(S)(U)),
            onHandleScroll: (U) => m(D)(U, _),
            onHandleSwipe: (U) => m($)(U, _),
            onMount: ye[4] || (ye[4] = (U) => J(m(Ea).calendar)),
            onResetFlow: ye[5] || (ye[5] = (U) => ue.$emit("reset-flow")),
            onTooltipOpen: ye[6] || (ye[6] = (U) => ue.$emit("tooltip-open", U)),
            onTooltipClose: ye[7] || (ye[7] = (U) => ue.$emit("tooltip-close", U))
          }), bt({ _: 2 }, [
            Me(m(ee), (U, Q) => ({
              name: U,
              fn: Ae((we) => [
                ie(ue.$slots, U, gt($t({ ...we })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      ue.enableTimePicker ? (v(), y("div", Xy, [
        ue.$slots["time-picker"] ? ie(ue.$slots, "time-picker", gt(dt({ key: 0 }, { time: m(c), updateTime: m(P) }))) : (v(), Pe(Os, dt({
          key: 1,
          ref_key: "timePickerRef",
          ref: E
        }, ue.$props, {
          hours: m(c).hours,
          minutes: m(c).minutes,
          seconds: m(c).seconds,
          "internal-model-value": ue.internalModelValue,
          "disabled-times-config": m(u),
          "validate-time": m(f),
          onMount: ye[8] || (ye[8] = (_) => J(m(Ea).timePicker)),
          "onUpdate:hours": ye[9] || (ye[9] = (_) => m(P)(_)),
          "onUpdate:minutes": ye[10] || (ye[10] = (_) => m(P)(_, !1)),
          "onUpdate:seconds": ye[11] || (ye[11] = (_) => m(P)(_, !1, !0)),
          onResetFlow: ye[12] || (ye[12] = (_) => ue.$emit("reset-flow")),
          onOverlayClosed: ye[13] || (ye[13] = (_) => K(_, !1)),
          onOverlayOpened: ye[14] || (ye[14] = (_) => K(_, !0)),
          onAmPmChange: ye[15] || (ye[15] = (_) => ue.$emit("am-pm-change", _))
        }), bt({ _: 2 }, [
          Me(m(q), (_, j) => ({
            name: _,
            fn: Ae((U) => [
              ie(ue.$slots, _, gt($t(U)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : Y("", !0)
    ], 64));
  }
}), Jy = (e, a) => {
  const t = B(), {
    defaultedMultiCalendars: n,
    defaultedConfig: r,
    defaultedHighlight: l,
    defaultedRange: o,
    propDates: i,
    defaultedFilters: s,
    defaultedMultiDates: c
  } = rt(e), { modelValue: u, year: d, month: f, calendars: h } = Un(e, a), { isDisabled: b } = Ma(e), { selectYear: w, groupedYears: D, showYearPicker: $, isDisabled: T, toggleYearPicker: g, handleYearSelect: M, handleYear: A } = As({
    modelValue: u,
    multiCalendars: n,
    range: o,
    highlight: l,
    calendars: h,
    propDates: i,
    month: f,
    year: d,
    filters: s,
    props: e,
    emit: a
  }), P = (V, E) => [V, E].map((ee) => ia(ee, "MMMM", { locale: e.formatLocale })).join("-"), C = H(() => (V) => u.value ? Array.isArray(u.value) ? u.value.some((E) => Ql(V, E)) : Ql(u.value, V) : !1), O = (V) => {
    if (o.value.enabled) {
      if (Array.isArray(u.value)) {
        const E = Ue(V, u.value[0]) || Ue(V, u.value[1]);
        return Nn(u.value, t.value, V) && !E;
      }
      return !1;
    }
    return !1;
  }, R = (V, E) => V.quarter === Wl(E) && V.year === Ne(E), S = (V) => typeof l.value == "function" ? l.value({ quarter: Wl(V), year: Ne(V) }) : !!l.value.quarters.find((E) => R(E, V)), X = H(() => (V) => {
    const E = Ze(/* @__PURE__ */ new Date(), { year: d.value(V) });
    return Mm({
      start: Rn(E),
      end: Jo(E)
    }).map((ee) => {
      const ce = Pa(ee), q = Ul(ee), J = b(ee), L = O(ce), F = S(ce);
      return {
        text: P(ce, q),
        value: ce,
        active: C.value(ce),
        highlighted: F,
        disabled: J,
        isBetween: L
      };
    });
  }), re = (V) => {
    yl(V, u, c.value.limit), a("auto-apply", !0);
  }, fe = (V) => {
    u.value = gl(u, V, a), dr(u.value, a, e.autoApply, e.modelAuto);
  }, I = (V) => {
    u.value = V, a("auto-apply");
  };
  return {
    defaultedConfig: r,
    defaultedMultiCalendars: n,
    groupedYears: D,
    year: d,
    isDisabled: T,
    quarters: X,
    showYearPicker: $,
    modelValue: u,
    setHoverDate: (V) => {
      t.value = V;
    },
    selectYear: w,
    selectQuarter: (V, E, ee) => {
      if (!ee)
        return h.value[E].month = We(Ul(V)), c.value.enabled ? re(V) : o.value.enabled ? fe(V) : I(V);
    },
    toggleYearPicker: g,
    handleYearSelect: M,
    handleYear: A
  };
}, eg = { class: "dp--quarter-items" }, tg = ["data-test-id", "disabled", "onClick", "onMouseover"], ag = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...ta
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, l = ea(), o = Ft(l, "yearMode"), {
      defaultedMultiCalendars: i,
      defaultedConfig: s,
      groupedYears: c,
      year: u,
      isDisabled: d,
      quarters: f,
      modelValue: h,
      showYearPicker: b,
      setHoverDate: w,
      selectQuarter: D,
      toggleYearPicker: $,
      handleYearSelect: T,
      handleYear: g
    } = Jy(r, n);
    return a({ getSidebarProps: () => ({
      modelValue: h,
      year: u,
      selectQuarter: D,
      handleYearSelect: T,
      handleYear: g
    }) }), (M, A) => (v(), Pe(cr, {
      "multi-calendars": m(i).count,
      collapse: M.collapse,
      stretch: "",
      "is-mobile": M.isMobile
    }, {
      default: Ae(({ instance: P }) => [
        k("div", {
          class: "dp-quarter-picker-wrap",
          style: Be({ minHeight: `${m(s).modeHeight}px` })
        }, [
          M.$slots["top-extra"] ? ie(M.$slots, "top-extra", {
            key: 0,
            value: M.internalModelValue
          }) : Y("", !0),
          k("div", null, [
            qe(Ss, dt(M.$props, {
              items: m(c)(P),
              instance: P,
              "show-year-picker": m(b)[P],
              year: m(u)(P),
              "is-disabled": (C) => m(d)(P, C),
              onHandleYear: (C) => m(g)(P, C),
              onYearSelect: (C) => m(T)(C, P),
              onToggleYearPicker: (C) => m($)(P, C == null ? void 0 : C.flow, C == null ? void 0 : C.show)
            }), bt({ _: 2 }, [
              Me(m(o), (C, O) => ({
                name: C,
                fn: Ae((R) => [
                  ie(M.$slots, C, gt($t(R)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          k("div", eg, [
            (v(!0), y(me, null, Me(m(f)(P), (C, O) => (v(), y("div", { key: O }, [
              k("button", {
                type: "button",
                class: pe(["dp--qr-btn", {
                  "dp--qr-btn-active": C.active,
                  "dp--qr-btn-between": C.isBetween,
                  "dp--qr-btn-disabled": C.disabled,
                  "dp--highlighted": C.highlighted
                }]),
                "data-test-id": C.value,
                disabled: C.disabled,
                onClick: (R) => m(D)(C.value, P, C.disabled),
                onMouseover: (R) => m(w)(C.value)
              }, [
                M.$slots.quarter ? ie(M.$slots, "quarter", {
                  key: 0,
                  value: C.value,
                  text: C.text
                }) : (v(), y(me, { key: 1 }, [
                  Je(_e(C.text), 1)
                ], 64))
              ], 42, tg)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), Es = (e, a) => {
  const t = B(0);
  Xe(() => {
    n(), window.addEventListener("resize", n, { passive: !0 });
  }), vn(() => {
    window.removeEventListener("resize", n);
  });
  const n = () => {
    t.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: H(
      () => t.value <= e.value.mobileBreakpoint && !a ? !0 : void 0
    )
  };
}, ng = ["id", "tabindex", "role", "aria-label"], rg = {
  key: 0,
  class: "dp--menu-load-container"
}, lg = {
  key: 1,
  class: "dp--menu-header"
}, og = ["data-dp-mobile"], sg = {
  key: 0,
  class: "dp__sidebar_left"
}, ig = ["data-dp-mobile"], ug = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], cg = {
  key: 2,
  class: "dp__sidebar_right"
}, dg = {
  key: 3,
  class: "dp__action_extra"
}, lo = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...ur,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, l = B(null), o = H(() => {
      const { openOnTop: z, ...he } = r;
      return {
        ...he,
        isMobile: D.value,
        flowStep: fe.value,
        menuWrapRef: l.value
      };
    }), { setMenuFocused: i, setShiftKey: s, control: c } = Ms(), u = ea(), { defaultedTextInput: d, defaultedInline: f, defaultedConfig: h, defaultedUI: b, handleEventPropagation: w } = rt(r), { isMobile: D } = Es(h, r.shadow), $ = B(null), T = B(0), g = B(null), M = B(!1), A = B(null), P = B(!1), C = (z) => {
      P.value = !0, h.value.allowPreventDefault && z.preventDefault(), xa(z, h.value, !0);
    };
    Xe(() => {
      if (!r.shadow) {
        M.value = !0, O(), window.addEventListener("resize", O);
        const z = vt(l);
        z && !d.value.enabled && !f.value.enabled && (i(!0), J()), z && (z.addEventListener("pointerdown", C), z.addEventListener("mousedown", C));
      }
      document.addEventListener("mousedown", Le);
    }), vn(() => {
      window.removeEventListener("resize", O), document.removeEventListener("mousedown", Le);
      const z = vt(l);
      z && (z.removeEventListener("pointerdown", C), z.removeEventListener("mousedown", C));
    });
    const O = () => {
      const z = vt(g);
      z && (T.value = z.getBoundingClientRect().width);
    }, { arrowRight: R, arrowLeft: S, arrowDown: X, arrowUp: re } = Ia(), { flowStep: fe, updateFlowStep: I, childMount: V, resetFlow: E, handleFlow: ee } = hg(r, n, A), ce = H(() => r.monthPicker ? wy : r.yearPicker ? ky : r.timePicker ? Ny : r.quarterPicker ? ag : Zy), q = H(() => {
      var z;
      if (h.value.arrowLeft) return h.value.arrowLeft;
      const he = (z = l.value) == null ? void 0 : z.getBoundingClientRect(), Se = r.getInputRect();
      return (Se == null ? void 0 : Se.width) < (T == null ? void 0 : T.value) && (Se == null ? void 0 : Se.left) <= ((he == null ? void 0 : he.left) ?? 0) ? `${(Se == null ? void 0 : Se.width) / 2}px` : (Se == null ? void 0 : Se.right) >= ((he == null ? void 0 : he.right) ?? 0) && (Se == null ? void 0 : Se.width) < (T == null ? void 0 : T.value) ? `${(T == null ? void 0 : T.value) - (Se == null ? void 0 : Se.width) / 2}px` : "50%";
    }), J = () => {
      const z = vt(l);
      z && z.focus({ preventScroll: !0 });
    }, L = H(() => {
      var z;
      return ((z = A.value) == null ? void 0 : z.getSidebarProps()) || {};
    }), F = () => {
      r.openOnTop && n("recalculate-position");
    }, x = Ft(u, "action"), N = H(() => r.monthPicker || r.yearPicker ? Ft(u, "monthYear") : r.timePicker ? Ft(u, "timePicker") : Ft(u, "shared")), Z = H(() => r.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), ae = H(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly,
      "dp-menu-loading": r.loading
    })), p = H(
      () => ({
        dp__menu: !0,
        dp__menu_index: !f.value.enabled,
        dp__relative: f.value.enabled,
        ...b.value.menu ?? {}
      })
    ), W = (z) => {
      xa(z, h.value, !0);
    }, ve = (z) => {
      r.escClose && (n("close-picker"), w(z));
    }, Fe = (z) => {
      if (r.arrowNavigation) {
        if (z === St.up) return re();
        if (z === St.down) return X();
        if (z === St.left) return S();
        if (z === St.right) return R();
      } else z === St.left || z === St.up ? _("handleArrow", St.left, 0, z === St.up) : _("handleArrow", St.right, 0, z === St.down);
    }, K = (z) => {
      s(z.shiftKey), !r.disableMonthYearSelect && z.code === nt.tab && z.target.classList.contains("dp__menu") && c.value.shiftKeyInMenu && (z.preventDefault(), xa(z, h.value, !0), n("close-picker"));
    }, Ee = () => {
      J(), n("time-picker-close");
    }, ue = (z) => {
      var he, Se, He;
      (he = A.value) == null || he.toggleTimePicker(!1, !1), (Se = A.value) == null || Se.toggleMonthPicker(!1, !1, z), (He = A.value) == null || He.toggleYearPicker(!1, !1, z);
    }, ye = (z, he = 0) => {
      var Se, He, Ge;
      return z === "month" ? (Se = A.value) == null ? void 0 : Se.toggleMonthPicker(!1, !0, he) : z === "year" ? (He = A.value) == null ? void 0 : He.toggleYearPicker(!1, !0, he) : z === "time" ? (Ge = A.value) == null ? void 0 : Ge.toggleTimePicker(!0, !1) : ue(he);
    }, _ = (z, ...he) => {
      var Se, He;
      (Se = A.value) != null && Se[z] && ((He = A.value) == null || He[z](...he));
    }, j = () => {
      _("selectCurrentDate");
    }, U = (z, he) => {
      _("presetDate", qs(z), he);
    }, Q = () => {
      _("clearHoverDate");
    }, we = (z, he) => {
      _("updateMonthYear", z, he);
    }, ge = (z, he) => {
      z.preventDefault(), Fe(he);
    }, Oe = (z) => {
      var he, Se, He;
      if (K(z), z.key === nt.home || z.key === nt.end)
        return _(
          "selectWeekDate",
          z.key === nt.home,
          z.target.getAttribute("id")
        );
      switch ((z.key === nt.pageUp || z.key === nt.pageDown) && (z.shiftKey ? (_("changeYear", z.key === nt.pageUp), (he = Br(l.value, "overlay-year")) == null || he.focus()) : (_("changeMonth", z.key === nt.pageUp), (Se = Br(l.value, z.key === nt.pageUp ? "action-prev" : "action-next")) == null || Se.focus()), z.target.getAttribute("id") && ((He = l.value) == null || He.focus({ preventScroll: !0 }))), z.key) {
        case nt.esc:
          return ve(z);
        case nt.arrowLeft:
          return ge(z, St.left);
        case nt.arrowRight:
          return ge(z, St.right);
        case nt.arrowUp:
          return ge(z, St.up);
        case nt.arrowDown:
          return ge(z, St.down);
        default:
          return;
      }
    }, Le = (z) => {
      var he;
      f.value.enabled && !f.value.input && !((he = l.value) != null && he.contains(z.target)) && P.value && (P.value = !1, n("menu-blur"));
    };
    return a({
      updateMonthYear: we,
      switchView: ye,
      handleFlow: ee,
      onValueCleared: () => {
        var z, he;
        (he = (z = A.value) == null ? void 0 : z.setStartTime) == null || he.call(z);
      }
    }), (z, he) => {
      var Se, He, Ge;
      return v(), y("div", {
        id: z.uid ? `dp-menu-${z.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: l,
        tabindex: m(f).enabled ? void 0 : "0",
        role: m(f).enabled ? void 0 : "dialog",
        "aria-label": (Se = z.ariaLabels) == null ? void 0 : Se.menu,
        class: pe(p.value),
        style: Be({ "--dp-arrow-left": q.value }),
        onMouseleave: Q,
        onClick: W,
        onKeydown: Oe
      }, [
        (z.disabled || z.readonly) && m(f).enabled || z.loading ? (v(), y("div", {
          key: 0,
          class: pe(ae.value)
        }, [
          z.loading ? (v(), y("div", rg, he[19] || (he[19] = [
            k("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : Y("", !0)
        ], 2)) : Y("", !0),
        z.$slots["menu-header"] ? (v(), y("div", lg, [
          ie(z.$slots, "menu-header")
        ])) : Y("", !0),
        !m(f).enabled && !z.teleportCenter ? (v(), y("div", {
          key: 2,
          class: pe(Z.value)
        }, null, 2)) : Y("", !0),
        k("div", {
          ref_key: "innerMenuRef",
          ref: g,
          class: pe({
            dp__menu_content_wrapper: ((He = z.presetDates) == null ? void 0 : He.length) || !!z.$slots["left-sidebar"] || !!z.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((Ge = z.presetDates) == null ? void 0 : Ge.length) || !!z.$slots["left-sidebar"] || !!z.$slots["right-sidebar"])
          }),
          "data-dp-mobile": m(D),
          style: Be({ "--dp-menu-width": `${T.value}px` })
        }, [
          z.$slots["left-sidebar"] ? (v(), y("div", sg, [
            ie(z.$slots, "left-sidebar", gt($t(L.value)))
          ])) : Y("", !0),
          z.presetDates.length ? (v(), y("div", {
            key: 1,
            class: pe({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": m(D)
          }, [
            (v(!0), y(me, null, Me(z.presetDates, (xe, tt) => (v(), y(me, { key: tt }, [
              xe.slot ? ie(z.$slots, xe.slot, {
                key: 0,
                presetDate: U,
                label: xe.label,
                value: xe.value
              }) : (v(), y("button", {
                key: 1,
                type: "button",
                style: Be(xe.style || {}),
                class: pe(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test-id": xe.testId ?? void 0,
                "data-dp-mobile": m(D),
                onClick: yt((wt) => U(xe.value, xe.noTz), ["prevent"]),
                onKeydown: (wt) => m(Pt)(wt, () => U(xe.value, xe.noTz), !0)
              }, _e(xe.label), 47, ug))
            ], 64))), 128))
          ], 10, ig)) : Y("", !0),
          k("div", {
            ref_key: "calendarWrapperRef",
            ref: $,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (v(), Pe(Va(ce.value), dt({
              ref_key: "dynCmpRef",
              ref: A
            }, o.value, {
              "flow-step": m(fe),
              onMount: m(V),
              onUpdateFlowStep: m(I),
              onResetFlow: m(E),
              onFocusMenu: J,
              onSelectDate: he[0] || (he[0] = (xe) => z.$emit("select-date")),
              onDateUpdate: he[1] || (he[1] = (xe) => z.$emit("date-update", xe)),
              onTooltipOpen: he[2] || (he[2] = (xe) => z.$emit("tooltip-open", xe)),
              onTooltipClose: he[3] || (he[3] = (xe) => z.$emit("tooltip-close", xe)),
              onAutoApply: he[4] || (he[4] = (xe) => z.$emit("auto-apply", xe)),
              onRangeStart: he[5] || (he[5] = (xe) => z.$emit("range-start", xe)),
              onRangeEnd: he[6] || (he[6] = (xe) => z.$emit("range-end", xe)),
              onInvalidFixedRange: he[7] || (he[7] = (xe) => z.$emit("invalid-fixed-range", xe)),
              onTimeUpdate: he[8] || (he[8] = (xe) => z.$emit("time-update")),
              onAmPmChange: he[9] || (he[9] = (xe) => z.$emit("am-pm-change", xe)),
              onTimePickerOpen: he[10] || (he[10] = (xe) => z.$emit("time-picker-open", xe)),
              onTimePickerClose: Ee,
              onRecalculatePosition: F,
              onUpdateMonthYear: he[11] || (he[11] = (xe) => z.$emit("update-month-year", xe)),
              onAutoApplyInvalid: he[12] || (he[12] = (xe) => z.$emit("auto-apply-invalid", xe)),
              onInvalidDate: he[13] || (he[13] = (xe) => z.$emit("invalid-date", xe)),
              onOverlayToggle: he[14] || (he[14] = (xe) => z.$emit("overlay-toggle", xe)),
              "onUpdate:internalModelValue": he[15] || (he[15] = (xe) => z.$emit("update:internal-model-value", xe))
            }), bt({ _: 2 }, [
              Me(N.value, (xe, tt) => ({
                name: xe,
                fn: Ae((wt) => [
                  ie(z.$slots, xe, gt($t({ ...wt })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          z.$slots["right-sidebar"] ? (v(), y("div", cg, [
            ie(z.$slots, "right-sidebar", gt($t(L.value)))
          ])) : Y("", !0),
          z.$slots["action-extra"] ? (v(), y("div", dg, [
            z.$slots["action-extra"] ? ie(z.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: j
            }) : Y("", !0)
          ])) : Y("", !0)
        ], 14, og),
        !z.autoApply || m(h).keepActionRow ? (v(), Pe(dy, dt({
          key: 3,
          "menu-mount": M.value
        }, o.value, {
          "calendar-width": T.value,
          onClosePicker: he[16] || (he[16] = (xe) => z.$emit("close-picker")),
          onSelectDate: he[17] || (he[17] = (xe) => z.$emit("select-date")),
          onInvalidSelect: he[18] || (he[18] = (xe) => z.$emit("invalid-select")),
          onSelectNow: j
        }), bt({ _: 2 }, [
          Me(m(x), (xe, tt) => ({
            name: xe,
            fn: Ae((wt) => [
              ie(z.$slots, xe, gt($t({ ...wt })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : Y("", !0)
      ], 46, ng);
    };
  }
});
var Za = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(Za || {});
const fg = ({
  menuRef: e,
  menuRefInner: a,
  inputRef: t,
  pickerWrapperRef: n,
  inline: r,
  emit: l,
  props: o,
  slots: i
}) => {
  const { defaultedConfig: s } = rt(o), c = B({}), u = B(!1), d = B({
    top: "0",
    left: "0"
  }), f = B(!1), h = tn(o, "teleportCenter");
  et(h, () => {
    d.value = JSON.parse(JSON.stringify({})), A();
  });
  const b = (E) => {
    if (o.teleport) {
      const ee = E.getBoundingClientRect();
      return {
        left: ee.left + window.scrollX,
        top: ee.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, w = (E, ee) => {
    d.value.left = `${E + ee - c.value.width}px`;
  }, D = (E) => {
    d.value.left = `${E}px`;
  }, $ = (E, ee) => {
    o.position === Za.left && D(E), o.position === Za.right && w(E, ee), o.position === Za.center && (d.value.left = `${E + ee / 2 - c.value.width / 2}px`);
  }, T = (E) => {
    const { width: ee, height: ce } = E.getBoundingClientRect(), { top: q, left: J } = b(E);
    return { top: +q, left: +J, width: ee, height: ce };
  }, g = () => {
    d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
  }, M = () => {
    const E = vt(t);
    d.value = o.altPosition(E);
  }, A = (E = !0) => {
    var ee;
    if (!r.value.enabled) {
      if (h.value) return g();
      if (o.altPosition !== null) return M();
      if (E) {
        const ce = o.teleport ? (ee = a.value) == null ? void 0 : ee.$el : e.value;
        ce && (c.value = ce.getBoundingClientRect()), l("recalculate-position");
      }
      return re();
    }
  }, P = ({ inputEl: E, left: ee, width: ce }) => {
    window.screen.width > 768 && !u.value && $(ee, ce), R(E);
  }, C = (E) => {
    const { top: ee, left: ce, height: q, width: J } = T(E);
    d.value.top = `${q + ee + +o.offset}px`, f.value = !1, u.value || (d.value.left = `${ce + J / 2 - c.value.width / 2}px`), P({ inputEl: E, left: ce, width: J });
  }, O = (E) => {
    const { top: ee, left: ce, width: q } = T(E);
    d.value.top = `${ee - +o.offset - c.value.height}px`, f.value = !0, P({ inputEl: E, left: ce, width: q });
  }, R = (E) => {
    if (o.autoPosition) {
      const { left: ee, width: ce } = T(E), { left: q, right: J } = c.value;
      if (!u.value) {
        if (Math.abs(q) !== Math.abs(J)) {
          if (q <= 0)
            return u.value = !0, D(ee);
          if (J >= document.documentElement.clientWidth)
            return u.value = !0, w(ee, ce);
        }
        return $(ee, ce);
      }
    }
  }, S = () => {
    const E = vt(t);
    if (E) {
      if (o.autoPosition === Qt.top) return Qt.top;
      if (o.autoPosition === Qt.bottom) return Qt.bottom;
      const { height: ee } = c.value, { top: ce, height: q } = E.getBoundingClientRect(), J = window.innerHeight - ce - q, L = ce;
      return ee <= J ? Qt.bottom : ee > J && ee <= L ? Qt.top : J >= L ? Qt.bottom : Qt.top;
    }
    return Qt.bottom;
  }, X = (E) => S() === Qt.bottom ? C(E) : O(E), re = () => {
    const E = vt(t);
    if (E)
      return o.autoPosition ? X(E) : C(E);
  }, fe = function(E) {
    if (E) {
      const ee = E.scrollHeight > E.clientHeight, ce = window.getComputedStyle(E).overflowY.indexOf("hidden") !== -1;
      return ee && !ce;
    }
    return !0;
  }, I = function(E) {
    return !E || E === document.body || E.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : fe(E) ? E : I(
      E.assignedSlot && s.value.shadowDom ? E.assignedSlot.parentNode : E.parentNode
    );
  }, V = (E) => {
    if (E)
      switch (o.position) {
        case Za.left:
          return { left: 0, transform: "translateX(0)" };
        case Za.right:
          return { left: `${E.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${E.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: f,
    menuStyle: d,
    xCorrect: u,
    setMenuPosition: A,
    getScrollableParent: I,
    shadowRender: (E, ee, ce) => {
      var q, J, L;
      const F = document.createElement("div"), x = (q = vt(t)) == null ? void 0 : q.getBoundingClientRect();
      F.setAttribute("id", "dp--temp-container");
      const N = (J = n.value) != null && J.clientWidth ? n.value : document.body;
      N.append(F);
      const Z = V(x), ae = s.value.shadowDom ? Object.keys(i).filter(
        (W) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(W)
      ) : Object.keys(i), p = zs(
        ee,
        {
          ...ce,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...Z }
        },
        Object.fromEntries(ae.map((W) => [W, i[W]]))
      );
      E != null && (p.appContext = E.appContext), wl(p, F), c.value = (L = p.el) == null ? void 0 : L.getBoundingClientRect(), wl(null, F), N.removeChild(F);
    }
  };
}, ba = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], pg = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], mg = {
  all: () => ba,
  monthYear: () => ba.filter((e) => e.use.includes("month-year")),
  input: () => pg,
  timePicker: () => ba.filter((e) => e.use.includes("time")),
  action: () => ba.filter((e) => e.use.includes("action")),
  calendar: () => ba.filter((e) => e.use.includes("calendar")),
  menu: () => ba.filter((e) => e.use.includes("menu")),
  shared: () => ba.filter((e) => e.use.includes("shared")),
  yearMode: () => ba.filter((e) => e.use.includes("year-mode"))
}, Ft = (e, a, t) => {
  const n = [];
  return mg[a]().forEach((r) => {
    e[r.name] && n.push(r.name);
  }), t != null && t.length && t.forEach((r) => {
    r.slot && n.push(r.slot);
  }), n;
}, Wn = (e) => {
  const a = H(() => (n) => e.value ? n ? e.value.open : e.value.close : ""), t = H(() => (n) => e.value ? n ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: a, showTransition: !!e.value, menuTransition: t };
}, Un = (e, a, t) => {
  const { defaultedRange: n, defaultedTz: r } = rt(e), l = de(Bt(de(), r.value.timezone)), o = B([{ month: We(l), year: Ne(l) }]), i = (f) => {
    const h = {
      hours: ya(l),
      minutes: Da(l),
      seconds: 0
    };
    return n.value.enabled ? [h[f], h[f]] : h[f];
  }, s = _a({
    hours: i("hours"),
    minutes: i("minutes"),
    seconds: i("seconds")
  });
  et(
    n,
    (f, h) => {
      f.enabled !== h.enabled && (s.hours = i("hours"), s.minutes = i("minutes"), s.seconds = i("seconds"));
    },
    { deep: !0 }
  );
  const c = H({
    get: () => e.internalModelValue,
    set: (f) => {
      !e.readonly && !e.disabled && a("update:internal-model-value", f);
    }
  }), u = H(
    () => (f) => o.value[f] ? o.value[f].month : 0
  ), d = H(
    () => (f) => o.value[f] ? o.value[f].year : 0
  );
  return et(
    c,
    (f, h) => {
      t && JSON.stringify(f ?? {}) !== JSON.stringify(h ?? {}) && t();
    },
    { deep: !0 }
  ), {
    calendars: o,
    time: s,
    modelValue: c,
    month: u,
    year: d,
    today: l
  };
}, vg = (e, a) => {
  const {
    defaultedMultiCalendars: t,
    defaultedMultiDates: n,
    defaultedUI: r,
    defaultedHighlight: l,
    defaultedTz: o,
    propDates: i,
    defaultedRange: s
  } = rt(a), { isDisabled: c } = Ma(a), u = B(null), d = B(Bt(/* @__PURE__ */ new Date(), o.value.timezone)), f = (p) => {
    !p.current && a.hideOffsetDates || (u.value = p.value);
  }, h = () => {
    u.value = null;
  }, b = (p) => Array.isArray(e.value) && s.value.enabled && e.value[0] && u.value ? p ? ct(u.value, e.value[0]) : ot(u.value, e.value[0]) : !0, w = (p, W) => {
    const ve = () => e.value ? W ? e.value[0] || null : e.value[1] : null, Fe = e.value && Array.isArray(e.value) ? ve() : null;
    return Ue(de(p.value), Fe);
  }, D = (p) => {
    const W = Array.isArray(e.value) ? e.value[0] : null;
    return p ? !ot(u.value ?? null, W) : !0;
  }, $ = (p, W = !0) => (s.value.enabled || a.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? a.hideOffsetDates && !p.current ? !1 : Ue(de(p.value), e.value[W ? 0 : 1]) : s.value.enabled ? w(p, W) && D(W) || Ue(p.value, Array.isArray(e.value) ? e.value[0] : null) && b(W) : !1, T = (p, W) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const ve = Ue(p.value, u.value);
      return W ? ct(e.value[0], p.value) && ve : ot(e.value[0], p.value) && ve;
    }
    return !1;
  }, g = (p) => !e.value || a.hideOffsetDates && !p.current ? !1 : s.value.enabled ? a.modelAuto && Array.isArray(e.value) ? Ue(p.value, e.value[0] ? e.value[0] : d.value) : !1 : n.value.enabled && Array.isArray(e.value) ? e.value.some((W) => Ue(W, p.value)) : Ue(p.value, e.value ? e.value : d.value), M = (p) => {
    if (s.value.autoRange || a.weekPicker) {
      if (u.value) {
        if (a.hideOffsetDates && !p.current) return !1;
        const W = zt(u.value, +s.value.autoRange), ve = fa(de(u.value), a.weekStart);
        return a.weekPicker ? Ue(ve[1], de(p.value)) : Ue(W, de(p.value));
      }
      return !1;
    }
    return !1;
  }, A = (p) => {
    if (s.value.autoRange || a.weekPicker) {
      if (u.value) {
        const W = zt(u.value, +s.value.autoRange);
        if (a.hideOffsetDates && !p.current) return !1;
        const ve = fa(de(u.value), a.weekStart);
        return a.weekPicker ? ct(p.value, ve[0]) && ot(p.value, ve[1]) : ct(p.value, u.value) && ot(p.value, W);
      }
      return !1;
    }
    return !1;
  }, P = (p) => {
    if (s.value.autoRange || a.weekPicker) {
      if (u.value) {
        if (a.hideOffsetDates && !p.current) return !1;
        const W = fa(de(u.value), a.weekStart);
        return a.weekPicker ? Ue(W[0], p.value) : Ue(u.value, p.value);
      }
      return !1;
    }
    return !1;
  }, C = (p) => Nn(e.value, u.value, p.value), O = () => a.modelAuto && Array.isArray(a.internalModelValue) ? !!a.internalModelValue[0] : !1, R = () => a.modelAuto ? hs(a.internalModelValue) : !0, S = (p) => {
    if (a.weekPicker) return !1;
    const W = s.value.enabled ? !$(p) && !$(p, !1) : !0;
    return !c(p.value) && !g(p) && !(!p.current && a.hideOffsetDates) && W;
  }, X = (p) => s.value.enabled ? a.modelAuto ? O() && g(p) : !1 : g(p), re = (p) => l.value ? Rh(p.value, i.value.highlight) : !1, fe = (p) => {
    const W = c(p.value);
    return W && (typeof l.value == "function" ? !l.value(p.value, W) : !l.value.options.highlightDisabled);
  }, I = (p) => {
    var W;
    return typeof l.value == "function" ? l.value(p.value) : (W = l.value.weekdays) == null ? void 0 : W.includes(p.value.getDay());
  }, V = (p) => (s.value.enabled || a.weekPicker) && (!(t.value.count > 0) || p.current) && R() && !(!p.current && a.hideOffsetDates) && !g(p) ? C(p) : !1, E = (p) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: W, after: ve } = to(+s.value.maxRange, e.value[0]);
      return cn(p.value, W) || Fa(p.value, ve);
    }
    return !1;
  }, ee = (p) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: W, after: ve } = to(+s.value.minRange, e.value[0]);
      return Nn([W, ve], e.value[0], p.value);
    }
    return !1;
  }, ce = (p) => s.value.enabled && (s.value.maxRange || s.value.minRange) ? s.value.maxRange && s.value.minRange ? E(p) || ee(p) : s.value.maxRange ? E(p) : ee(p) : !1, q = (p) => {
    const { isRangeStart: W, isRangeEnd: ve } = x(p), Fe = s.value.enabled ? W || ve : !1;
    return {
      dp__cell_offset: !p.current,
      dp__pointer: !a.disabled && !(!p.current && a.hideOffsetDates) && !c(p.value) && !ce(p),
      dp__cell_disabled: c(p.value) || ce(p),
      dp__cell_highlight: !fe(p) && (re(p) || I(p)) && !X(p) && !Fe && !P(p) && !(V(p) && a.weekPicker) && !ve,
      dp__cell_highlight_active: !fe(p) && (re(p) || I(p)) && X(p),
      dp__today: !a.noToday && Ue(p.value, d.value) && p.current,
      "dp--past": ot(p.value, d.value),
      "dp--future": ct(p.value, d.value)
    };
  }, J = (p) => ({
    dp__active_date: X(p),
    dp__date_hover: S(p)
  }), L = (p) => {
    if (e.value && !Array.isArray(e.value)) {
      const W = fa(e.value, a.weekStart);
      return {
        ...Z(p),
        dp__range_start: Ue(W[0], p.value),
        dp__range_end: Ue(W[1], p.value),
        dp__range_between_week: ct(p.value, W[0]) && ot(p.value, W[1])
      };
    }
    return {
      ...Z(p)
    };
  }, F = (p) => {
    if (e.value && Array.isArray(e.value)) {
      const W = fa(e.value[0], a.weekStart), ve = e.value[1] ? fa(e.value[1], a.weekStart) : [];
      return {
        ...Z(p),
        dp__range_start: Ue(W[0], p.value) || Ue(ve[0], p.value),
        dp__range_end: Ue(W[1], p.value) || Ue(ve[1], p.value),
        dp__range_between_week: ct(p.value, W[0]) && ot(p.value, W[1]) || ct(p.value, ve[0]) && ot(p.value, ve[1]),
        dp__range_between: ct(p.value, W[1]) && ot(p.value, ve[0])
      };
    }
    return {
      ...Z(p)
    };
  }, x = (p) => {
    const W = t.value.count > 0 ? p.current && $(p) && R() : $(p) && R(), ve = t.value.count > 0 ? p.current && $(p, !1) && R() : $(p, !1) && R();
    return { isRangeStart: W, isRangeEnd: ve };
  }, N = (p) => {
    const { isRangeStart: W, isRangeEnd: ve } = x(p);
    return {
      dp__range_start: W,
      dp__range_end: ve,
      dp__range_between: V(p),
      dp__date_hover: Ue(p.value, u.value) && !W && !ve && !a.weekPicker,
      dp__date_hover_start: T(p, !0),
      dp__date_hover_end: T(p, !1)
    };
  }, Z = (p) => ({
    ...N(p),
    dp__cell_auto_range: A(p),
    dp__cell_auto_range_start: P(p),
    dp__cell_auto_range_end: M(p)
  }), ae = (p) => s.value.enabled ? s.value.autoRange ? Z(p) : a.modelAuto ? { ...J(p), ...N(p) } : a.weekPicker ? F(p) : N(p) : a.weekPicker ? L(p) : J(p);
  return {
    setHoverDate: f,
    clearHoverDate: h,
    getDayClassData: (p) => a.hideOffsetDates && !p.current ? {} : {
      ...q(p),
      ...ae(p),
      [a.dayClass ? a.dayClass(p.value, a.internalModelValue) : ""]: !0,
      ...r.value.calendarCell ?? {}
    }
  };
}, Ma = (e) => {
  const { defaultedFilters: a, defaultedRange: t, propDates: n, defaultedMultiDates: r } = rt(e), l = (I) => n.value.disabledDates ? typeof n.value.disabledDates == "function" ? n.value.disabledDates(de(I)) : !!ar(I, n.value.disabledDates) : !1, o = (I) => n.value.maxDate ? e.yearPicker ? Ne(I) > Ne(n.value.maxDate) : ct(I, n.value.maxDate) : !1, i = (I) => n.value.minDate ? e.yearPicker ? Ne(I) < Ne(n.value.minDate) : ot(I, n.value.minDate) : !1, s = (I) => {
    const V = o(I), E = i(I), ee = l(I), ce = a.value.months.map((x) => +x).includes(We(I)), q = e.disabledWeekDays.length ? e.disabledWeekDays.some((x) => +x === _v(I)) : !1, J = h(I), L = Ne(I), F = L < +e.yearRange[0] || L > +e.yearRange[1];
    return !(V || E || ee || ce || F || q || J);
  }, c = (I, V) => ot(...wa(n.value.minDate, I, V)) || Ue(...wa(n.value.minDate, I, V)), u = (I, V) => ct(...wa(n.value.maxDate, I, V)) || Ue(...wa(n.value.maxDate, I, V)), d = (I, V, E) => {
    let ee = !1;
    return n.value.maxDate && E && u(I, V) && (ee = !0), n.value.minDate && !E && c(I, V) && (ee = !0), ee;
  }, f = (I, V, E, ee) => {
    let ce = !1;
    return ee && (n.value.minDate || n.value.maxDate) ? n.value.minDate && n.value.maxDate ? ce = d(I, V, E) : (n.value.minDate && c(I, V) || n.value.maxDate && u(I, V)) && (ce = !0) : ce = !0, ce;
  }, h = (I) => Array.isArray(n.value.allowedDates) && !n.value.allowedDates.length ? !0 : n.value.allowedDates ? !ar(I, n.value.allowedDates, bs(e.monthPicker, e.yearPicker)) : !1, b = (I) => !s(I), w = (I) => t.value.noDisabledRange ? !Zo({ start: I[0], end: I[1] }).some((V) => b(V)) : !0, D = (I) => {
    if (I) {
      const V = Ne(I);
      return V >= +e.yearRange[0] && V <= e.yearRange[1];
    }
    return !0;
  }, $ = (I, V) => !!(Array.isArray(I) && I[V] && (t.value.maxRange || t.value.minRange) && D(I[V])), T = (I, V, E = 0) => {
    if ($(V, E) && D(I)) {
      const ee = Qo(I, V[E]), ce = xs(V[E], I), q = ce.length === 1 ? 0 : ce.filter((L) => b(L)).length, J = Math.abs(ee) - (t.value.minMaxRawRange ? 0 : q);
      if (t.value.minRange && t.value.maxRange)
        return J >= +t.value.minRange && J <= +t.value.maxRange;
      if (t.value.minRange) return J >= +t.value.minRange;
      if (t.value.maxRange) return J <= +t.value.maxRange;
    }
    return !0;
  }, g = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, M = (I) => Array.isArray(I) ? [I[0] ? kr(I[0]) : null, I[1] ? kr(I[1]) : null] : kr(I), A = (I, V, E) => I.find(
    (ee) => +ee.hours === ya(V) && ee.minutes === "*" ? !0 : +ee.minutes === Da(V) && +ee.hours === ya(V)
  ) && E, P = (I, V, E) => {
    const [ee, ce] = I, [q, J] = V;
    return !A(ee, q, E) && !A(ce, J, E) && E;
  }, C = (I, V) => {
    const E = Array.isArray(V) ? V : [V];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? P(e.disabledTimes, E, I) : !E.some((ee) => A(e.disabledTimes, ee, I)) : I;
  }, O = (I, V) => {
    const E = Array.isArray(V) ? [Na(V[0]), V[1] ? Na(V[1]) : void 0] : Na(V), ee = !e.disabledTimes(E);
    return I && ee;
  }, R = (I, V) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? C(V, I) : O(V, I) : V, S = (I) => {
    let V = !0;
    if (!I || g()) return !0;
    const E = !n.value.minDate && !n.value.maxDate ? M(I) : I;
    return (e.maxTime || n.value.maxDate) && (V = eo(
      e.maxTime,
      n.value.maxDate,
      "max",
      _t(E),
      V
    )), (e.minTime || n.value.minDate) && (V = eo(
      e.minTime,
      n.value.minDate,
      "min",
      _t(E),
      V
    )), R(I, V);
  }, X = (I) => {
    if (!e.monthPicker) return !0;
    let V = !0;
    const E = de(Xt(I));
    if (n.value.minDate && n.value.maxDate) {
      const ee = de(Xt(n.value.minDate)), ce = de(Xt(n.value.maxDate));
      return ct(E, ee) && ot(E, ce) || Ue(E, ee) || Ue(E, ce);
    }
    if (n.value.minDate) {
      const ee = de(Xt(n.value.minDate));
      V = ct(E, ee) || Ue(E, ee);
    }
    if (n.value.maxDate) {
      const ee = de(Xt(n.value.maxDate));
      V = ot(E, ee) || Ue(E, ee);
    }
    return V;
  }, re = H(() => (I) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : S(I)), fe = H(() => (I) => e.monthPicker ? Array.isArray(I) && (t.value.enabled || r.value.enabled) ? !I.filter((V) => !X(V)).length : X(I) : !0);
  return {
    isDisabled: b,
    validateDate: s,
    validateMonthYearInRange: f,
    isDateRangeAllowed: w,
    checkMinMaxRange: T,
    isValidTime: S,
    isTimeValid: re,
    isMonthValid: fe
  };
}, fr = () => {
  const e = H(() => (n, r) => n == null ? void 0 : n.includes(r)), a = H(() => (n, r) => n.count ? n.solo ? !0 : r === 0 : !0), t = H(() => (n, r) => n.count ? n.solo ? !0 : r === n.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: a, showRightIcon: t };
}, hg = (e, a, t) => {
  const n = B(0), r = _a({
    [Ea.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [Ea.calendar]: !1,
    [Ea.header]: !1
  }), l = H(() => e.monthPicker || e.timePicker), o = (d) => {
    var f;
    if ((f = e.flow) != null && f.length) {
      if (!d && l.value) return u();
      r[d] = !0, Object.keys(r).filter((h) => !r[h]).length || u();
    }
  }, i = () => {
    var d, f;
    (d = e.flow) != null && d.length && n.value !== -1 && (n.value += 1, a("flow-step", n.value), u()), ((f = e.flow) == null ? void 0 : f.length) === n.value && mt().then(() => s());
  }, s = () => {
    n.value = -1;
  }, c = (d, f, ...h) => {
    var b, w;
    e.flow[n.value] === d && t.value && ((w = (b = t.value)[f]) == null || w.call(b, ...h));
  }, u = (d = 0) => {
    d && (n.value += d), c(Dt.month, "toggleMonthPicker", !0), c(Dt.year, "toggleYearPicker", !0), c(Dt.calendar, "toggleTimePicker", !1, !0), c(Dt.time, "toggleTimePicker", !0, !0);
    const f = e.flow[n.value];
    (f === Dt.hours || f === Dt.minutes || f === Dt.seconds) && c(f, "toggleTimePicker", !0, !0, f);
  };
  return { childMount: o, updateFlowStep: i, resetFlow: s, handleFlow: u, flowStep: n };
}, yg = {
  key: 1,
  class: "dp__input_wrap"
}, gg = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], bg = {
  key: 2,
  class: "dp--clear-btn"
}, wg = ["aria-label"], _g = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...ur
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, {
      defaultedTextInput: l,
      defaultedAriaLabels: o,
      defaultedInline: i,
      defaultedConfig: s,
      defaultedRange: c,
      defaultedMultiDates: u,
      defaultedUI: d,
      getDefaultPattern: f,
      getDefaultStartTime: h
    } = rt(r), { checkMinMaxRange: b } = Ma(r), w = B(), D = B(null), $ = B(!1), T = B(!1), g = H(
      () => ({
        dp__pointer: !r.disabled && !r.readonly && !l.value.enabled,
        dp__disabled: r.disabled,
        dp__input_readonly: !l.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !r.hideInputIcon,
        dp__input_valid: typeof r.state == "boolean" ? r.state : !1,
        dp__input_invalid: typeof r.state == "boolean" ? !r.state : !1,
        dp__input_focus: $.value || r.isMenuOpen,
        dp__input_reg: !l.value.enabled,
        ...d.value.input ?? {}
      })
    ), M = () => {
      n("set-input-date", null), r.clearable && r.autoApply && (n("set-empty-date"), w.value = null);
    }, A = (L) => {
      const F = h();
      return Nh(
        L,
        l.value.format ?? f(),
        F ?? Cs({}, r.enableSeconds),
        r.inputValue,
        T.value,
        r.formatLocale
      );
    }, P = (L) => {
      const { rangeSeparator: F } = l.value, [x, N] = L.split(`${F}`);
      if (x) {
        const Z = A(x.trim()), ae = N ? A(N.trim()) : void 0;
        if (Fa(Z, ae)) return;
        const p = Z && ae ? [Z, ae] : [Z];
        b(ae, p, 0) && (w.value = Z ? p : null);
      }
    }, C = () => {
      T.value = !0;
    }, O = (L) => {
      if (c.value.enabled)
        P(L);
      else if (u.value.enabled) {
        const F = L.split(";");
        w.value = F.map((x) => A(x.trim())).filter((x) => x);
      } else
        w.value = A(L);
    }, R = (L) => {
      var F;
      const x = typeof L == "string" ? L : (F = L.target) == null ? void 0 : F.value;
      x !== "" ? (l.value.openMenu && !r.isMenuOpen && n("open"), O(x), n("set-input-date", w.value)) : M(), T.value = !1, n("update:input-value", x), n("text-input", L, w.value);
    }, S = (L) => {
      l.value.enabled ? (O(L.target.value), l.value.enterSubmit && Lr(w.value) && r.inputValue !== "" ? (n("set-input-date", w.value, !0), w.value = null) : l.value.enterSubmit && r.inputValue === "" && (w.value = null, n("clear"))) : fe(L);
    }, X = (L, F) => {
      l.value.enabled && l.value.tabSubmit && !F && O(L.target.value), l.value.tabSubmit && Lr(w.value) && r.inputValue !== "" ? (n("set-input-date", w.value, !0, !0), w.value = null) : l.value.tabSubmit && r.inputValue === "" && (w.value = null, n("clear", !0));
    }, re = () => {
      $.value = !0, n("focus"), mt().then(() => {
        var L;
        l.value.enabled && l.value.selectOnFocus && ((L = D.value) == null || L.select());
      });
    }, fe = (L) => {
      if (xa(L, s.value, !0), l.value.enabled && l.value.openMenu && !i.value.input) {
        if (l.value.openMenu === "open" && !r.isMenuOpen) return n("open");
        if (l.value.openMenu === "toggle") return n("toggle");
      } else l.value.enabled || n("toggle");
    }, I = () => {
      n("real-blur"), $.value = !1, (!r.isMenuOpen || i.value.enabled && i.value.input) && n("blur"), r.autoApply && l.value.enabled && w.value && !r.isMenuOpen && (n("set-input-date", w.value), n("select-date"), w.value = null);
    }, V = (L) => {
      xa(L, s.value, !0), n("clear");
    }, E = () => {
      n("close");
    }, ee = (L) => {
      if (L.key === "Tab" && X(L), L.key === "Enter" && S(L), L.key === "Escape" && l.value.escClose && E(), !l.value.enabled) {
        if (L.code === "Tab") return;
        L.preventDefault();
      }
    }, ce = () => {
      var L;
      (L = D.value) == null || L.focus({ preventScroll: !0 });
    }, q = (L) => {
      w.value = L;
    }, J = (L) => {
      L.key === nt.tab && X(L, !0);
    };
    return a({
      focusInput: ce,
      setParsedDate: q
    }), (L, F) => {
      var x, N, Z;
      return v(), y("div", { onClick: fe }, [
        L.$slots.trigger && !L.$slots["dp-input"] && !m(i).enabled ? ie(L.$slots, "trigger", { key: 0 }) : Y("", !0),
        !L.$slots.trigger && (!m(i).enabled || m(i).input) ? (v(), y("div", yg, [
          L.$slots["dp-input"] && !L.$slots.trigger && (!m(i).enabled || m(i).enabled && m(i).input) ? ie(L.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: R,
            onEnter: S,
            onTab: X,
            onClear: V,
            onBlur: I,
            onKeypress: ee,
            onPaste: C,
            onFocus: re,
            openMenu: () => L.$emit("open"),
            closeMenu: () => L.$emit("close"),
            toggleMenu: () => L.$emit("toggle")
          }) : Y("", !0),
          L.$slots["dp-input"] ? Y("", !0) : (v(), y("input", {
            key: 1,
            id: L.uid ? `dp-input-${L.uid}` : void 0,
            ref_key: "inputRef",
            ref: D,
            "data-test-id": "dp-input",
            name: L.name,
            class: pe(g.value),
            inputmode: m(l).enabled ? "text" : "none",
            placeholder: L.placeholder,
            disabled: L.disabled,
            readonly: L.readonly,
            required: L.required,
            value: e.inputValue,
            autocomplete: L.autocomplete,
            "aria-label": (x = m(o)) == null ? void 0 : x.input,
            "aria-disabled": L.disabled || void 0,
            "aria-invalid": L.state === !1 ? !0 : void 0,
            onInput: R,
            onBlur: I,
            onFocus: re,
            onKeypress: ee,
            onKeydown: F[0] || (F[0] = (ae) => ee(ae)),
            onPaste: C
          }, null, 42, gg)),
          k("div", {
            onClick: F[3] || (F[3] = (ae) => n("toggle"))
          }, [
            L.$slots["input-icon"] && !L.hideInputIcon ? (v(), y("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: F[1] || (F[1] = (ae) => n("toggle"))
            }, [
              ie(L.$slots, "input-icon")
            ])) : Y("", !0),
            !L.$slots["input-icon"] && !L.hideInputIcon && !L.$slots["dp-input"] ? (v(), Pe(m(yn), {
              key: 1,
              "aria-label": (N = m(o)) == null ? void 0 : N.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: F[2] || (F[2] = (ae) => n("toggle"))
            }, null, 8, ["aria-label"])) : Y("", !0)
          ]),
          L.$slots["clear-icon"] && (L.alwaysClearable || e.inputValue && L.clearable && !L.disabled && !L.readonly) ? (v(), y("span", bg, [
            ie(L.$slots, "clear-icon", { clear: V })
          ])) : Y("", !0),
          !L.$slots["clear-icon"] && (L.alwaysClearable || L.clearable && e.inputValue && !L.disabled && !L.readonly) ? (v(), y("button", {
            key: 3,
            "aria-label": (Z = m(o)) == null ? void 0 : Z.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: F[4] || (F[4] = (ae) => m(Pt)(ae, () => V(ae), !0, J)),
            onClick: F[5] || (F[5] = yt((ae) => V(ae), ["prevent"]))
          }, [
            qe(m(ms), {
              class: "dp__input_icons",
              "data-test-id": "clear-icon"
            })
          ], 40, wg)) : Y("", !0)
        ])) : Y("", !0)
      ]);
    };
  }
}), kg = typeof window < "u" ? window : void 0, Mr = () => {
}, xg = (e) => js() ? (Gs(e), !0) : !1, Cg = (e, a, t, n) => {
  if (!e) return Mr;
  let r = Mr;
  const l = et(
    () => m(e),
    (i) => {
      r(), i && (i.removeEventListener(a, t), i.addEventListener(a, t, n), r = () => {
        i.removeEventListener(a, t, n), r = Mr;
      });
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    l(), r();
  };
  return xg(o), o;
}, Dg = (e, a, t, n = {}) => {
  const { window: r = kg, event: l = "pointerdown" } = n;
  return r ? Cg(r, l, (o) => {
    const i = vt(e), s = vt(a);
    !i || !s || i === o.target || o.composedPath().includes(i) || o.composedPath().includes(s) || t(o);
  }, { passive: !0 }) : void 0;
}, Tg = ["data-dp-mobile"], Ig = /* @__PURE__ */ Te({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...ur
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(e, { expose: a, emit: t }) {
    const n = t, r = e, l = ea(), o = B(!1), i = tn(r, "modelValue"), s = tn(r, "timezone"), c = B(null), u = B(null), d = B(null), f = B(!1), h = B(null), b = B(!1), w = B(!1), D = B(!1), $ = B(!1), { setMenuFocused: T, setShiftKey: g } = Ms(), { clearArrowNav: M } = Ia(), { validateDate: A, isValidTime: P } = Ma(r), {
      defaultedTransitions: C,
      defaultedTextInput: O,
      defaultedInline: R,
      defaultedConfig: S,
      defaultedRange: X,
      defaultedMultiDates: re
    } = rt(r), { menuTransition: fe, showTransition: I } = Wn(C), { isMobile: V } = Es(S), E = Ws();
    Xe(() => {
      p(r.modelValue), mt().then(() => {
        if (!R.value.enabled) {
          const se = x(h.value);
          se == null || se.addEventListener("scroll", U), window == null || window.addEventListener("resize", Q);
        }
      }), R.value.enabled && (o.value = !0), window == null || window.addEventListener("keyup", we), window == null || window.addEventListener("keydown", ge);
    }), vn(() => {
      if (!R.value.enabled) {
        const se = x(h.value);
        se == null || se.removeEventListener("scroll", U), window == null || window.removeEventListener("resize", Q);
      }
      window == null || window.removeEventListener("keyup", we), window == null || window.removeEventListener("keydown", ge);
    });
    const ee = Ft(l, "all", r.presetDates), ce = Ft(l, "input");
    et(
      [i, s],
      () => {
        p(i.value);
      },
      { deep: !0 }
    );
    const { openOnTop: q, menuStyle: J, xCorrect: L, setMenuPosition: F, getScrollableParent: x, shadowRender: N } = fg({
      menuRef: c,
      menuRefInner: u,
      inputRef: d,
      pickerWrapperRef: h,
      inline: R,
      emit: n,
      props: r,
      slots: l
    }), {
      inputValue: Z,
      internalModelValue: ae,
      parseExternalModelValue: p,
      emitModelValue: W,
      formatInputValue: ve,
      checkBeforeEmit: Fe
    } = sy(n, r, f), K = H(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: R.value.enabled,
        "dp--flex-display-collapsed": D.value,
        dp__flex_display_with_input: R.value.input
      })
    ), Ee = H(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), ue = H(() => r.teleport ? {
      to: typeof r.teleport == "boolean" ? "body" : r.teleport,
      disabled: !r.teleport || R.value.enabled
    } : {}), ye = H(() => ({ class: "dp__outer_menu_wrap" })), _ = H(() => R.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), j = () => {
      var se, ke;
      return ((ke = (se = d.value) == null ? void 0 : se.$el) == null ? void 0 : ke.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, U = () => {
      o.value && (S.value.closeOnScroll ? tt() : F());
    }, Q = () => {
      var se;
      o.value && F();
      const ke = ((se = u.value) == null ? void 0 : se.$el.getBoundingClientRect().width) ?? 0;
      D.value = document.body.offsetWidth <= ke;
    }, we = (se) => {
      se.key === "Tab" && !R.value.enabled && !r.teleport && S.value.tabOutClosesMenu && (h.value.contains(document.activeElement) || tt()), w.value = se.shiftKey;
    }, ge = (se) => {
      w.value = se.shiftKey;
    }, Oe = () => {
      !r.disabled && !r.readonly && (N(E, lo, r), F(!1), o.value = !0, o.value && n("open"), o.value || xe(), p(r.modelValue));
    }, Le = () => {
      var se, ke;
      Z.value = "", xe(), (se = u.value) == null || se.onValueCleared(), (ke = d.value) == null || ke.setParsedDate(null), n("update:model-value", null), n("update:model-timezone-value", null), n("cleared"), S.value.closeOnClearValue && tt();
    }, z = () => {
      const se = ae.value;
      return !se || !Array.isArray(se) && A(se) ? !0 : Array.isArray(se) ? re.value.enabled || se.length === 2 && A(se[0]) && A(se[1]) ? !0 : X.value.partialRange && !r.timePicker ? A(se[0]) : !1 : !1;
    }, he = () => {
      Fe() && z() ? (W(), tt()) : n("invalid-select", ae.value);
    }, Se = (se) => {
      He(), W(), S.value.closeOnAutoApply && !se && tt();
    }, He = () => {
      d.value && O.value.enabled && d.value.setParsedDate(ae.value);
    }, Ge = (se = !1) => {
      r.autoApply && P(ae.value) && z() && (X.value.enabled && Array.isArray(ae.value) ? (X.value.partialRange || ae.value.length === 2) && Se(se) : Se(se));
    }, xe = () => {
      O.value.enabled || (ae.value = null);
    }, tt = (se = !1) => {
      var ke, Ie;
      se && ae.value && S.value.setDateOnMenuClose && he(), R.value.enabled || (o.value && (o.value = !1, L.value = !1, T(!1), g(!1), M(), n("closed"), Z.value && p(i.value)), xe(), n("blur"), (Ie = (ke = u.value) == null ? void 0 : ke.$el) == null || Ie.remove());
    }, wt = (se, ke, Ie = !1) => {
      if (!se) {
        ae.value = null;
        return;
      }
      const aa = Array.isArray(se) ? !se.some((le) => !A(le)) : A(se), ne = P(se);
      aa && ne ? ($.value = !0, ae.value = se, ke ? (b.value = Ie, he(), n("text-submit")) : r.autoApply && Ge(), mt().then(() => {
        $.value = !1;
      })) : n("invalid-date", se);
    }, Ua = () => {
      r.autoApply && P(ae.value) && W(), He();
    }, za = () => o.value ? tt() : Oe(), qa = (se) => {
      ae.value = se;
    }, gn = () => {
      O.value.enabled && (f.value = !0, ve()), n("focus");
    }, jt = () => {
      if (O.value.enabled && (f.value = !1, p(r.modelValue), b.value)) {
        const se = Oh(h.value, w.value);
        se == null || se.focus();
      }
      n("blur");
    }, bn = (se) => {
      u.value && u.value.updateMonthYear(0, {
        month: Xl(se.month),
        year: Xl(se.year)
      });
    }, wn = (se) => {
      p(se ?? r.modelValue);
    }, G = (se, ke) => {
      var Ie;
      (Ie = u.value) == null || Ie.switchView(se, ke);
    }, be = (se, ke) => S.value.onClickOutside ? S.value.onClickOutside(se, ke) : tt(!0), $e = (se = 0) => {
      var ke;
      (ke = u.value) == null || ke.handleFlow(se);
    }, Ve = () => c;
    return Dg(
      c,
      d,
      (se) => be(z, se)
    ), a({
      closeMenu: tt,
      selectDate: he,
      clearValue: Le,
      openMenu: Oe,
      onScroll: U,
      formatInputValue: ve,
      // exposed for testing purposes
      updateInternalModelValue: qa,
      // modify internal modelValue
      setMonthYear: bn,
      parseModel: wn,
      switchView: G,
      toggleMenu: za,
      handleFlow: $e,
      getDpWrapMenuRef: Ve
    }), (se, ke) => (v(), y("div", {
      ref_key: "pickerWrapperRef",
      ref: h,
      class: pe(K.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": m(V)
    }, [
      qe(_g, dt({
        ref_key: "inputRef",
        ref: d,
        "input-value": m(Z),
        "onUpdate:inputValue": ke[0] || (ke[0] = (Ie) => ma(Z) ? Z.value = Ie : null),
        "is-menu-open": o.value
      }, se.$props, {
        onClear: Le,
        onOpen: Oe,
        onSetInputDate: wt,
        onSetEmptyDate: m(W),
        onSelectDate: he,
        onToggle: za,
        onClose: tt,
        onFocus: gn,
        onBlur: jt,
        onRealBlur: ke[1] || (ke[1] = (Ie) => f.value = !1),
        onTextInput: ke[2] || (ke[2] = (Ie) => se.$emit("text-input", Ie))
      }), bt({ _: 2 }, [
        Me(m(ce), (Ie, aa) => ({
          name: Ie,
          fn: Ae((ne) => [
            ie(se.$slots, Ie, gt($t(ne)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (v(), Pe(Va(se.teleport ? Us : "div"), gt($t(ue.value)), {
        default: Ae(() => [
          qe(Ha, {
            name: m(fe)(m(q)),
            css: m(I) && !m(R).enabled
          }, {
            default: Ae(() => [
              o.value ? (v(), y("div", dt({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: c
              }, ye.value, {
                class: { "dp--menu-wrapper": !m(R).enabled },
                style: m(R).enabled ? void 0 : m(J)
              }), [
                qe(lo, dt({
                  ref_key: "dpMenuRef",
                  ref: u
                }, se.$props, {
                  "internal-model-value": m(ae),
                  "onUpdate:internalModelValue": ke[3] || (ke[3] = (Ie) => ma(ae) ? ae.value = Ie : null),
                  class: { [Ee.value]: !0, "dp--menu-wrapper": se.teleport },
                  "open-on-top": m(q),
                  "no-overlay-focus": _.value,
                  collapse: D.value,
                  "get-input-rect": j,
                  "is-text-input-date": $.value,
                  onClosePicker: tt,
                  onSelectDate: he,
                  onAutoApply: Ge,
                  onTimeUpdate: Ua,
                  onFlowStep: ke[4] || (ke[4] = (Ie) => se.$emit("flow-step", Ie)),
                  onUpdateMonthYear: ke[5] || (ke[5] = (Ie) => se.$emit("update-month-year", Ie)),
                  onInvalidSelect: ke[6] || (ke[6] = (Ie) => se.$emit("invalid-select", m(ae))),
                  onAutoApplyInvalid: ke[7] || (ke[7] = (Ie) => se.$emit("invalid-select", Ie)),
                  onInvalidFixedRange: ke[8] || (ke[8] = (Ie) => se.$emit("invalid-fixed-range", Ie)),
                  onRecalculatePosition: m(F),
                  onTooltipOpen: ke[9] || (ke[9] = (Ie) => se.$emit("tooltip-open", Ie)),
                  onTooltipClose: ke[10] || (ke[10] = (Ie) => se.$emit("tooltip-close", Ie)),
                  onTimePickerOpen: ke[11] || (ke[11] = (Ie) => se.$emit("time-picker-open", Ie)),
                  onTimePickerClose: ke[12] || (ke[12] = (Ie) => se.$emit("time-picker-close", Ie)),
                  onAmPmChange: ke[13] || (ke[13] = (Ie) => se.$emit("am-pm-change", Ie)),
                  onRangeStart: ke[14] || (ke[14] = (Ie) => se.$emit("range-start", Ie)),
                  onRangeEnd: ke[15] || (ke[15] = (Ie) => se.$emit("range-end", Ie)),
                  onDateUpdate: ke[16] || (ke[16] = (Ie) => se.$emit("date-update", Ie)),
                  onInvalidDate: ke[17] || (ke[17] = (Ie) => se.$emit("invalid-date", Ie)),
                  onOverlayToggle: ke[18] || (ke[18] = (Ie) => se.$emit("overlay-toggle", Ie)),
                  onMenuBlur: ke[19] || (ke[19] = (Ie) => se.$emit("blur"))
                }), bt({ _: 2 }, [
                  Me(m(ee), (Ie, aa) => ({
                    name: Ie,
                    fn: Ae((ne) => [
                      ie(se.$slots, Ie, gt($t({ ...ne })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : Y("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, Tg));
  }
}), mn = /* @__PURE__ */ (() => {
  const e = Ig;
  return e.install = (a) => {
    a.component("Vue3DatePicker", e);
  }, e;
})(), Mg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mn
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(Mg).forEach(([e, a]) => {
  e !== "default" && (mn[e] = a);
});
Date.prototype.CompareSystemTimeDateHourMinute = function(e) {
  return this.getFullYear() < e.getFullYear() ? -1 : this.getFullYear() > e.getFullYear() ? 1 : this.getMonth() < e.getMonth() ? -1 : this.getMonth() > e.getMonth() ? 1 : this.getDate() < e.getDate() ? -1 : this.getDate() > e.getDate() ? 1 : this.getHours() < e.getHours() ? -1 : this.getHours() > e.getHours() ? 1 : this.getMinutes() < e.getMinutes() ? -1 : this.getMinutes() > e.getMinutes() ? 1 : 0;
};
Date.prototype.CompareSystemTimeDate = function(e) {
  return this.getFullYear() < e.getFullYear() ? -1 : this.getFullYear() > e.getFullYear() ? 1 : this.getMonth() < e.getMonth() ? -1 : this.getMonth() > e.getMonth() ? 1 : this.getDate() < e.getDate() ? -1 : this.getDate() > e.getDate() ? 1 : 0;
};
Date.prototype.SystemtimeToStr3 = function() {
  const e = this.getDate(), a = this.getMonth() + 1, t = this.getFullYear(), n = this.getHours(), r = this.getMinutes(), l = this.getSeconds();
  return t.toString() + ("00" + a).slice(-2) + ("00" + e).slice(-2) + ("00" + n).slice(-2) + ("00" + r).slice(-2) + ("00" + l).slice(-2);
};
Date.prototype.SystemtimeToStr4 = function() {
  const e = this.getDate(), a = this.getMonth() + 1, t = this.getFullYear(), n = this.getHours(), r = this.getMinutes(), l = this.getSeconds(), o = this.getMilliseconds();
  return t.toString() + ("00" + a).slice(-2) + ("00" + e).slice(-2) + ("00" + n).slice(-2) + ("00" + r).slice(-2) + ("00" + l).slice(-2) + ("000" + o).slice(-3);
};
Date.prototype.SystemtimeToStr7 = function() {
  const e = this.getDate(), a = this.getMonth() + 1, t = this.getFullYear(), n = this.getHours(), r = this.getMinutes();
  return t.toString() + "/" + ("00" + a).slice(-2) + "/" + ("00" + e).slice(-2) + " " + ("00" + n).slice(-2) + ":" + ("00" + r).slice(-2);
};
Date.prototype.SystemtimeToStr7UTC = function() {
  const e = this.getUTCDate(), a = this.getUTCMonth() + 1, t = this.getUTCFullYear(), n = this.getUTCHours(), r = this.getUTCMinutes();
  return t.toString() + "/" + ("00" + a).slice(-2) + "/" + ("00" + e).slice(-2) + " " + ("00" + n).slice(-2) + ":" + ("00" + r).slice(-2);
};
Date.prototype.SystemtimeToDateStr = function() {
  const e = this.getDate(), a = this.getMonth() + 1, t = this.getFullYear();
  return this.getHours(), this.getMinutes(), `${t}/${("00" + a).slice(-2)}/${("00" + e).slice(-2)}`;
};
Date.prototype.AddMonth = function(e) {
  const a = new Date(this);
  if (this.setMonth(this.getMonth() + e), a.getDate() != this.getDate()) {
    this.setMonth(this.getMonth() - 1);
    const t = new Date(this.getFullYear(), this.getMonth() + 1, 0);
    this.setDate(t.getDate());
  }
};
Date.prototype.AddHour = function(e) {
  this.setHours(this.getHours() + e);
};
const Sg = (e) => (Tt("data-v-0ff13238"), e = e(), It(), e), $g = { class: "d-flex flex-row align-items-center" }, Pg = /* @__PURE__ */ Sg(() => /* @__PURE__ */ k("span", { class: "search-keyword-size-center-text" }, "～", -1)), Ag = /* @__PURE__ */ Te({
  __name: "SearchKeywordTypeDateTimeRange",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(e, { expose: a }) {
    const t = e, n = B(/* @__PURE__ */ new Date());
    n.value.AddMonth(-1);
    const r = B(/* @__PURE__ */ new Date());
    return a({
      getData: () => {
        if (n.value == null && r.value == null)
          return null;
        const o = new ir();
        return o.searchID = t.searchID, o.searchType = va.DateTimeRange, n.value != null && (o.dateTime1 = n.value), r.value != null && (o.dateTime2 = r.value), o;
      }
    }), (o, i) => (v(), y("div", $g, [
      qe(m(mn), {
        modelValue: n.value,
        "onUpdate:modelValue": i[0] || (i[0] = (s) => n.value = s),
        locale: "ja",
        enableTimePicker: !0,
        format: "yyyy-MM-dd HH:mm",
        previewFormat: "yyyy-MM-dd HH:mm",
        yearRange: [1970, 2070],
        minDate: /* @__PURE__ */ new Date("1970-01-01"),
        maxDate: /* @__PURE__ */ new Date("2070-12-31"),
        clearable: !0,
        style: { width: "240px" },
        inputClassName: "input-text-scv datepickerInput",
        weekStart: "0"
      }, null, 8, ["modelValue", "minDate", "maxDate"]),
      Pg,
      qe(m(mn), {
        modelValue: r.value,
        "onUpdate:modelValue": i[1] || (i[1] = (s) => r.value = s),
        locale: "ja",
        enableTimePicker: !0,
        format: "yyyy-MM-dd HH:mm",
        previewFormat: "yyyy-MM-dd HH:mm",
        yearRange: [1970, 2070],
        minDate: /* @__PURE__ */ new Date("1970-01-01"),
        maxDate: /* @__PURE__ */ new Date("2070-12-31"),
        clearable: !0,
        style: { width: "240px" },
        inputClassName: "input-text-scv datepickerInput",
        weekStart: "0"
      }, null, 8, ["modelValue", "minDate", "maxDate"])
    ]));
  }
}), Og = /* @__PURE__ */ Ye(Ag, [["__scopeId", "data-v-0ff13238"]]), Rg = {
  class: "d-flex flex-row align-items-center flex-wrap",
  style: { "row-gap": "8px" }
}, Eg = {
  class: "select-icon",
  style: { "margin-right": "16px" }
}, Ng = ["value"], Bg = /* @__PURE__ */ Te({
  __name: "SearchKeywordSelectGroup",
  props: {
    groupList: { type: Array, required: !0 }
    // 検索対象一覧
  },
  setup(e, { expose: a }) {
    const t = B(new Fl()), n = B(), r = B(), l = B();
    return a({
      getData: () => n.value != null && n.value != null ? n.value.getData() : r.value != null && r.value != null ? r.value.getData() : l.value != null && l.value != null ? l.value.getData() : null,
      clearData: () => {
        n.value != null && n.value != null && n.value.clearData(), t.value = new Fl();
      }
    }), (s, c) => (v(), y("div", Rg, [
      k("div", Eg, [
        ht(k("select", {
          class: "input-text-scv overflow-text",
          style: { width: "200px" },
          "onUpdate:modelValue": c[0] || (c[0] = (u) => t.value = u)
        }, [
          (v(!0), y(me, null, Me(e.groupList, (u) => (v(), y("option", {
            value: u,
            key: u.strName
          }, _e(u.strName), 9, Ng))), 128))
        ], 512), [
          [On, t.value]
        ])
      ]),
      k("div", null, [
        m(va).Text == t.value.type ? (v(), Pe(im, {
          key: 0,
          ref_key: "refText",
          ref: n,
          searchID: t.value.searchID
        }, null, 8, ["searchID"])) : m(va).Size == t.value.type ? (v(), Pe(ym, {
          key: 1,
          ref_key: "refSize",
          ref: r,
          searchID: t.value.searchID
        }, null, 8, ["searchID"])) : m(va).DateTimeRange == t.value.type ? (v(), Pe(Og, {
          key: 2,
          ref_key: "refDate",
          ref: l,
          searchID: t.value.searchID
        }, null, 8, ["searchID"])) : Y("", !0)
      ])
    ]));
  }
}), Mb = /* @__PURE__ */ Ye(Bg, [["__scopeId", "data-v-bfd4cdde"]]), Lg = 100, Sb = /* @__PURE__ */ Te({
  __name: "SearchKeywordTypeSimpleText",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(e, { expose: a }) {
    const t = e, n = B(new ir()), r = () => n.value.strOrCondition.trim().length != 0;
    return a({
      getData: () => r() ? (n.value.searchType = va.Text, n.value.searchID = t.searchID, n.value) : null,
      clearData: () => {
        n.value.strOrCondition = "";
      }
    }), (i, s) => (v(), Pe(ka, {
      modelValue: n.value.strOrCondition,
      "onUpdate:modelValue": s[0] || (s[0] = (c) => n.value.strOrCondition = c),
      class: "input-text-scv",
      placeholder: "文字列",
      convertType: "text",
      maxlength: Lg
    }, null, 8, ["modelValue"]));
  }
});
class Fg {
  // アイコンID
  constructor() {
    te(this, "itemID");
    // アイテムID
    te(this, "itemName");
    // アイテム名
    te(this, "itemUINamePath");
    // UI用のアイテムパス
    te(this, "parentID");
    // 親ID
    te(this, "displayOrder");
    // 表示順序
    te(this, "iconID");
    this.itemID = 0, this.itemName = "", this.itemUINamePath = "", this.parentID = 0, this.displayOrder = 0, this.iconID = 0;
  }
  equalsObject(a) {
    return !(this.itemID != a.itemID || this.itemName != a.itemName || this.itemUINamePath != a.itemUINamePath || this.displayOrder != a.displayOrder || this.parentID != a.parentID || this.iconID != a.iconID);
  }
}
const An = class An {
  // 新規アイテムの仮ID
  constructor() {
    te(this, "itemId");
    // アイテムID
    te(this, "itemName");
    // アイテム名
    te(this, "itemUINamePath");
    // UI用アイテムパス名
    te(this, "arChildren", new Array());
    // 子部署
    te(this, "displayOrder");
    // 表示順
    te(this, "iconID");
    // アイコンID
    // オプション変数
    te(this, "alertCount");
    // アラート端末数
    te(this, "checkState");
    // チェック状態
    te(this, "sortMode");
    this.itemId = 0, this.itemName = "", this.itemUINamePath = "", this.alertCount = 0, this.checkState = !1, this.displayOrder = 0, this.iconID = 0, this.sortMode = 0;
  }
  /// <summary>
  /// 初期化
  /// </summary>
  SetDefault() {
    this.itemId = 0, this.itemName = "", this.itemUINamePath = "", this.alertCount = 0, this.checkState = !1, this.arChildren = new Array(), this.displayOrder = 0, this.iconID = 0, this.sortMode = 0;
  }
  /// <summary>
  /// データベースの情報をデータクラスに変換します
  /// @param [in] arItemList : データベースのデータ
  /// </summary>
  Load(a, t = 0) {
    this.SetDefault(), this.sortMode = t, a.sort(function(i, s) {
      return i.parentID < s.parentID ? -1 : i.parentID > s.parentID ? 1 : oo.CompareTreeItemData(i, s, t);
    });
    const n = /* @__PURE__ */ new Map(), r = new Array();
    n.set(0, this);
    const l = a.length;
    for (let i = 0; i < l; ++i) {
      if (a[i].itemID == 0)
        continue;
      let s = new An();
      s.itemId = a[i].itemID, s.itemName = a[i].itemName, s.itemUINamePath = a[i].itemUINamePath, s.displayOrder = a[i].displayOrder, s.iconID = a[i].iconID, s.sortMode = this.sortMode, n.set(a[i].itemID, s);
      const c = n.get(a[i].parentID);
      if (c == null) {
        r.push(a[i]);
        continue;
      }
      c.arChildren.push(s);
    }
    const o = r.length;
    for (let i = 0; i < o; i++) {
      const s = n.get(r[i].itemID);
      if (s == null)
        continue;
      const c = n.get(r[i].parentID);
      c != null && c.arChildren.push(s);
    }
  }
  /// <summary>
  /// アイテムをツリーに追加
  /// @param [in] treeItem : アイテム
  /// </summary>
  AddItem(a) {
    const t = this.GetItemData(a.parentID);
    if (t == null)
      return;
    let n = new An();
    n.itemId = a.itemID, n.itemName = a.itemName, n.itemUINamePath = a.itemUINamePath, n.iconID = a.iconID, t.arChildren.push(n), this.SortChildItem(t);
  }
  /// <summary>
  /// データクラスをデータベースの情報に変換します
  /// @param [out] arItemList : データベース情報
  /// </summary>
  Save(a) {
    this.SaveChildren(a);
  }
  /// <summary>
  /// データクラスをデータベースの情報に変換します（子アイテム）
  /// @param [out] arItemList : データベース情報
  /// </summary>
  SaveChildren(a) {
    for (let t = 0; t < this.arChildren.length; t++) {
      const n = new Fg();
      n.itemID = this.arChildren[t].itemId, n.itemName = this.arChildren[t].itemName, n.itemUINamePath = this.itemUINamePath, n.parentID = this.itemId, n.displayOrder = this.displayOrder, n.iconID = this.iconID, a.push(n), this.arChildren[t].SaveChildren(a);
    }
  }
  /**
   * 指定されたアイテムIDのアイテム情報を返します
   * @param[in] nItemID : アイテムID
   * @return undefined:見つからなかった undefined以外：アイテムID
   */
  GetItemData(a) {
    if (this.itemId == a)
      return this;
    for (let t = 0; t < this.arChildren.length; t++) {
      const n = this.arChildren[t].GetItemData(a);
      if (n != null)
        return n;
    }
  }
  /**
   * 指定されたアイテムIDの親アイテム情報を返します
   * @param[in] nItemID : アイテムID
   * @return undefined:見つからなかった undefined以外：アイテムID
   */
  GetParentItemData(a) {
    if (this.itemId != a)
      for (let t = 0; t < this.arChildren.length; t++) {
        if (this.arChildren[t].itemId == a)
          return this;
        const n = this.arChildren[t].GetParentItemData(a);
        if (n != null)
          return n;
      }
  }
  /**
   * 指定されたアイテムIDの子アイテムを削除します
   * @param[in] nItemID : アイテムID
   * @return true : 削除        false : 対象が見つからない
   */
  DeleteChildItemData(a) {
    for (let t = 0; t < this.arChildren.length; t++) {
      if (this.arChildren[t].itemId == a)
        return this.arChildren.splice(t, 1), !0;
      const n = this.arChildren[t].DeleteChildItemData(a);
      if (n == !0)
        return n;
    }
    return !1;
  }
  /**
   * アイテムID一覧を取得します
   * @param[out] arItemID : アイテムID一覧
   */
  GetAllItemID(a) {
    0 < this.itemId && a.push(this.itemId);
    for (let t = 0; t < this.arChildren.length; t++)
      this.arChildren[t].GetAllItemID(a);
  }
  /**
   * 階層を取得します
   * @param[in] nItemID : アイテムID
   * @param[out] nResult : 結果（階層）
   */
  GetHierarchy(a) {
    if (this.itemId == a)
      return 1;
    for (let t = 0; t < this.arChildren.length; t++) {
      if (this.arChildren[t].itemId == a)
        return 2;
      const n = this.arChildren[t].GetHierarchy(a);
      if (n != 0)
        return n + 1;
    }
    return 0;
  }
  /**
   * 配下アイテムが何階層あるかを取得します
   * @return : 結果（階層）※自分を含めての値
   */
  GetChildrenHierarchy() {
    let a = 0;
    for (let t = 0; t < this.arChildren.length; t++) {
      const n = this.arChildren[t].GetChildrenHierarchy();
      a < n && (a = n);
    }
    return a + 1;
  }
  /**
   * 自身のフルパスを取得
   * @param  : isIncludeRoot: ルートを含むかどうか
   * @return : フルパス
   */
  GetFullPath(a, t = !0) {
    let n = "", r = a;
    if (r == 0)
      return n;
    const l = this.GetItemData(a);
    if (l == null)
      return n;
    for (n += l.itemName; 0 < r; ) {
      const o = this.GetParentItemData(r);
      if (o == null || o.itemId == 0)
        break;
      if (!t) {
        const i = this.GetParentItemData(o.itemId);
        if (i == null || i.itemId == 0)
          break;
      }
      n = o.itemName + "/" + n, r = o.itemId;
    }
    return n;
  }
  /**
   * UI用のアイテムパスを検索してアイテムIDを検索する
   * @return : 見つかった場合はそのアイテムID情報を、見つからなかった場合は null を返します。
   */
  findItemIDFromUINamePath(a) {
    if (this.itemUINamePath === a)
      return this;
    for (let t = 0; t < this.arChildren.length; ++t) {
      const n = this.arChildren[t].findItemIDFromUINamePath(a);
      if (n !== null)
        return n;
    }
    return null;
  }
  /**
   * 子アイテムのチェック状態を変更する
   * @param[in] bCheck : チェック状態
   */
  CheckChildItem(a) {
    for (let t = 0; t < this.arChildren.length; t++)
      this.arChildren[t].checkState = a, this.arChildren[t].CheckChildItem(a);
  }
  /**
   * チェック状態を変更する
   * @param[in] itemIDs : チェックがオンのアイテムID
   */
  SetCheckAllItem(a) {
    new Set(a).has(this.itemId) ? this.checkState = !0 : this.checkState = !1;
    for (let n = 0; n < this.arChildren.length; n++)
      this.arChildren[n].SetCheckAllItem(a);
  }
  /**
   * チェック状態を取得する
   * @param[out] itemIDs : チェックがオンのアイテムID
   */
  GetCheckAllItem(a) {
    this.checkState && 0 < this.itemId && a.push(this.itemId);
    for (let t = 0; t < this.arChildren.length; t++)
      this.arChildren[t].GetCheckAllItem(a);
  }
  /**
   * 指定した親の子アイテムをソートする
   * @param parentItem    親アイテム
   */
  SortChildItem(a) {
    a.arChildren.sort(function(t, n) {
      return oo.CompareTreeData(t, n, a.sortMode);
    });
  }
};
// ソートモード
te(An, "NEW_ITEM_ID", -1);
let Vt = An;
class oo {
  /**
   * 与えられた2つのアイテムを比較（※TreeItemData用）
   * @param item1    比較するアイテム
   * @param item2    比較するアイテム
   * @param mode 比較モード
   * @return -1 item1がitem2より順序が先の場合
   * @return 0  item1とitem2が同一の場合
   * @return 1  item1がitem2より順序が後の場合
   */
  static CompareTreeItemData(a, t, n) {
    switch (n) {
      case 0:
        return a.displayOrder < t.displayOrder ? -1 : a.displayOrder > t.displayOrder ? 1 : 0;
      case 1:
        return _l.compare(a.itemName, t.itemName, !1);
      default:
        return 0;
    }
  }
  /**
   * 与えられた2つのアイテムを比較（※TreeData用）
   * @param item1    比較するアイテム
   * @param item2    比較するアイテム
   * @param mode 比較モード
   * @return -1 item1がitem2より順序が先の場合
   * @return 0  item1とitem2が同一の場合
   * @return 1  item1がitem2より順序が後の場合
   */
  static CompareTreeData(a, t, n) {
    switch (n) {
      case 0:
        return a.displayOrder < t.displayOrder ? -1 : a.displayOrder > t.displayOrder ? 1 : 0;
      case 1:
        return _l.compare(a.itemName, t.itemName, !1);
      default:
        return 0;
    }
  }
}
const Vg = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='uuid-5ef8da2c-8ddd-401a-8ec8-f310fa1e5901'%20data-name='24x24'/%3e%3cg%20id='uuid-07eeb596-5a9b-48f8-a59b-7fdf5c71bca0'%20data-name='240x240'/%3e%3cg%20id='uuid-10e8f05e-e852-4213-a293-b9c4d4f34de8'%20data-name='未使用パーツ'/%3e%3cg%20id='uuid-f80c0a3f-49aa-4473-b090-e914938743c2'%20data-name='レイヤー%205'%3e%3cpath%20d='M217.5,177.5L138.69654,41.17667c-3.6825-6.88-10.85488-11.17667-18.69654-11.17667s-15.01429,4.29167-18.71596,11.20583L22.5,177.5c-1.77262,3.28583-2.5,6.25-2.5,10,0,12.5,10,22.5,22.5,22.5H197.5c12.5,0,22.5-10,22.5-22.5,0-3.75-.73263-6.72333-2.5-10Z'%20fill='%23fabe50'/%3e%3cpath%20d='M120,40c4.14771,0,7.93347,2.25928,9.88,5.896,.05139,.0957,.10449,.19092,.15894,.28564l78.72217,136.18262c.92468,1.74512,1.23889,3.05859,1.23889,5.13574,0,7.00928-5.4906,12.5-12.5,12.5H42.5c-7.0094,0-12.5-5.49072-12.5-12.5,0-2.07812,.31433-3.3916,1.23914-5.13623L109.94165,46.21045c.05444-.09375,.1073-.18896,.15857-.28467,1.95679-3.65527,5.75012-5.92578,9.89978-5.92578m0-10c-7.84167,0-15.01428,4.2915-18.71594,11.20605L22.5,177.5c-1.77258,3.28564-2.5,6.25-2.5,10,0,12.5,10,22.5,22.5,22.5H197.5c12.5,0,22.5-10,22.5-22.5,0-3.75-.73267-6.72314-2.5-10L138.69653,41.17676c-3.6825-6.87988-10.85486-11.17676-18.69653-11.17676h0Z'%20fill='%23996231'/%3e%3ccircle%20cx='120'%20cy='177.5'%20r='12.5'%20fill='%23493712'/%3e%3cpath%20d='M128.58154,143.77917c-.37083,3.51583-4.11333,6.22083-8.57917,6.22083-4.47167,0-8.21417-2.705-8.58167-6.22083,0,0-3.92071-62.77917-3.92071-68.94583,0-7.83333,3.96667-14.83333,12.50238-14.83333,8.53333,0,12.49762,7,12.49762,14.83333,0,6.16667-3.91846,68.94583-3.91846,68.94583Z'%20fill='%23493712'/%3e%3c/g%3e%3c/svg%3e", bl = (e) => (Tt("data-v-3df2b49b"), e = e(), It(), e), Hg = {
  class: "d-flex align-items-center",
  style: { height: "32px" }
}, Yg = { class: "svg-container" }, Wg = ["innerHTML"], Ug = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}, zg = /* @__PURE__ */ bl(() => /* @__PURE__ */ k("div", { style: { width: "8px" } }, null, -1)), qg = /* @__PURE__ */ bl(() => /* @__PURE__ */ k("img", {
  src: Vg,
  height: "20"
}, null, -1)), jg = /* @__PURE__ */ bl(() => /* @__PURE__ */ k("div", { style: { width: "4px" } }, null, -1)), Gg = { class: "alert-count-text" }, Qg = /* @__PURE__ */ Te({
  __name: "TreeCtrlItemText",
  props: {
    treeItem: { type: Vt, required: !0, default: new Vt() },
    // [in] (必須)部署ツリー
    selectItem: { type: Vt, required: !0 },
    // [in] (必須)選択中の部署
    arDisableItemID: { type: Array, default: () => [] },
    // [in] (オプション)無効状態にする部署
    getIconHtml: { type: Function, default: null }
    // [in] (オプション)アイコンのHTMLを取得
  },
  emits: ["selectItem"],
  setup(e, { emit: a }) {
    const t = e, n = () => t.arDisableItemID.find((l) => l == t.treeItem.itemId) != null ? "disableText" : 0 < t.treeItem.alertCount ? "alertText" : "";
    return (r, l) => (v(), y("div", Hg, [
      k("div", Yg, [
        e.getIconHtml ? (v(), y("span", {
          key: 0,
          innerHTML: e.getIconHtml(t.treeItem.iconID)
        }, null, 8, Wg)) : Y("", !0)
      ]),
      k("div", {
        class: pe(n()),
        style: { "margin-left": "4px" }
      }, [
        k("span", null, _e(t.treeItem.itemName), 1)
      ], 2),
      0 < e.treeItem.alertCount ? (v(), y("div", Ug, [
        zg,
        qg,
        jg,
        k("span", Gg, _e(t.treeItem.alertCount), 1)
      ])) : Y("", !0),
      ie(r.$slots, "label" + t.treeItem.itemId, {}, void 0, !0)
    ]));
  }
}), Kg = /* @__PURE__ */ Ye(Qg, [["__scopeId", "data-v-3df2b49b"]]), Xg = (e) => (Tt("data-v-7536fed3"), e = e(), It(), e), Zg = ["onClick"], Jg = {
  class: "d-flex align-items-center",
  style: { "min-width": "24px", height: "24px" }
}, e0 = ["onClick", "id"], t0 = /* @__PURE__ */ Xg(() => /* @__PURE__ */ k("i", { class: "icon-arrow1right" }, null, -1)), a0 = [
  t0
], n0 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: { "margin-left": "4px", "min-width": "24px", height: "24px" }
}, r0 = {
  key: 1,
  class: "scv-check-label-box"
}, l0 = ["onUpdate:modelValue", "onClick"], o0 = {
  key: 0,
  class: "nested"
}, s0 = /* @__PURE__ */ Te({
  __name: "TreeCtrlItem",
  props: {
    treeItem: { type: Vt, required: !0, default: new Vt() },
    // [in] (必須)アイテム
    selectItem: { type: Vt, required: !0 },
    // [in] (必須)選択中のアイテム
    arDisableItemID: { type: Array, default: () => [] },
    // [in] (オプション)無効状態にするアイテム
    nHierarchy: { type: Number, default: 0 },
    // [in] 自階層
    selectMode: { type: Number, default: 0 },
    // [in]（オプション）選択方法 0 : 行選択（単一） 1 : チェックボックス（複数）
    /* アイコンのHTMLを取得 */
    getIconHtml: { type: Function, default: null },
    /* チェックボックス押下時（変更前） */
    selectRowCheckButtonFunc: { type: Function, default: null },
    /*
     * 子の一部だけチェックされている親項目を「不定」状態として表示するかどうか。
     * trueの場合、TriStateCheckbox.vueを使用して子が混在する親項目を不定表示にする。
     */
    enableIndeterminate: { type: Boolean, default: !1 }
  },
  emits: ["selectItem", "expanded", "checkItem"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t;
    let l = B(new Vt()), o = B(), i = B();
    et(
      () => n.treeItem,
      () => {
        l.value = n.treeItem;
      },
      {
        deep: !0
      }
    ), et(
      () => n.selectItem,
      () => {
        let g = l.value.GetParentItemData(n.selectItem.itemId);
        g == null || g.itemId == 0 || mt(() => {
          T(!0, g.itemId);
        });
      },
      {
        deep: !0
      }
    );
    const s = (g, M) => {
      var P, C, O, R, S, X, re, fe, I, V, E, ee;
      const A = g.currentTarget;
      A.classList.contains("icon-font-open") == !0 ? ((R = (O = (C = (P = A.parentElement) == null ? void 0 : P.parentElement) == null ? void 0 : C.parentElement) == null ? void 0 : O.querySelector(".nested")) == null || R.classList.remove("active"), A.classList.remove("icon-font-open"), A.classList.add("icon-font-close"), (S = A.firstElementChild) == null || S.classList.remove("icon-arrow1down"), (X = A.firstElementChild) == null || X.classList.add("icon-arrow1right")) : ((V = (I = (fe = (re = A.parentElement) == null ? void 0 : re.parentElement) == null ? void 0 : fe.parentElement) == null ? void 0 : I.querySelector(".nested")) == null || V.classList.add("active"), A.classList.remove("icon-font-close"), A.classList.add("icon-font-open"), (E = A.firstElementChild) == null || E.classList.remove("icon-arrow1right"), (ee = A.firstElementChild) == null || ee.classList.add("icon-arrow1down")), r("expanded");
    }, c = (g) => {
      n.arDisableItemID.find((A) => A == g.itemId) == null && n.selectMode == 0 && r("selectItem", g);
    }, u = (g, M = new Event("default"), A) => {
      if (n.selectMode != 0) {
        if (n.selectRowCheckButtonFunc != null && M.type != "default" && !n.selectRowCheckButtonFunc(g, g.checkState)) {
          M.preventDefault();
          return;
        }
        if (A) {
          M.preventDefault(), setTimeout(u, 1, g, M, !1);
          return;
        }
        g.checkState = !g.checkState, r("checkItem");
      }
    }, d = () => {
      r("checkItem");
    }, f = (g) => {
      if (g.arChildren.length === 0)
        return g.checkState ? ut.Checked : ut.Unchecked;
      const M = g.arChildren.map((C) => f(C)), A = M.every((C) => ut.Checked === C), P = M.every((C) => ut.Unchecked === C);
      return A ? ut.Checked : P ? ut.Unchecked : ut.Indeterminate;
    }, h = (g, M) => {
      g.checkState = M, g.arChildren.forEach((A) => h(A, M));
    }, b = (g, M) => {
      h(g, ut.Checked === M), r("checkItem");
    }, w = (g) => n.selectMode == 0 && g == n.selectItem.itemId ? "tree-selectItem" : "", D = () => {
      var g = n.nHierarchy * 28;
      return "padding-left:" + g.toString() + "px";
    }, $ = () => {
      r("expanded");
    }, T = (g, M = void 0) => {
      var C, O, R, S, X, re, fe, I, V, E, ee, ce;
      if (i.value == null || o.value == null)
        return;
      const A = i.value;
      for (let q of A)
        q.expandTree(g, M);
      const P = o.value;
      for (let q of P)
        M != null && (q.id == 0 || q.id != M) || (g ? q.classList.contains("icon-font-close") == !0 && ((S = (R = (O = (C = q.parentElement) == null ? void 0 : C.parentElement) == null ? void 0 : O.parentElement) == null ? void 0 : R.querySelector(".nested")) == null || S.classList.add("active"), q.classList.remove("icon-font-close"), q.classList.add("icon-font-open"), (X = q.firstElementChild) == null || X.classList.remove("icon-arrow1right"), (re = q.firstElementChild) == null || re.classList.add("icon-arrow1down")) : q.classList.contains("icon-font-open") == !0 && ((E = (V = (I = (fe = q.parentElement) == null ? void 0 : fe.parentElement) == null ? void 0 : I.parentElement) == null ? void 0 : V.querySelector(".nested")) == null || E.classList.remove("active"), q.classList.remove("icon-font-open"), q.classList.add("icon-font-close"), (ee = q.firstElementChild) == null || ee.classList.remove("icon-arrow1down"), (ce = q.firstElementChild) == null || ce.classList.add("icon-arrow1right")));
      r("expanded");
    };
    return a({
      expandTree: T
    }), (g, M) => {
      const A = Vr("TreeCtrlItem", !0);
      return v(!0), y(me, null, Me(e.treeItem.arChildren, (P) => (v(), y("li", {
        key: P.itemId
      }, [
        k("div", {
          class: pe([w(P.itemId), "d-flex align-items-center tree-treeText"]),
          style: Be([D(), { "margin-bottom": "4px" }]),
          onClick: yt((C) => c(P), ["stop"])
        }, [
          k("div", Jg, [
            0 < P.arChildren.length ? (v(), y("div", {
              key: 0,
              class: "icon-font-close",
              ref_for: !0,
              ref_key: "ref_expand",
              ref: o,
              onClick: (C) => s(C),
              id: P.itemId.toString(),
              style: { "margin-right": "auto", "margin-left": "auto" }
            }, a0, 8, e0)) : Y("", !0)
          ]),
          n.selectMode == 1 ? (v(), y("div", n0, [
            n.enableIndeterminate ? (v(), Pe(po, {
              key: 0,
              modelValue: f(P),
              allowTriState: !1,
              beforeChange: () => n.selectRowCheckButtonFunc === null || n.selectRowCheckButtonFunc(P, P.checkState),
              "onUpdate:modelValue": (C) => b(P, C)
            }, null, 8, ["modelValue", "beforeChange", "onUpdate:modelValue"])) : (v(), y("label", r0, [
              ht(k("input", {
                type: "checkbox",
                "onUpdate:modelValue": (C) => P.checkState = C,
                onClick: (C) => u(P, C, !0)
              }, null, 8, l0), [
                [so, P.checkState]
              ])
            ]))
          ])) : Y("", !0),
          qe(Kg, {
            treeItem: P,
            selectItem: n.selectItem,
            arDisableItemID: n.arDisableItemID,
            selectMode: n.selectMode,
            getIconHtml: n.getIconHtml,
            onClick: (C) => u(P, C, !1)
          }, bt({ _: 2 }, [
            Me(g.$slots, (C, O) => ({
              name: O,
              fn: Ae((R) => [
                ie(g.$slots, O, dt({ ref_for: !0 }, R), void 0, !0)
              ])
            }))
          ]), 1032, ["treeItem", "selectItem", "arDisableItemID", "selectMode", "getIconHtml", "onClick"])
        ], 14, Zg),
        0 < P.arChildren.length ? (v(), y("ul", o0, [
          qe(A, {
            treeItem: P,
            selectItem: n.selectItem,
            arDisableItemID: n.arDisableItemID,
            nHierarchy: n.nHierarchy + 1,
            getIconHtml: n.getIconHtml,
            selectRowCheckButtonFunc: n.selectRowCheckButtonFunc,
            enableIndeterminate: n.enableIndeterminate,
            onSelectItem: c,
            onExpanded: $,
            onCheckItem: d,
            selectMode: n.selectMode,
            ref_for: !0,
            ref_key: "ref_childTreeCtrlItem",
            ref: i
          }, bt({ _: 2 }, [
            Me(g.$slots, (C, O) => ({
              name: O,
              fn: Ae((R) => [
                ie(g.$slots, O, dt({ ref_for: !0 }, R), void 0, !0)
              ])
            }))
          ]), 1032, ["treeItem", "selectItem", "arDisableItemID", "nHierarchy", "getIconHtml", "selectRowCheckButtonFunc", "enableIndeterminate", "selectMode"])
        ])) : Y("", !0)
      ]))), 128);
    };
  }
}), i0 = /* @__PURE__ */ Ye(s0, [["__scopeId", "data-v-7536fed3"]]), u0 = ["id"], c0 = ["id"], $b = /* @__PURE__ */ Te({
  __name: "TreeCtrl",
  props: {
    treeItem: { type: Vt, required: !0, default: new Vt() },
    // [in]（必須）アイテム情報一覧
    selectItem: { type: Vt, default: new Vt() },
    // [in]（selecteModが0の時、必須）選択中のアイテム情報
    arDisableItemID: { type: Array, default: () => [] },
    // [in]（オプション）無効にするアイテムのアイテムID
    idPrefix: { type: String, default: "" },
    // [in] アイテムツリーIDのプレフィックス
    getIconHtml: { type: Function, default: null },
    // [in] (オプション)アイコンのHTMLを取得
    /*
     * （オプション）選択方法
     * 0 : 行選択（単一）
     * 1 : チェックボックス（複数）
     *
     * 0の場合はpropsで「selectItem」の指定が必須です。
     * 1の場合は
     */
    selectMode: { type: Number, default: 0 },
    /* チェックボックス押下時（変更前） */
    selectRowCheckButtonFunc: { type: Function, default: null },
    /*
     * 子の一部だけチェックされている親項目を「不定」状態として表示するかどうか。
     * trueにするとTriStateCheckbox.vueを使った不定状態表示になる。
     */
    enableIndeterminate: { type: Boolean, default: !1 }
  },
  emits: ["selectItem", "expanded", "checkItem"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t;
    let l = null, o = B();
    Qs(() => {
      i();
    });
    const i = () => {
      const b = document.getElementById(n.idPrefix + "-Area"), w = document.getElementById(n.idPrefix + "-Tree");
      if (b == null || w == null)
        return;
      const D = b.clientHeight - b.offsetHeight;
      5 >= D && 0 <= D || -5 <= D && D <= 0 ? w.style.width = "100%" : w.style.width = "max-content";
    }, s = () => {
      i();
    }, c = () => {
      r("checkItem");
    }, u = (b) => {
      n.selectItem.itemId != b.itemId && r("selectItem", b);
    };
    return a({
      show: () => {
        l == null && (l = ui(i, 100), window.addEventListener("resize", l)), i();
      },
      hide: () => {
        l != null && (window.removeEventListener("resize", l), l = null);
      },
      expandTree: (b, w = void 0) => {
        o.value != null && o.value.expandTree(b, w);
      }
    }), (b, w) => (v(), y("div", {
      id: n.idPrefix + "-Area",
      class: "tree-area d-flex flex-column flex-grow-1 overflow-auto"
    }, [
      k("div", {
        id: n.idPrefix + "-Tree",
        style: { "list-style-type": "none", padding: "8px" }
      }, [
        qe(i0, {
          treeItem: n.treeItem,
          selectItem: n.selectItem,
          arDisableItemID: n.arDisableItemID,
          nHierarchy: 0,
          selectMode: n.selectMode,
          selectRowCheckButtonFunc: e.selectRowCheckButtonFunc,
          getIconHtml: n.getIconHtml,
          enableIndeterminate: n.enableIndeterminate,
          onSelectItem: u,
          onExpanded: s,
          onCheckItem: c,
          ref_key: "ref_treeCtrlItem",
          ref: o
        }, bt({ _: 2 }, [
          Me(b.$slots, (D, $) => ({
            name: $,
            fn: Ae((T) => [
              ie(b.$slots, $, gt($t(T)))
            ])
          }))
        ]), 1032, ["treeItem", "selectItem", "arDisableItemID", "selectMode", "selectRowCheckButtonFunc", "getIconHtml", "enableIndeterminate"])
      ], 8, c0)
    ], 8, u0));
  }
}), d0 = (e) => (Tt("data-v-d17fd203"), e = e(), It(), e), f0 = { class: "accordion-tree" }, p0 = ["onClick"], m0 = /* @__PURE__ */ d0(() => /* @__PURE__ */ k("i", { class: "icon-arrow1down" }, null, -1)), v0 = [
  m0
], h0 = ["onClick"], y0 = ["src"], g0 = { class: "item-label" }, b0 = /* @__PURE__ */ Te({
  __name: "AccordionTree",
  props: {
    items: {},
    depth: { default: 0 },
    transition: { type: [Boolean, String], default: !1 },
    hoverBackgroundColor: { default: "#f0f4f8" },
    selectedId: { default: null }
  },
  emits: ["toggle", "select"],
  setup(e, { emit: a }) {
    nr((u) => ({
      "7891a95c": u.hoverBackgroundColor,
      "2d1d5a2c": l.value
    }));
    const t = e, n = a, r = H(() => t.transition !== !1 && t.transition !== void 0), l = H(() => typeof t.transition == "string" && t.transition !== "" ? t.transition : "0.2s"), o = H(() => r.value ? "slide-fade" : ""), i = (u) => {
      n("toggle", u);
    }, s = (u) => {
      n("toggle", u);
    }, c = (u) => {
      n("select", u);
    };
    return (u, d) => {
      const f = Vr("AccordionTree", !0);
      return v(), y("ul", f0, [
        (v(!0), y(me, null, Me(u.items, (h) => (v(), y("li", {
          key: h.id,
          class: "accordion-item"
        }, [
          k("div", {
            class: pe(["accordion-item-content", { isSelectedId: u.selectedId === h.id }]),
            style: Be({ paddingLeft: `${u.depth * 28}px` })
          }, [
            k("span", {
              class: pe(["toggle-arrow-container", { clickable: h.children && h.children.length > 0 }]),
              onClick: yt((b) => h.children && h.children.length > 0 ? i(h.id) : c({ id: h.id, tag: h.tag }), ["stop"])
            }, [
              h.children && h.children.length > 0 ? (v(), y("span", {
                key: 0,
                class: pe(["toggle-arrow", { "is-open": h.isOpen }])
              }, v0, 2)) : Y("", !0)
            ], 10, p0),
            k("div", {
              class: "item-interactive-area",
              onClick: yt((b) => c({ id: h.id, tag: h.tag }), ["stop"])
            }, [
              h.iconUrl ? (v(), y("img", {
                key: 0,
                src: h.iconUrl,
                alt: "",
                class: "item-icon"
              }, null, 8, y0)) : Y("", !0),
              k("span", g0, _e(h.label), 1)
            ], 8, h0)
          ], 6),
          qe(Ha, { name: o.value }, {
            default: Ae(() => [
              h.children && h.children.length > 0 && h.isOpen ? (v(), Pe(f, {
                key: 0,
                items: h.children,
                depth: u.depth + 1,
                transition: u.transition,
                "hover-background-color": u.hoverBackgroundColor,
                "selected-id": u.selectedId,
                onToggle: s,
                onSelect: c
              }, null, 8, ["items", "depth", "transition", "hover-background-color", "selected-id"])) : Y("", !0)
            ]),
            _: 2
          }, 1032, ["name"])
        ]))), 128))
      ]);
    };
  }
}), Pb = /* @__PURE__ */ Ye(b0, [["__scopeId", "data-v-d17fd203"]]);
var Bn = /* @__PURE__ */ ((e) => (e[e.Default = 0] = "Default", e[e.Radio = 1] = "Radio", e))(Bn || {});
const w0 = {
  key: 0,
  class: "tab radio"
}, _0 = ["id", "name", "checked"], k0 = ["for"], x0 = /* @__PURE__ */ Te({
  __name: "Tab",
  props: {
    id: {},
    active: { type: Boolean, default: !1 },
    tabStyle: { default: Bn.Default },
    group: {}
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = B(Ya.NewID());
    function l() {
      n("click", t.id);
    }
    return (o, i) => m(Bn).Radio === t.tabStyle ? (v(), y("div", w0, [
      k("input", {
        id: m(r),
        name: t.group,
        type: "radio",
        checked: t.active,
        onClick: l
      }, null, 8, _0),
      k("label", { for: m(r) }, [
        ie(o.$slots, "default", {}, void 0, !0)
      ], 8, k0)
    ])) : (v(), y("div", {
      key: 1,
      class: pe(["tab default", { active: t.active }]),
      onClick: l
    }, [
      ie(o.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Ab = /* @__PURE__ */ Ye(x0, [["__scopeId", "data-v-7c1afb07"]]), C0 = /* @__PURE__ */ Te({
  __name: "Tabs",
  props: {
    tabs: {},
    activeTab: {},
    tabStyle: { default: Bn.Default }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = B(Ya.NewID()), l = ea(), o = H(() => {
      if (l.default) {
        let s = l.default();
        return s[0].type === Symbol.for("v-fgt") && (s = s[0].children), s;
      } else
        return t.tabs ?? [];
    });
    function i(s) {
      n("click", s);
    }
    return (s, c) => (v(), y("div", {
      class: pe(["tabs", { radio: m(Bn).Radio === t.tabStyle }])
    }, [
      (v(!0), y(me, null, Me(m(o), (u, d) => (v(), Pe(Va(u), {
        key: d,
        active: u.props.id === t.activeTab,
        tabStyle: t.tabStyle,
        group: m(r),
        onClick: i
      }, null, 8, ["active", "tabStyle", "group"]))), 128))
    ], 2));
  }
}), Ob = /* @__PURE__ */ Ye(C0, [["__scopeId", "data-v-318c50f4"]]), D0 = { class: "labeled-text-label" }, T0 = { class: "labeled-text-text" }, I0 = /* @__PURE__ */ Te({
  __name: "LabeledText",
  props: {
    name: {},
    direction: { default: "row" },
    height: {},
    width: {},
    labelWidth: {},
    gap: { default: 8 },
    underline: { type: Boolean, default: !1 },
    labelAlign: { default: "left" }
  },
  setup(e) {
    nr((u) => ({
      "6232f3cb": m(n),
      "7878bb7a": m(l),
      "649196db": m(o),
      "1f62e762": m(i),
      "10be1270": m(c),
      "32f4bbe8": m(s),
      69948995: m(r)
    }));
    const a = e, t = H(() => a.direction === "row"), n = H(() => `${a.gap}px`), r = H(() => a.underline ? "1px solid #cccccc" : void 0), l = H(() => a.height ? `${a.height}px` : void 0), o = H(() => a.width ? `${a.width}px` : void 0), i = H(() => a.labelWidth ? `${a.labelWidth}px` : void 0), s = H(() => a.width ? a.labelWidth ? `${a.width - a.labelWidth - a.gap - 8}px` : "100%" : a.labelWidth ? `${a.labelWidth}px` : void 0), c = H(() => a.labelAlign);
    return (u, d) => (v(), y("div", {
      class: pe(["labeled-text-main", { "labeled-text-horizontal": m(t), "labeled-text-vertical": !m(t) }, "default-text-font"])
    }, [
      k("div", D0, _e(a.name) + "：", 1),
      k("div", T0, [
        ie(u.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}), Rb = /* @__PURE__ */ Ye(I0, [["__scopeId", "data-v-db83d95a"]]), M0 = { class: "stepperProgress" }, S0 = /* @__PURE__ */ Te({
  __name: "StepperProgress",
  props: {
    items: {},
    step: {}
  },
  setup(e) {
    const a = e;
    return (t, n) => (v(), y("div", M0, [
      (v(!0), y(me, null, Me(a.items, (r, l) => (v(), y("div", {
        key: l,
        class: pe({
          completed: l < a.step,
          active: l === a.step,
          upcoming: l > a.step
        })
      }, _e(r), 3))), 128))
    ]));
  }
}), $0 = /* @__PURE__ */ Ye(S0, [["__scopeId", "data-v-34d010b0"]]), P0 = { class: "stepper" }, A0 = { class: "stepperContent" }, O0 = { class: "stepperActions" }, R0 = { class: "stepperActionsLeft" }, E0 = { class: "stepperActionsRight" }, N0 = ["disabled"], B0 = ["disabled"], L0 = /* @__PURE__ */ Te({
  __name: "Stepper",
  props: {
    items: {},
    step: {},
    transition: { type: Function, default: () => !0 },
    reverseTransition: { type: Function, default: () => !0 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:step", "cancel", "apply"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = H({
      get: () => t.step,
      set: (w) => n("update:step", w)
    }), l = H(() => t.items.length), o = ea(), i = H(() => {
      const w = o[`item.${r.value + 1}`];
      if (w) {
        const D = u(w([]), "backButtonLabel");
        if (D && D.props)
          return D.props.backButtonLabel ?? "一つ前に戻る";
      }
      return "一つ前に戻る";
    }), s = H(() => {
      const w = o[`item.${r.value + 1}`];
      if (w) {
        const D = u(w([]), "nextButtonLabel");
        if (D && D.props)
          return D.props.nextButtonLabel ?? "次へ";
      }
      return "次へ";
    }), c = H(() => {
      const w = o[`item.${r.value + 1}`];
      if (w) {
        const D = u(w([]), "applyButtonLabel");
        if (D && D.props)
          return D.props.applyButtonLabel ?? "適用";
      }
      return "適用";
    });
    function u(w, D) {
      if (!w.find)
        return;
      let $ = [];
      return w.forEach((T) => {
        if (T.props && T.props[D] !== void 0 && $.push(T), T.children) {
          const g = typeof T.children == "function" ? T.children() : T.children, M = u(g, D);
          M && $.push(M);
        }
      }), 0 < $.length ? $[0] : void 0;
    }
    function d() {
      t.transition(r.value) && (r.value += 1);
    }
    function f() {
      t.reverseTransition(r.value) && (r.value -= 1);
    }
    function h() {
      n("cancel", r.value);
    }
    function b() {
      n("apply");
    }
    return (w, D) => (v(), y("div", P0, [
      ie(w.$slots, "header", {}, () => [
        qe($0, {
          items: t.items,
          step: m(r)
        }, null, 8, ["items", "step"])
      ], !0),
      k("div", A0, [
        (v(!0), y(me, null, Me(t.items.length, ($) => (v(), y(me, { key: $ }, [
          $ - 1 === m(r) ? ie(w.$slots, `item.${$}`, { key: 0 }, void 0, !0) : Y("", !0)
        ], 64))), 128))
      ]),
      ie(w.$slots, "actions", {}, () => [
        k("div", O0, [
          k("div", R0, [
            0 < m(r) ? (v(), y("button", {
              key: 0,
              class: "btn-scv-white",
              onClick: f
            }, [
              ie(w.$slots, "back", {}, () => [
                Je(_e(m(i)), 1)
              ], !0)
            ])) : Y("", !0)
          ]),
          k("div", E0, [
            m(r) < m(l) - 1 ? (v(), y("button", {
              key: 0,
              class: "btn-scv-blue",
              onClick: d,
              disabled: t.nextDisabled
            }, [
              ie(w.$slots, "next", {}, () => [
                Je(_e(m(s)), 1)
              ], !0)
            ], 8, N0)) : Y("", !0),
            m(r) === m(l) - 1 ? (v(), y("button", {
              key: 1,
              class: "btn-scv-blue",
              onClick: b,
              disabled: t.nextDisabled
            }, [
              ie(w.$slots, "apply", {}, () => [
                Je(_e(m(c)), 1)
              ], !0)
            ], 8, B0)) : Y("", !0),
            k("button", {
              class: "btn-scv-white",
              onClick: h
            }, [
              ie(w.$slots, "cancel", {}, () => [
                Je(_e("キャンセル"))
              ], !0)
            ])
          ])
        ])
      ], !0)
    ]));
  }
}), Eb = /* @__PURE__ */ Ye(L0, [["__scopeId", "data-v-072f914f"]]), Nb = /* @__PURE__ */ Te({
  __name: "StepperItem",
  props: {
    backButtonLabel: {},
    nextButtonLabel: {},
    applyButtonLabel: {}
  },
  setup(e) {
    return (a, t) => ie(a.$slots, "default");
  }
});
var Kt = /* @__PURE__ */ ((e) => (e[e.Date = 0] = "Date", e[e.Time = 1] = "Time", e[e.DateTime = 2] = "DateTime", e[e.DateAndTime = 3] = "DateAndTime", e))(Kt || {});
const Ns = (e) => (Tt("data-v-566f1521"), e = e(), It(), e), F0 = { class: "dateTimePicker" }, V0 = /* @__PURE__ */ Ns(() => /* @__PURE__ */ k("i", { class: "icon-calendar" }, null, -1)), H0 = ["value", "onInput", "onKeydown", "onBlur", "onPaste"], Y0 = /* @__PURE__ */ Ns(() => /* @__PURE__ */ k("i", { class: "icon-time" }, null, -1)), W0 = ["value", "onInput", "onKeydown", "onBlur", "onPaste"], U0 = ["disabled"], z0 = /* @__PURE__ */ Te({
  __name: "DateTimePicker",
  props: {
    modelValue: {},
    pickerStyle: { default: Kt.DateAndTime },
    modern: { type: Boolean, default: !0 },
    markHoliday: { type: Boolean, default: !1 },
    inputStyleClass: {},
    directInput: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledPastDate: { type: Boolean, default: !1 },
    teleport: { type: [Boolean, String], default: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = H({
      get: () => t.modelValue,
      set: (T) => {
        if (Kt.DateTime === t.pickerStyle)
          n("update:modelValue", T);
        else {
          const g = new Date(t.modelValue);
          g.setFullYear(T.getFullYear()), g.setMonth(T.getMonth()), g.setDate(T.getDate()), n("update:modelValue", g);
        }
      }
    }), l = H({
      get: () => ({
        hours: t.modelValue.getHours(),
        minutes: t.modelValue.getMinutes(),
        seconds: t.modelValue.getSeconds()
      }),
      set: (T) => {
        const g = new Date(t.modelValue);
        g.setHours(T.hours), g.setMinutes(T.minutes), g.setSeconds(T.seconds), n("update:modelValue", g);
      }
    }), o = H({
      get: () => {
        const T = t.modelValue.getHours().toString().padStart(2, "0"), g = t.modelValue.getMinutes().toString().padStart(2, "0");
        return `${T}:${g}`;
      },
      set: (T) => {
        const [g, M] = T.split(":"), A = new Date(t.modelValue);
        A.setHours(Number.parseInt(g)), A.setMinutes(Number.parseInt(M)), A.setSeconds(0), n("update:modelValue", A);
      }
    }), i = H(() => {
      switch (t.pickerStyle) {
        case Kt.Date:
        case Kt.DateTime:
        case Kt.DateAndTime:
          return !0;
        default:
          return !1;
      }
    }), s = H(() => {
      switch (t.pickerStyle) {
        case Kt.Time:
        case Kt.DateAndTime:
          return !0;
        default:
          return !1;
      }
    }), c = H(() => {
      let T = "yyyy/MM/dd";
      return Kt.DateTime === t.pickerStyle && (T = "yyyy/MM/dd HH:mm"), {
        input: T,
        preview: T
      };
    }), u = H(() => ({
      input: "HH:mm",
      preview: "HH:mm"
    })), d = H(() => {
      switch (t.pickerStyle) {
        case Kt.DateTime:
          return "dateTimePicker";
        default:
          return "datePicker";
      }
    }), f = H(() => t.inputStyleClass ? {
      input: t.inputStyleClass
    } : {}), h = H(() => t.disabledPastDate ? [oi().get("years"), 2070] : [1970, 2070]), b = H(() => t.disabledPastDate ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date("1970-01-01"));
    function w(T) {
      if (t.markHoliday)
        switch (T.getDay()) {
          case 6:
            return "saturday";
          case 0:
            return "sunday";
          default:
            return "weekday";
        }
      else
        return "";
    }
    function D(T) {
      const g = T.key.toLowerCase();
      (g === "backspace" || g === "delete") && T.preventDefault();
    }
    function $(T) {
      T.preventDefault(), T.dataTransfer && (T.dataTransfer.dropEffect = "none");
    }
    return (T, g) => (v(), y("div", F0, [
      m(i) ? (v(), Pe(m(mn), {
        key: 0,
        modelValue: m(r),
        "onUpdate:modelValue": g[1] || (g[1] = (M) => ma(r) ? r.value = M : null),
        locale: "ja",
        enableTimePicker: m(Kt).DateTime === t.pickerStyle,
        format: m(c).input,
        previewFormat: m(c).preview,
        yearRange: m(h),
        minDate: m(b),
        maxDate: /* @__PURE__ */ new Date("2070-12-31"),
        clearable: !1,
        textInput: t.directInput,
        autoApply: !0,
        weekStart: 0,
        dayClass: w,
        class: pe(m(d)),
        ui: m(f),
        disabled: t.disabled,
        teleport: t.teleport
      }, {
        "input-icon": Ae(() => [
          V0
        ]),
        "dp-input": Ae(({ value: M, onInput: A, onEnter: P, onTab: C, onBlur: O, onPaste: R }) => [
          k("input", {
            type: "text",
            value: M,
            onInput: A,
            onKeydown: [
              Cn(P, ["enter"]),
              Cn(C, ["tab"])
            ],
            onBlur: O,
            onPaste: R,
            onDrop: g[0] || (g[0] = yt(() => {
            }, ["prevent"])),
            onDragover: $,
            onDragenter: $,
            class: pe(["dp__pointer dp__input_readonly dp__input dp__input_icon_pad dp__input_reg", t.inputStyleClass])
          }, null, 42, H0)
        ]),
        _: 1
      }, 8, ["modelValue", "enableTimePicker", "format", "previewFormat", "yearRange", "minDate", "maxDate", "textInput", "class", "ui", "disabled", "teleport"])) : Y("", !0),
      m(s) ? (v(), y(me, { key: 1 }, [
        t.modern ? (v(), Pe(m(mn), {
          key: 0,
          timePicker: "",
          modelValue: m(l),
          "onUpdate:modelValue": g[3] || (g[3] = (M) => ma(l) ? l.value = M : null),
          locale: "ja",
          format: m(u).input,
          previewFormat: m(u).preview,
          clearable: !1,
          textInput: t.directInput,
          autoApply: !0,
          class: "timePicker",
          inputClassName: t.inputStyleClass,
          ui: m(f),
          disabled: t.disabled,
          teleport: t.teleport
        }, {
          "input-icon": Ae(() => [
            Y0
          ]),
          "dp-input": Ae(({ value: M, onInput: A, onEnter: P, onTab: C, onBlur: O, onPaste: R }) => [
            k("input", {
              type: "text",
              value: M,
              onInput: A,
              onKeydown: [
                Cn(P, ["enter"]),
                Cn(C, ["tab"])
              ],
              onBlur: O,
              onPaste: R,
              onDrop: g[2] || (g[2] = yt(() => {
              }, ["prevent"])),
              onDragover: $,
              onDragenter: $,
              class: pe(["dp__pointer dp__input_readonly dp__input dp__input_icon_pad dp__input_reg", t.inputStyleClass])
            }, null, 42, W0)
          ]),
          _: 1
        }, 8, ["modelValue", "format", "previewFormat", "textInput", "inputClassName", "ui", "disabled", "teleport"])) : ht((v(), y("input", {
          key: 1,
          type: "time",
          inputmode: "text",
          "onUpdate:modelValue": g[4] || (g[4] = (M) => ma(o) ? o.value = M : null),
          class: pe(["dp__theme_light timePickerClassic", t.inputStyleClass]),
          disabled: t.disabled,
          onKeydown: D
        }, null, 42, U0)), [
          [Ln, m(o)]
        ])
      ], 64)) : Y("", !0)
    ]));
  }
}), Bb = /* @__PURE__ */ Ye(z0, [["__scopeId", "data-v-566f1521"]]), q0 = { class: "dayOfWeeks" }, j0 = ["onClick", "disabled", "checked"], G0 = /* @__PURE__ */ Te({
  __name: "DayOfWeeks",
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = ["月", "火", "水", "木", "金", "土", "日"], l = H({
      get: () => t.modelValue,
      set: (c) => n("update:modelValue", c)
    }), o = H(() => (c) => r[c]);
    function i(c) {
      return (l.value & 1 << c) !== 0;
    }
    function s(c, u) {
      const d = u.target, f = l.value;
      d.checked ? l.value = f | 1 << c : l.value = f & ~(1 << c);
    }
    return (c, u) => (v(), y("div", q0, [
      (v(), y(me, null, Me(7, (d, f) => k("div", {
        key: f,
        class: "dayOfWeek"
      }, [
        k("input", {
          type: "checkbox",
          onClick: (h) => s(f, h),
          disabled: t.disabled,
          checked: i(f)
        }, null, 8, j0),
        k("span", null, _e(m(o)(f)), 1)
      ])), 64))
    ]));
  }
}), Lb = /* @__PURE__ */ Ye(G0, [["__scopeId", "data-v-b3f8bac9"]]), Q0 = ["innerHTML"], K0 = ["innerHTML"], X0 = /* @__PURE__ */ Te({
  __name: "Annotator",
  props: {
    annotation: {},
    error: {},
    position: { default: "bottom" },
    for: {}
  },
  setup(e) {
    const a = e, t = B(null), n = H(() => {
      var d, f;
      return 0 < (((d = a.annotation) == null ? void 0 : d.length) ?? 0) || 0 < (((f = a.error) == null ? void 0 : f.length) ?? 0);
    }), r = H(() => {
      var d;
      return 0 < (((d = a.annotation) == null ? void 0 : d.length) ?? 0);
    }), l = H(() => {
      var d;
      return 0 < (((d = a.error) == null ? void 0 : d.length) ?? 0);
    }), o = H(() => Tn(a.annotation ?? "")), i = H(() => Tn(a.error ?? "")), s = B({}), { watchElementVisibility: c } = co();
    Xe(() => {
      a.position !== "top" && a.position !== "bottom" || a.for && t.value && c(t.value, {
        onVisibled(d) {
          const f = document.getElementById(a.for);
          s.value = {
            paddingLeft: `${f ? u(f) : 0}px`
          };
        },
        options: {
          immediate: !0
        }
      });
    });
    function u(d) {
      const f = d.parentElement, h = d.getBoundingClientRect(), b = f == null ? void 0 : f.getBoundingClientRect();
      return h.left - ((b == null ? void 0 : b.left) ?? 0);
    }
    return (d, f) => (v(), y("div", {
      ref_key: "thisComponentRoot",
      ref: t,
      class: pe(["annotator", [
        { "decorator-pos-top": a.position === "top" },
        { "decorator-pos-right": a.position === "right" },
        { "decorator-pos-bottom": a.position === "bottom" }
      ]])
    }, [
      ie(d.$slots, "default", {}, void 0, !0),
      m(n) ? (v(), y("div", {
        key: 0,
        class: "decoration-area",
        style: Be(m(s))
      }, [
        m(r) ? (v(!0), y(me, { key: 0 }, Me(m(o), (h, b) => (v(), y("span", {
          key: b,
          innerHTML: h,
          class: "input-text-annotation"
        }, null, 8, Q0))), 128)) : Y("", !0),
        m(l) ? (v(!0), y(me, { key: 1 }, Me(m(i), (h, b) => (v(), y("span", {
          key: b,
          innerHTML: h,
          class: "input-text-validation-error-message"
        }, null, 8, K0))), 128)) : Y("", !0)
      ], 4)) : Y("", !0)
    ], 2));
  }
}), Fb = /* @__PURE__ */ Ye(X0, [["__scopeId", "data-v-d6f2d1b8"]]), Z0 = (e) => (Tt("data-v-22614ff2"), e = e(), It(), e), J0 = /* @__PURE__ */ Z0(() => /* @__PURE__ */ k("img", {
  src: Xs,
  class: "mini-icon",
  alt: "info"
}, null, -1)), eb = /* @__PURE__ */ Te({
  __name: "InfomationArea",
  props: {
    // margin-bottomを外から設定できるようにする（デフォルトは「なし」）
    marginBottom: {
      type: String,
      default: "0px"
    },
    // 文言の幅でぎゅっとなる（fit-content）をオプションにする
    fitContent: {
      type: Boolean,
      default: !1
      // true: 文言の幅に合わせる, false: 親要素の幅いっぱい(100%)
    },
    // 通常の文字色（色指定なし）にするオプション
    normalText: {
      type: Boolean,
      default: !1
      // false: 従来の薄い色(annotation), true: 親の文字色を継承(normal)
    }
  },
  setup(e) {
    const a = e, t = H(() => ({
      marginBottom: a.marginBottom,
      width: a.fitContent ? "fit-content" : "100%"
    }));
    return (n, r) => (v(), y("div", {
      class: "guide-info-box",
      style: Be(t.value)
    }, [
      J0,
      k("div", {
        class: pe(["text-container", { "annotation-text": !e.normalText }])
      }, [
        ie(n.$slots, "default", {}, void 0, !0)
      ], 2)
    ], 4));
  }
}), Vb = /* @__PURE__ */ Ye(eb, [["__scopeId", "data-v-22614ff2"]]);
export {
  Pb as AccordionTree,
  Fb as Annotator,
  Cl as BGColorMenuButton,
  Wb as Checkbox,
  ut as CheckboxState,
  Zn as ColumnWidthData,
  Bb as DateTimePicker,
  Kt as DateTimePickerStyle,
  Lb as DayOfWeeks,
  fb as DropdownButton,
  pb as DropdownItemBase,
  Dl as DropdownMenu,
  Gi as DropdownSelectMenu,
  Cb as GlobalLoading,
  Ll as GlobalLoadingUtil,
  yb as IPv4Input,
  Vb as InfomationArea,
  bb as LabeledComponent,
  Rb as LabeledText,
  Cd as ListCtrl,
  wb as ListCtrlColumnData,
  ze as ListCtrlColumnType,
  Dn as ListSelectionType,
  xb as ListTitleBar,
  gb as MACAddressInput,
  ka as MaskInput,
  Db as MessageBox,
  qb as MessageBoxButtonID,
  Ub as MessageBoxEx,
  jb as MessageBoxFlags,
  Gb as MessageUtil,
  _b as PaginatedListCtrl,
  Ud as PaginationArea,
  Xa as PaginationListCtrlStyles,
  Nd as PaginationUtil,
  Ib as Radio,
  mb as SearchInput,
  ir as SearchKeywordAllData,
  Fl as SearchKeywordGroup,
  va as SearchKeywordGroupType,
  Mb as SearchKeywordSelectGroup,
  Sb as SearchKeywordTypeSimpleText,
  im as SearchKeywordTypeText,
  yu as SelectBox,
  hb as SelectFileInput,
  Eb as Stepper,
  Nb as StepperItem,
  $0 as StepperProgress,
  db as SwitchButton,
  Ab as Tab,
  Bn as TabStyle,
  Ob as Tabs,
  Pp as TemplateModal,
  Tb as TemplateModalEx,
  $b as TreeCtrl,
  Vt as TreeData,
  Fg as TreeItemData,
  po as TriStateCheckbox,
  Kn as VILabelLayout,
  vb as ValidatedInput,
  kb as VariableListCtrl
};
